/* tslint:disable */
/* eslint-disable */
//  This file was automatically generated and should not be edited.

export type CreateOrganizationInput = {
  id?: string | null;
  name: string;
  address?: string | null;
};

export type ModelOrganizationConditionInput = {
  name?: ModelStringInput | null;
  address?: ModelStringInput | null;
  and?: Array<ModelOrganizationConditionInput | null> | null;
  or?: Array<ModelOrganizationConditionInput | null> | null;
  not?: ModelOrganizationConditionInput | null;
};

export type ModelStringInput = {
  ne?: string | null;
  eq?: string | null;
  le?: string | null;
  lt?: string | null;
  ge?: string | null;
  gt?: string | null;
  contains?: string | null;
  notContains?: string | null;
  between?: Array<string | null> | null;
  beginsWith?: string | null;
  attributeExists?: boolean | null;
  attributeType?: ModelAttributeTypes | null;
  size?: ModelSizeInput | null;
};

export enum ModelAttributeTypes {
  binary = 'binary',
  binarySet = 'binarySet',
  bool = 'bool',
  list = 'list',
  map = 'map',
  number = 'number',
  numberSet = 'numberSet',
  string = 'string',
  stringSet = 'stringSet',
  _null = '_null',
}

export type ModelSizeInput = {
  ne?: number | null;
  eq?: number | null;
  le?: number | null;
  lt?: number | null;
  ge?: number | null;
  gt?: number | null;
  between?: Array<number | null> | null;
};

export type Organization = {
  __typename: 'Organization';
  id: string;
  employees?: ModelEmployeeConnection | null;
  name: string;
  address?: string | null;
  objectives?: ModelObjectiveConnection | null;
  createdAt: string;
  updatedAt: string;
};

export type ModelEmployeeConnection = {
  __typename: 'ModelEmployeeConnection';
  items: Array<Employee | null>;
  nextToken?: string | null;
};

export type Employee = {
  __typename: 'Employee';
  id: string;
  organizationId?: string | null;
  organizationUnitId?: string | null;
  organizationUnit?: OrganizationUnit | null;
  userId: string;
  user?: User | null;
  nik: string;
  status: EmploymentStatus;
  domicile?: string | null;
  managerId?: string | null;
  manager?: Employee | null;
  jobTitles?: ModelEmployeeJobTitleConnection | null;
  socialMedias?: ModelEmployeeSocialMediaConnection | null;
  positionHistories?: ModelEmployeePositionHistoryConnection | null;
  educationHistories?: ModelEmployeeEducationHistoryConnection | null;
  assignmentHistories?: ModelEmployeeAssignmentHistoryConnection | null;
  activities?: ModelEmployeeActivityConnection | null;
  badges?: ModelEmployeeBadgeConnection | null;
  skills?: ModelEmployeeSkillConnection | null;
  trainings?: ModelEmployeeTrainingConnection | null;
  rewards?: ModelEmployeeRewardConnection | null;
  objectives?: ModelObjectiveConnection | null;
  createdAt: string;
  updatedAt: string;
};

export type OrganizationUnit = {
  __typename: 'OrganizationUnit';
  id: string;
  organizationId?: string | null;
  name: string;
  parentId?: string | null;
  parent?: OrganizationUnit | null;
  children?: ModelOrganizationUnitConnection | null;
  objectives?: ModelObjectiveConnection | null;
  createdAt: string;
  updatedAt: string;
};

export type ModelOrganizationUnitConnection = {
  __typename: 'ModelOrganizationUnitConnection';
  items: Array<OrganizationUnit | null>;
  nextToken?: string | null;
};

export type ModelObjectiveConnection = {
  __typename: 'ModelObjectiveConnection';
  items: Array<Objective | null>;
  nextToken?: string | null;
};

export type Objective = {
  __typename: 'Objective';
  id: string;
  ownerId?: string | null;
  title: string;
  description?: string | null;
  createdAt: string;
  updatedAt: string;
};

export type User = {
  __typename: 'User';
  id: string;
  username: string;
  name: string;
  email: string;
  createdAt: string;
  updatedAt: string;
};

export enum EmploymentStatus {
  PERMANENT = 'PERMANENT',
  CONTRACT = 'CONTRACT',
  HONORARY = 'HONORARY',
  INTERNSHIP = 'INTERNSHIP',
  PROBATION = 'PROBATION',
  RETIRED = 'RETIRED',
  RESIGNED = 'RESIGNED',
}

export type ModelEmployeeJobTitleConnection = {
  __typename: 'ModelEmployeeJobTitleConnection';
  items: Array<EmployeeJobTitle | null>;
  nextToken?: string | null;
};

export type EmployeeJobTitle = {
  __typename: 'EmployeeJobTitle';
  id: string;
  employeeId?: string | null;
  jobTitleId?: string | null;
  jobTitle?: JobTitle | null;
  createdAt: string;
  updatedAt: string;
};

export type JobTitle = {
  __typename: 'JobTitle';
  id: string;
  organizationUnit?: OrganizationUnit | null;
  organizationUnitId?: string | null;
  title?: string | null;
  createdAt: string;
  updatedAt: string;
};

export type ModelEmployeeSocialMediaConnection = {
  __typename: 'ModelEmployeeSocialMediaConnection';
  items: Array<EmployeeSocialMedia | null>;
  nextToken?: string | null;
};

export type EmployeeSocialMedia = {
  __typename: 'EmployeeSocialMedia';
  id: string;
  employeeId?: string | null;
  socialMediaId?: string | null;
  socialMedia?: SocialMedia | null;
  username: string;
  createdAt: string;
  updatedAt: string;
};

export type SocialMedia = {
  __typename: 'SocialMedia';
  id: string;
  name: string;
  url?: string | null;
  iconUrl?: string | null;
  createdAt: string;
  updatedAt: string;
};

export type ModelEmployeePositionHistoryConnection = {
  __typename: 'ModelEmployeePositionHistoryConnection';
  items: Array<EmployeePositionHistory | null>;
  nextToken?: string | null;
};

export type EmployeePositionHistory = {
  __typename: 'EmployeePositionHistory';
  id: string;
  employeeId?: string | null;
  dateFrom?: string | null;
  dateUntil?: string | null;
  officeName?: string | null;
  location?: string | null;
  description?: string | null;
  internalPosition?: boolean | null;
  createdAt: string;
  updatedAt: string;
};

export type ModelEmployeeEducationHistoryConnection = {
  __typename: 'ModelEmployeeEducationHistoryConnection';
  items: Array<EmployeeEducationHistory | null>;
  nextToken?: string | null;
};

export type EmployeeEducationHistory = {
  __typename: 'EmployeeEducationHistory';
  id: string;
  employeeId?: string | null;
  schoolName?: string | null;
  entryYear?: number | null;
  graduationYear?: number | null;
  createdAt: string;
  updatedAt: string;
};

export type ModelEmployeeAssignmentHistoryConnection = {
  __typename: 'ModelEmployeeAssignmentHistoryConnection';
  items: Array<EmployeeAssignmentHistory | null>;
  nextToken?: string | null;
};

export type EmployeeAssignmentHistory = {
  __typename: 'EmployeeAssignmentHistory';
  id: string;
  employeeId?: string | null;
  dateFrom?: string | null;
  dateUntil?: string | null;
  officeName?: string | null;
  location?: string | null;
  description?: string | null;
  bodRelated?: boolean | null;
  createdAt: string;
  updatedAt: string;
};

export type ModelEmployeeActivityConnection = {
  __typename: 'ModelEmployeeActivityConnection';
  items: Array<EmployeeActivity | null>;
  nextToken?: string | null;
};

export type EmployeeActivity = {
  __typename: 'EmployeeActivity';
  id: string;
  employeeId?: string | null;
  activityId: string;
  activity?: Activity | null;
  point?: number | null;
  datetime?: string | null;
  createdAt: string;
  updatedAt: string;
};

export type Activity = {
  __typename: 'Activity';
  id: string;
  name?: string | null;
  point?: number | null;
  createdAt: string;
  updatedAt: string;
};

export type ModelEmployeeBadgeConnection = {
  __typename: 'ModelEmployeeBadgeConnection';
  items: Array<EmployeeBadge | null>;
  nextToken?: string | null;
};

export type EmployeeBadge = {
  __typename: 'EmployeeBadge';
  id: string;
  employeeId: string;
  badgeId: string;
  badge?: Badge | null;
  grantDate?: string | null;
  grantedById: string;
  grantedBy?: Employee | null;
  createdAt: string;
  updatedAt: string;
};

export type Badge = {
  __typename: 'Badge';
  id: string;
  name?: string | null;
  iconUrl?: string | null;
  createdAt: string;
  updatedAt: string;
};

export type ModelEmployeeSkillConnection = {
  __typename: 'ModelEmployeeSkillConnection';
  items: Array<EmployeeSkill | null>;
  nextToken?: string | null;
};

export type EmployeeSkill = {
  __typename: 'EmployeeSkill';
  id: string;
  employeeId: string;
  skillGroup?: string | null;
  skill?: string | null;
  name?: string | null;
  level?: SkillLevel | null;
  progress?: number | null;
  createdAt: string;
  updatedAt: string;
};

export enum SkillLevel {
  BEGINNER = 'BEGINNER',
  INTERMEDIATE = 'INTERMEDIATE',
  ADVANCED = 'ADVANCED',
  EXPERT = 'EXPERT',
}

export type ModelEmployeeTrainingConnection = {
  __typename: 'ModelEmployeeTrainingConnection';
  items: Array<EmployeeTraining | null>;
  nextToken?: string | null;
};

export type EmployeeTraining = {
  __typename: 'EmployeeTraining';
  id: string;
  employeeId: string;
  date?: string | null;
  name?: string | null;
  description?: string | null;
  type?: TrainingType | null;
  createdAt: string;
  updatedAt: string;
};

export enum TrainingType {
  CERTIFICATION = 'CERTIFICATION',
  WORKSHOP = 'WORKSHOP',
  PENJENJANGAN = 'PENJENJANGAN',
}

export type ModelEmployeeRewardConnection = {
  __typename: 'ModelEmployeeRewardConnection';
  items: Array<EmployeeReward | null>;
  nextToken?: string | null;
};

export type EmployeeReward = {
  __typename: 'EmployeeReward';
  id: string;
  employeeId: string;
  date?: string | null;
  name?: string | null;
  description?: string | null;
  type?: RewardType | null;
  createdAt: string;
  updatedAt: string;
};

export enum RewardType {
  INTERNAL = 'INTERNAL',
  EXTERNAL = 'EXTERNAL',
  INDISIPLINER = 'INDISIPLINER',
}

export type UpdateOrganizationInput = {
  id: string;
  name?: string | null;
  address?: string | null;
};

export type DeleteOrganizationInput = {
  id: string;
};

export type CreateEmployeeInput = {
  id?: string | null;
  organizationId?: string | null;
  organizationUnitId?: string | null;
  userId: string;
  nik: string;
  status: EmploymentStatus;
  domicile?: string | null;
  managerId?: string | null;
};

export type ModelEmployeeConditionInput = {
  organizationId?: ModelIDInput | null;
  organizationUnitId?: ModelIDInput | null;
  userId?: ModelIDInput | null;
  nik?: ModelStringInput | null;
  status?: ModelEmploymentStatusInput | null;
  domicile?: ModelStringInput | null;
  managerId?: ModelIDInput | null;
  and?: Array<ModelEmployeeConditionInput | null> | null;
  or?: Array<ModelEmployeeConditionInput | null> | null;
  not?: ModelEmployeeConditionInput | null;
};

export type ModelIDInput = {
  ne?: string | null;
  eq?: string | null;
  le?: string | null;
  lt?: string | null;
  ge?: string | null;
  gt?: string | null;
  contains?: string | null;
  notContains?: string | null;
  between?: Array<string | null> | null;
  beginsWith?: string | null;
  attributeExists?: boolean | null;
  attributeType?: ModelAttributeTypes | null;
  size?: ModelSizeInput | null;
};

export type ModelEmploymentStatusInput = {
  eq?: EmploymentStatus | null;
  ne?: EmploymentStatus | null;
};

export type UpdateEmployeeInput = {
  id: string;
  organizationId?: string | null;
  organizationUnitId?: string | null;
  userId?: string | null;
  nik?: string | null;
  status?: EmploymentStatus | null;
  domicile?: string | null;
  managerId?: string | null;
};

export type DeleteEmployeeInput = {
  id: string;
};

export type CreateEmployeeJobTitleInput = {
  id?: string | null;
  employeeId?: string | null;
  jobTitleId?: string | null;
};

export type ModelEmployeeJobTitleConditionInput = {
  employeeId?: ModelIDInput | null;
  jobTitleId?: ModelIDInput | null;
  and?: Array<ModelEmployeeJobTitleConditionInput | null> | null;
  or?: Array<ModelEmployeeJobTitleConditionInput | null> | null;
  not?: ModelEmployeeJobTitleConditionInput | null;
};

export type UpdateEmployeeJobTitleInput = {
  id: string;
  employeeId?: string | null;
  jobTitleId?: string | null;
};

export type DeleteEmployeeJobTitleInput = {
  id: string;
};

export type CreateObjectiveInput = {
  id?: string | null;
  ownerId?: string | null;
  title: string;
  description?: string | null;
};

export type ModelObjectiveConditionInput = {
  ownerId?: ModelIDInput | null;
  title?: ModelStringInput | null;
  description?: ModelStringInput | null;
  and?: Array<ModelObjectiveConditionInput | null> | null;
  or?: Array<ModelObjectiveConditionInput | null> | null;
  not?: ModelObjectiveConditionInput | null;
};

export type UpdateObjectiveInput = {
  id: string;
  ownerId?: string | null;
  title?: string | null;
  description?: string | null;
};

export type DeleteObjectiveInput = {
  id: string;
};

export type CreateUserInput = {
  id?: string | null;
  username: string;
  name: string;
  email: string;
};

export type ModelUserConditionInput = {
  username?: ModelStringInput | null;
  name?: ModelStringInput | null;
  email?: ModelStringInput | null;
  and?: Array<ModelUserConditionInput | null> | null;
  or?: Array<ModelUserConditionInput | null> | null;
  not?: ModelUserConditionInput | null;
};

export type UpdateUserInput = {
  id: string;
  username?: string | null;
  name?: string | null;
  email?: string | null;
};

export type DeleteUserInput = {
  id: string;
};

export type CreateJobTitleInput = {
  id?: string | null;
  organizationUnitId?: string | null;
  title?: string | null;
};

export type ModelJobTitleConditionInput = {
  organizationUnitId?: ModelIDInput | null;
  title?: ModelStringInput | null;
  and?: Array<ModelJobTitleConditionInput | null> | null;
  or?: Array<ModelJobTitleConditionInput | null> | null;
  not?: ModelJobTitleConditionInput | null;
};

export type UpdateJobTitleInput = {
  id: string;
  organizationUnitId?: string | null;
  title?: string | null;
};

export type DeleteJobTitleInput = {
  id: string;
};

export type CreateOrganizationUnitInput = {
  id?: string | null;
  organizationId?: string | null;
  name: string;
  parentId?: string | null;
};

export type ModelOrganizationUnitConditionInput = {
  organizationId?: ModelIDInput | null;
  name?: ModelStringInput | null;
  parentId?: ModelIDInput | null;
  and?: Array<ModelOrganizationUnitConditionInput | null> | null;
  or?: Array<ModelOrganizationUnitConditionInput | null> | null;
  not?: ModelOrganizationUnitConditionInput | null;
};

export type UpdateOrganizationUnitInput = {
  id: string;
  organizationId?: string | null;
  name?: string | null;
  parentId?: string | null;
};

export type DeleteOrganizationUnitInput = {
  id: string;
};

export type CreateSocialMediaInput = {
  id?: string | null;
  name: string;
  url?: string | null;
  iconUrl?: string | null;
};

export type ModelSocialMediaConditionInput = {
  name?: ModelStringInput | null;
  url?: ModelStringInput | null;
  iconUrl?: ModelStringInput | null;
  and?: Array<ModelSocialMediaConditionInput | null> | null;
  or?: Array<ModelSocialMediaConditionInput | null> | null;
  not?: ModelSocialMediaConditionInput | null;
};

export type UpdateSocialMediaInput = {
  id: string;
  name?: string | null;
  url?: string | null;
  iconUrl?: string | null;
};

export type DeleteSocialMediaInput = {
  id: string;
};

export type CreateEmployeeSocialMediaInput = {
  id?: string | null;
  employeeId?: string | null;
  socialMediaId?: string | null;
  username: string;
};

export type ModelEmployeeSocialMediaConditionInput = {
  employeeId?: ModelIDInput | null;
  socialMediaId?: ModelIDInput | null;
  username?: ModelStringInput | null;
  and?: Array<ModelEmployeeSocialMediaConditionInput | null> | null;
  or?: Array<ModelEmployeeSocialMediaConditionInput | null> | null;
  not?: ModelEmployeeSocialMediaConditionInput | null;
};

export type UpdateEmployeeSocialMediaInput = {
  id: string;
  employeeId?: string | null;
  socialMediaId?: string | null;
  username?: string | null;
};

export type DeleteEmployeeSocialMediaInput = {
  id: string;
};

export type CreateEmployeePositionHistoryInput = {
  id?: string | null;
  employeeId?: string | null;
  dateFrom?: string | null;
  dateUntil?: string | null;
  officeName?: string | null;
  location?: string | null;
  description?: string | null;
  internalPosition?: boolean | null;
};

export type ModelEmployeePositionHistoryConditionInput = {
  employeeId?: ModelIDInput | null;
  dateFrom?: ModelStringInput | null;
  dateUntil?: ModelStringInput | null;
  officeName?: ModelStringInput | null;
  location?: ModelStringInput | null;
  description?: ModelStringInput | null;
  internalPosition?: ModelBooleanInput | null;
  and?: Array<ModelEmployeePositionHistoryConditionInput | null> | null;
  or?: Array<ModelEmployeePositionHistoryConditionInput | null> | null;
  not?: ModelEmployeePositionHistoryConditionInput | null;
};

export type ModelBooleanInput = {
  ne?: boolean | null;
  eq?: boolean | null;
  attributeExists?: boolean | null;
  attributeType?: ModelAttributeTypes | null;
};

export type UpdateEmployeePositionHistoryInput = {
  id: string;
  employeeId?: string | null;
  dateFrom?: string | null;
  dateUntil?: string | null;
  officeName?: string | null;
  location?: string | null;
  description?: string | null;
  internalPosition?: boolean | null;
};

export type DeleteEmployeePositionHistoryInput = {
  id: string;
};

export type CreateEmployeeEducationHistoryInput = {
  id?: string | null;
  employeeId?: string | null;
  schoolName?: string | null;
  entryYear?: number | null;
  graduationYear?: number | null;
};

export type ModelEmployeeEducationHistoryConditionInput = {
  employeeId?: ModelIDInput | null;
  schoolName?: ModelStringInput | null;
  entryYear?: ModelIntInput | null;
  graduationYear?: ModelIntInput | null;
  and?: Array<ModelEmployeeEducationHistoryConditionInput | null> | null;
  or?: Array<ModelEmployeeEducationHistoryConditionInput | null> | null;
  not?: ModelEmployeeEducationHistoryConditionInput | null;
};

export type ModelIntInput = {
  ne?: number | null;
  eq?: number | null;
  le?: number | null;
  lt?: number | null;
  ge?: number | null;
  gt?: number | null;
  between?: Array<number | null> | null;
  attributeExists?: boolean | null;
  attributeType?: ModelAttributeTypes | null;
};

export type UpdateEmployeeEducationHistoryInput = {
  id: string;
  employeeId?: string | null;
  schoolName?: string | null;
  entryYear?: number | null;
  graduationYear?: number | null;
};

export type DeleteEmployeeEducationHistoryInput = {
  id: string;
};

export type CreateEmployeeAssignmentHistoryInput = {
  id?: string | null;
  employeeId?: string | null;
  dateFrom?: string | null;
  dateUntil?: string | null;
  officeName?: string | null;
  location?: string | null;
  description?: string | null;
  bodRelated?: boolean | null;
};

export type ModelEmployeeAssignmentHistoryConditionInput = {
  employeeId?: ModelIDInput | null;
  dateFrom?: ModelStringInput | null;
  dateUntil?: ModelStringInput | null;
  officeName?: ModelStringInput | null;
  location?: ModelStringInput | null;
  description?: ModelStringInput | null;
  bodRelated?: ModelBooleanInput | null;
  and?: Array<ModelEmployeeAssignmentHistoryConditionInput | null> | null;
  or?: Array<ModelEmployeeAssignmentHistoryConditionInput | null> | null;
  not?: ModelEmployeeAssignmentHistoryConditionInput | null;
};

export type UpdateEmployeeAssignmentHistoryInput = {
  id: string;
  employeeId?: string | null;
  dateFrom?: string | null;
  dateUntil?: string | null;
  officeName?: string | null;
  location?: string | null;
  description?: string | null;
  bodRelated?: boolean | null;
};

export type DeleteEmployeeAssignmentHistoryInput = {
  id: string;
};

export type CreateEmployeeActivityInput = {
  id?: string | null;
  employeeId?: string | null;
  activityId: string;
  point?: number | null;
  datetime?: string | null;
};

export type ModelEmployeeActivityConditionInput = {
  employeeId?: ModelIDInput | null;
  activityId?: ModelIDInput | null;
  point?: ModelIntInput | null;
  datetime?: ModelStringInput | null;
  and?: Array<ModelEmployeeActivityConditionInput | null> | null;
  or?: Array<ModelEmployeeActivityConditionInput | null> | null;
  not?: ModelEmployeeActivityConditionInput | null;
};

export type UpdateEmployeeActivityInput = {
  id: string;
  employeeId?: string | null;
  activityId?: string | null;
  point?: number | null;
  datetime?: string | null;
};

export type DeleteEmployeeActivityInput = {
  id: string;
};

export type CreateEmployeeBadgeInput = {
  id?: string | null;
  employeeId: string;
  badgeId: string;
  grantDate?: string | null;
  grantedById: string;
};

export type ModelEmployeeBadgeConditionInput = {
  employeeId?: ModelIDInput | null;
  badgeId?: ModelIDInput | null;
  grantDate?: ModelStringInput | null;
  grantedById?: ModelIDInput | null;
  and?: Array<ModelEmployeeBadgeConditionInput | null> | null;
  or?: Array<ModelEmployeeBadgeConditionInput | null> | null;
  not?: ModelEmployeeBadgeConditionInput | null;
};

export type UpdateEmployeeBadgeInput = {
  id: string;
  employeeId?: string | null;
  badgeId?: string | null;
  grantDate?: string | null;
  grantedById?: string | null;
};

export type DeleteEmployeeBadgeInput = {
  id: string;
};

export type CreateEmployeeSkillInput = {
  id?: string | null;
  employeeId: string;
  skillGroup?: string | null;
  skill?: string | null;
  name?: string | null;
  level?: SkillLevel | null;
  progress?: number | null;
};

export type ModelEmployeeSkillConditionInput = {
  employeeId?: ModelIDInput | null;
  skillGroup?: ModelStringInput | null;
  skill?: ModelStringInput | null;
  name?: ModelStringInput | null;
  level?: ModelSkillLevelInput | null;
  progress?: ModelIntInput | null;
  and?: Array<ModelEmployeeSkillConditionInput | null> | null;
  or?: Array<ModelEmployeeSkillConditionInput | null> | null;
  not?: ModelEmployeeSkillConditionInput | null;
};

export type ModelSkillLevelInput = {
  eq?: SkillLevel | null;
  ne?: SkillLevel | null;
};

export type UpdateEmployeeSkillInput = {
  id: string;
  employeeId?: string | null;
  skillGroup?: string | null;
  skill?: string | null;
  name?: string | null;
  level?: SkillLevel | null;
  progress?: number | null;
};

export type DeleteEmployeeSkillInput = {
  id: string;
};

export type CreateEmployeeTrainingInput = {
  id?: string | null;
  employeeId: string;
  date?: string | null;
  name?: string | null;
  description?: string | null;
  type?: TrainingType | null;
};

export type ModelEmployeeTrainingConditionInput = {
  employeeId?: ModelIDInput | null;
  date?: ModelStringInput | null;
  name?: ModelStringInput | null;
  description?: ModelStringInput | null;
  type?: ModelTrainingTypeInput | null;
  and?: Array<ModelEmployeeTrainingConditionInput | null> | null;
  or?: Array<ModelEmployeeTrainingConditionInput | null> | null;
  not?: ModelEmployeeTrainingConditionInput | null;
};

export type ModelTrainingTypeInput = {
  eq?: TrainingType | null;
  ne?: TrainingType | null;
};

export type UpdateEmployeeTrainingInput = {
  id: string;
  employeeId?: string | null;
  date?: string | null;
  name?: string | null;
  description?: string | null;
  type?: TrainingType | null;
};

export type DeleteEmployeeTrainingInput = {
  id: string;
};

export type CreateEmployeeRewardInput = {
  id?: string | null;
  employeeId: string;
  date?: string | null;
  name?: string | null;
  description?: string | null;
  type?: RewardType | null;
};

export type ModelEmployeeRewardConditionInput = {
  employeeId?: ModelIDInput | null;
  date?: ModelStringInput | null;
  name?: ModelStringInput | null;
  description?: ModelStringInput | null;
  type?: ModelRewardTypeInput | null;
  and?: Array<ModelEmployeeRewardConditionInput | null> | null;
  or?: Array<ModelEmployeeRewardConditionInput | null> | null;
  not?: ModelEmployeeRewardConditionInput | null;
};

export type ModelRewardTypeInput = {
  eq?: RewardType | null;
  ne?: RewardType | null;
};

export type UpdateEmployeeRewardInput = {
  id: string;
  employeeId?: string | null;
  date?: string | null;
  name?: string | null;
  description?: string | null;
  type?: RewardType | null;
};

export type DeleteEmployeeRewardInput = {
  id: string;
};

export type CreateActivityInput = {
  id?: string | null;
  name?: string | null;
  point?: number | null;
};

export type ModelActivityConditionInput = {
  name?: ModelStringInput | null;
  point?: ModelIntInput | null;
  and?: Array<ModelActivityConditionInput | null> | null;
  or?: Array<ModelActivityConditionInput | null> | null;
  not?: ModelActivityConditionInput | null;
};

export type UpdateActivityInput = {
  id: string;
  name?: string | null;
  point?: number | null;
};

export type DeleteActivityInput = {
  id: string;
};

export type CreateBadgeInput = {
  id?: string | null;
  name?: string | null;
  iconUrl?: string | null;
};

export type ModelBadgeConditionInput = {
  name?: ModelStringInput | null;
  iconUrl?: ModelStringInput | null;
  and?: Array<ModelBadgeConditionInput | null> | null;
  or?: Array<ModelBadgeConditionInput | null> | null;
  not?: ModelBadgeConditionInput | null;
};

export type UpdateBadgeInput = {
  id: string;
  name?: string | null;
  iconUrl?: string | null;
};

export type DeleteBadgeInput = {
  id: string;
};

export type CreateKnowledgeMapInput = {
  id?: string | null;
  name?: string | null;
  ownerId: string;
};

export type ModelKnowledgeMapConditionInput = {
  name?: ModelStringInput | null;
  ownerId?: ModelIDInput | null;
  and?: Array<ModelKnowledgeMapConditionInput | null> | null;
  or?: Array<ModelKnowledgeMapConditionInput | null> | null;
  not?: ModelKnowledgeMapConditionInput | null;
};

export type KnowledgeMap = {
  __typename: 'KnowledgeMap';
  id: string;
  name?: string | null;
  ownerId: string;
  businessProcesses?: ModelBusinessProcessConnection | null;
  collaborators?: ModelKnowledgeMapCollaboratorConnection | null;
  createdAt: string;
  updatedAt: string;
};

export type ModelBusinessProcessConnection = {
  __typename: 'ModelBusinessProcessConnection';
  items: Array<BusinessProcess | null>;
  nextToken?: string | null;
};

export type BusinessProcess = {
  __typename: 'BusinessProcess';
  id: string;
  knowledgeMapId: string;
  title: string;
  description: string;
  strategicActivities?: ModelStrategicActivityConnection | null;
  comments?: ModelBusinessProcessCommentConnection | null;
  createdAt: string;
  updatedAt: string;
};

export type ModelStrategicActivityConnection = {
  __typename: 'ModelStrategicActivityConnection';
  items: Array<StrategicActivity | null>;
  nextToken?: string | null;
};

export type StrategicActivity = {
  __typename: 'StrategicActivity';
  id: string;
  businessProcessId: string;
  title: string;
  description: string;
  importantKnowledges?: ModelImportantKnowledgeConnection | null;
  comments?: ModelStrategicActivityCommentConnection | null;
  createdAt: string;
  updatedAt: string;
};

export type ModelImportantKnowledgeConnection = {
  __typename: 'ModelImportantKnowledgeConnection';
  items: Array<ImportantKnowledge | null>;
  nextToken?: string | null;
};

export type ImportantKnowledge = {
  __typename: 'ImportantKnowledge';
  id: string;
  strategicActivityId: string;
  title: string;
  description: string;
  documents?: ModelImportantKnowledgeDocumentConnection | null;
  comments?: ModelImportantKnowledgeCommentConnection | null;
  createdAt: string;
  updatedAt: string;
};

export type ModelImportantKnowledgeDocumentConnection = {
  __typename: 'ModelImportantKnowledgeDocumentConnection';
  items: Array<ImportantKnowledgeDocument | null>;
  nextToken?: string | null;
};

export type ImportantKnowledgeDocument = {
  __typename: 'ImportantKnowledgeDocument';
  id: string;
  importantKnowledgeId: string;
  documentType: ImportantKnowledgeDocumentType;
  documentId: string;
  document?: RepositoryFile | null;
  creatorId: string;
  creator?: Employee | null;
  createdAt: string;
  updatedAt: string;
};

export enum ImportantKnowledgeDocumentType {
  KNOWLEDGE_DOCUMENT = 'KNOWLEDGE_DOCUMENT',
  BEST_PRACTICE = 'BEST_PRACTICE',
  LESSON_LEARNED = 'LESSON_LEARNED',
}

export type RepositoryFile = {
  __typename: 'RepositoryFile';
  id: string;
  folderId: string;
  filename?: string | null;
  filetype?: FileMediaType | null;
  createdById: string;
  createdBy?: Employee | null;
  createdAt: string;
  updatedAt: string;
};

export enum FileMediaType {
  IMAGE = 'IMAGE',
  DOCUMENT = 'DOCUMENT',
  AUDIO = 'AUDIO',
  VIDEO = 'VIDEO',
}

export type ModelImportantKnowledgeCommentConnection = {
  __typename: 'ModelImportantKnowledgeCommentConnection';
  items: Array<ImportantKnowledgeComment | null>;
  nextToken?: string | null;
};

export type ImportantKnowledgeComment = {
  __typename: 'ImportantKnowledgeComment';
  id: string;
  importantKnowledgeId: string;
  comment: string;
  createdById: string;
  createdBy?: Employee | null;
  parentId?: string | null;
  replies?: ModelImportantKnowledgeCommentConnection | null;
  createdAt: string;
  updatedAt: string;
};

export type ModelStrategicActivityCommentConnection = {
  __typename: 'ModelStrategicActivityCommentConnection';
  items: Array<StrategicActivityComment | null>;
  nextToken?: string | null;
};

export type StrategicActivityComment = {
  __typename: 'StrategicActivityComment';
  id: string;
  strategicActivityId: string;
  comment: string;
  createdById: string;
  createdBy?: Employee | null;
  parentId?: string | null;
  replies?: ModelStrategicActivityCommentConnection | null;
  createdAt: string;
  updatedAt: string;
};

export type ModelBusinessProcessCommentConnection = {
  __typename: 'ModelBusinessProcessCommentConnection';
  items: Array<BusinessProcessComment | null>;
  nextToken?: string | null;
};

export type BusinessProcessComment = {
  __typename: 'BusinessProcessComment';
  id: string;
  businessProcessId: string;
  comment: string;
  createdById: string;
  createdBy?: Employee | null;
  parentId?: string | null;
  replies?: ModelBusinessProcessCommentConnection | null;
  createdAt: string;
  updatedAt: string;
};

export type ModelKnowledgeMapCollaboratorConnection = {
  __typename: 'ModelKnowledgeMapCollaboratorConnection';
  items: Array<KnowledgeMapCollaborator | null>;
  nextToken?: string | null;
};

export type KnowledgeMapCollaborator = {
  __typename: 'KnowledgeMapCollaborator';
  id: string;
  employeeId?: string | null;
  employee?: Employee | null;
  knowledgeMapId: string;
  createdAt: string;
  updatedAt: string;
};

export type UpdateKnowledgeMapInput = {
  id: string;
  name?: string | null;
  ownerId?: string | null;
};

export type DeleteKnowledgeMapInput = {
  id: string;
};

export type CreateKnowledgeMapCollaboratorInput = {
  id?: string | null;
  employeeId?: string | null;
  knowledgeMapId: string;
};

export type ModelKnowledgeMapCollaboratorConditionInput = {
  employeeId?: ModelIDInput | null;
  knowledgeMapId?: ModelIDInput | null;
  and?: Array<ModelKnowledgeMapCollaboratorConditionInput | null> | null;
  or?: Array<ModelKnowledgeMapCollaboratorConditionInput | null> | null;
  not?: ModelKnowledgeMapCollaboratorConditionInput | null;
};

export type UpdateKnowledgeMapCollaboratorInput = {
  id: string;
  employeeId?: string | null;
  knowledgeMapId?: string | null;
};

export type DeleteKnowledgeMapCollaboratorInput = {
  id: string;
};

export type CreateBusinessProcessInput = {
  id?: string | null;
  knowledgeMapId: string;
  title: string;
  description: string;
};

export type ModelBusinessProcessConditionInput = {
  knowledgeMapId?: ModelIDInput | null;
  title?: ModelStringInput | null;
  description?: ModelStringInput | null;
  and?: Array<ModelBusinessProcessConditionInput | null> | null;
  or?: Array<ModelBusinessProcessConditionInput | null> | null;
  not?: ModelBusinessProcessConditionInput | null;
};

export type UpdateBusinessProcessInput = {
  id: string;
  knowledgeMapId?: string | null;
  title?: string | null;
  description?: string | null;
};

export type DeleteBusinessProcessInput = {
  id: string;
};

export type CreateBusinessProcessCommentInput = {
  id?: string | null;
  businessProcessId: string;
  comment: string;
  createdById: string;
  parentId?: string | null;
};

export type ModelBusinessProcessCommentConditionInput = {
  businessProcessId?: ModelIDInput | null;
  comment?: ModelStringInput | null;
  createdById?: ModelIDInput | null;
  parentId?: ModelIDInput | null;
  and?: Array<ModelBusinessProcessCommentConditionInput | null> | null;
  or?: Array<ModelBusinessProcessCommentConditionInput | null> | null;
  not?: ModelBusinessProcessCommentConditionInput | null;
};

export type UpdateBusinessProcessCommentInput = {
  id: string;
  businessProcessId?: string | null;
  comment?: string | null;
  createdById?: string | null;
  parentId?: string | null;
};

export type DeleteBusinessProcessCommentInput = {
  id: string;
};

export type CreateStrategicActivityInput = {
  id?: string | null;
  businessProcessId: string;
  title: string;
  description: string;
};

export type ModelStrategicActivityConditionInput = {
  businessProcessId?: ModelIDInput | null;
  title?: ModelStringInput | null;
  description?: ModelStringInput | null;
  and?: Array<ModelStrategicActivityConditionInput | null> | null;
  or?: Array<ModelStrategicActivityConditionInput | null> | null;
  not?: ModelStrategicActivityConditionInput | null;
};

export type UpdateStrategicActivityInput = {
  id: string;
  businessProcessId?: string | null;
  title?: string | null;
  description?: string | null;
};

export type DeleteStrategicActivityInput = {
  id: string;
};

export type CreateStrategicActivityCommentInput = {
  id?: string | null;
  strategicActivityId: string;
  comment: string;
  createdById: string;
  parentId?: string | null;
};

export type ModelStrategicActivityCommentConditionInput = {
  strategicActivityId?: ModelIDInput | null;
  comment?: ModelStringInput | null;
  createdById?: ModelIDInput | null;
  parentId?: ModelIDInput | null;
  and?: Array<ModelStrategicActivityCommentConditionInput | null> | null;
  or?: Array<ModelStrategicActivityCommentConditionInput | null> | null;
  not?: ModelStrategicActivityCommentConditionInput | null;
};

export type UpdateStrategicActivityCommentInput = {
  id: string;
  strategicActivityId?: string | null;
  comment?: string | null;
  createdById?: string | null;
  parentId?: string | null;
};

export type DeleteStrategicActivityCommentInput = {
  id: string;
};

export type CreateImportantKnowledgeInput = {
  id?: string | null;
  strategicActivityId: string;
  title: string;
  description: string;
};

export type ModelImportantKnowledgeConditionInput = {
  strategicActivityId?: ModelIDInput | null;
  title?: ModelStringInput | null;
  description?: ModelStringInput | null;
  and?: Array<ModelImportantKnowledgeConditionInput | null> | null;
  or?: Array<ModelImportantKnowledgeConditionInput | null> | null;
  not?: ModelImportantKnowledgeConditionInput | null;
};

export type UpdateImportantKnowledgeInput = {
  id: string;
  strategicActivityId?: string | null;
  title?: string | null;
  description?: string | null;
};

export type DeleteImportantKnowledgeInput = {
  id: string;
};

export type CreateImportantKnowledgeCommentInput = {
  id?: string | null;
  importantKnowledgeId: string;
  comment: string;
  createdById: string;
  parentId?: string | null;
};

export type ModelImportantKnowledgeCommentConditionInput = {
  importantKnowledgeId?: ModelIDInput | null;
  comment?: ModelStringInput | null;
  createdById?: ModelIDInput | null;
  parentId?: ModelIDInput | null;
  and?: Array<ModelImportantKnowledgeCommentConditionInput | null> | null;
  or?: Array<ModelImportantKnowledgeCommentConditionInput | null> | null;
  not?: ModelImportantKnowledgeCommentConditionInput | null;
};

export type UpdateImportantKnowledgeCommentInput = {
  id: string;
  importantKnowledgeId?: string | null;
  comment?: string | null;
  createdById?: string | null;
  parentId?: string | null;
};

export type DeleteImportantKnowledgeCommentInput = {
  id: string;
};

export type CreateImportantKnowledgeDocumentInput = {
  id?: string | null;
  importantKnowledgeId: string;
  documentType: ImportantKnowledgeDocumentType;
  documentId: string;
  creatorId: string;
};

export type ModelImportantKnowledgeDocumentConditionInput = {
  importantKnowledgeId?: ModelIDInput | null;
  documentType?: ModelImportantKnowledgeDocumentTypeInput | null;
  documentId?: ModelIDInput | null;
  creatorId?: ModelIDInput | null;
  and?: Array<ModelImportantKnowledgeDocumentConditionInput | null> | null;
  or?: Array<ModelImportantKnowledgeDocumentConditionInput | null> | null;
  not?: ModelImportantKnowledgeDocumentConditionInput | null;
};

export type ModelImportantKnowledgeDocumentTypeInput = {
  eq?: ImportantKnowledgeDocumentType | null;
  ne?: ImportantKnowledgeDocumentType | null;
};

export type UpdateImportantKnowledgeDocumentInput = {
  id: string;
  importantKnowledgeId?: string | null;
  documentType?: ImportantKnowledgeDocumentType | null;
  documentId?: string | null;
  creatorId?: string | null;
};

export type DeleteImportantKnowledgeDocumentInput = {
  id: string;
};

export type CreateCompetencyFieldInput = {
  id?: string | null;
  name: string;
};

export type ModelCompetencyFieldConditionInput = {
  name?: ModelStringInput | null;
  and?: Array<ModelCompetencyFieldConditionInput | null> | null;
  or?: Array<ModelCompetencyFieldConditionInput | null> | null;
  not?: ModelCompetencyFieldConditionInput | null;
};

export type CompetencyField = {
  __typename: 'CompetencyField';
  id: string;
  name: string;
  createdAt: string;
  updatedAt: string;
};

export type UpdateCompetencyFieldInput = {
  id: string;
  name?: string | null;
};

export type DeleteCompetencyFieldInput = {
  id: string;
};

export type CreateSubjectMatterExpertInput = {
  id?: string | null;
  employeeId: string;
};

export type ModelSubjectMatterExpertConditionInput = {
  employeeId?: ModelIDInput | null;
  and?: Array<ModelSubjectMatterExpertConditionInput | null> | null;
  or?: Array<ModelSubjectMatterExpertConditionInput | null> | null;
  not?: ModelSubjectMatterExpertConditionInput | null;
};

export type SubjectMatterExpert = {
  __typename: 'SubjectMatterExpert';
  id: string;
  employeeId: string;
  employee?: Employee | null;
  competencies?: ModelSubjectMatterExpertCompetencyConnection | null;
  createdAt: string;
  updatedAt: string;
};

export type ModelSubjectMatterExpertCompetencyConnection = {
  __typename: 'ModelSubjectMatterExpertCompetencyConnection';
  items: Array<SubjectMatterExpertCompetency | null>;
  nextToken?: string | null;
};

export type SubjectMatterExpertCompetency = {
  __typename: 'SubjectMatterExpertCompetency';
  id: string;
  subjectMatterExpertId: string;
  competencyFieldId: string;
  competencyField?: CompetencyField | null;
  createdAt: string;
  updatedAt: string;
};

export type UpdateSubjectMatterExpertInput = {
  id: string;
  employeeId?: string | null;
};

export type DeleteSubjectMatterExpertInput = {
  id: string;
};

export type CreateSubjectMatterExpertCompetencyInput = {
  id?: string | null;
  subjectMatterExpertId: string;
  competencyFieldId: string;
};

export type ModelSubjectMatterExpertCompetencyConditionInput = {
  subjectMatterExpertId?: ModelIDInput | null;
  competencyFieldId?: ModelIDInput | null;
  and?: Array<ModelSubjectMatterExpertCompetencyConditionInput | null> | null;
  or?: Array<ModelSubjectMatterExpertCompetencyConditionInput | null> | null;
  not?: ModelSubjectMatterExpertCompetencyConditionInput | null;
};

export type UpdateSubjectMatterExpertCompetencyInput = {
  id: string;
  subjectMatterExpertId?: string | null;
  competencyFieldId?: string | null;
};

export type DeleteSubjectMatterExpertCompetencyInput = {
  id: string;
};

export type CreateRepositoryFolderInput = {
  id?: string | null;
  foldername?: string | null;
  parentId?: string | null;
};

export type ModelRepositoryFolderConditionInput = {
  foldername?: ModelStringInput | null;
  parentId?: ModelIDInput | null;
  and?: Array<ModelRepositoryFolderConditionInput | null> | null;
  or?: Array<ModelRepositoryFolderConditionInput | null> | null;
  not?: ModelRepositoryFolderConditionInput | null;
};

export type RepositoryFolder = {
  __typename: 'RepositoryFolder';
  id: string;
  files?: ModelRepositoryFileConnection | null;
  foldername?: string | null;
  parentId?: string | null;
  parent?: RepositoryFolder | null;
  replies?: ModelRepositoryFolderConnection | null;
  createdAt: string;
  updatedAt: string;
};

export type ModelRepositoryFileConnection = {
  __typename: 'ModelRepositoryFileConnection';
  items: Array<RepositoryFile | null>;
  nextToken?: string | null;
};

export type ModelRepositoryFolderConnection = {
  __typename: 'ModelRepositoryFolderConnection';
  items: Array<RepositoryFolder | null>;
  nextToken?: string | null;
};

export type UpdateRepositoryFolderInput = {
  id: string;
  foldername?: string | null;
  parentId?: string | null;
};

export type DeleteRepositoryFolderInput = {
  id: string;
};

export type CreateRepositoryFileInput = {
  id?: string | null;
  folderId: string;
  filename?: string | null;
  filetype?: FileMediaType | null;
  createdById: string;
};

export type ModelRepositoryFileConditionInput = {
  folderId?: ModelIDInput | null;
  filename?: ModelStringInput | null;
  filetype?: ModelFileMediaTypeInput | null;
  createdById?: ModelIDInput | null;
  and?: Array<ModelRepositoryFileConditionInput | null> | null;
  or?: Array<ModelRepositoryFileConditionInput | null> | null;
  not?: ModelRepositoryFileConditionInput | null;
};

export type ModelFileMediaTypeInput = {
  eq?: FileMediaType | null;
  ne?: FileMediaType | null;
};

export type UpdateRepositoryFileInput = {
  id: string;
  folderId?: string | null;
  filename?: string | null;
  filetype?: FileMediaType | null;
  createdById?: string | null;
};

export type DeleteRepositoryFileInput = {
  id: string;
};

export type CreateCommunityCategoryInput = {
  id?: string | null;
  category?: string | null;
};

export type ModelCommunityCategoryConditionInput = {
  category?: ModelStringInput | null;
  and?: Array<ModelCommunityCategoryConditionInput | null> | null;
  or?: Array<ModelCommunityCategoryConditionInput | null> | null;
  not?: ModelCommunityCategoryConditionInput | null;
};

export type CommunityCategory = {
  __typename: 'CommunityCategory';
  id: string;
  category?: string | null;
  createdAt: string;
  updatedAt: string;
};

export type UpdateCommunityCategoryInput = {
  id: string;
  category?: string | null;
};

export type DeleteCommunityCategoryInput = {
  id: string;
};

export type CreateCommunityInput = {
  id?: string | null;
  coverUrl?: string | null;
  profileUrl?: string | null;
  name: string;
  description: string;
  tags?: Array<string | null> | null;
  categoryId?: string | null;
  unitId?: string | null;
  knowledgeFocus?: Array<string | null> | null;
  objective?: Array<string | null> | null;
  kpi?: Array<string | null> | null;
  policy?: Array<string | null> | null;
  memberCanInvite: boolean;
  reviewNewPost: boolean;
  ownerId?: string | null;
  type: CommunityType;
};

export enum CommunityType {
  COI = 'COI',
  COP = 'COP',
}

export type ModelCommunityConditionInput = {
  coverUrl?: ModelStringInput | null;
  profileUrl?: ModelStringInput | null;
  name?: ModelStringInput | null;
  description?: ModelStringInput | null;
  tags?: ModelStringInput | null;
  categoryId?: ModelIDInput | null;
  unitId?: ModelIDInput | null;
  knowledgeFocus?: ModelStringInput | null;
  objective?: ModelStringInput | null;
  kpi?: ModelStringInput | null;
  policy?: ModelStringInput | null;
  memberCanInvite?: ModelBooleanInput | null;
  reviewNewPost?: ModelBooleanInput | null;
  ownerId?: ModelIDInput | null;
  type?: ModelCommunityTypeInput | null;
  and?: Array<ModelCommunityConditionInput | null> | null;
  or?: Array<ModelCommunityConditionInput | null> | null;
  not?: ModelCommunityConditionInput | null;
};

export type ModelCommunityTypeInput = {
  eq?: CommunityType | null;
  ne?: CommunityType | null;
};

export type Community = {
  __typename: 'Community';
  id: string;
  coverUrl?: string | null;
  profileUrl?: string | null;
  name: string;
  description: string;
  tags?: Array<string | null> | null;
  categoryId?: string | null;
  category?: CommunityCategory | null;
  unitId?: string | null;
  unit?: OrganizationUnit | null;
  knowledgeFocus?: Array<string | null> | null;
  objective?: Array<string | null> | null;
  kpi?: Array<string | null> | null;
  policy?: Array<string | null> | null;
  memberCanInvite: boolean;
  reviewNewPost: boolean;
  ownerId?: string | null;
  owner?: User | null;
  pendingCoreMembers?: ModelPendingCoreMemberConnection | null;
  coreMembers?: ModelCoreMemberConnection | null;
  followers?: ModelCommunityFollowersConnection | null;
  documentations?: ModelCommunityDocumentationConnection | null;
  posts?: ModelPostConnection | null;
  events?: ModelEventConnection | null;
  type: CommunityType;
  createdAt: string;
  updatedAt: string;
};

export type ModelPendingCoreMemberConnection = {
  __typename: 'ModelPendingCoreMemberConnection';
  items: Array<PendingCoreMember | null>;
  nextToken?: string | null;
};

export type PendingCoreMember = {
  __typename: 'PendingCoreMember';
  id: string;
  communityId?: string | null;
  employeeId?: string | null;
  employee?: Employee | null;
  createdAt: string;
  updatedAt: string;
};

export type ModelCoreMemberConnection = {
  __typename: 'ModelCoreMemberConnection';
  items: Array<CoreMember | null>;
  nextToken?: string | null;
};

export type CoreMember = {
  __typename: 'CoreMember';
  id: string;
  communityId?: string | null;
  employeeId?: string | null;
  employee?: Employee | null;
  createdAt: string;
  updatedAt: string;
};

export type ModelCommunityFollowersConnection = {
  __typename: 'ModelCommunityFollowersConnection';
  items: Array<CommunityFollowers | null>;
  nextToken?: string | null;
};

export type CommunityFollowers = {
  __typename: 'CommunityFollowers';
  id: string;
  communityId?: string | null;
  employeeId?: string | null;
  employee?: Employee | null;
  createdAt: string;
  updatedAt: string;
};

export type ModelCommunityDocumentationConnection = {
  __typename: 'ModelCommunityDocumentationConnection';
  items: Array<CommunityDocumentation | null>;
  nextToken?: string | null;
};

export type CommunityDocumentation = {
  __typename: 'CommunityDocumentation';
  id: string;
  communityId?: string | null;
  documentId?: string | null;
  document?: RepositoryFile | null;
  createdAt: string;
  updatedAt: string;
};

export type ModelPostConnection = {
  __typename: 'ModelPostConnection';
  items: Array<Post | null>;
  nextToken?: string | null;
};

export type Post = {
  __typename: 'Post';
  id: string;
  communityId?: string | null;
  creatorId?: string | null;
  creator?: Employee | null;
  content?: string | null;
  documentId?: string | null;
  eventId?: string | null;
  event?: Event | null;
  articleId?: string | null;
  article?: Article | null;
  surveyId?: string | null;
  survey?: Survey | null;
  approvedBy?: Employee | null;
  createdAt: string;
  updatedAt: string;
};

export type Event = {
  __typename: 'Event';
  id: string;
  eventId?: string | null;
  communityId?: string | null;
  community?: Community | null;
  owner?: string | null;
  profileUrl?: string | null;
  type: EventType;
  title: string;
  description?: string | null;
  about?: string | null;
  datetimeFrom?: string | null;
  datetimeTo?: string | null;
  externalLink?: string | null;
  location?: string | null;
  noteTakers?: ModelNoteTakersConnection | null;
  employeeSpeakers?: Array<Employee | null> | null;
  externalSpeakers?: Array<EventSpeaker | null> | null;
  committees?: ModelComitteeConnection | null;
  documentations?: ModelCommunityDocumentationConnection | null;
  attendeeIds?: ModelAttendeeConnection | null;
  messages?: ModelEventMessageConnection | null;
  createdAt: string;
  updatedAt: string;
};

export enum EventType {
  ONLINE = 'ONLINE',
  OFFLINE = 'OFFLINE',
}

export type ModelNoteTakersConnection = {
  __typename: 'ModelNoteTakersConnection';
  items: Array<NoteTakers | null>;
  nextToken?: string | null;
};

export type NoteTakers = {
  __typename: 'NoteTakers';
  id: string;
  eventId?: string | null;
  employeeId?: string | null;
  employee?: Employee | null;
  createdAt: string;
  updatedAt: string;
};

export type EventSpeaker = {
  __typename: 'EventSpeaker';
  id: string;
  name?: string | null;
  jobTitle?: string | null;
  company?: string | null;
  photo_url?: string | null;
  createdAt: string;
  updatedAt: string;
};

export type ModelComitteeConnection = {
  __typename: 'ModelComitteeConnection';
  items: Array<Comittee | null>;
  nextToken?: string | null;
};

export type Comittee = {
  __typename: 'Comittee';
  id: string;
  eventId?: string | null;
  employeeId?: string | null;
  employee?: Employee | null;
  createdAt: string;
  updatedAt: string;
};

export type ModelAttendeeConnection = {
  __typename: 'ModelAttendeeConnection';
  items: Array<Attendee | null>;
  nextToken?: string | null;
};

export type Attendee = {
  __typename: 'Attendee';
  id: string;
  employeeId?: string | null;
  employee?: Employee | null;
  createdAt: string;
  updatedAt: string;
};

export type ModelEventMessageConnection = {
  __typename: 'ModelEventMessageConnection';
  items: Array<EventMessage | null>;
  nextToken?: string | null;
};

export type EventMessage = {
  __typename: 'EventMessage';
  id: string;
  eventId?: string | null;
  from?: Employee | null;
  toId?: Employee | null;
  message?: string | null;
  parentId?: string | null;
  parent?: EventMessage | null;
  replies?: ModelEventMessageConnection | null;
  attachmentUrl?: string | null;
  createdAt: string;
  updatedAt: string;
};

export type Article = {
  __typename: 'Article';
  id: string;
  profileUrl?: string | null;
  status: ArticleStatus;
  owner?: User | null;
  title: string;
  content: string;
  createdAt?: string | null;
  createdBy?: User | null;
  updatedAt?: string | null;
  updatedBy?: User | null;
};

export enum ArticleStatus {
  DRAFT = 'DRAFT',
  PUBLISHED = 'PUBLISHED',
}

export type Survey = {
  __typename: 'Survey';
  id: string;
  name: string;
  datetimeStart?: string | null;
  datetimeEnd?: string | null;
  options?: ModelSurveyOptionConnection | null;
  createdAt: string;
  updatedAt: string;
};

export type ModelSurveyOptionConnection = {
  __typename: 'ModelSurveyOptionConnection';
  items: Array<SurveyOption | null>;
  nextToken?: string | null;
};

export type SurveyOption = {
  __typename: 'SurveyOption';
  id: string;
  surveyOptionId?: string | null;
  caption?: string | null;
  totalVote?: number | null;
  createdAt: string;
  updatedAt: string;
};

export type ModelEventConnection = {
  __typename: 'ModelEventConnection';
  items: Array<Event | null>;
  nextToken?: string | null;
};

export type UpdateCommunityInput = {
  id: string;
  coverUrl?: string | null;
  profileUrl?: string | null;
  name?: string | null;
  description?: string | null;
  tags?: Array<string | null> | null;
  categoryId?: string | null;
  unitId?: string | null;
  knowledgeFocus?: Array<string | null> | null;
  objective?: Array<string | null> | null;
  kpi?: Array<string | null> | null;
  policy?: Array<string | null> | null;
  memberCanInvite?: boolean | null;
  reviewNewPost?: boolean | null;
  ownerId?: string | null;
  type?: CommunityType | null;
};

export type DeleteCommunityInput = {
  id: string;
};

export type CreatePendingCoreMemberInput = {
  id?: string | null;
  communityId?: string | null;
  employeeId?: string | null;
};

export type ModelPendingCoreMemberConditionInput = {
  communityId?: ModelIDInput | null;
  employeeId?: ModelIDInput | null;
  and?: Array<ModelPendingCoreMemberConditionInput | null> | null;
  or?: Array<ModelPendingCoreMemberConditionInput | null> | null;
  not?: ModelPendingCoreMemberConditionInput | null;
};

export type UpdatePendingCoreMemberInput = {
  id: string;
  communityId?: string | null;
  employeeId?: string | null;
};

export type DeletePendingCoreMemberInput = {
  id: string;
};

export type CreateCoreMemberInput = {
  id?: string | null;
  communityId?: string | null;
  employeeId?: string | null;
};

export type ModelCoreMemberConditionInput = {
  communityId?: ModelIDInput | null;
  employeeId?: ModelIDInput | null;
  and?: Array<ModelCoreMemberConditionInput | null> | null;
  or?: Array<ModelCoreMemberConditionInput | null> | null;
  not?: ModelCoreMemberConditionInput | null;
};

export type UpdateCoreMemberInput = {
  id: string;
  communityId?: string | null;
  employeeId?: string | null;
};

export type DeleteCoreMemberInput = {
  id: string;
};

export type CreateCommunityFollowersInput = {
  id?: string | null;
  communityId?: string | null;
  employeeId?: string | null;
};

export type ModelCommunityFollowersConditionInput = {
  communityId?: ModelIDInput | null;
  employeeId?: ModelIDInput | null;
  and?: Array<ModelCommunityFollowersConditionInput | null> | null;
  or?: Array<ModelCommunityFollowersConditionInput | null> | null;
  not?: ModelCommunityFollowersConditionInput | null;
};

export type UpdateCommunityFollowersInput = {
  id: string;
  communityId?: string | null;
  employeeId?: string | null;
};

export type DeleteCommunityFollowersInput = {
  id: string;
};

export type CreateCommunityDocumentationInput = {
  id?: string | null;
  communityId?: string | null;
  documentId?: string | null;
};

export type ModelCommunityDocumentationConditionInput = {
  communityId?: ModelIDInput | null;
  documentId?: ModelIDInput | null;
  and?: Array<ModelCommunityDocumentationConditionInput | null> | null;
  or?: Array<ModelCommunityDocumentationConditionInput | null> | null;
  not?: ModelCommunityDocumentationConditionInput | null;
};

export type UpdateCommunityDocumentationInput = {
  id: string;
  communityId?: string | null;
  documentId?: string | null;
};

export type DeleteCommunityDocumentationInput = {
  id: string;
};

export type CreatePostInput = {
  id?: string | null;
  communityId?: string | null;
  creatorId?: string | null;
  content?: string | null;
  documentId?: string | null;
  eventId?: string | null;
  articleId?: string | null;
  surveyId?: string | null;
};

export type ModelPostConditionInput = {
  communityId?: ModelIDInput | null;
  creatorId?: ModelIDInput | null;
  content?: ModelStringInput | null;
  documentId?: ModelStringInput | null;
  eventId?: ModelIDInput | null;
  articleId?: ModelIDInput | null;
  surveyId?: ModelIDInput | null;
  and?: Array<ModelPostConditionInput | null> | null;
  or?: Array<ModelPostConditionInput | null> | null;
  not?: ModelPostConditionInput | null;
};

export type UpdatePostInput = {
  id: string;
  communityId?: string | null;
  creatorId?: string | null;
  content?: string | null;
  documentId?: string | null;
  eventId?: string | null;
  articleId?: string | null;
  surveyId?: string | null;
};

export type DeletePostInput = {
  id: string;
};

export type CreateEventInput = {
  id?: string | null;
  eventId?: string | null;
  communityId?: string | null;
  owner?: string | null;
  profileUrl?: string | null;
  type: EventType;
  title: string;
  description?: string | null;
  about?: string | null;
  datetimeFrom?: string | null;
  datetimeTo?: string | null;
  externalLink?: string | null;
  location?: string | null;
};

export type ModelEventConditionInput = {
  eventId?: ModelIDInput | null;
  communityId?: ModelIDInput | null;
  owner?: ModelStringInput | null;
  profileUrl?: ModelStringInput | null;
  type?: ModelEventTypeInput | null;
  title?: ModelStringInput | null;
  description?: ModelStringInput | null;
  about?: ModelStringInput | null;
  datetimeFrom?: ModelStringInput | null;
  datetimeTo?: ModelStringInput | null;
  externalLink?: ModelStringInput | null;
  location?: ModelStringInput | null;
  and?: Array<ModelEventConditionInput | null> | null;
  or?: Array<ModelEventConditionInput | null> | null;
  not?: ModelEventConditionInput | null;
};

export type ModelEventTypeInput = {
  eq?: EventType | null;
  ne?: EventType | null;
};

export type UpdateEventInput = {
  id: string;
  eventId?: string | null;
  communityId?: string | null;
  owner?: string | null;
  profileUrl?: string | null;
  type?: EventType | null;
  title?: string | null;
  description?: string | null;
  about?: string | null;
  datetimeFrom?: string | null;
  datetimeTo?: string | null;
  externalLink?: string | null;
  location?: string | null;
};

export type DeleteEventInput = {
  id: string;
};

export type CreateNoteTakersInput = {
  id?: string | null;
  eventId?: string | null;
  employeeId?: string | null;
};

export type ModelNoteTakersConditionInput = {
  eventId?: ModelIDInput | null;
  employeeId?: ModelIDInput | null;
  and?: Array<ModelNoteTakersConditionInput | null> | null;
  or?: Array<ModelNoteTakersConditionInput | null> | null;
  not?: ModelNoteTakersConditionInput | null;
};

export type UpdateNoteTakersInput = {
  id: string;
  eventId?: string | null;
  employeeId?: string | null;
};

export type DeleteNoteTakersInput = {
  id: string;
};

export type CreateComitteeInput = {
  id?: string | null;
  eventId?: string | null;
  employeeId?: string | null;
};

export type ModelComitteeConditionInput = {
  eventId?: ModelIDInput | null;
  employeeId?: ModelIDInput | null;
  and?: Array<ModelComitteeConditionInput | null> | null;
  or?: Array<ModelComitteeConditionInput | null> | null;
  not?: ModelComitteeConditionInput | null;
};

export type UpdateComitteeInput = {
  id: string;
  eventId?: string | null;
  employeeId?: string | null;
};

export type DeleteComitteeInput = {
  id: string;
};

export type CreateAttendeeInput = {
  id?: string | null;
  employeeId?: string | null;
};

export type ModelAttendeeConditionInput = {
  employeeId?: ModelIDInput | null;
  and?: Array<ModelAttendeeConditionInput | null> | null;
  or?: Array<ModelAttendeeConditionInput | null> | null;
  not?: ModelAttendeeConditionInput | null;
};

export type UpdateAttendeeInput = {
  id: string;
  employeeId?: string | null;
};

export type DeleteAttendeeInput = {
  id: string;
};

export type CreateEmployeeSpeakerInput = {
  id?: string | null;
  employeeId?: string | null;
};

export type ModelEmployeeSpeakerConditionInput = {
  employeeId?: ModelIDInput | null;
  and?: Array<ModelEmployeeSpeakerConditionInput | null> | null;
  or?: Array<ModelEmployeeSpeakerConditionInput | null> | null;
  not?: ModelEmployeeSpeakerConditionInput | null;
};

export type EmployeeSpeaker = {
  __typename: 'EmployeeSpeaker';
  id: string;
  employeeId?: string | null;
  employe?: Employee | null;
  createdAt: string;
  updatedAt: string;
};

export type UpdateEmployeeSpeakerInput = {
  id: string;
  employeeId?: string | null;
};

export type DeleteEmployeeSpeakerInput = {
  id: string;
};

export type CreateEventSpeakerInput = {
  id?: string | null;
  name?: string | null;
  jobTitle?: string | null;
  company?: string | null;
  photo_url?: string | null;
};

export type ModelEventSpeakerConditionInput = {
  name?: ModelStringInput | null;
  jobTitle?: ModelStringInput | null;
  company?: ModelStringInput | null;
  photo_url?: ModelStringInput | null;
  and?: Array<ModelEventSpeakerConditionInput | null> | null;
  or?: Array<ModelEventSpeakerConditionInput | null> | null;
  not?: ModelEventSpeakerConditionInput | null;
};

export type UpdateEventSpeakerInput = {
  id: string;
  name?: string | null;
  jobTitle?: string | null;
  company?: string | null;
  photo_url?: string | null;
};

export type DeleteEventSpeakerInput = {
  id: string;
};

export type CreateEventMessageInput = {
  id?: string | null;
  eventId?: string | null;
  message?: string | null;
  parentId?: string | null;
  attachmentUrl?: string | null;
};

export type ModelEventMessageConditionInput = {
  eventId?: ModelIDInput | null;
  message?: ModelStringInput | null;
  parentId?: ModelIDInput | null;
  attachmentUrl?: ModelStringInput | null;
  and?: Array<ModelEventMessageConditionInput | null> | null;
  or?: Array<ModelEventMessageConditionInput | null> | null;
  not?: ModelEventMessageConditionInput | null;
};

export type UpdateEventMessageInput = {
  id: string;
  eventId?: string | null;
  message?: string | null;
  parentId?: string | null;
  attachmentUrl?: string | null;
};

export type DeleteEventMessageInput = {
  id: string;
};

export type CreateArticleInput = {
  id?: string | null;
  profileUrl?: string | null;
  status: ArticleStatus;
  title: string;
  content: string;
  createdAt?: string | null;
  updatedAt?: string | null;
};

export type ModelArticleConditionInput = {
  profileUrl?: ModelStringInput | null;
  status?: ModelArticleStatusInput | null;
  title?: ModelStringInput | null;
  content?: ModelStringInput | null;
  createdAt?: ModelStringInput | null;
  updatedAt?: ModelStringInput | null;
  and?: Array<ModelArticleConditionInput | null> | null;
  or?: Array<ModelArticleConditionInput | null> | null;
  not?: ModelArticleConditionInput | null;
};

export type ModelArticleStatusInput = {
  eq?: ArticleStatus | null;
  ne?: ArticleStatus | null;
};

export type UpdateArticleInput = {
  id: string;
  profileUrl?: string | null;
  status?: ArticleStatus | null;
  title?: string | null;
  content?: string | null;
  createdAt?: string | null;
  updatedAt?: string | null;
};

export type DeleteArticleInput = {
  id: string;
};

export type CreateSurveyInput = {
  id?: string | null;
  name: string;
  datetimeStart?: string | null;
  datetimeEnd?: string | null;
};

export type ModelSurveyConditionInput = {
  name?: ModelStringInput | null;
  datetimeStart?: ModelStringInput | null;
  datetimeEnd?: ModelStringInput | null;
  and?: Array<ModelSurveyConditionInput | null> | null;
  or?: Array<ModelSurveyConditionInput | null> | null;
  not?: ModelSurveyConditionInput | null;
};

export type UpdateSurveyInput = {
  id: string;
  name?: string | null;
  datetimeStart?: string | null;
  datetimeEnd?: string | null;
};

export type DeleteSurveyInput = {
  id: string;
};

export type CreateSurveyOptionInput = {
  id?: string | null;
  surveyOptionId?: string | null;
  caption?: string | null;
  totalVote?: number | null;
};

export type ModelSurveyOptionConditionInput = {
  surveyOptionId?: ModelIDInput | null;
  caption?: ModelStringInput | null;
  totalVote?: ModelIntInput | null;
  and?: Array<ModelSurveyOptionConditionInput | null> | null;
  or?: Array<ModelSurveyOptionConditionInput | null> | null;
  not?: ModelSurveyOptionConditionInput | null;
};

export type UpdateSurveyOptionInput = {
  id: string;
  surveyOptionId?: string | null;
  caption?: string | null;
  totalVote?: number | null;
};

export type DeleteSurveyOptionInput = {
  id: string;
};

export type ModelOrganizationFilterInput = {
  id?: ModelIDInput | null;
  name?: ModelStringInput | null;
  address?: ModelStringInput | null;
  and?: Array<ModelOrganizationFilterInput | null> | null;
  or?: Array<ModelOrganizationFilterInput | null> | null;
  not?: ModelOrganizationFilterInput | null;
};

export type ModelOrganizationConnection = {
  __typename: 'ModelOrganizationConnection';
  items: Array<Organization | null>;
  nextToken?: string | null;
};

export type ModelEmployeeFilterInput = {
  id?: ModelIDInput | null;
  organizationId?: ModelIDInput | null;
  organizationUnitId?: ModelIDInput | null;
  userId?: ModelIDInput | null;
  nik?: ModelStringInput | null;
  status?: ModelEmploymentStatusInput | null;
  domicile?: ModelStringInput | null;
  managerId?: ModelIDInput | null;
  and?: Array<ModelEmployeeFilterInput | null> | null;
  or?: Array<ModelEmployeeFilterInput | null> | null;
  not?: ModelEmployeeFilterInput | null;
};

export type ModelEmployeeJobTitleFilterInput = {
  id?: ModelIDInput | null;
  employeeId?: ModelIDInput | null;
  jobTitleId?: ModelIDInput | null;
  and?: Array<ModelEmployeeJobTitleFilterInput | null> | null;
  or?: Array<ModelEmployeeJobTitleFilterInput | null> | null;
  not?: ModelEmployeeJobTitleFilterInput | null;
};

export type ModelObjectiveFilterInput = {
  id?: ModelIDInput | null;
  ownerId?: ModelIDInput | null;
  title?: ModelStringInput | null;
  description?: ModelStringInput | null;
  and?: Array<ModelObjectiveFilterInput | null> | null;
  or?: Array<ModelObjectiveFilterInput | null> | null;
  not?: ModelObjectiveFilterInput | null;
};

export type ModelUserFilterInput = {
  id?: ModelIDInput | null;
  username?: ModelStringInput | null;
  name?: ModelStringInput | null;
  email?: ModelStringInput | null;
  and?: Array<ModelUserFilterInput | null> | null;
  or?: Array<ModelUserFilterInput | null> | null;
  not?: ModelUserFilterInput | null;
};

export type ModelUserConnection = {
  __typename: 'ModelUserConnection';
  items: Array<User | null>;
  nextToken?: string | null;
};

export type ModelJobTitleFilterInput = {
  id?: ModelIDInput | null;
  organizationUnitId?: ModelIDInput | null;
  title?: ModelStringInput | null;
  and?: Array<ModelJobTitleFilterInput | null> | null;
  or?: Array<ModelJobTitleFilterInput | null> | null;
  not?: ModelJobTitleFilterInput | null;
};

export type ModelJobTitleConnection = {
  __typename: 'ModelJobTitleConnection';
  items: Array<JobTitle | null>;
  nextToken?: string | null;
};

export type ModelOrganizationUnitFilterInput = {
  id?: ModelIDInput | null;
  organizationId?: ModelIDInput | null;
  name?: ModelStringInput | null;
  parentId?: ModelIDInput | null;
  and?: Array<ModelOrganizationUnitFilterInput | null> | null;
  or?: Array<ModelOrganizationUnitFilterInput | null> | null;
  not?: ModelOrganizationUnitFilterInput | null;
};

export type ModelSocialMediaFilterInput = {
  id?: ModelIDInput | null;
  name?: ModelStringInput | null;
  url?: ModelStringInput | null;
  iconUrl?: ModelStringInput | null;
  and?: Array<ModelSocialMediaFilterInput | null> | null;
  or?: Array<ModelSocialMediaFilterInput | null> | null;
  not?: ModelSocialMediaFilterInput | null;
};

export type ModelSocialMediaConnection = {
  __typename: 'ModelSocialMediaConnection';
  items: Array<SocialMedia | null>;
  nextToken?: string | null;
};

export type ModelEmployeeSocialMediaFilterInput = {
  id?: ModelIDInput | null;
  employeeId?: ModelIDInput | null;
  socialMediaId?: ModelIDInput | null;
  username?: ModelStringInput | null;
  and?: Array<ModelEmployeeSocialMediaFilterInput | null> | null;
  or?: Array<ModelEmployeeSocialMediaFilterInput | null> | null;
  not?: ModelEmployeeSocialMediaFilterInput | null;
};

export type ModelEmployeePositionHistoryFilterInput = {
  id?: ModelIDInput | null;
  employeeId?: ModelIDInput | null;
  dateFrom?: ModelStringInput | null;
  dateUntil?: ModelStringInput | null;
  officeName?: ModelStringInput | null;
  location?: ModelStringInput | null;
  description?: ModelStringInput | null;
  internalPosition?: ModelBooleanInput | null;
  and?: Array<ModelEmployeePositionHistoryFilterInput | null> | null;
  or?: Array<ModelEmployeePositionHistoryFilterInput | null> | null;
  not?: ModelEmployeePositionHistoryFilterInput | null;
};

export type ModelEmployeeEducationHistoryFilterInput = {
  id?: ModelIDInput | null;
  employeeId?: ModelIDInput | null;
  schoolName?: ModelStringInput | null;
  entryYear?: ModelIntInput | null;
  graduationYear?: ModelIntInput | null;
  and?: Array<ModelEmployeeEducationHistoryFilterInput | null> | null;
  or?: Array<ModelEmployeeEducationHistoryFilterInput | null> | null;
  not?: ModelEmployeeEducationHistoryFilterInput | null;
};

export type ModelEmployeeAssignmentHistoryFilterInput = {
  id?: ModelIDInput | null;
  employeeId?: ModelIDInput | null;
  dateFrom?: ModelStringInput | null;
  dateUntil?: ModelStringInput | null;
  officeName?: ModelStringInput | null;
  location?: ModelStringInput | null;
  description?: ModelStringInput | null;
  bodRelated?: ModelBooleanInput | null;
  and?: Array<ModelEmployeeAssignmentHistoryFilterInput | null> | null;
  or?: Array<ModelEmployeeAssignmentHistoryFilterInput | null> | null;
  not?: ModelEmployeeAssignmentHistoryFilterInput | null;
};

export type ModelEmployeeActivityFilterInput = {
  id?: ModelIDInput | null;
  employeeId?: ModelIDInput | null;
  activityId?: ModelIDInput | null;
  point?: ModelIntInput | null;
  datetime?: ModelStringInput | null;
  and?: Array<ModelEmployeeActivityFilterInput | null> | null;
  or?: Array<ModelEmployeeActivityFilterInput | null> | null;
  not?: ModelEmployeeActivityFilterInput | null;
};

export type ModelEmployeeBadgeFilterInput = {
  id?: ModelIDInput | null;
  employeeId?: ModelIDInput | null;
  badgeId?: ModelIDInput | null;
  grantDate?: ModelStringInput | null;
  grantedById?: ModelIDInput | null;
  and?: Array<ModelEmployeeBadgeFilterInput | null> | null;
  or?: Array<ModelEmployeeBadgeFilterInput | null> | null;
  not?: ModelEmployeeBadgeFilterInput | null;
};

export type ModelEmployeeSkillFilterInput = {
  id?: ModelIDInput | null;
  employeeId?: ModelIDInput | null;
  skillGroup?: ModelStringInput | null;
  skill?: ModelStringInput | null;
  name?: ModelStringInput | null;
  level?: ModelSkillLevelInput | null;
  progress?: ModelIntInput | null;
  and?: Array<ModelEmployeeSkillFilterInput | null> | null;
  or?: Array<ModelEmployeeSkillFilterInput | null> | null;
  not?: ModelEmployeeSkillFilterInput | null;
};

export type ModelEmployeeTrainingFilterInput = {
  id?: ModelIDInput | null;
  employeeId?: ModelIDInput | null;
  date?: ModelStringInput | null;
  name?: ModelStringInput | null;
  description?: ModelStringInput | null;
  type?: ModelTrainingTypeInput | null;
  and?: Array<ModelEmployeeTrainingFilterInput | null> | null;
  or?: Array<ModelEmployeeTrainingFilterInput | null> | null;
  not?: ModelEmployeeTrainingFilterInput | null;
};

export type ModelEmployeeRewardFilterInput = {
  id?: ModelIDInput | null;
  employeeId?: ModelIDInput | null;
  date?: ModelStringInput | null;
  name?: ModelStringInput | null;
  description?: ModelStringInput | null;
  type?: ModelRewardTypeInput | null;
  and?: Array<ModelEmployeeRewardFilterInput | null> | null;
  or?: Array<ModelEmployeeRewardFilterInput | null> | null;
  not?: ModelEmployeeRewardFilterInput | null;
};

export type ModelActivityFilterInput = {
  id?: ModelIDInput | null;
  name?: ModelStringInput | null;
  point?: ModelIntInput | null;
  and?: Array<ModelActivityFilterInput | null> | null;
  or?: Array<ModelActivityFilterInput | null> | null;
  not?: ModelActivityFilterInput | null;
};

export type ModelActivityConnection = {
  __typename: 'ModelActivityConnection';
  items: Array<Activity | null>;
  nextToken?: string | null;
};

export type ModelBadgeFilterInput = {
  id?: ModelIDInput | null;
  name?: ModelStringInput | null;
  iconUrl?: ModelStringInput | null;
  and?: Array<ModelBadgeFilterInput | null> | null;
  or?: Array<ModelBadgeFilterInput | null> | null;
  not?: ModelBadgeFilterInput | null;
};

export type ModelBadgeConnection = {
  __typename: 'ModelBadgeConnection';
  items: Array<Badge | null>;
  nextToken?: string | null;
};

export type ModelKnowledgeMapFilterInput = {
  id?: ModelIDInput | null;
  name?: ModelStringInput | null;
  ownerId?: ModelIDInput | null;
  and?: Array<ModelKnowledgeMapFilterInput | null> | null;
  or?: Array<ModelKnowledgeMapFilterInput | null> | null;
  not?: ModelKnowledgeMapFilterInput | null;
};

export type ModelKnowledgeMapConnection = {
  __typename: 'ModelKnowledgeMapConnection';
  items: Array<KnowledgeMap | null>;
  nextToken?: string | null;
};

export type ModelKnowledgeMapCollaboratorFilterInput = {
  id?: ModelIDInput | null;
  employeeId?: ModelIDInput | null;
  knowledgeMapId?: ModelIDInput | null;
  and?: Array<ModelKnowledgeMapCollaboratorFilterInput | null> | null;
  or?: Array<ModelKnowledgeMapCollaboratorFilterInput | null> | null;
  not?: ModelKnowledgeMapCollaboratorFilterInput | null;
};

export type ModelBusinessProcessFilterInput = {
  id?: ModelIDInput | null;
  knowledgeMapId?: ModelIDInput | null;
  title?: ModelStringInput | null;
  description?: ModelStringInput | null;
  and?: Array<ModelBusinessProcessFilterInput | null> | null;
  or?: Array<ModelBusinessProcessFilterInput | null> | null;
  not?: ModelBusinessProcessFilterInput | null;
};

export type ModelBusinessProcessCommentFilterInput = {
  id?: ModelIDInput | null;
  businessProcessId?: ModelIDInput | null;
  comment?: ModelStringInput | null;
  createdById?: ModelIDInput | null;
  parentId?: ModelIDInput | null;
  and?: Array<ModelBusinessProcessCommentFilterInput | null> | null;
  or?: Array<ModelBusinessProcessCommentFilterInput | null> | null;
  not?: ModelBusinessProcessCommentFilterInput | null;
};

export type ModelStrategicActivityFilterInput = {
  id?: ModelIDInput | null;
  businessProcessId?: ModelIDInput | null;
  title?: ModelStringInput | null;
  description?: ModelStringInput | null;
  and?: Array<ModelStrategicActivityFilterInput | null> | null;
  or?: Array<ModelStrategicActivityFilterInput | null> | null;
  not?: ModelStrategicActivityFilterInput | null;
};

export type ModelStrategicActivityCommentFilterInput = {
  id?: ModelIDInput | null;
  strategicActivityId?: ModelIDInput | null;
  comment?: ModelStringInput | null;
  createdById?: ModelIDInput | null;
  parentId?: ModelIDInput | null;
  and?: Array<ModelStrategicActivityCommentFilterInput | null> | null;
  or?: Array<ModelStrategicActivityCommentFilterInput | null> | null;
  not?: ModelStrategicActivityCommentFilterInput | null;
};

export type ModelImportantKnowledgeFilterInput = {
  id?: ModelIDInput | null;
  strategicActivityId?: ModelIDInput | null;
  title?: ModelStringInput | null;
  description?: ModelStringInput | null;
  and?: Array<ModelImportantKnowledgeFilterInput | null> | null;
  or?: Array<ModelImportantKnowledgeFilterInput | null> | null;
  not?: ModelImportantKnowledgeFilterInput | null;
};

export type ModelImportantKnowledgeCommentFilterInput = {
  id?: ModelIDInput | null;
  importantKnowledgeId?: ModelIDInput | null;
  comment?: ModelStringInput | null;
  createdById?: ModelIDInput | null;
  parentId?: ModelIDInput | null;
  and?: Array<ModelImportantKnowledgeCommentFilterInput | null> | null;
  or?: Array<ModelImportantKnowledgeCommentFilterInput | null> | null;
  not?: ModelImportantKnowledgeCommentFilterInput | null;
};

export type ModelImportantKnowledgeDocumentFilterInput = {
  id?: ModelIDInput | null;
  importantKnowledgeId?: ModelIDInput | null;
  documentType?: ModelImportantKnowledgeDocumentTypeInput | null;
  documentId?: ModelIDInput | null;
  creatorId?: ModelIDInput | null;
  and?: Array<ModelImportantKnowledgeDocumentFilterInput | null> | null;
  or?: Array<ModelImportantKnowledgeDocumentFilterInput | null> | null;
  not?: ModelImportantKnowledgeDocumentFilterInput | null;
};

export type ModelCompetencyFieldFilterInput = {
  id?: ModelIDInput | null;
  name?: ModelStringInput | null;
  and?: Array<ModelCompetencyFieldFilterInput | null> | null;
  or?: Array<ModelCompetencyFieldFilterInput | null> | null;
  not?: ModelCompetencyFieldFilterInput | null;
};

export type ModelCompetencyFieldConnection = {
  __typename: 'ModelCompetencyFieldConnection';
  items: Array<CompetencyField | null>;
  nextToken?: string | null;
};

export type ModelSubjectMatterExpertFilterInput = {
  id?: ModelIDInput | null;
  employeeId?: ModelIDInput | null;
  and?: Array<ModelSubjectMatterExpertFilterInput | null> | null;
  or?: Array<ModelSubjectMatterExpertFilterInput | null> | null;
  not?: ModelSubjectMatterExpertFilterInput | null;
};

export type ModelSubjectMatterExpertConnection = {
  __typename: 'ModelSubjectMatterExpertConnection';
  items: Array<SubjectMatterExpert | null>;
  nextToken?: string | null;
};

export type ModelSubjectMatterExpertCompetencyFilterInput = {
  id?: ModelIDInput | null;
  subjectMatterExpertId?: ModelIDInput | null;
  competencyFieldId?: ModelIDInput | null;
  and?: Array<ModelSubjectMatterExpertCompetencyFilterInput | null> | null;
  or?: Array<ModelSubjectMatterExpertCompetencyFilterInput | null> | null;
  not?: ModelSubjectMatterExpertCompetencyFilterInput | null;
};

export type ModelRepositoryFolderFilterInput = {
  id?: ModelIDInput | null;
  foldername?: ModelStringInput | null;
  parentId?: ModelIDInput | null;
  and?: Array<ModelRepositoryFolderFilterInput | null> | null;
  or?: Array<ModelRepositoryFolderFilterInput | null> | null;
  not?: ModelRepositoryFolderFilterInput | null;
};

export type ModelRepositoryFileFilterInput = {
  id?: ModelIDInput | null;
  folderId?: ModelIDInput | null;
  filename?: ModelStringInput | null;
  filetype?: ModelFileMediaTypeInput | null;
  createdById?: ModelIDInput | null;
  and?: Array<ModelRepositoryFileFilterInput | null> | null;
  or?: Array<ModelRepositoryFileFilterInput | null> | null;
  not?: ModelRepositoryFileFilterInput | null;
};

export type ModelCommunityCategoryFilterInput = {
  id?: ModelIDInput | null;
  category?: ModelStringInput | null;
  and?: Array<ModelCommunityCategoryFilterInput | null> | null;
  or?: Array<ModelCommunityCategoryFilterInput | null> | null;
  not?: ModelCommunityCategoryFilterInput | null;
};

export type ModelCommunityCategoryConnection = {
  __typename: 'ModelCommunityCategoryConnection';
  items: Array<CommunityCategory | null>;
  nextToken?: string | null;
};

export type ModelCommunityFilterInput = {
  id?: ModelIDInput | null;
  coverUrl?: ModelStringInput | null;
  profileUrl?: ModelStringInput | null;
  name?: ModelStringInput | null;
  description?: ModelStringInput | null;
  tags?: ModelStringInput | null;
  categoryId?: ModelIDInput | null;
  unitId?: ModelIDInput | null;
  knowledgeFocus?: ModelStringInput | null;
  objective?: ModelStringInput | null;
  kpi?: ModelStringInput | null;
  policy?: ModelStringInput | null;
  memberCanInvite?: ModelBooleanInput | null;
  reviewNewPost?: ModelBooleanInput | null;
  ownerId?: ModelIDInput | null;
  type?: ModelCommunityTypeInput | null;
  and?: Array<ModelCommunityFilterInput | null> | null;
  or?: Array<ModelCommunityFilterInput | null> | null;
  not?: ModelCommunityFilterInput | null;
};

export type ModelCommunityConnection = {
  __typename: 'ModelCommunityConnection';
  items: Array<Community | null>;
  nextToken?: string | null;
};

export type ModelPendingCoreMemberFilterInput = {
  id?: ModelIDInput | null;
  communityId?: ModelIDInput | null;
  employeeId?: ModelIDInput | null;
  and?: Array<ModelPendingCoreMemberFilterInput | null> | null;
  or?: Array<ModelPendingCoreMemberFilterInput | null> | null;
  not?: ModelPendingCoreMemberFilterInput | null;
};

export type ModelCoreMemberFilterInput = {
  id?: ModelIDInput | null;
  communityId?: ModelIDInput | null;
  employeeId?: ModelIDInput | null;
  and?: Array<ModelCoreMemberFilterInput | null> | null;
  or?: Array<ModelCoreMemberFilterInput | null> | null;
  not?: ModelCoreMemberFilterInput | null;
};

export type ModelCommunityFollowersFilterInput = {
  id?: ModelIDInput | null;
  communityId?: ModelIDInput | null;
  employeeId?: ModelIDInput | null;
  and?: Array<ModelCommunityFollowersFilterInput | null> | null;
  or?: Array<ModelCommunityFollowersFilterInput | null> | null;
  not?: ModelCommunityFollowersFilterInput | null;
};

export type ModelCommunityDocumentationFilterInput = {
  id?: ModelIDInput | null;
  communityId?: ModelIDInput | null;
  documentId?: ModelIDInput | null;
  and?: Array<ModelCommunityDocumentationFilterInput | null> | null;
  or?: Array<ModelCommunityDocumentationFilterInput | null> | null;
  not?: ModelCommunityDocumentationFilterInput | null;
};

export type ModelPostFilterInput = {
  id?: ModelIDInput | null;
  communityId?: ModelIDInput | null;
  creatorId?: ModelIDInput | null;
  content?: ModelStringInput | null;
  documentId?: ModelStringInput | null;
  eventId?: ModelIDInput | null;
  articleId?: ModelIDInput | null;
  surveyId?: ModelIDInput | null;
  and?: Array<ModelPostFilterInput | null> | null;
  or?: Array<ModelPostFilterInput | null> | null;
  not?: ModelPostFilterInput | null;
};

export type ModelEventFilterInput = {
  id?: ModelIDInput | null;
  eventId?: ModelIDInput | null;
  communityId?: ModelIDInput | null;
  owner?: ModelStringInput | null;
  profileUrl?: ModelStringInput | null;
  type?: ModelEventTypeInput | null;
  title?: ModelStringInput | null;
  description?: ModelStringInput | null;
  about?: ModelStringInput | null;
  datetimeFrom?: ModelStringInput | null;
  datetimeTo?: ModelStringInput | null;
  externalLink?: ModelStringInput | null;
  location?: ModelStringInput | null;
  and?: Array<ModelEventFilterInput | null> | null;
  or?: Array<ModelEventFilterInput | null> | null;
  not?: ModelEventFilterInput | null;
};

export type ModelNoteTakersFilterInput = {
  id?: ModelIDInput | null;
  eventId?: ModelIDInput | null;
  employeeId?: ModelIDInput | null;
  and?: Array<ModelNoteTakersFilterInput | null> | null;
  or?: Array<ModelNoteTakersFilterInput | null> | null;
  not?: ModelNoteTakersFilterInput | null;
};

export type ModelComitteeFilterInput = {
  id?: ModelIDInput | null;
  eventId?: ModelIDInput | null;
  employeeId?: ModelIDInput | null;
  and?: Array<ModelComitteeFilterInput | null> | null;
  or?: Array<ModelComitteeFilterInput | null> | null;
  not?: ModelComitteeFilterInput | null;
};

export type ModelAttendeeFilterInput = {
  id?: ModelIDInput | null;
  employeeId?: ModelIDInput | null;
  and?: Array<ModelAttendeeFilterInput | null> | null;
  or?: Array<ModelAttendeeFilterInput | null> | null;
  not?: ModelAttendeeFilterInput | null;
};

export type ModelEmployeeSpeakerFilterInput = {
  id?: ModelIDInput | null;
  employeeId?: ModelIDInput | null;
  and?: Array<ModelEmployeeSpeakerFilterInput | null> | null;
  or?: Array<ModelEmployeeSpeakerFilterInput | null> | null;
  not?: ModelEmployeeSpeakerFilterInput | null;
};

export type ModelEmployeeSpeakerConnection = {
  __typename: 'ModelEmployeeSpeakerConnection';
  items: Array<EmployeeSpeaker | null>;
  nextToken?: string | null;
};

export type ModelEventSpeakerFilterInput = {
  id?: ModelIDInput | null;
  name?: ModelStringInput | null;
  jobTitle?: ModelStringInput | null;
  company?: ModelStringInput | null;
  photo_url?: ModelStringInput | null;
  and?: Array<ModelEventSpeakerFilterInput | null> | null;
  or?: Array<ModelEventSpeakerFilterInput | null> | null;
  not?: ModelEventSpeakerFilterInput | null;
};

export type ModelEventSpeakerConnection = {
  __typename: 'ModelEventSpeakerConnection';
  items: Array<EventSpeaker | null>;
  nextToken?: string | null;
};

export type ModelEventMessageFilterInput = {
  id?: ModelIDInput | null;
  eventId?: ModelIDInput | null;
  message?: ModelStringInput | null;
  parentId?: ModelIDInput | null;
  attachmentUrl?: ModelStringInput | null;
  and?: Array<ModelEventMessageFilterInput | null> | null;
  or?: Array<ModelEventMessageFilterInput | null> | null;
  not?: ModelEventMessageFilterInput | null;
};

export type ModelArticleFilterInput = {
  id?: ModelIDInput | null;
  profileUrl?: ModelStringInput | null;
  status?: ModelArticleStatusInput | null;
  title?: ModelStringInput | null;
  content?: ModelStringInput | null;
  createdAt?: ModelStringInput | null;
  updatedAt?: ModelStringInput | null;
  and?: Array<ModelArticleFilterInput | null> | null;
  or?: Array<ModelArticleFilterInput | null> | null;
  not?: ModelArticleFilterInput | null;
};

export type ModelArticleConnection = {
  __typename: 'ModelArticleConnection';
  items: Array<Article | null>;
  nextToken?: string | null;
};

export type ModelSurveyFilterInput = {
  id?: ModelIDInput | null;
  name?: ModelStringInput | null;
  datetimeStart?: ModelStringInput | null;
  datetimeEnd?: ModelStringInput | null;
  and?: Array<ModelSurveyFilterInput | null> | null;
  or?: Array<ModelSurveyFilterInput | null> | null;
  not?: ModelSurveyFilterInput | null;
};

export type ModelSurveyConnection = {
  __typename: 'ModelSurveyConnection';
  items: Array<Survey | null>;
  nextToken?: string | null;
};

export type ModelSurveyOptionFilterInput = {
  id?: ModelIDInput | null;
  surveyOptionId?: ModelIDInput | null;
  caption?: ModelStringInput | null;
  totalVote?: ModelIntInput | null;
  and?: Array<ModelSurveyOptionFilterInput | null> | null;
  or?: Array<ModelSurveyOptionFilterInput | null> | null;
  not?: ModelSurveyOptionFilterInput | null;
};

export enum ModelSortDirection {
  ASC = 'ASC',
  DESC = 'DESC',
}

export type ModelSubscriptionOrganizationFilterInput = {
  id?: ModelSubscriptionIDInput | null;
  name?: ModelSubscriptionStringInput | null;
  address?: ModelSubscriptionStringInput | null;
  and?: Array<ModelSubscriptionOrganizationFilterInput | null> | null;
  or?: Array<ModelSubscriptionOrganizationFilterInput | null> | null;
};

export type ModelSubscriptionIDInput = {
  ne?: string | null;
  eq?: string | null;
  le?: string | null;
  lt?: string | null;
  ge?: string | null;
  gt?: string | null;
  contains?: string | null;
  notContains?: string | null;
  between?: Array<string | null> | null;
  beginsWith?: string | null;
  in?: Array<string | null> | null;
  notIn?: Array<string | null> | null;
};

export type ModelSubscriptionStringInput = {
  ne?: string | null;
  eq?: string | null;
  le?: string | null;
  lt?: string | null;
  ge?: string | null;
  gt?: string | null;
  contains?: string | null;
  notContains?: string | null;
  between?: Array<string | null> | null;
  beginsWith?: string | null;
  in?: Array<string | null> | null;
  notIn?: Array<string | null> | null;
};

export type ModelSubscriptionEmployeeFilterInput = {
  id?: ModelSubscriptionIDInput | null;
  organizationId?: ModelSubscriptionIDInput | null;
  organizationUnitId?: ModelSubscriptionIDInput | null;
  userId?: ModelSubscriptionIDInput | null;
  nik?: ModelSubscriptionStringInput | null;
  status?: ModelSubscriptionStringInput | null;
  domicile?: ModelSubscriptionStringInput | null;
  managerId?: ModelSubscriptionIDInput | null;
  and?: Array<ModelSubscriptionEmployeeFilterInput | null> | null;
  or?: Array<ModelSubscriptionEmployeeFilterInput | null> | null;
};

export type ModelSubscriptionEmployeeJobTitleFilterInput = {
  id?: ModelSubscriptionIDInput | null;
  employeeId?: ModelSubscriptionIDInput | null;
  jobTitleId?: ModelSubscriptionIDInput | null;
  and?: Array<ModelSubscriptionEmployeeJobTitleFilterInput | null> | null;
  or?: Array<ModelSubscriptionEmployeeJobTitleFilterInput | null> | null;
};

export type ModelSubscriptionObjectiveFilterInput = {
  id?: ModelSubscriptionIDInput | null;
  ownerId?: ModelSubscriptionIDInput | null;
  title?: ModelSubscriptionStringInput | null;
  description?: ModelSubscriptionStringInput | null;
  and?: Array<ModelSubscriptionObjectiveFilterInput | null> | null;
  or?: Array<ModelSubscriptionObjectiveFilterInput | null> | null;
};

export type ModelSubscriptionUserFilterInput = {
  id?: ModelSubscriptionIDInput | null;
  username?: ModelSubscriptionStringInput | null;
  name?: ModelSubscriptionStringInput | null;
  email?: ModelSubscriptionStringInput | null;
  and?: Array<ModelSubscriptionUserFilterInput | null> | null;
  or?: Array<ModelSubscriptionUserFilterInput | null> | null;
};

export type ModelSubscriptionJobTitleFilterInput = {
  id?: ModelSubscriptionIDInput | null;
  organizationUnitId?: ModelSubscriptionIDInput | null;
  title?: ModelSubscriptionStringInput | null;
  and?: Array<ModelSubscriptionJobTitleFilterInput | null> | null;
  or?: Array<ModelSubscriptionJobTitleFilterInput | null> | null;
};

export type ModelSubscriptionOrganizationUnitFilterInput = {
  id?: ModelSubscriptionIDInput | null;
  organizationId?: ModelSubscriptionIDInput | null;
  name?: ModelSubscriptionStringInput | null;
  parentId?: ModelSubscriptionIDInput | null;
  and?: Array<ModelSubscriptionOrganizationUnitFilterInput | null> | null;
  or?: Array<ModelSubscriptionOrganizationUnitFilterInput | null> | null;
};

export type ModelSubscriptionSocialMediaFilterInput = {
  id?: ModelSubscriptionIDInput | null;
  name?: ModelSubscriptionStringInput | null;
  url?: ModelSubscriptionStringInput | null;
  iconUrl?: ModelSubscriptionStringInput | null;
  and?: Array<ModelSubscriptionSocialMediaFilterInput | null> | null;
  or?: Array<ModelSubscriptionSocialMediaFilterInput | null> | null;
};

export type ModelSubscriptionEmployeeSocialMediaFilterInput = {
  id?: ModelSubscriptionIDInput | null;
  employeeId?: ModelSubscriptionIDInput | null;
  socialMediaId?: ModelSubscriptionIDInput | null;
  username?: ModelSubscriptionStringInput | null;
  and?: Array<ModelSubscriptionEmployeeSocialMediaFilterInput | null> | null;
  or?: Array<ModelSubscriptionEmployeeSocialMediaFilterInput | null> | null;
};

export type ModelSubscriptionEmployeePositionHistoryFilterInput = {
  id?: ModelSubscriptionIDInput | null;
  employeeId?: ModelSubscriptionIDInput | null;
  dateFrom?: ModelSubscriptionStringInput | null;
  dateUntil?: ModelSubscriptionStringInput | null;
  officeName?: ModelSubscriptionStringInput | null;
  location?: ModelSubscriptionStringInput | null;
  description?: ModelSubscriptionStringInput | null;
  internalPosition?: ModelSubscriptionBooleanInput | null;
  and?: Array<ModelSubscriptionEmployeePositionHistoryFilterInput | null> | null;
  or?: Array<ModelSubscriptionEmployeePositionHistoryFilterInput | null> | null;
};

export type ModelSubscriptionBooleanInput = {
  ne?: boolean | null;
  eq?: boolean | null;
};

export type ModelSubscriptionEmployeeEducationHistoryFilterInput = {
  id?: ModelSubscriptionIDInput | null;
  employeeId?: ModelSubscriptionIDInput | null;
  schoolName?: ModelSubscriptionStringInput | null;
  entryYear?: ModelSubscriptionIntInput | null;
  graduationYear?: ModelSubscriptionIntInput | null;
  and?: Array<ModelSubscriptionEmployeeEducationHistoryFilterInput | null> | null;
  or?: Array<ModelSubscriptionEmployeeEducationHistoryFilterInput | null> | null;
};

export type ModelSubscriptionIntInput = {
  ne?: number | null;
  eq?: number | null;
  le?: number | null;
  lt?: number | null;
  ge?: number | null;
  gt?: number | null;
  between?: Array<number | null> | null;
  in?: Array<number | null> | null;
  notIn?: Array<number | null> | null;
};

export type ModelSubscriptionEmployeeAssignmentHistoryFilterInput = {
  id?: ModelSubscriptionIDInput | null;
  employeeId?: ModelSubscriptionIDInput | null;
  dateFrom?: ModelSubscriptionStringInput | null;
  dateUntil?: ModelSubscriptionStringInput | null;
  officeName?: ModelSubscriptionStringInput | null;
  location?: ModelSubscriptionStringInput | null;
  description?: ModelSubscriptionStringInput | null;
  bodRelated?: ModelSubscriptionBooleanInput | null;
  and?: Array<ModelSubscriptionEmployeeAssignmentHistoryFilterInput | null> | null;
  or?: Array<ModelSubscriptionEmployeeAssignmentHistoryFilterInput | null> | null;
};

export type ModelSubscriptionEmployeeActivityFilterInput = {
  id?: ModelSubscriptionIDInput | null;
  employeeId?: ModelSubscriptionIDInput | null;
  activityId?: ModelSubscriptionIDInput | null;
  point?: ModelSubscriptionIntInput | null;
  datetime?: ModelSubscriptionStringInput | null;
  and?: Array<ModelSubscriptionEmployeeActivityFilterInput | null> | null;
  or?: Array<ModelSubscriptionEmployeeActivityFilterInput | null> | null;
};

export type ModelSubscriptionEmployeeBadgeFilterInput = {
  id?: ModelSubscriptionIDInput | null;
  employeeId?: ModelSubscriptionIDInput | null;
  badgeId?: ModelSubscriptionIDInput | null;
  grantDate?: ModelSubscriptionStringInput | null;
  grantedById?: ModelSubscriptionIDInput | null;
  and?: Array<ModelSubscriptionEmployeeBadgeFilterInput | null> | null;
  or?: Array<ModelSubscriptionEmployeeBadgeFilterInput | null> | null;
};

export type ModelSubscriptionEmployeeSkillFilterInput = {
  id?: ModelSubscriptionIDInput | null;
  employeeId?: ModelSubscriptionIDInput | null;
  skillGroup?: ModelSubscriptionStringInput | null;
  skill?: ModelSubscriptionStringInput | null;
  name?: ModelSubscriptionStringInput | null;
  level?: ModelSubscriptionStringInput | null;
  progress?: ModelSubscriptionIntInput | null;
  and?: Array<ModelSubscriptionEmployeeSkillFilterInput | null> | null;
  or?: Array<ModelSubscriptionEmployeeSkillFilterInput | null> | null;
};

export type ModelSubscriptionEmployeeTrainingFilterInput = {
  id?: ModelSubscriptionIDInput | null;
  employeeId?: ModelSubscriptionIDInput | null;
  date?: ModelSubscriptionStringInput | null;
  name?: ModelSubscriptionStringInput | null;
  description?: ModelSubscriptionStringInput | null;
  type?: ModelSubscriptionStringInput | null;
  and?: Array<ModelSubscriptionEmployeeTrainingFilterInput | null> | null;
  or?: Array<ModelSubscriptionEmployeeTrainingFilterInput | null> | null;
};

export type ModelSubscriptionEmployeeRewardFilterInput = {
  id?: ModelSubscriptionIDInput | null;
  employeeId?: ModelSubscriptionIDInput | null;
  date?: ModelSubscriptionStringInput | null;
  name?: ModelSubscriptionStringInput | null;
  description?: ModelSubscriptionStringInput | null;
  type?: ModelSubscriptionStringInput | null;
  and?: Array<ModelSubscriptionEmployeeRewardFilterInput | null> | null;
  or?: Array<ModelSubscriptionEmployeeRewardFilterInput | null> | null;
};

export type ModelSubscriptionActivityFilterInput = {
  id?: ModelSubscriptionIDInput | null;
  name?: ModelSubscriptionStringInput | null;
  point?: ModelSubscriptionIntInput | null;
  and?: Array<ModelSubscriptionActivityFilterInput | null> | null;
  or?: Array<ModelSubscriptionActivityFilterInput | null> | null;
};

export type ModelSubscriptionBadgeFilterInput = {
  id?: ModelSubscriptionIDInput | null;
  name?: ModelSubscriptionStringInput | null;
  iconUrl?: ModelSubscriptionStringInput | null;
  and?: Array<ModelSubscriptionBadgeFilterInput | null> | null;
  or?: Array<ModelSubscriptionBadgeFilterInput | null> | null;
};

export type ModelSubscriptionKnowledgeMapFilterInput = {
  id?: ModelSubscriptionIDInput | null;
  name?: ModelSubscriptionStringInput | null;
  ownerId?: ModelSubscriptionIDInput | null;
  and?: Array<ModelSubscriptionKnowledgeMapFilterInput | null> | null;
  or?: Array<ModelSubscriptionKnowledgeMapFilterInput | null> | null;
};

export type ModelSubscriptionKnowledgeMapCollaboratorFilterInput = {
  id?: ModelSubscriptionIDInput | null;
  employeeId?: ModelSubscriptionIDInput | null;
  knowledgeMapId?: ModelSubscriptionIDInput | null;
  and?: Array<ModelSubscriptionKnowledgeMapCollaboratorFilterInput | null> | null;
  or?: Array<ModelSubscriptionKnowledgeMapCollaboratorFilterInput | null> | null;
};

export type ModelSubscriptionBusinessProcessFilterInput = {
  id?: ModelSubscriptionIDInput | null;
  knowledgeMapId?: ModelSubscriptionIDInput | null;
  title?: ModelSubscriptionStringInput | null;
  description?: ModelSubscriptionStringInput | null;
  and?: Array<ModelSubscriptionBusinessProcessFilterInput | null> | null;
  or?: Array<ModelSubscriptionBusinessProcessFilterInput | null> | null;
};

export type ModelSubscriptionBusinessProcessCommentFilterInput = {
  id?: ModelSubscriptionIDInput | null;
  businessProcessId?: ModelSubscriptionIDInput | null;
  comment?: ModelSubscriptionStringInput | null;
  createdById?: ModelSubscriptionIDInput | null;
  parentId?: ModelSubscriptionIDInput | null;
  and?: Array<ModelSubscriptionBusinessProcessCommentFilterInput | null> | null;
  or?: Array<ModelSubscriptionBusinessProcessCommentFilterInput | null> | null;
};

export type ModelSubscriptionStrategicActivityFilterInput = {
  id?: ModelSubscriptionIDInput | null;
  businessProcessId?: ModelSubscriptionIDInput | null;
  title?: ModelSubscriptionStringInput | null;
  description?: ModelSubscriptionStringInput | null;
  and?: Array<ModelSubscriptionStrategicActivityFilterInput | null> | null;
  or?: Array<ModelSubscriptionStrategicActivityFilterInput | null> | null;
};

export type ModelSubscriptionStrategicActivityCommentFilterInput = {
  id?: ModelSubscriptionIDInput | null;
  strategicActivityId?: ModelSubscriptionIDInput | null;
  comment?: ModelSubscriptionStringInput | null;
  createdById?: ModelSubscriptionIDInput | null;
  parentId?: ModelSubscriptionIDInput | null;
  and?: Array<ModelSubscriptionStrategicActivityCommentFilterInput | null> | null;
  or?: Array<ModelSubscriptionStrategicActivityCommentFilterInput | null> | null;
};

export type ModelSubscriptionImportantKnowledgeFilterInput = {
  id?: ModelSubscriptionIDInput | null;
  strategicActivityId?: ModelSubscriptionIDInput | null;
  title?: ModelSubscriptionStringInput | null;
  description?: ModelSubscriptionStringInput | null;
  and?: Array<ModelSubscriptionImportantKnowledgeFilterInput | null> | null;
  or?: Array<ModelSubscriptionImportantKnowledgeFilterInput | null> | null;
};

export type ModelSubscriptionImportantKnowledgeCommentFilterInput = {
  id?: ModelSubscriptionIDInput | null;
  importantKnowledgeId?: ModelSubscriptionIDInput | null;
  comment?: ModelSubscriptionStringInput | null;
  createdById?: ModelSubscriptionIDInput | null;
  parentId?: ModelSubscriptionIDInput | null;
  and?: Array<ModelSubscriptionImportantKnowledgeCommentFilterInput | null> | null;
  or?: Array<ModelSubscriptionImportantKnowledgeCommentFilterInput | null> | null;
};

export type ModelSubscriptionImportantKnowledgeDocumentFilterInput = {
  id?: ModelSubscriptionIDInput | null;
  importantKnowledgeId?: ModelSubscriptionIDInput | null;
  documentType?: ModelSubscriptionStringInput | null;
  documentId?: ModelSubscriptionIDInput | null;
  creatorId?: ModelSubscriptionIDInput | null;
  and?: Array<ModelSubscriptionImportantKnowledgeDocumentFilterInput | null> | null;
  or?: Array<ModelSubscriptionImportantKnowledgeDocumentFilterInput | null> | null;
};

export type ModelSubscriptionCompetencyFieldFilterInput = {
  id?: ModelSubscriptionIDInput | null;
  name?: ModelSubscriptionStringInput | null;
  and?: Array<ModelSubscriptionCompetencyFieldFilterInput | null> | null;
  or?: Array<ModelSubscriptionCompetencyFieldFilterInput | null> | null;
};

export type ModelSubscriptionSubjectMatterExpertFilterInput = {
  id?: ModelSubscriptionIDInput | null;
  employeeId?: ModelSubscriptionIDInput | null;
  and?: Array<ModelSubscriptionSubjectMatterExpertFilterInput | null> | null;
  or?: Array<ModelSubscriptionSubjectMatterExpertFilterInput | null> | null;
};

export type ModelSubscriptionSubjectMatterExpertCompetencyFilterInput = {
  id?: ModelSubscriptionIDInput | null;
  subjectMatterExpertId?: ModelSubscriptionIDInput | null;
  competencyFieldId?: ModelSubscriptionIDInput | null;
  and?: Array<ModelSubscriptionSubjectMatterExpertCompetencyFilterInput | null> | null;
  or?: Array<ModelSubscriptionSubjectMatterExpertCompetencyFilterInput | null> | null;
};

export type ModelSubscriptionRepositoryFolderFilterInput = {
  id?: ModelSubscriptionIDInput | null;
  foldername?: ModelSubscriptionStringInput | null;
  parentId?: ModelSubscriptionIDInput | null;
  and?: Array<ModelSubscriptionRepositoryFolderFilterInput | null> | null;
  or?: Array<ModelSubscriptionRepositoryFolderFilterInput | null> | null;
};

export type ModelSubscriptionRepositoryFileFilterInput = {
  id?: ModelSubscriptionIDInput | null;
  folderId?: ModelSubscriptionIDInput | null;
  filename?: ModelSubscriptionStringInput | null;
  filetype?: ModelSubscriptionStringInput | null;
  createdById?: ModelSubscriptionIDInput | null;
  and?: Array<ModelSubscriptionRepositoryFileFilterInput | null> | null;
  or?: Array<ModelSubscriptionRepositoryFileFilterInput | null> | null;
};

export type ModelSubscriptionCommunityCategoryFilterInput = {
  id?: ModelSubscriptionIDInput | null;
  category?: ModelSubscriptionStringInput | null;
  and?: Array<ModelSubscriptionCommunityCategoryFilterInput | null> | null;
  or?: Array<ModelSubscriptionCommunityCategoryFilterInput | null> | null;
};

export type ModelSubscriptionCommunityFilterInput = {
  id?: ModelSubscriptionIDInput | null;
  coverUrl?: ModelSubscriptionStringInput | null;
  profileUrl?: ModelSubscriptionStringInput | null;
  name?: ModelSubscriptionStringInput | null;
  description?: ModelSubscriptionStringInput | null;
  tags?: ModelSubscriptionStringInput | null;
  categoryId?: ModelSubscriptionIDInput | null;
  unitId?: ModelSubscriptionIDInput | null;
  knowledgeFocus?: ModelSubscriptionStringInput | null;
  objective?: ModelSubscriptionStringInput | null;
  kpi?: ModelSubscriptionStringInput | null;
  policy?: ModelSubscriptionStringInput | null;
  memberCanInvite?: ModelSubscriptionBooleanInput | null;
  reviewNewPost?: ModelSubscriptionBooleanInput | null;
  ownerId?: ModelSubscriptionIDInput | null;
  type?: ModelSubscriptionStringInput | null;
  and?: Array<ModelSubscriptionCommunityFilterInput | null> | null;
  or?: Array<ModelSubscriptionCommunityFilterInput | null> | null;
};

export type ModelSubscriptionPendingCoreMemberFilterInput = {
  id?: ModelSubscriptionIDInput | null;
  communityId?: ModelSubscriptionIDInput | null;
  employeeId?: ModelSubscriptionIDInput | null;
  and?: Array<ModelSubscriptionPendingCoreMemberFilterInput | null> | null;
  or?: Array<ModelSubscriptionPendingCoreMemberFilterInput | null> | null;
};

export type ModelSubscriptionCoreMemberFilterInput = {
  id?: ModelSubscriptionIDInput | null;
  communityId?: ModelSubscriptionIDInput | null;
  employeeId?: ModelSubscriptionIDInput | null;
  and?: Array<ModelSubscriptionCoreMemberFilterInput | null> | null;
  or?: Array<ModelSubscriptionCoreMemberFilterInput | null> | null;
};

export type ModelSubscriptionCommunityFollowersFilterInput = {
  id?: ModelSubscriptionIDInput | null;
  communityId?: ModelSubscriptionIDInput | null;
  employeeId?: ModelSubscriptionIDInput | null;
  and?: Array<ModelSubscriptionCommunityFollowersFilterInput | null> | null;
  or?: Array<ModelSubscriptionCommunityFollowersFilterInput | null> | null;
};

export type ModelSubscriptionCommunityDocumentationFilterInput = {
  id?: ModelSubscriptionIDInput | null;
  communityId?: ModelSubscriptionIDInput | null;
  documentId?: ModelSubscriptionIDInput | null;
  and?: Array<ModelSubscriptionCommunityDocumentationFilterInput | null> | null;
  or?: Array<ModelSubscriptionCommunityDocumentationFilterInput | null> | null;
};

export type ModelSubscriptionPostFilterInput = {
  id?: ModelSubscriptionIDInput | null;
  communityId?: ModelSubscriptionIDInput | null;
  creatorId?: ModelSubscriptionIDInput | null;
  content?: ModelSubscriptionStringInput | null;
  documentId?: ModelSubscriptionStringInput | null;
  eventId?: ModelSubscriptionIDInput | null;
  articleId?: ModelSubscriptionIDInput | null;
  surveyId?: ModelSubscriptionIDInput | null;
  and?: Array<ModelSubscriptionPostFilterInput | null> | null;
  or?: Array<ModelSubscriptionPostFilterInput | null> | null;
};

export type ModelSubscriptionEventFilterInput = {
  id?: ModelSubscriptionIDInput | null;
  eventId?: ModelSubscriptionIDInput | null;
  communityId?: ModelSubscriptionIDInput | null;
  owner?: ModelSubscriptionStringInput | null;
  profileUrl?: ModelSubscriptionStringInput | null;
  type?: ModelSubscriptionStringInput | null;
  title?: ModelSubscriptionStringInput | null;
  description?: ModelSubscriptionStringInput | null;
  about?: ModelSubscriptionStringInput | null;
  datetimeFrom?: ModelSubscriptionStringInput | null;
  datetimeTo?: ModelSubscriptionStringInput | null;
  externalLink?: ModelSubscriptionStringInput | null;
  location?: ModelSubscriptionStringInput | null;
  and?: Array<ModelSubscriptionEventFilterInput | null> | null;
  or?: Array<ModelSubscriptionEventFilterInput | null> | null;
};

export type ModelSubscriptionNoteTakersFilterInput = {
  id?: ModelSubscriptionIDInput | null;
  eventId?: ModelSubscriptionIDInput | null;
  employeeId?: ModelSubscriptionIDInput | null;
  and?: Array<ModelSubscriptionNoteTakersFilterInput | null> | null;
  or?: Array<ModelSubscriptionNoteTakersFilterInput | null> | null;
};

export type ModelSubscriptionComitteeFilterInput = {
  id?: ModelSubscriptionIDInput | null;
  eventId?: ModelSubscriptionIDInput | null;
  employeeId?: ModelSubscriptionIDInput | null;
  and?: Array<ModelSubscriptionComitteeFilterInput | null> | null;
  or?: Array<ModelSubscriptionComitteeFilterInput | null> | null;
};

export type ModelSubscriptionAttendeeFilterInput = {
  id?: ModelSubscriptionIDInput | null;
  employeeId?: ModelSubscriptionIDInput | null;
  and?: Array<ModelSubscriptionAttendeeFilterInput | null> | null;
  or?: Array<ModelSubscriptionAttendeeFilterInput | null> | null;
};

export type ModelSubscriptionEmployeeSpeakerFilterInput = {
  id?: ModelSubscriptionIDInput | null;
  employeeId?: ModelSubscriptionIDInput | null;
  and?: Array<ModelSubscriptionEmployeeSpeakerFilterInput | null> | null;
  or?: Array<ModelSubscriptionEmployeeSpeakerFilterInput | null> | null;
};

export type ModelSubscriptionEventSpeakerFilterInput = {
  id?: ModelSubscriptionIDInput | null;
  name?: ModelSubscriptionStringInput | null;
  jobTitle?: ModelSubscriptionStringInput | null;
  company?: ModelSubscriptionStringInput | null;
  photo_url?: ModelSubscriptionStringInput | null;
  and?: Array<ModelSubscriptionEventSpeakerFilterInput | null> | null;
  or?: Array<ModelSubscriptionEventSpeakerFilterInput | null> | null;
};

export type ModelSubscriptionEventMessageFilterInput = {
  id?: ModelSubscriptionIDInput | null;
  eventId?: ModelSubscriptionIDInput | null;
  message?: ModelSubscriptionStringInput | null;
  parentId?: ModelSubscriptionIDInput | null;
  attachmentUrl?: ModelSubscriptionStringInput | null;
  and?: Array<ModelSubscriptionEventMessageFilterInput | null> | null;
  or?: Array<ModelSubscriptionEventMessageFilterInput | null> | null;
};

export type ModelSubscriptionArticleFilterInput = {
  id?: ModelSubscriptionIDInput | null;
  profileUrl?: ModelSubscriptionStringInput | null;
  status?: ModelSubscriptionStringInput | null;
  title?: ModelSubscriptionStringInput | null;
  content?: ModelSubscriptionStringInput | null;
  createdAt?: ModelSubscriptionStringInput | null;
  updatedAt?: ModelSubscriptionStringInput | null;
  and?: Array<ModelSubscriptionArticleFilterInput | null> | null;
  or?: Array<ModelSubscriptionArticleFilterInput | null> | null;
};

export type ModelSubscriptionSurveyFilterInput = {
  id?: ModelSubscriptionIDInput | null;
  name?: ModelSubscriptionStringInput | null;
  datetimeStart?: ModelSubscriptionStringInput | null;
  datetimeEnd?: ModelSubscriptionStringInput | null;
  and?: Array<ModelSubscriptionSurveyFilterInput | null> | null;
  or?: Array<ModelSubscriptionSurveyFilterInput | null> | null;
};

export type ModelSubscriptionSurveyOptionFilterInput = {
  id?: ModelSubscriptionIDInput | null;
  surveyOptionId?: ModelSubscriptionIDInput | null;
  caption?: ModelSubscriptionStringInput | null;
  totalVote?: ModelSubscriptionIntInput | null;
  and?: Array<ModelSubscriptionSurveyOptionFilterInput | null> | null;
  or?: Array<ModelSubscriptionSurveyOptionFilterInput | null> | null;
};

export type CreateOrganizationMutationVariables = {
  input: CreateOrganizationInput;
  condition?: ModelOrganizationConditionInput | null;
};

export type CreateOrganizationMutation = {
  createOrganization?: {
    __typename: 'Organization';
    id: string;
    employees?: {
      __typename: 'ModelEmployeeConnection';
      nextToken?: string | null;
    } | null;
    name: string;
    address?: string | null;
    objectives?: {
      __typename: 'ModelObjectiveConnection';
      nextToken?: string | null;
    } | null;
    createdAt: string;
    updatedAt: string;
  } | null;
};

export type UpdateOrganizationMutationVariables = {
  input: UpdateOrganizationInput;
  condition?: ModelOrganizationConditionInput | null;
};

export type UpdateOrganizationMutation = {
  updateOrganization?: {
    __typename: 'Organization';
    id: string;
    employees?: {
      __typename: 'ModelEmployeeConnection';
      nextToken?: string | null;
    } | null;
    name: string;
    address?: string | null;
    objectives?: {
      __typename: 'ModelObjectiveConnection';
      nextToken?: string | null;
    } | null;
    createdAt: string;
    updatedAt: string;
  } | null;
};

export type DeleteOrganizationMutationVariables = {
  input: DeleteOrganizationInput;
  condition?: ModelOrganizationConditionInput | null;
};

export type DeleteOrganizationMutation = {
  deleteOrganization?: {
    __typename: 'Organization';
    id: string;
    employees?: {
      __typename: 'ModelEmployeeConnection';
      nextToken?: string | null;
    } | null;
    name: string;
    address?: string | null;
    objectives?: {
      __typename: 'ModelObjectiveConnection';
      nextToken?: string | null;
    } | null;
    createdAt: string;
    updatedAt: string;
  } | null;
};

export type CreateEmployeeMutationVariables = {
  input: CreateEmployeeInput;
  condition?: ModelEmployeeConditionInput | null;
};

export type CreateEmployeeMutation = {
  createEmployee?: {
    __typename: 'Employee';
    id: string;
    organizationId?: string | null;
    organizationUnitId?: string | null;
    organizationUnit?: {
      __typename: 'OrganizationUnit';
      id: string;
      organizationId?: string | null;
      name: string;
      parentId?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    userId: string;
    user?: {
      __typename: 'User';
      id: string;
      username: string;
      name: string;
      email: string;
      createdAt: string;
      updatedAt: string;
    } | null;
    nik: string;
    status: EmploymentStatus;
    domicile?: string | null;
    managerId?: string | null;
    manager?: {
      __typename: 'Employee';
      id: string;
      organizationId?: string | null;
      organizationUnitId?: string | null;
      userId: string;
      nik: string;
      status: EmploymentStatus;
      domicile?: string | null;
      managerId?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    jobTitles?: {
      __typename: 'ModelEmployeeJobTitleConnection';
      nextToken?: string | null;
    } | null;
    socialMedias?: {
      __typename: 'ModelEmployeeSocialMediaConnection';
      nextToken?: string | null;
    } | null;
    positionHistories?: {
      __typename: 'ModelEmployeePositionHistoryConnection';
      nextToken?: string | null;
    } | null;
    educationHistories?: {
      __typename: 'ModelEmployeeEducationHistoryConnection';
      nextToken?: string | null;
    } | null;
    assignmentHistories?: {
      __typename: 'ModelEmployeeAssignmentHistoryConnection';
      nextToken?: string | null;
    } | null;
    activities?: {
      __typename: 'ModelEmployeeActivityConnection';
      nextToken?: string | null;
    } | null;
    badges?: {
      __typename: 'ModelEmployeeBadgeConnection';
      nextToken?: string | null;
    } | null;
    skills?: {
      __typename: 'ModelEmployeeSkillConnection';
      nextToken?: string | null;
    } | null;
    trainings?: {
      __typename: 'ModelEmployeeTrainingConnection';
      nextToken?: string | null;
    } | null;
    rewards?: {
      __typename: 'ModelEmployeeRewardConnection';
      nextToken?: string | null;
    } | null;
    objectives?: {
      __typename: 'ModelObjectiveConnection';
      nextToken?: string | null;
    } | null;
    createdAt: string;
    updatedAt: string;
  } | null;
};

export type UpdateEmployeeMutationVariables = {
  input: UpdateEmployeeInput;
  condition?: ModelEmployeeConditionInput | null;
};

export type UpdateEmployeeMutation = {
  updateEmployee?: {
    __typename: 'Employee';
    id: string;
    organizationId?: string | null;
    organizationUnitId?: string | null;
    organizationUnit?: {
      __typename: 'OrganizationUnit';
      id: string;
      organizationId?: string | null;
      name: string;
      parentId?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    userId: string;
    user?: {
      __typename: 'User';
      id: string;
      username: string;
      name: string;
      email: string;
      createdAt: string;
      updatedAt: string;
    } | null;
    nik: string;
    status: EmploymentStatus;
    domicile?: string | null;
    managerId?: string | null;
    manager?: {
      __typename: 'Employee';
      id: string;
      organizationId?: string | null;
      organizationUnitId?: string | null;
      userId: string;
      nik: string;
      status: EmploymentStatus;
      domicile?: string | null;
      managerId?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    jobTitles?: {
      __typename: 'ModelEmployeeJobTitleConnection';
      nextToken?: string | null;
    } | null;
    socialMedias?: {
      __typename: 'ModelEmployeeSocialMediaConnection';
      nextToken?: string | null;
    } | null;
    positionHistories?: {
      __typename: 'ModelEmployeePositionHistoryConnection';
      nextToken?: string | null;
    } | null;
    educationHistories?: {
      __typename: 'ModelEmployeeEducationHistoryConnection';
      nextToken?: string | null;
    } | null;
    assignmentHistories?: {
      __typename: 'ModelEmployeeAssignmentHistoryConnection';
      nextToken?: string | null;
    } | null;
    activities?: {
      __typename: 'ModelEmployeeActivityConnection';
      nextToken?: string | null;
    } | null;
    badges?: {
      __typename: 'ModelEmployeeBadgeConnection';
      nextToken?: string | null;
    } | null;
    skills?: {
      __typename: 'ModelEmployeeSkillConnection';
      nextToken?: string | null;
    } | null;
    trainings?: {
      __typename: 'ModelEmployeeTrainingConnection';
      nextToken?: string | null;
    } | null;
    rewards?: {
      __typename: 'ModelEmployeeRewardConnection';
      nextToken?: string | null;
    } | null;
    objectives?: {
      __typename: 'ModelObjectiveConnection';
      nextToken?: string | null;
    } | null;
    createdAt: string;
    updatedAt: string;
  } | null;
};

export type DeleteEmployeeMutationVariables = {
  input: DeleteEmployeeInput;
  condition?: ModelEmployeeConditionInput | null;
};

export type DeleteEmployeeMutation = {
  deleteEmployee?: {
    __typename: 'Employee';
    id: string;
    organizationId?: string | null;
    organizationUnitId?: string | null;
    organizationUnit?: {
      __typename: 'OrganizationUnit';
      id: string;
      organizationId?: string | null;
      name: string;
      parentId?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    userId: string;
    user?: {
      __typename: 'User';
      id: string;
      username: string;
      name: string;
      email: string;
      createdAt: string;
      updatedAt: string;
    } | null;
    nik: string;
    status: EmploymentStatus;
    domicile?: string | null;
    managerId?: string | null;
    manager?: {
      __typename: 'Employee';
      id: string;
      organizationId?: string | null;
      organizationUnitId?: string | null;
      userId: string;
      nik: string;
      status: EmploymentStatus;
      domicile?: string | null;
      managerId?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    jobTitles?: {
      __typename: 'ModelEmployeeJobTitleConnection';
      nextToken?: string | null;
    } | null;
    socialMedias?: {
      __typename: 'ModelEmployeeSocialMediaConnection';
      nextToken?: string | null;
    } | null;
    positionHistories?: {
      __typename: 'ModelEmployeePositionHistoryConnection';
      nextToken?: string | null;
    } | null;
    educationHistories?: {
      __typename: 'ModelEmployeeEducationHistoryConnection';
      nextToken?: string | null;
    } | null;
    assignmentHistories?: {
      __typename: 'ModelEmployeeAssignmentHistoryConnection';
      nextToken?: string | null;
    } | null;
    activities?: {
      __typename: 'ModelEmployeeActivityConnection';
      nextToken?: string | null;
    } | null;
    badges?: {
      __typename: 'ModelEmployeeBadgeConnection';
      nextToken?: string | null;
    } | null;
    skills?: {
      __typename: 'ModelEmployeeSkillConnection';
      nextToken?: string | null;
    } | null;
    trainings?: {
      __typename: 'ModelEmployeeTrainingConnection';
      nextToken?: string | null;
    } | null;
    rewards?: {
      __typename: 'ModelEmployeeRewardConnection';
      nextToken?: string | null;
    } | null;
    objectives?: {
      __typename: 'ModelObjectiveConnection';
      nextToken?: string | null;
    } | null;
    createdAt: string;
    updatedAt: string;
  } | null;
};

export type CreateEmployeeJobTitleMutationVariables = {
  input: CreateEmployeeJobTitleInput;
  condition?: ModelEmployeeJobTitleConditionInput | null;
};

export type CreateEmployeeJobTitleMutation = {
  createEmployeeJobTitle?: {
    __typename: 'EmployeeJobTitle';
    id: string;
    employeeId?: string | null;
    jobTitleId?: string | null;
    jobTitle?: {
      __typename: 'JobTitle';
      id: string;
      organizationUnitId?: string | null;
      title?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    createdAt: string;
    updatedAt: string;
  } | null;
};

export type UpdateEmployeeJobTitleMutationVariables = {
  input: UpdateEmployeeJobTitleInput;
  condition?: ModelEmployeeJobTitleConditionInput | null;
};

export type UpdateEmployeeJobTitleMutation = {
  updateEmployeeJobTitle?: {
    __typename: 'EmployeeJobTitle';
    id: string;
    employeeId?: string | null;
    jobTitleId?: string | null;
    jobTitle?: {
      __typename: 'JobTitle';
      id: string;
      organizationUnitId?: string | null;
      title?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    createdAt: string;
    updatedAt: string;
  } | null;
};

export type DeleteEmployeeJobTitleMutationVariables = {
  input: DeleteEmployeeJobTitleInput;
  condition?: ModelEmployeeJobTitleConditionInput | null;
};

export type DeleteEmployeeJobTitleMutation = {
  deleteEmployeeJobTitle?: {
    __typename: 'EmployeeJobTitle';
    id: string;
    employeeId?: string | null;
    jobTitleId?: string | null;
    jobTitle?: {
      __typename: 'JobTitle';
      id: string;
      organizationUnitId?: string | null;
      title?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    createdAt: string;
    updatedAt: string;
  } | null;
};

export type CreateObjectiveMutationVariables = {
  input: CreateObjectiveInput;
  condition?: ModelObjectiveConditionInput | null;
};

export type CreateObjectiveMutation = {
  createObjective?: {
    __typename: 'Objective';
    id: string;
    ownerId?: string | null;
    title: string;
    description?: string | null;
    createdAt: string;
    updatedAt: string;
  } | null;
};

export type UpdateObjectiveMutationVariables = {
  input: UpdateObjectiveInput;
  condition?: ModelObjectiveConditionInput | null;
};

export type UpdateObjectiveMutation = {
  updateObjective?: {
    __typename: 'Objective';
    id: string;
    ownerId?: string | null;
    title: string;
    description?: string | null;
    createdAt: string;
    updatedAt: string;
  } | null;
};

export type DeleteObjectiveMutationVariables = {
  input: DeleteObjectiveInput;
  condition?: ModelObjectiveConditionInput | null;
};

export type DeleteObjectiveMutation = {
  deleteObjective?: {
    __typename: 'Objective';
    id: string;
    ownerId?: string | null;
    title: string;
    description?: string | null;
    createdAt: string;
    updatedAt: string;
  } | null;
};

export type CreateUserMutationVariables = {
  input: CreateUserInput;
  condition?: ModelUserConditionInput | null;
};

export type CreateUserMutation = {
  createUser?: {
    __typename: 'User';
    id: string;
    username: string;
    name: string;
    email: string;
    createdAt: string;
    updatedAt: string;
  } | null;
};

export type UpdateUserMutationVariables = {
  input: UpdateUserInput;
  condition?: ModelUserConditionInput | null;
};

export type UpdateUserMutation = {
  updateUser?: {
    __typename: 'User';
    id: string;
    username: string;
    name: string;
    email: string;
    createdAt: string;
    updatedAt: string;
  } | null;
};

export type DeleteUserMutationVariables = {
  input: DeleteUserInput;
  condition?: ModelUserConditionInput | null;
};

export type DeleteUserMutation = {
  deleteUser?: {
    __typename: 'User';
    id: string;
    username: string;
    name: string;
    email: string;
    createdAt: string;
    updatedAt: string;
  } | null;
};

export type CreateJobTitleMutationVariables = {
  input: CreateJobTitleInput;
  condition?: ModelJobTitleConditionInput | null;
};

export type CreateJobTitleMutation = {
  createJobTitle?: {
    __typename: 'JobTitle';
    id: string;
    organizationUnit?: {
      __typename: 'OrganizationUnit';
      id: string;
      organizationId?: string | null;
      name: string;
      parentId?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    organizationUnitId?: string | null;
    title?: string | null;
    createdAt: string;
    updatedAt: string;
  } | null;
};

export type UpdateJobTitleMutationVariables = {
  input: UpdateJobTitleInput;
  condition?: ModelJobTitleConditionInput | null;
};

export type UpdateJobTitleMutation = {
  updateJobTitle?: {
    __typename: 'JobTitle';
    id: string;
    organizationUnit?: {
      __typename: 'OrganizationUnit';
      id: string;
      organizationId?: string | null;
      name: string;
      parentId?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    organizationUnitId?: string | null;
    title?: string | null;
    createdAt: string;
    updatedAt: string;
  } | null;
};

export type DeleteJobTitleMutationVariables = {
  input: DeleteJobTitleInput;
  condition?: ModelJobTitleConditionInput | null;
};

export type DeleteJobTitleMutation = {
  deleteJobTitle?: {
    __typename: 'JobTitle';
    id: string;
    organizationUnit?: {
      __typename: 'OrganizationUnit';
      id: string;
      organizationId?: string | null;
      name: string;
      parentId?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    organizationUnitId?: string | null;
    title?: string | null;
    createdAt: string;
    updatedAt: string;
  } | null;
};

export type CreateOrganizationUnitMutationVariables = {
  input: CreateOrganizationUnitInput;
  condition?: ModelOrganizationUnitConditionInput | null;
};

export type CreateOrganizationUnitMutation = {
  createOrganizationUnit?: {
    __typename: 'OrganizationUnit';
    id: string;
    organizationId?: string | null;
    name: string;
    parentId?: string | null;
    parent?: {
      __typename: 'OrganizationUnit';
      id: string;
      organizationId?: string | null;
      name: string;
      parentId?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    children?: {
      __typename: 'ModelOrganizationUnitConnection';
      nextToken?: string | null;
    } | null;
    objectives?: {
      __typename: 'ModelObjectiveConnection';
      nextToken?: string | null;
    } | null;
    createdAt: string;
    updatedAt: string;
  } | null;
};

export type UpdateOrganizationUnitMutationVariables = {
  input: UpdateOrganizationUnitInput;
  condition?: ModelOrganizationUnitConditionInput | null;
};

export type UpdateOrganizationUnitMutation = {
  updateOrganizationUnit?: {
    __typename: 'OrganizationUnit';
    id: string;
    organizationId?: string | null;
    name: string;
    parentId?: string | null;
    parent?: {
      __typename: 'OrganizationUnit';
      id: string;
      organizationId?: string | null;
      name: string;
      parentId?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    children?: {
      __typename: 'ModelOrganizationUnitConnection';
      nextToken?: string | null;
    } | null;
    objectives?: {
      __typename: 'ModelObjectiveConnection';
      nextToken?: string | null;
    } | null;
    createdAt: string;
    updatedAt: string;
  } | null;
};

export type DeleteOrganizationUnitMutationVariables = {
  input: DeleteOrganizationUnitInput;
  condition?: ModelOrganizationUnitConditionInput | null;
};

export type DeleteOrganizationUnitMutation = {
  deleteOrganizationUnit?: {
    __typename: 'OrganizationUnit';
    id: string;
    organizationId?: string | null;
    name: string;
    parentId?: string | null;
    parent?: {
      __typename: 'OrganizationUnit';
      id: string;
      organizationId?: string | null;
      name: string;
      parentId?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    children?: {
      __typename: 'ModelOrganizationUnitConnection';
      nextToken?: string | null;
    } | null;
    objectives?: {
      __typename: 'ModelObjectiveConnection';
      nextToken?: string | null;
    } | null;
    createdAt: string;
    updatedAt: string;
  } | null;
};

export type CreateSocialMediaMutationVariables = {
  input: CreateSocialMediaInput;
  condition?: ModelSocialMediaConditionInput | null;
};

export type CreateSocialMediaMutation = {
  createSocialMedia?: {
    __typename: 'SocialMedia';
    id: string;
    name: string;
    url?: string | null;
    iconUrl?: string | null;
    createdAt: string;
    updatedAt: string;
  } | null;
};

export type UpdateSocialMediaMutationVariables = {
  input: UpdateSocialMediaInput;
  condition?: ModelSocialMediaConditionInput | null;
};

export type UpdateSocialMediaMutation = {
  updateSocialMedia?: {
    __typename: 'SocialMedia';
    id: string;
    name: string;
    url?: string | null;
    iconUrl?: string | null;
    createdAt: string;
    updatedAt: string;
  } | null;
};

export type DeleteSocialMediaMutationVariables = {
  input: DeleteSocialMediaInput;
  condition?: ModelSocialMediaConditionInput | null;
};

export type DeleteSocialMediaMutation = {
  deleteSocialMedia?: {
    __typename: 'SocialMedia';
    id: string;
    name: string;
    url?: string | null;
    iconUrl?: string | null;
    createdAt: string;
    updatedAt: string;
  } | null;
};

export type CreateEmployeeSocialMediaMutationVariables = {
  input: CreateEmployeeSocialMediaInput;
  condition?: ModelEmployeeSocialMediaConditionInput | null;
};

export type CreateEmployeeSocialMediaMutation = {
  createEmployeeSocialMedia?: {
    __typename: 'EmployeeSocialMedia';
    id: string;
    employeeId?: string | null;
    socialMediaId?: string | null;
    socialMedia?: {
      __typename: 'SocialMedia';
      id: string;
      name: string;
      url?: string | null;
      iconUrl?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    username: string;
    createdAt: string;
    updatedAt: string;
  } | null;
};

export type UpdateEmployeeSocialMediaMutationVariables = {
  input: UpdateEmployeeSocialMediaInput;
  condition?: ModelEmployeeSocialMediaConditionInput | null;
};

export type UpdateEmployeeSocialMediaMutation = {
  updateEmployeeSocialMedia?: {
    __typename: 'EmployeeSocialMedia';
    id: string;
    employeeId?: string | null;
    socialMediaId?: string | null;
    socialMedia?: {
      __typename: 'SocialMedia';
      id: string;
      name: string;
      url?: string | null;
      iconUrl?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    username: string;
    createdAt: string;
    updatedAt: string;
  } | null;
};

export type DeleteEmployeeSocialMediaMutationVariables = {
  input: DeleteEmployeeSocialMediaInput;
  condition?: ModelEmployeeSocialMediaConditionInput | null;
};

export type DeleteEmployeeSocialMediaMutation = {
  deleteEmployeeSocialMedia?: {
    __typename: 'EmployeeSocialMedia';
    id: string;
    employeeId?: string | null;
    socialMediaId?: string | null;
    socialMedia?: {
      __typename: 'SocialMedia';
      id: string;
      name: string;
      url?: string | null;
      iconUrl?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    username: string;
    createdAt: string;
    updatedAt: string;
  } | null;
};

export type CreateEmployeePositionHistoryMutationVariables = {
  input: CreateEmployeePositionHistoryInput;
  condition?: ModelEmployeePositionHistoryConditionInput | null;
};

export type CreateEmployeePositionHistoryMutation = {
  createEmployeePositionHistory?: {
    __typename: 'EmployeePositionHistory';
    id: string;
    employeeId?: string | null;
    dateFrom?: string | null;
    dateUntil?: string | null;
    officeName?: string | null;
    location?: string | null;
    description?: string | null;
    internalPosition?: boolean | null;
    createdAt: string;
    updatedAt: string;
  } | null;
};

export type UpdateEmployeePositionHistoryMutationVariables = {
  input: UpdateEmployeePositionHistoryInput;
  condition?: ModelEmployeePositionHistoryConditionInput | null;
};

export type UpdateEmployeePositionHistoryMutation = {
  updateEmployeePositionHistory?: {
    __typename: 'EmployeePositionHistory';
    id: string;
    employeeId?: string | null;
    dateFrom?: string | null;
    dateUntil?: string | null;
    officeName?: string | null;
    location?: string | null;
    description?: string | null;
    internalPosition?: boolean | null;
    createdAt: string;
    updatedAt: string;
  } | null;
};

export type DeleteEmployeePositionHistoryMutationVariables = {
  input: DeleteEmployeePositionHistoryInput;
  condition?: ModelEmployeePositionHistoryConditionInput | null;
};

export type DeleteEmployeePositionHistoryMutation = {
  deleteEmployeePositionHistory?: {
    __typename: 'EmployeePositionHistory';
    id: string;
    employeeId?: string | null;
    dateFrom?: string | null;
    dateUntil?: string | null;
    officeName?: string | null;
    location?: string | null;
    description?: string | null;
    internalPosition?: boolean | null;
    createdAt: string;
    updatedAt: string;
  } | null;
};

export type CreateEmployeeEducationHistoryMutationVariables = {
  input: CreateEmployeeEducationHistoryInput;
  condition?: ModelEmployeeEducationHistoryConditionInput | null;
};

export type CreateEmployeeEducationHistoryMutation = {
  createEmployeeEducationHistory?: {
    __typename: 'EmployeeEducationHistory';
    id: string;
    employeeId?: string | null;
    schoolName?: string | null;
    entryYear?: number | null;
    graduationYear?: number | null;
    createdAt: string;
    updatedAt: string;
  } | null;
};

export type UpdateEmployeeEducationHistoryMutationVariables = {
  input: UpdateEmployeeEducationHistoryInput;
  condition?: ModelEmployeeEducationHistoryConditionInput | null;
};

export type UpdateEmployeeEducationHistoryMutation = {
  updateEmployeeEducationHistory?: {
    __typename: 'EmployeeEducationHistory';
    id: string;
    employeeId?: string | null;
    schoolName?: string | null;
    entryYear?: number | null;
    graduationYear?: number | null;
    createdAt: string;
    updatedAt: string;
  } | null;
};

export type DeleteEmployeeEducationHistoryMutationVariables = {
  input: DeleteEmployeeEducationHistoryInput;
  condition?: ModelEmployeeEducationHistoryConditionInput | null;
};

export type DeleteEmployeeEducationHistoryMutation = {
  deleteEmployeeEducationHistory?: {
    __typename: 'EmployeeEducationHistory';
    id: string;
    employeeId?: string | null;
    schoolName?: string | null;
    entryYear?: number | null;
    graduationYear?: number | null;
    createdAt: string;
    updatedAt: string;
  } | null;
};

export type CreateEmployeeAssignmentHistoryMutationVariables = {
  input: CreateEmployeeAssignmentHistoryInput;
  condition?: ModelEmployeeAssignmentHistoryConditionInput | null;
};

export type CreateEmployeeAssignmentHistoryMutation = {
  createEmployeeAssignmentHistory?: {
    __typename: 'EmployeeAssignmentHistory';
    id: string;
    employeeId?: string | null;
    dateFrom?: string | null;
    dateUntil?: string | null;
    officeName?: string | null;
    location?: string | null;
    description?: string | null;
    bodRelated?: boolean | null;
    createdAt: string;
    updatedAt: string;
  } | null;
};

export type UpdateEmployeeAssignmentHistoryMutationVariables = {
  input: UpdateEmployeeAssignmentHistoryInput;
  condition?: ModelEmployeeAssignmentHistoryConditionInput | null;
};

export type UpdateEmployeeAssignmentHistoryMutation = {
  updateEmployeeAssignmentHistory?: {
    __typename: 'EmployeeAssignmentHistory';
    id: string;
    employeeId?: string | null;
    dateFrom?: string | null;
    dateUntil?: string | null;
    officeName?: string | null;
    location?: string | null;
    description?: string | null;
    bodRelated?: boolean | null;
    createdAt: string;
    updatedAt: string;
  } | null;
};

export type DeleteEmployeeAssignmentHistoryMutationVariables = {
  input: DeleteEmployeeAssignmentHistoryInput;
  condition?: ModelEmployeeAssignmentHistoryConditionInput | null;
};

export type DeleteEmployeeAssignmentHistoryMutation = {
  deleteEmployeeAssignmentHistory?: {
    __typename: 'EmployeeAssignmentHistory';
    id: string;
    employeeId?: string | null;
    dateFrom?: string | null;
    dateUntil?: string | null;
    officeName?: string | null;
    location?: string | null;
    description?: string | null;
    bodRelated?: boolean | null;
    createdAt: string;
    updatedAt: string;
  } | null;
};

export type CreateEmployeeActivityMutationVariables = {
  input: CreateEmployeeActivityInput;
  condition?: ModelEmployeeActivityConditionInput | null;
};

export type CreateEmployeeActivityMutation = {
  createEmployeeActivity?: {
    __typename: 'EmployeeActivity';
    id: string;
    employeeId?: string | null;
    activityId: string;
    activity?: {
      __typename: 'Activity';
      id: string;
      name?: string | null;
      point?: number | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    point?: number | null;
    datetime?: string | null;
    createdAt: string;
    updatedAt: string;
  } | null;
};

export type UpdateEmployeeActivityMutationVariables = {
  input: UpdateEmployeeActivityInput;
  condition?: ModelEmployeeActivityConditionInput | null;
};

export type UpdateEmployeeActivityMutation = {
  updateEmployeeActivity?: {
    __typename: 'EmployeeActivity';
    id: string;
    employeeId?: string | null;
    activityId: string;
    activity?: {
      __typename: 'Activity';
      id: string;
      name?: string | null;
      point?: number | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    point?: number | null;
    datetime?: string | null;
    createdAt: string;
    updatedAt: string;
  } | null;
};

export type DeleteEmployeeActivityMutationVariables = {
  input: DeleteEmployeeActivityInput;
  condition?: ModelEmployeeActivityConditionInput | null;
};

export type DeleteEmployeeActivityMutation = {
  deleteEmployeeActivity?: {
    __typename: 'EmployeeActivity';
    id: string;
    employeeId?: string | null;
    activityId: string;
    activity?: {
      __typename: 'Activity';
      id: string;
      name?: string | null;
      point?: number | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    point?: number | null;
    datetime?: string | null;
    createdAt: string;
    updatedAt: string;
  } | null;
};

export type CreateEmployeeBadgeMutationVariables = {
  input: CreateEmployeeBadgeInput;
  condition?: ModelEmployeeBadgeConditionInput | null;
};

export type CreateEmployeeBadgeMutation = {
  createEmployeeBadge?: {
    __typename: 'EmployeeBadge';
    id: string;
    employeeId: string;
    badgeId: string;
    badge?: {
      __typename: 'Badge';
      id: string;
      name?: string | null;
      iconUrl?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    grantDate?: string | null;
    grantedById: string;
    grantedBy?: {
      __typename: 'Employee';
      id: string;
      organizationId?: string | null;
      organizationUnitId?: string | null;
      userId: string;
      nik: string;
      status: EmploymentStatus;
      domicile?: string | null;
      managerId?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    createdAt: string;
    updatedAt: string;
  } | null;
};

export type UpdateEmployeeBadgeMutationVariables = {
  input: UpdateEmployeeBadgeInput;
  condition?: ModelEmployeeBadgeConditionInput | null;
};

export type UpdateEmployeeBadgeMutation = {
  updateEmployeeBadge?: {
    __typename: 'EmployeeBadge';
    id: string;
    employeeId: string;
    badgeId: string;
    badge?: {
      __typename: 'Badge';
      id: string;
      name?: string | null;
      iconUrl?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    grantDate?: string | null;
    grantedById: string;
    grantedBy?: {
      __typename: 'Employee';
      id: string;
      organizationId?: string | null;
      organizationUnitId?: string | null;
      userId: string;
      nik: string;
      status: EmploymentStatus;
      domicile?: string | null;
      managerId?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    createdAt: string;
    updatedAt: string;
  } | null;
};

export type DeleteEmployeeBadgeMutationVariables = {
  input: DeleteEmployeeBadgeInput;
  condition?: ModelEmployeeBadgeConditionInput | null;
};

export type DeleteEmployeeBadgeMutation = {
  deleteEmployeeBadge?: {
    __typename: 'EmployeeBadge';
    id: string;
    employeeId: string;
    badgeId: string;
    badge?: {
      __typename: 'Badge';
      id: string;
      name?: string | null;
      iconUrl?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    grantDate?: string | null;
    grantedById: string;
    grantedBy?: {
      __typename: 'Employee';
      id: string;
      organizationId?: string | null;
      organizationUnitId?: string | null;
      userId: string;
      nik: string;
      status: EmploymentStatus;
      domicile?: string | null;
      managerId?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    createdAt: string;
    updatedAt: string;
  } | null;
};

export type CreateEmployeeSkillMutationVariables = {
  input: CreateEmployeeSkillInput;
  condition?: ModelEmployeeSkillConditionInput | null;
};

export type CreateEmployeeSkillMutation = {
  createEmployeeSkill?: {
    __typename: 'EmployeeSkill';
    id: string;
    employeeId: string;
    skillGroup?: string | null;
    skill?: string | null;
    name?: string | null;
    level?: SkillLevel | null;
    progress?: number | null;
    createdAt: string;
    updatedAt: string;
  } | null;
};

export type UpdateEmployeeSkillMutationVariables = {
  input: UpdateEmployeeSkillInput;
  condition?: ModelEmployeeSkillConditionInput | null;
};

export type UpdateEmployeeSkillMutation = {
  updateEmployeeSkill?: {
    __typename: 'EmployeeSkill';
    id: string;
    employeeId: string;
    skillGroup?: string | null;
    skill?: string | null;
    name?: string | null;
    level?: SkillLevel | null;
    progress?: number | null;
    createdAt: string;
    updatedAt: string;
  } | null;
};

export type DeleteEmployeeSkillMutationVariables = {
  input: DeleteEmployeeSkillInput;
  condition?: ModelEmployeeSkillConditionInput | null;
};

export type DeleteEmployeeSkillMutation = {
  deleteEmployeeSkill?: {
    __typename: 'EmployeeSkill';
    id: string;
    employeeId: string;
    skillGroup?: string | null;
    skill?: string | null;
    name?: string | null;
    level?: SkillLevel | null;
    progress?: number | null;
    createdAt: string;
    updatedAt: string;
  } | null;
};

export type CreateEmployeeTrainingMutationVariables = {
  input: CreateEmployeeTrainingInput;
  condition?: ModelEmployeeTrainingConditionInput | null;
};

export type CreateEmployeeTrainingMutation = {
  createEmployeeTraining?: {
    __typename: 'EmployeeTraining';
    id: string;
    employeeId: string;
    date?: string | null;
    name?: string | null;
    description?: string | null;
    type?: TrainingType | null;
    createdAt: string;
    updatedAt: string;
  } | null;
};

export type UpdateEmployeeTrainingMutationVariables = {
  input: UpdateEmployeeTrainingInput;
  condition?: ModelEmployeeTrainingConditionInput | null;
};

export type UpdateEmployeeTrainingMutation = {
  updateEmployeeTraining?: {
    __typename: 'EmployeeTraining';
    id: string;
    employeeId: string;
    date?: string | null;
    name?: string | null;
    description?: string | null;
    type?: TrainingType | null;
    createdAt: string;
    updatedAt: string;
  } | null;
};

export type DeleteEmployeeTrainingMutationVariables = {
  input: DeleteEmployeeTrainingInput;
  condition?: ModelEmployeeTrainingConditionInput | null;
};

export type DeleteEmployeeTrainingMutation = {
  deleteEmployeeTraining?: {
    __typename: 'EmployeeTraining';
    id: string;
    employeeId: string;
    date?: string | null;
    name?: string | null;
    description?: string | null;
    type?: TrainingType | null;
    createdAt: string;
    updatedAt: string;
  } | null;
};

export type CreateEmployeeRewardMutationVariables = {
  input: CreateEmployeeRewardInput;
  condition?: ModelEmployeeRewardConditionInput | null;
};

export type CreateEmployeeRewardMutation = {
  createEmployeeReward?: {
    __typename: 'EmployeeReward';
    id: string;
    employeeId: string;
    date?: string | null;
    name?: string | null;
    description?: string | null;
    type?: RewardType | null;
    createdAt: string;
    updatedAt: string;
  } | null;
};

export type UpdateEmployeeRewardMutationVariables = {
  input: UpdateEmployeeRewardInput;
  condition?: ModelEmployeeRewardConditionInput | null;
};

export type UpdateEmployeeRewardMutation = {
  updateEmployeeReward?: {
    __typename: 'EmployeeReward';
    id: string;
    employeeId: string;
    date?: string | null;
    name?: string | null;
    description?: string | null;
    type?: RewardType | null;
    createdAt: string;
    updatedAt: string;
  } | null;
};

export type DeleteEmployeeRewardMutationVariables = {
  input: DeleteEmployeeRewardInput;
  condition?: ModelEmployeeRewardConditionInput | null;
};

export type DeleteEmployeeRewardMutation = {
  deleteEmployeeReward?: {
    __typename: 'EmployeeReward';
    id: string;
    employeeId: string;
    date?: string | null;
    name?: string | null;
    description?: string | null;
    type?: RewardType | null;
    createdAt: string;
    updatedAt: string;
  } | null;
};

export type CreateActivityMutationVariables = {
  input: CreateActivityInput;
  condition?: ModelActivityConditionInput | null;
};

export type CreateActivityMutation = {
  createActivity?: {
    __typename: 'Activity';
    id: string;
    name?: string | null;
    point?: number | null;
    createdAt: string;
    updatedAt: string;
  } | null;
};

export type UpdateActivityMutationVariables = {
  input: UpdateActivityInput;
  condition?: ModelActivityConditionInput | null;
};

export type UpdateActivityMutation = {
  updateActivity?: {
    __typename: 'Activity';
    id: string;
    name?: string | null;
    point?: number | null;
    createdAt: string;
    updatedAt: string;
  } | null;
};

export type DeleteActivityMutationVariables = {
  input: DeleteActivityInput;
  condition?: ModelActivityConditionInput | null;
};

export type DeleteActivityMutation = {
  deleteActivity?: {
    __typename: 'Activity';
    id: string;
    name?: string | null;
    point?: number | null;
    createdAt: string;
    updatedAt: string;
  } | null;
};

export type CreateBadgeMutationVariables = {
  input: CreateBadgeInput;
  condition?: ModelBadgeConditionInput | null;
};

export type CreateBadgeMutation = {
  createBadge?: {
    __typename: 'Badge';
    id: string;
    name?: string | null;
    iconUrl?: string | null;
    createdAt: string;
    updatedAt: string;
  } | null;
};

export type UpdateBadgeMutationVariables = {
  input: UpdateBadgeInput;
  condition?: ModelBadgeConditionInput | null;
};

export type UpdateBadgeMutation = {
  updateBadge?: {
    __typename: 'Badge';
    id: string;
    name?: string | null;
    iconUrl?: string | null;
    createdAt: string;
    updatedAt: string;
  } | null;
};

export type DeleteBadgeMutationVariables = {
  input: DeleteBadgeInput;
  condition?: ModelBadgeConditionInput | null;
};

export type DeleteBadgeMutation = {
  deleteBadge?: {
    __typename: 'Badge';
    id: string;
    name?: string | null;
    iconUrl?: string | null;
    createdAt: string;
    updatedAt: string;
  } | null;
};

export type CreateKnowledgeMapMutationVariables = {
  input: CreateKnowledgeMapInput;
  condition?: ModelKnowledgeMapConditionInput | null;
};

export type CreateKnowledgeMapMutation = {
  createKnowledgeMap?: {
    __typename: 'KnowledgeMap';
    id: string;
    name?: string | null;
    ownerId: string;
    businessProcesses?: {
      __typename: 'ModelBusinessProcessConnection';
      nextToken?: string | null;
    } | null;
    collaborators?: {
      __typename: 'ModelKnowledgeMapCollaboratorConnection';
      nextToken?: string | null;
    } | null;
    createdAt: string;
    updatedAt: string;
  } | null;
};

export type UpdateKnowledgeMapMutationVariables = {
  input: UpdateKnowledgeMapInput;
  condition?: ModelKnowledgeMapConditionInput | null;
};

export type UpdateKnowledgeMapMutation = {
  updateKnowledgeMap?: {
    __typename: 'KnowledgeMap';
    id: string;
    name?: string | null;
    ownerId: string;
    businessProcesses?: {
      __typename: 'ModelBusinessProcessConnection';
      nextToken?: string | null;
    } | null;
    collaborators?: {
      __typename: 'ModelKnowledgeMapCollaboratorConnection';
      nextToken?: string | null;
    } | null;
    createdAt: string;
    updatedAt: string;
  } | null;
};

export type DeleteKnowledgeMapMutationVariables = {
  input: DeleteKnowledgeMapInput;
  condition?: ModelKnowledgeMapConditionInput | null;
};

export type DeleteKnowledgeMapMutation = {
  deleteKnowledgeMap?: {
    __typename: 'KnowledgeMap';
    id: string;
    name?: string | null;
    ownerId: string;
    businessProcesses?: {
      __typename: 'ModelBusinessProcessConnection';
      nextToken?: string | null;
    } | null;
    collaborators?: {
      __typename: 'ModelKnowledgeMapCollaboratorConnection';
      nextToken?: string | null;
    } | null;
    createdAt: string;
    updatedAt: string;
  } | null;
};

export type CreateKnowledgeMapCollaboratorMutationVariables = {
  input: CreateKnowledgeMapCollaboratorInput;
  condition?: ModelKnowledgeMapCollaboratorConditionInput | null;
};

export type CreateKnowledgeMapCollaboratorMutation = {
  createKnowledgeMapCollaborator?: {
    __typename: 'KnowledgeMapCollaborator';
    id: string;
    employeeId?: string | null;
    employee?: {
      __typename: 'Employee';
      id: string;
      organizationId?: string | null;
      organizationUnitId?: string | null;
      userId: string;
      nik: string;
      status: EmploymentStatus;
      domicile?: string | null;
      managerId?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    knowledgeMapId: string;
    createdAt: string;
    updatedAt: string;
  } | null;
};

export type UpdateKnowledgeMapCollaboratorMutationVariables = {
  input: UpdateKnowledgeMapCollaboratorInput;
  condition?: ModelKnowledgeMapCollaboratorConditionInput | null;
};

export type UpdateKnowledgeMapCollaboratorMutation = {
  updateKnowledgeMapCollaborator?: {
    __typename: 'KnowledgeMapCollaborator';
    id: string;
    employeeId?: string | null;
    employee?: {
      __typename: 'Employee';
      id: string;
      organizationId?: string | null;
      organizationUnitId?: string | null;
      userId: string;
      nik: string;
      status: EmploymentStatus;
      domicile?: string | null;
      managerId?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    knowledgeMapId: string;
    createdAt: string;
    updatedAt: string;
  } | null;
};

export type DeleteKnowledgeMapCollaboratorMutationVariables = {
  input: DeleteKnowledgeMapCollaboratorInput;
  condition?: ModelKnowledgeMapCollaboratorConditionInput | null;
};

export type DeleteKnowledgeMapCollaboratorMutation = {
  deleteKnowledgeMapCollaborator?: {
    __typename: 'KnowledgeMapCollaborator';
    id: string;
    employeeId?: string | null;
    employee?: {
      __typename: 'Employee';
      id: string;
      organizationId?: string | null;
      organizationUnitId?: string | null;
      userId: string;
      nik: string;
      status: EmploymentStatus;
      domicile?: string | null;
      managerId?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    knowledgeMapId: string;
    createdAt: string;
    updatedAt: string;
  } | null;
};

export type CreateBusinessProcessMutationVariables = {
  input: CreateBusinessProcessInput;
  condition?: ModelBusinessProcessConditionInput | null;
};

export type CreateBusinessProcessMutation = {
  createBusinessProcess?: {
    __typename: 'BusinessProcess';
    id: string;
    knowledgeMapId: string;
    title: string;
    description: string;
    strategicActivities?: {
      __typename: 'ModelStrategicActivityConnection';
      nextToken?: string | null;
    } | null;
    comments?: {
      __typename: 'ModelBusinessProcessCommentConnection';
      nextToken?: string | null;
    } | null;
    createdAt: string;
    updatedAt: string;
  } | null;
};

export type UpdateBusinessProcessMutationVariables = {
  input: UpdateBusinessProcessInput;
  condition?: ModelBusinessProcessConditionInput | null;
};

export type UpdateBusinessProcessMutation = {
  updateBusinessProcess?: {
    __typename: 'BusinessProcess';
    id: string;
    knowledgeMapId: string;
    title: string;
    description: string;
    strategicActivities?: {
      __typename: 'ModelStrategicActivityConnection';
      nextToken?: string | null;
    } | null;
    comments?: {
      __typename: 'ModelBusinessProcessCommentConnection';
      nextToken?: string | null;
    } | null;
    createdAt: string;
    updatedAt: string;
  } | null;
};

export type DeleteBusinessProcessMutationVariables = {
  input: DeleteBusinessProcessInput;
  condition?: ModelBusinessProcessConditionInput | null;
};

export type DeleteBusinessProcessMutation = {
  deleteBusinessProcess?: {
    __typename: 'BusinessProcess';
    id: string;
    knowledgeMapId: string;
    title: string;
    description: string;
    strategicActivities?: {
      __typename: 'ModelStrategicActivityConnection';
      nextToken?: string | null;
    } | null;
    comments?: {
      __typename: 'ModelBusinessProcessCommentConnection';
      nextToken?: string | null;
    } | null;
    createdAt: string;
    updatedAt: string;
  } | null;
};

export type CreateBusinessProcessCommentMutationVariables = {
  input: CreateBusinessProcessCommentInput;
  condition?: ModelBusinessProcessCommentConditionInput | null;
};

export type CreateBusinessProcessCommentMutation = {
  createBusinessProcessComment?: {
    __typename: 'BusinessProcessComment';
    id: string;
    businessProcessId: string;
    comment: string;
    createdById: string;
    createdBy?: {
      __typename: 'Employee';
      id: string;
      organizationId?: string | null;
      organizationUnitId?: string | null;
      userId: string;
      nik: string;
      status: EmploymentStatus;
      domicile?: string | null;
      managerId?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    parentId?: string | null;
    replies?: {
      __typename: 'ModelBusinessProcessCommentConnection';
      nextToken?: string | null;
    } | null;
    createdAt: string;
    updatedAt: string;
  } | null;
};

export type UpdateBusinessProcessCommentMutationVariables = {
  input: UpdateBusinessProcessCommentInput;
  condition?: ModelBusinessProcessCommentConditionInput | null;
};

export type UpdateBusinessProcessCommentMutation = {
  updateBusinessProcessComment?: {
    __typename: 'BusinessProcessComment';
    id: string;
    businessProcessId: string;
    comment: string;
    createdById: string;
    createdBy?: {
      __typename: 'Employee';
      id: string;
      organizationId?: string | null;
      organizationUnitId?: string | null;
      userId: string;
      nik: string;
      status: EmploymentStatus;
      domicile?: string | null;
      managerId?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    parentId?: string | null;
    replies?: {
      __typename: 'ModelBusinessProcessCommentConnection';
      nextToken?: string | null;
    } | null;
    createdAt: string;
    updatedAt: string;
  } | null;
};

export type DeleteBusinessProcessCommentMutationVariables = {
  input: DeleteBusinessProcessCommentInput;
  condition?: ModelBusinessProcessCommentConditionInput | null;
};

export type DeleteBusinessProcessCommentMutation = {
  deleteBusinessProcessComment?: {
    __typename: 'BusinessProcessComment';
    id: string;
    businessProcessId: string;
    comment: string;
    createdById: string;
    createdBy?: {
      __typename: 'Employee';
      id: string;
      organizationId?: string | null;
      organizationUnitId?: string | null;
      userId: string;
      nik: string;
      status: EmploymentStatus;
      domicile?: string | null;
      managerId?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    parentId?: string | null;
    replies?: {
      __typename: 'ModelBusinessProcessCommentConnection';
      nextToken?: string | null;
    } | null;
    createdAt: string;
    updatedAt: string;
  } | null;
};

export type CreateStrategicActivityMutationVariables = {
  input: CreateStrategicActivityInput;
  condition?: ModelStrategicActivityConditionInput | null;
};

export type CreateStrategicActivityMutation = {
  createStrategicActivity?: {
    __typename: 'StrategicActivity';
    id: string;
    businessProcessId: string;
    title: string;
    description: string;
    importantKnowledges?: {
      __typename: 'ModelImportantKnowledgeConnection';
      nextToken?: string | null;
    } | null;
    comments?: {
      __typename: 'ModelStrategicActivityCommentConnection';
      nextToken?: string | null;
    } | null;
    createdAt: string;
    updatedAt: string;
  } | null;
};

export type UpdateStrategicActivityMutationVariables = {
  input: UpdateStrategicActivityInput;
  condition?: ModelStrategicActivityConditionInput | null;
};

export type UpdateStrategicActivityMutation = {
  updateStrategicActivity?: {
    __typename: 'StrategicActivity';
    id: string;
    businessProcessId: string;
    title: string;
    description: string;
    importantKnowledges?: {
      __typename: 'ModelImportantKnowledgeConnection';
      nextToken?: string | null;
    } | null;
    comments?: {
      __typename: 'ModelStrategicActivityCommentConnection';
      nextToken?: string | null;
    } | null;
    createdAt: string;
    updatedAt: string;
  } | null;
};

export type DeleteStrategicActivityMutationVariables = {
  input: DeleteStrategicActivityInput;
  condition?: ModelStrategicActivityConditionInput | null;
};

export type DeleteStrategicActivityMutation = {
  deleteStrategicActivity?: {
    __typename: 'StrategicActivity';
    id: string;
    businessProcessId: string;
    title: string;
    description: string;
    importantKnowledges?: {
      __typename: 'ModelImportantKnowledgeConnection';
      nextToken?: string | null;
    } | null;
    comments?: {
      __typename: 'ModelStrategicActivityCommentConnection';
      nextToken?: string | null;
    } | null;
    createdAt: string;
    updatedAt: string;
  } | null;
};

export type CreateStrategicActivityCommentMutationVariables = {
  input: CreateStrategicActivityCommentInput;
  condition?: ModelStrategicActivityCommentConditionInput | null;
};

export type CreateStrategicActivityCommentMutation = {
  createStrategicActivityComment?: {
    __typename: 'StrategicActivityComment';
    id: string;
    strategicActivityId: string;
    comment: string;
    createdById: string;
    createdBy?: {
      __typename: 'Employee';
      id: string;
      organizationId?: string | null;
      organizationUnitId?: string | null;
      userId: string;
      nik: string;
      status: EmploymentStatus;
      domicile?: string | null;
      managerId?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    parentId?: string | null;
    replies?: {
      __typename: 'ModelStrategicActivityCommentConnection';
      nextToken?: string | null;
    } | null;
    createdAt: string;
    updatedAt: string;
  } | null;
};

export type UpdateStrategicActivityCommentMutationVariables = {
  input: UpdateStrategicActivityCommentInput;
  condition?: ModelStrategicActivityCommentConditionInput | null;
};

export type UpdateStrategicActivityCommentMutation = {
  updateStrategicActivityComment?: {
    __typename: 'StrategicActivityComment';
    id: string;
    strategicActivityId: string;
    comment: string;
    createdById: string;
    createdBy?: {
      __typename: 'Employee';
      id: string;
      organizationId?: string | null;
      organizationUnitId?: string | null;
      userId: string;
      nik: string;
      status: EmploymentStatus;
      domicile?: string | null;
      managerId?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    parentId?: string | null;
    replies?: {
      __typename: 'ModelStrategicActivityCommentConnection';
      nextToken?: string | null;
    } | null;
    createdAt: string;
    updatedAt: string;
  } | null;
};

export type DeleteStrategicActivityCommentMutationVariables = {
  input: DeleteStrategicActivityCommentInput;
  condition?: ModelStrategicActivityCommentConditionInput | null;
};

export type DeleteStrategicActivityCommentMutation = {
  deleteStrategicActivityComment?: {
    __typename: 'StrategicActivityComment';
    id: string;
    strategicActivityId: string;
    comment: string;
    createdById: string;
    createdBy?: {
      __typename: 'Employee';
      id: string;
      organizationId?: string | null;
      organizationUnitId?: string | null;
      userId: string;
      nik: string;
      status: EmploymentStatus;
      domicile?: string | null;
      managerId?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    parentId?: string | null;
    replies?: {
      __typename: 'ModelStrategicActivityCommentConnection';
      nextToken?: string | null;
    } | null;
    createdAt: string;
    updatedAt: string;
  } | null;
};

export type CreateImportantKnowledgeMutationVariables = {
  input: CreateImportantKnowledgeInput;
  condition?: ModelImportantKnowledgeConditionInput | null;
};

export type CreateImportantKnowledgeMutation = {
  createImportantKnowledge?: {
    __typename: 'ImportantKnowledge';
    id: string;
    strategicActivityId: string;
    title: string;
    description: string;
    documents?: {
      __typename: 'ModelImportantKnowledgeDocumentConnection';
      nextToken?: string | null;
    } | null;
    comments?: {
      __typename: 'ModelImportantKnowledgeCommentConnection';
      nextToken?: string | null;
    } | null;
    createdAt: string;
    updatedAt: string;
  } | null;
};

export type UpdateImportantKnowledgeMutationVariables = {
  input: UpdateImportantKnowledgeInput;
  condition?: ModelImportantKnowledgeConditionInput | null;
};

export type UpdateImportantKnowledgeMutation = {
  updateImportantKnowledge?: {
    __typename: 'ImportantKnowledge';
    id: string;
    strategicActivityId: string;
    title: string;
    description: string;
    documents?: {
      __typename: 'ModelImportantKnowledgeDocumentConnection';
      nextToken?: string | null;
    } | null;
    comments?: {
      __typename: 'ModelImportantKnowledgeCommentConnection';
      nextToken?: string | null;
    } | null;
    createdAt: string;
    updatedAt: string;
  } | null;
};

export type DeleteImportantKnowledgeMutationVariables = {
  input: DeleteImportantKnowledgeInput;
  condition?: ModelImportantKnowledgeConditionInput | null;
};

export type DeleteImportantKnowledgeMutation = {
  deleteImportantKnowledge?: {
    __typename: 'ImportantKnowledge';
    id: string;
    strategicActivityId: string;
    title: string;
    description: string;
    documents?: {
      __typename: 'ModelImportantKnowledgeDocumentConnection';
      nextToken?: string | null;
    } | null;
    comments?: {
      __typename: 'ModelImportantKnowledgeCommentConnection';
      nextToken?: string | null;
    } | null;
    createdAt: string;
    updatedAt: string;
  } | null;
};

export type CreateImportantKnowledgeCommentMutationVariables = {
  input: CreateImportantKnowledgeCommentInput;
  condition?: ModelImportantKnowledgeCommentConditionInput | null;
};

export type CreateImportantKnowledgeCommentMutation = {
  createImportantKnowledgeComment?: {
    __typename: 'ImportantKnowledgeComment';
    id: string;
    importantKnowledgeId: string;
    comment: string;
    createdById: string;
    createdBy?: {
      __typename: 'Employee';
      id: string;
      organizationId?: string | null;
      organizationUnitId?: string | null;
      userId: string;
      nik: string;
      status: EmploymentStatus;
      domicile?: string | null;
      managerId?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    parentId?: string | null;
    replies?: {
      __typename: 'ModelImportantKnowledgeCommentConnection';
      nextToken?: string | null;
    } | null;
    createdAt: string;
    updatedAt: string;
  } | null;
};

export type UpdateImportantKnowledgeCommentMutationVariables = {
  input: UpdateImportantKnowledgeCommentInput;
  condition?: ModelImportantKnowledgeCommentConditionInput | null;
};

export type UpdateImportantKnowledgeCommentMutation = {
  updateImportantKnowledgeComment?: {
    __typename: 'ImportantKnowledgeComment';
    id: string;
    importantKnowledgeId: string;
    comment: string;
    createdById: string;
    createdBy?: {
      __typename: 'Employee';
      id: string;
      organizationId?: string | null;
      organizationUnitId?: string | null;
      userId: string;
      nik: string;
      status: EmploymentStatus;
      domicile?: string | null;
      managerId?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    parentId?: string | null;
    replies?: {
      __typename: 'ModelImportantKnowledgeCommentConnection';
      nextToken?: string | null;
    } | null;
    createdAt: string;
    updatedAt: string;
  } | null;
};

export type DeleteImportantKnowledgeCommentMutationVariables = {
  input: DeleteImportantKnowledgeCommentInput;
  condition?: ModelImportantKnowledgeCommentConditionInput | null;
};

export type DeleteImportantKnowledgeCommentMutation = {
  deleteImportantKnowledgeComment?: {
    __typename: 'ImportantKnowledgeComment';
    id: string;
    importantKnowledgeId: string;
    comment: string;
    createdById: string;
    createdBy?: {
      __typename: 'Employee';
      id: string;
      organizationId?: string | null;
      organizationUnitId?: string | null;
      userId: string;
      nik: string;
      status: EmploymentStatus;
      domicile?: string | null;
      managerId?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    parentId?: string | null;
    replies?: {
      __typename: 'ModelImportantKnowledgeCommentConnection';
      nextToken?: string | null;
    } | null;
    createdAt: string;
    updatedAt: string;
  } | null;
};

export type CreateImportantKnowledgeDocumentMutationVariables = {
  input: CreateImportantKnowledgeDocumentInput;
  condition?: ModelImportantKnowledgeDocumentConditionInput | null;
};

export type CreateImportantKnowledgeDocumentMutation = {
  createImportantKnowledgeDocument?: {
    __typename: 'ImportantKnowledgeDocument';
    id: string;
    importantKnowledgeId: string;
    documentType: ImportantKnowledgeDocumentType;
    documentId: string;
    document?: {
      __typename: 'RepositoryFile';
      id: string;
      folderId: string;
      filename?: string | null;
      filetype?: FileMediaType | null;
      createdById: string;
      createdAt: string;
      updatedAt: string;
    } | null;
    creatorId: string;
    creator?: {
      __typename: 'Employee';
      id: string;
      organizationId?: string | null;
      organizationUnitId?: string | null;
      userId: string;
      nik: string;
      status: EmploymentStatus;
      domicile?: string | null;
      managerId?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    createdAt: string;
    updatedAt: string;
  } | null;
};

export type UpdateImportantKnowledgeDocumentMutationVariables = {
  input: UpdateImportantKnowledgeDocumentInput;
  condition?: ModelImportantKnowledgeDocumentConditionInput | null;
};

export type UpdateImportantKnowledgeDocumentMutation = {
  updateImportantKnowledgeDocument?: {
    __typename: 'ImportantKnowledgeDocument';
    id: string;
    importantKnowledgeId: string;
    documentType: ImportantKnowledgeDocumentType;
    documentId: string;
    document?: {
      __typename: 'RepositoryFile';
      id: string;
      folderId: string;
      filename?: string | null;
      filetype?: FileMediaType | null;
      createdById: string;
      createdAt: string;
      updatedAt: string;
    } | null;
    creatorId: string;
    creator?: {
      __typename: 'Employee';
      id: string;
      organizationId?: string | null;
      organizationUnitId?: string | null;
      userId: string;
      nik: string;
      status: EmploymentStatus;
      domicile?: string | null;
      managerId?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    createdAt: string;
    updatedAt: string;
  } | null;
};

export type DeleteImportantKnowledgeDocumentMutationVariables = {
  input: DeleteImportantKnowledgeDocumentInput;
  condition?: ModelImportantKnowledgeDocumentConditionInput | null;
};

export type DeleteImportantKnowledgeDocumentMutation = {
  deleteImportantKnowledgeDocument?: {
    __typename: 'ImportantKnowledgeDocument';
    id: string;
    importantKnowledgeId: string;
    documentType: ImportantKnowledgeDocumentType;
    documentId: string;
    document?: {
      __typename: 'RepositoryFile';
      id: string;
      folderId: string;
      filename?: string | null;
      filetype?: FileMediaType | null;
      createdById: string;
      createdAt: string;
      updatedAt: string;
    } | null;
    creatorId: string;
    creator?: {
      __typename: 'Employee';
      id: string;
      organizationId?: string | null;
      organizationUnitId?: string | null;
      userId: string;
      nik: string;
      status: EmploymentStatus;
      domicile?: string | null;
      managerId?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    createdAt: string;
    updatedAt: string;
  } | null;
};

export type CreateCompetencyFieldMutationVariables = {
  input: CreateCompetencyFieldInput;
  condition?: ModelCompetencyFieldConditionInput | null;
};

export type CreateCompetencyFieldMutation = {
  createCompetencyField?: {
    __typename: 'CompetencyField';
    id: string;
    name: string;
    createdAt: string;
    updatedAt: string;
  } | null;
};

export type UpdateCompetencyFieldMutationVariables = {
  input: UpdateCompetencyFieldInput;
  condition?: ModelCompetencyFieldConditionInput | null;
};

export type UpdateCompetencyFieldMutation = {
  updateCompetencyField?: {
    __typename: 'CompetencyField';
    id: string;
    name: string;
    createdAt: string;
    updatedAt: string;
  } | null;
};

export type DeleteCompetencyFieldMutationVariables = {
  input: DeleteCompetencyFieldInput;
  condition?: ModelCompetencyFieldConditionInput | null;
};

export type DeleteCompetencyFieldMutation = {
  deleteCompetencyField?: {
    __typename: 'CompetencyField';
    id: string;
    name: string;
    createdAt: string;
    updatedAt: string;
  } | null;
};

export type CreateSubjectMatterExpertMutationVariables = {
  input: CreateSubjectMatterExpertInput;
  condition?: ModelSubjectMatterExpertConditionInput | null;
};

export type CreateSubjectMatterExpertMutation = {
  createSubjectMatterExpert?: {
    __typename: 'SubjectMatterExpert';
    id: string;
    employeeId: string;
    employee?: {
      __typename: 'Employee';
      id: string;
      organizationId?: string | null;
      organizationUnitId?: string | null;
      userId: string;
      nik: string;
      status: EmploymentStatus;
      domicile?: string | null;
      managerId?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    competencies?: {
      __typename: 'ModelSubjectMatterExpertCompetencyConnection';
      nextToken?: string | null;
    } | null;
    createdAt: string;
    updatedAt: string;
  } | null;
};

export type UpdateSubjectMatterExpertMutationVariables = {
  input: UpdateSubjectMatterExpertInput;
  condition?: ModelSubjectMatterExpertConditionInput | null;
};

export type UpdateSubjectMatterExpertMutation = {
  updateSubjectMatterExpert?: {
    __typename: 'SubjectMatterExpert';
    id: string;
    employeeId: string;
    employee?: {
      __typename: 'Employee';
      id: string;
      organizationId?: string | null;
      organizationUnitId?: string | null;
      userId: string;
      nik: string;
      status: EmploymentStatus;
      domicile?: string | null;
      managerId?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    competencies?: {
      __typename: 'ModelSubjectMatterExpertCompetencyConnection';
      nextToken?: string | null;
    } | null;
    createdAt: string;
    updatedAt: string;
  } | null;
};

export type DeleteSubjectMatterExpertMutationVariables = {
  input: DeleteSubjectMatterExpertInput;
  condition?: ModelSubjectMatterExpertConditionInput | null;
};

export type DeleteSubjectMatterExpertMutation = {
  deleteSubjectMatterExpert?: {
    __typename: 'SubjectMatterExpert';
    id: string;
    employeeId: string;
    employee?: {
      __typename: 'Employee';
      id: string;
      organizationId?: string | null;
      organizationUnitId?: string | null;
      userId: string;
      nik: string;
      status: EmploymentStatus;
      domicile?: string | null;
      managerId?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    competencies?: {
      __typename: 'ModelSubjectMatterExpertCompetencyConnection';
      nextToken?: string | null;
    } | null;
    createdAt: string;
    updatedAt: string;
  } | null;
};

export type CreateSubjectMatterExpertCompetencyMutationVariables = {
  input: CreateSubjectMatterExpertCompetencyInput;
  condition?: ModelSubjectMatterExpertCompetencyConditionInput | null;
};

export type CreateSubjectMatterExpertCompetencyMutation = {
  createSubjectMatterExpertCompetency?: {
    __typename: 'SubjectMatterExpertCompetency';
    id: string;
    subjectMatterExpertId: string;
    competencyFieldId: string;
    competencyField?: {
      __typename: 'CompetencyField';
      id: string;
      name: string;
      createdAt: string;
      updatedAt: string;
    } | null;
    createdAt: string;
    updatedAt: string;
  } | null;
};

export type UpdateSubjectMatterExpertCompetencyMutationVariables = {
  input: UpdateSubjectMatterExpertCompetencyInput;
  condition?: ModelSubjectMatterExpertCompetencyConditionInput | null;
};

export type UpdateSubjectMatterExpertCompetencyMutation = {
  updateSubjectMatterExpertCompetency?: {
    __typename: 'SubjectMatterExpertCompetency';
    id: string;
    subjectMatterExpertId: string;
    competencyFieldId: string;
    competencyField?: {
      __typename: 'CompetencyField';
      id: string;
      name: string;
      createdAt: string;
      updatedAt: string;
    } | null;
    createdAt: string;
    updatedAt: string;
  } | null;
};

export type DeleteSubjectMatterExpertCompetencyMutationVariables = {
  input: DeleteSubjectMatterExpertCompetencyInput;
  condition?: ModelSubjectMatterExpertCompetencyConditionInput | null;
};

export type DeleteSubjectMatterExpertCompetencyMutation = {
  deleteSubjectMatterExpertCompetency?: {
    __typename: 'SubjectMatterExpertCompetency';
    id: string;
    subjectMatterExpertId: string;
    competencyFieldId: string;
    competencyField?: {
      __typename: 'CompetencyField';
      id: string;
      name: string;
      createdAt: string;
      updatedAt: string;
    } | null;
    createdAt: string;
    updatedAt: string;
  } | null;
};

export type CreateRepositoryFolderMutationVariables = {
  input: CreateRepositoryFolderInput;
  condition?: ModelRepositoryFolderConditionInput | null;
};

export type CreateRepositoryFolderMutation = {
  createRepositoryFolder?: {
    __typename: 'RepositoryFolder';
    id: string;
    files?: {
      __typename: 'ModelRepositoryFileConnection';
      nextToken?: string | null;
    } | null;
    foldername?: string | null;
    parentId?: string | null;
    parent?: {
      __typename: 'RepositoryFolder';
      id: string;
      foldername?: string | null;
      parentId?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    replies?: {
      __typename: 'ModelRepositoryFolderConnection';
      nextToken?: string | null;
    } | null;
    createdAt: string;
    updatedAt: string;
  } | null;
};

export type UpdateRepositoryFolderMutationVariables = {
  input: UpdateRepositoryFolderInput;
  condition?: ModelRepositoryFolderConditionInput | null;
};

export type UpdateRepositoryFolderMutation = {
  updateRepositoryFolder?: {
    __typename: 'RepositoryFolder';
    id: string;
    files?: {
      __typename: 'ModelRepositoryFileConnection';
      nextToken?: string | null;
    } | null;
    foldername?: string | null;
    parentId?: string | null;
    parent?: {
      __typename: 'RepositoryFolder';
      id: string;
      foldername?: string | null;
      parentId?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    replies?: {
      __typename: 'ModelRepositoryFolderConnection';
      nextToken?: string | null;
    } | null;
    createdAt: string;
    updatedAt: string;
  } | null;
};

export type DeleteRepositoryFolderMutationVariables = {
  input: DeleteRepositoryFolderInput;
  condition?: ModelRepositoryFolderConditionInput | null;
};

export type DeleteRepositoryFolderMutation = {
  deleteRepositoryFolder?: {
    __typename: 'RepositoryFolder';
    id: string;
    files?: {
      __typename: 'ModelRepositoryFileConnection';
      nextToken?: string | null;
    } | null;
    foldername?: string | null;
    parentId?: string | null;
    parent?: {
      __typename: 'RepositoryFolder';
      id: string;
      foldername?: string | null;
      parentId?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    replies?: {
      __typename: 'ModelRepositoryFolderConnection';
      nextToken?: string | null;
    } | null;
    createdAt: string;
    updatedAt: string;
  } | null;
};

export type CreateRepositoryFileMutationVariables = {
  input: CreateRepositoryFileInput;
  condition?: ModelRepositoryFileConditionInput | null;
};

export type CreateRepositoryFileMutation = {
  createRepositoryFile?: {
    __typename: 'RepositoryFile';
    id: string;
    folderId: string;
    filename?: string | null;
    filetype?: FileMediaType | null;
    createdById: string;
    createdBy?: {
      __typename: 'Employee';
      id: string;
      organizationId?: string | null;
      organizationUnitId?: string | null;
      userId: string;
      nik: string;
      status: EmploymentStatus;
      domicile?: string | null;
      managerId?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    createdAt: string;
    updatedAt: string;
  } | null;
};

export type UpdateRepositoryFileMutationVariables = {
  input: UpdateRepositoryFileInput;
  condition?: ModelRepositoryFileConditionInput | null;
};

export type UpdateRepositoryFileMutation = {
  updateRepositoryFile?: {
    __typename: 'RepositoryFile';
    id: string;
    folderId: string;
    filename?: string | null;
    filetype?: FileMediaType | null;
    createdById: string;
    createdBy?: {
      __typename: 'Employee';
      id: string;
      organizationId?: string | null;
      organizationUnitId?: string | null;
      userId: string;
      nik: string;
      status: EmploymentStatus;
      domicile?: string | null;
      managerId?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    createdAt: string;
    updatedAt: string;
  } | null;
};

export type DeleteRepositoryFileMutationVariables = {
  input: DeleteRepositoryFileInput;
  condition?: ModelRepositoryFileConditionInput | null;
};

export type DeleteRepositoryFileMutation = {
  deleteRepositoryFile?: {
    __typename: 'RepositoryFile';
    id: string;
    folderId: string;
    filename?: string | null;
    filetype?: FileMediaType | null;
    createdById: string;
    createdBy?: {
      __typename: 'Employee';
      id: string;
      organizationId?: string | null;
      organizationUnitId?: string | null;
      userId: string;
      nik: string;
      status: EmploymentStatus;
      domicile?: string | null;
      managerId?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    createdAt: string;
    updatedAt: string;
  } | null;
};

export type CreateCommunityCategoryMutationVariables = {
  input: CreateCommunityCategoryInput;
  condition?: ModelCommunityCategoryConditionInput | null;
};

export type CreateCommunityCategoryMutation = {
  createCommunityCategory?: {
    __typename: 'CommunityCategory';
    id: string;
    category?: string | null;
    createdAt: string;
    updatedAt: string;
  } | null;
};

export type UpdateCommunityCategoryMutationVariables = {
  input: UpdateCommunityCategoryInput;
  condition?: ModelCommunityCategoryConditionInput | null;
};

export type UpdateCommunityCategoryMutation = {
  updateCommunityCategory?: {
    __typename: 'CommunityCategory';
    id: string;
    category?: string | null;
    createdAt: string;
    updatedAt: string;
  } | null;
};

export type DeleteCommunityCategoryMutationVariables = {
  input: DeleteCommunityCategoryInput;
  condition?: ModelCommunityCategoryConditionInput | null;
};

export type DeleteCommunityCategoryMutation = {
  deleteCommunityCategory?: {
    __typename: 'CommunityCategory';
    id: string;
    category?: string | null;
    createdAt: string;
    updatedAt: string;
  } | null;
};

export type CreateCommunityMutationVariables = {
  input: CreateCommunityInput;
  condition?: ModelCommunityConditionInput | null;
};

export type CreateCommunityMutation = {
  createCommunity?: {
    __typename: 'Community';
    id: string;
    coverUrl?: string | null;
    profileUrl?: string | null;
    name: string;
    description: string;
    tags?: Array<string | null> | null;
    categoryId?: string | null;
    category?: {
      __typename: 'CommunityCategory';
      id: string;
      category?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    unitId?: string | null;
    unit?: {
      __typename: 'OrganizationUnit';
      id: string;
      organizationId?: string | null;
      name: string;
      parentId?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    knowledgeFocus?: Array<string | null> | null;
    objective?: Array<string | null> | null;
    kpi?: Array<string | null> | null;
    policy?: Array<string | null> | null;
    memberCanInvite: boolean;
    reviewNewPost: boolean;
    ownerId?: string | null;
    owner?: {
      __typename: 'User';
      id: string;
      username: string;
      name: string;
      email: string;
      createdAt: string;
      updatedAt: string;
    } | null;
    pendingCoreMembers?: {
      __typename: 'ModelPendingCoreMemberConnection';
      nextToken?: string | null;
    } | null;
    coreMembers?: {
      __typename: 'ModelCoreMemberConnection';
      nextToken?: string | null;
    } | null;
    followers?: {
      __typename: 'ModelCommunityFollowersConnection';
      nextToken?: string | null;
    } | null;
    documentations?: {
      __typename: 'ModelCommunityDocumentationConnection';
      nextToken?: string | null;
    } | null;
    posts?: {
      __typename: 'ModelPostConnection';
      nextToken?: string | null;
    } | null;
    events?: {
      __typename: 'ModelEventConnection';
      nextToken?: string | null;
    } | null;
    type: CommunityType;
    createdAt: string;
    updatedAt: string;
  } | null;
};

export type UpdateCommunityMutationVariables = {
  input: UpdateCommunityInput;
  condition?: ModelCommunityConditionInput | null;
};

export type UpdateCommunityMutation = {
  updateCommunity?: {
    __typename: 'Community';
    id: string;
    coverUrl?: string | null;
    profileUrl?: string | null;
    name: string;
    description: string;
    tags?: Array<string | null> | null;
    categoryId?: string | null;
    category?: {
      __typename: 'CommunityCategory';
      id: string;
      category?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    unitId?: string | null;
    unit?: {
      __typename: 'OrganizationUnit';
      id: string;
      organizationId?: string | null;
      name: string;
      parentId?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    knowledgeFocus?: Array<string | null> | null;
    objective?: Array<string | null> | null;
    kpi?: Array<string | null> | null;
    policy?: Array<string | null> | null;
    memberCanInvite: boolean;
    reviewNewPost: boolean;
    ownerId?: string | null;
    owner?: {
      __typename: 'User';
      id: string;
      username: string;
      name: string;
      email: string;
      createdAt: string;
      updatedAt: string;
    } | null;
    pendingCoreMembers?: {
      __typename: 'ModelPendingCoreMemberConnection';
      nextToken?: string | null;
    } | null;
    coreMembers?: {
      __typename: 'ModelCoreMemberConnection';
      nextToken?: string | null;
    } | null;
    followers?: {
      __typename: 'ModelCommunityFollowersConnection';
      nextToken?: string | null;
    } | null;
    documentations?: {
      __typename: 'ModelCommunityDocumentationConnection';
      nextToken?: string | null;
    } | null;
    posts?: {
      __typename: 'ModelPostConnection';
      nextToken?: string | null;
    } | null;
    events?: {
      __typename: 'ModelEventConnection';
      nextToken?: string | null;
    } | null;
    type: CommunityType;
    createdAt: string;
    updatedAt: string;
  } | null;
};

export type DeleteCommunityMutationVariables = {
  input: DeleteCommunityInput;
  condition?: ModelCommunityConditionInput | null;
};

export type DeleteCommunityMutation = {
  deleteCommunity?: {
    __typename: 'Community';
    id: string;
    coverUrl?: string | null;
    profileUrl?: string | null;
    name: string;
    description: string;
    tags?: Array<string | null> | null;
    categoryId?: string | null;
    category?: {
      __typename: 'CommunityCategory';
      id: string;
      category?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    unitId?: string | null;
    unit?: {
      __typename: 'OrganizationUnit';
      id: string;
      organizationId?: string | null;
      name: string;
      parentId?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    knowledgeFocus?: Array<string | null> | null;
    objective?: Array<string | null> | null;
    kpi?: Array<string | null> | null;
    policy?: Array<string | null> | null;
    memberCanInvite: boolean;
    reviewNewPost: boolean;
    ownerId?: string | null;
    owner?: {
      __typename: 'User';
      id: string;
      username: string;
      name: string;
      email: string;
      createdAt: string;
      updatedAt: string;
    } | null;
    pendingCoreMembers?: {
      __typename: 'ModelPendingCoreMemberConnection';
      nextToken?: string | null;
    } | null;
    coreMembers?: {
      __typename: 'ModelCoreMemberConnection';
      nextToken?: string | null;
    } | null;
    followers?: {
      __typename: 'ModelCommunityFollowersConnection';
      nextToken?: string | null;
    } | null;
    documentations?: {
      __typename: 'ModelCommunityDocumentationConnection';
      nextToken?: string | null;
    } | null;
    posts?: {
      __typename: 'ModelPostConnection';
      nextToken?: string | null;
    } | null;
    events?: {
      __typename: 'ModelEventConnection';
      nextToken?: string | null;
    } | null;
    type: CommunityType;
    createdAt: string;
    updatedAt: string;
  } | null;
};

export type CreatePendingCoreMemberMutationVariables = {
  input: CreatePendingCoreMemberInput;
  condition?: ModelPendingCoreMemberConditionInput | null;
};

export type CreatePendingCoreMemberMutation = {
  createPendingCoreMember?: {
    __typename: 'PendingCoreMember';
    id: string;
    communityId?: string | null;
    employeeId?: string | null;
    employee?: {
      __typename: 'Employee';
      id: string;
      organizationId?: string | null;
      organizationUnitId?: string | null;
      userId: string;
      nik: string;
      status: EmploymentStatus;
      domicile?: string | null;
      managerId?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    createdAt: string;
    updatedAt: string;
  } | null;
};

export type UpdatePendingCoreMemberMutationVariables = {
  input: UpdatePendingCoreMemberInput;
  condition?: ModelPendingCoreMemberConditionInput | null;
};

export type UpdatePendingCoreMemberMutation = {
  updatePendingCoreMember?: {
    __typename: 'PendingCoreMember';
    id: string;
    communityId?: string | null;
    employeeId?: string | null;
    employee?: {
      __typename: 'Employee';
      id: string;
      organizationId?: string | null;
      organizationUnitId?: string | null;
      userId: string;
      nik: string;
      status: EmploymentStatus;
      domicile?: string | null;
      managerId?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    createdAt: string;
    updatedAt: string;
  } | null;
};

export type DeletePendingCoreMemberMutationVariables = {
  input: DeletePendingCoreMemberInput;
  condition?: ModelPendingCoreMemberConditionInput | null;
};

export type DeletePendingCoreMemberMutation = {
  deletePendingCoreMember?: {
    __typename: 'PendingCoreMember';
    id: string;
    communityId?: string | null;
    employeeId?: string | null;
    employee?: {
      __typename: 'Employee';
      id: string;
      organizationId?: string | null;
      organizationUnitId?: string | null;
      userId: string;
      nik: string;
      status: EmploymentStatus;
      domicile?: string | null;
      managerId?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    createdAt: string;
    updatedAt: string;
  } | null;
};

export type CreateCoreMemberMutationVariables = {
  input: CreateCoreMemberInput;
  condition?: ModelCoreMemberConditionInput | null;
};

export type CreateCoreMemberMutation = {
  createCoreMember?: {
    __typename: 'CoreMember';
    id: string;
    communityId?: string | null;
    employeeId?: string | null;
    employee?: {
      __typename: 'Employee';
      id: string;
      organizationId?: string | null;
      organizationUnitId?: string | null;
      userId: string;
      nik: string;
      status: EmploymentStatus;
      domicile?: string | null;
      managerId?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    createdAt: string;
    updatedAt: string;
  } | null;
};

export type UpdateCoreMemberMutationVariables = {
  input: UpdateCoreMemberInput;
  condition?: ModelCoreMemberConditionInput | null;
};

export type UpdateCoreMemberMutation = {
  updateCoreMember?: {
    __typename: 'CoreMember';
    id: string;
    communityId?: string | null;
    employeeId?: string | null;
    employee?: {
      __typename: 'Employee';
      id: string;
      organizationId?: string | null;
      organizationUnitId?: string | null;
      userId: string;
      nik: string;
      status: EmploymentStatus;
      domicile?: string | null;
      managerId?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    createdAt: string;
    updatedAt: string;
  } | null;
};

export type DeleteCoreMemberMutationVariables = {
  input: DeleteCoreMemberInput;
  condition?: ModelCoreMemberConditionInput | null;
};

export type DeleteCoreMemberMutation = {
  deleteCoreMember?: {
    __typename: 'CoreMember';
    id: string;
    communityId?: string | null;
    employeeId?: string | null;
    employee?: {
      __typename: 'Employee';
      id: string;
      organizationId?: string | null;
      organizationUnitId?: string | null;
      userId: string;
      nik: string;
      status: EmploymentStatus;
      domicile?: string | null;
      managerId?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    createdAt: string;
    updatedAt: string;
  } | null;
};

export type CreateCommunityFollowersMutationVariables = {
  input: CreateCommunityFollowersInput;
  condition?: ModelCommunityFollowersConditionInput | null;
};

export type CreateCommunityFollowersMutation = {
  createCommunityFollowers?: {
    __typename: 'CommunityFollowers';
    id: string;
    communityId?: string | null;
    employeeId?: string | null;
    employee?: {
      __typename: 'Employee';
      id: string;
      organizationId?: string | null;
      organizationUnitId?: string | null;
      userId: string;
      nik: string;
      status: EmploymentStatus;
      domicile?: string | null;
      managerId?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    createdAt: string;
    updatedAt: string;
  } | null;
};

export type UpdateCommunityFollowersMutationVariables = {
  input: UpdateCommunityFollowersInput;
  condition?: ModelCommunityFollowersConditionInput | null;
};

export type UpdateCommunityFollowersMutation = {
  updateCommunityFollowers?: {
    __typename: 'CommunityFollowers';
    id: string;
    communityId?: string | null;
    employeeId?: string | null;
    employee?: {
      __typename: 'Employee';
      id: string;
      organizationId?: string | null;
      organizationUnitId?: string | null;
      userId: string;
      nik: string;
      status: EmploymentStatus;
      domicile?: string | null;
      managerId?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    createdAt: string;
    updatedAt: string;
  } | null;
};

export type DeleteCommunityFollowersMutationVariables = {
  input: DeleteCommunityFollowersInput;
  condition?: ModelCommunityFollowersConditionInput | null;
};

export type DeleteCommunityFollowersMutation = {
  deleteCommunityFollowers?: {
    __typename: 'CommunityFollowers';
    id: string;
    communityId?: string | null;
    employeeId?: string | null;
    employee?: {
      __typename: 'Employee';
      id: string;
      organizationId?: string | null;
      organizationUnitId?: string | null;
      userId: string;
      nik: string;
      status: EmploymentStatus;
      domicile?: string | null;
      managerId?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    createdAt: string;
    updatedAt: string;
  } | null;
};

export type CreateCommunityDocumentationMutationVariables = {
  input: CreateCommunityDocumentationInput;
  condition?: ModelCommunityDocumentationConditionInput | null;
};

export type CreateCommunityDocumentationMutation = {
  createCommunityDocumentation?: {
    __typename: 'CommunityDocumentation';
    id: string;
    communityId?: string | null;
    documentId?: string | null;
    document?: {
      __typename: 'RepositoryFile';
      id: string;
      folderId: string;
      filename?: string | null;
      filetype?: FileMediaType | null;
      createdById: string;
      createdAt: string;
      updatedAt: string;
    } | null;
    createdAt: string;
    updatedAt: string;
  } | null;
};

export type UpdateCommunityDocumentationMutationVariables = {
  input: UpdateCommunityDocumentationInput;
  condition?: ModelCommunityDocumentationConditionInput | null;
};

export type UpdateCommunityDocumentationMutation = {
  updateCommunityDocumentation?: {
    __typename: 'CommunityDocumentation';
    id: string;
    communityId?: string | null;
    documentId?: string | null;
    document?: {
      __typename: 'RepositoryFile';
      id: string;
      folderId: string;
      filename?: string | null;
      filetype?: FileMediaType | null;
      createdById: string;
      createdAt: string;
      updatedAt: string;
    } | null;
    createdAt: string;
    updatedAt: string;
  } | null;
};

export type DeleteCommunityDocumentationMutationVariables = {
  input: DeleteCommunityDocumentationInput;
  condition?: ModelCommunityDocumentationConditionInput | null;
};

export type DeleteCommunityDocumentationMutation = {
  deleteCommunityDocumentation?: {
    __typename: 'CommunityDocumentation';
    id: string;
    communityId?: string | null;
    documentId?: string | null;
    document?: {
      __typename: 'RepositoryFile';
      id: string;
      folderId: string;
      filename?: string | null;
      filetype?: FileMediaType | null;
      createdById: string;
      createdAt: string;
      updatedAt: string;
    } | null;
    createdAt: string;
    updatedAt: string;
  } | null;
};

export type CreatePostMutationVariables = {
  input: CreatePostInput;
  condition?: ModelPostConditionInput | null;
};

export type CreatePostMutation = {
  createPost?: {
    __typename: 'Post';
    id: string;
    communityId?: string | null;
    creatorId?: string | null;
    creator?: {
      __typename: 'Employee';
      id: string;
      organizationId?: string | null;
      organizationUnitId?: string | null;
      userId: string;
      nik: string;
      status: EmploymentStatus;
      domicile?: string | null;
      managerId?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    content?: string | null;
    documentId?: string | null;
    eventId?: string | null;
    event?: {
      __typename: 'Event';
      id: string;
      eventId?: string | null;
      communityId?: string | null;
      owner?: string | null;
      profileUrl?: string | null;
      type: EventType;
      title: string;
      description?: string | null;
      about?: string | null;
      datetimeFrom?: string | null;
      datetimeTo?: string | null;
      externalLink?: string | null;
      location?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    articleId?: string | null;
    article?: {
      __typename: 'Article';
      id: string;
      profileUrl?: string | null;
      status: ArticleStatus;
      title: string;
      content: string;
      createdAt?: string | null;
      updatedAt?: string | null;
    } | null;
    surveyId?: string | null;
    survey?: {
      __typename: 'Survey';
      id: string;
      name: string;
      datetimeStart?: string | null;
      datetimeEnd?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    approvedBy?: {
      __typename: 'Employee';
      id: string;
      organizationId?: string | null;
      organizationUnitId?: string | null;
      userId: string;
      nik: string;
      status: EmploymentStatus;
      domicile?: string | null;
      managerId?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    createdAt: string;
    updatedAt: string;
  } | null;
};

export type UpdatePostMutationVariables = {
  input: UpdatePostInput;
  condition?: ModelPostConditionInput | null;
};

export type UpdatePostMutation = {
  updatePost?: {
    __typename: 'Post';
    id: string;
    communityId?: string | null;
    creatorId?: string | null;
    creator?: {
      __typename: 'Employee';
      id: string;
      organizationId?: string | null;
      organizationUnitId?: string | null;
      userId: string;
      nik: string;
      status: EmploymentStatus;
      domicile?: string | null;
      managerId?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    content?: string | null;
    documentId?: string | null;
    eventId?: string | null;
    event?: {
      __typename: 'Event';
      id: string;
      eventId?: string | null;
      communityId?: string | null;
      owner?: string | null;
      profileUrl?: string | null;
      type: EventType;
      title: string;
      description?: string | null;
      about?: string | null;
      datetimeFrom?: string | null;
      datetimeTo?: string | null;
      externalLink?: string | null;
      location?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    articleId?: string | null;
    article?: {
      __typename: 'Article';
      id: string;
      profileUrl?: string | null;
      status: ArticleStatus;
      title: string;
      content: string;
      createdAt?: string | null;
      updatedAt?: string | null;
    } | null;
    surveyId?: string | null;
    survey?: {
      __typename: 'Survey';
      id: string;
      name: string;
      datetimeStart?: string | null;
      datetimeEnd?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    approvedBy?: {
      __typename: 'Employee';
      id: string;
      organizationId?: string | null;
      organizationUnitId?: string | null;
      userId: string;
      nik: string;
      status: EmploymentStatus;
      domicile?: string | null;
      managerId?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    createdAt: string;
    updatedAt: string;
  } | null;
};

export type DeletePostMutationVariables = {
  input: DeletePostInput;
  condition?: ModelPostConditionInput | null;
};

export type DeletePostMutation = {
  deletePost?: {
    __typename: 'Post';
    id: string;
    communityId?: string | null;
    creatorId?: string | null;
    creator?: {
      __typename: 'Employee';
      id: string;
      organizationId?: string | null;
      organizationUnitId?: string | null;
      userId: string;
      nik: string;
      status: EmploymentStatus;
      domicile?: string | null;
      managerId?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    content?: string | null;
    documentId?: string | null;
    eventId?: string | null;
    event?: {
      __typename: 'Event';
      id: string;
      eventId?: string | null;
      communityId?: string | null;
      owner?: string | null;
      profileUrl?: string | null;
      type: EventType;
      title: string;
      description?: string | null;
      about?: string | null;
      datetimeFrom?: string | null;
      datetimeTo?: string | null;
      externalLink?: string | null;
      location?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    articleId?: string | null;
    article?: {
      __typename: 'Article';
      id: string;
      profileUrl?: string | null;
      status: ArticleStatus;
      title: string;
      content: string;
      createdAt?: string | null;
      updatedAt?: string | null;
    } | null;
    surveyId?: string | null;
    survey?: {
      __typename: 'Survey';
      id: string;
      name: string;
      datetimeStart?: string | null;
      datetimeEnd?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    approvedBy?: {
      __typename: 'Employee';
      id: string;
      organizationId?: string | null;
      organizationUnitId?: string | null;
      userId: string;
      nik: string;
      status: EmploymentStatus;
      domicile?: string | null;
      managerId?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    createdAt: string;
    updatedAt: string;
  } | null;
};

export type CreateEventMutationVariables = {
  input: CreateEventInput;
  condition?: ModelEventConditionInput | null;
};

export type CreateEventMutation = {
  createEvent?: {
    __typename: 'Event';
    id: string;
    eventId?: string | null;
    communityId?: string | null;
    community?: {
      __typename: 'Community';
      id: string;
      coverUrl?: string | null;
      profileUrl?: string | null;
      name: string;
      description: string;
      tags?: Array<string | null> | null;
      categoryId?: string | null;
      unitId?: string | null;
      knowledgeFocus?: Array<string | null> | null;
      objective?: Array<string | null> | null;
      kpi?: Array<string | null> | null;
      policy?: Array<string | null> | null;
      memberCanInvite: boolean;
      reviewNewPost: boolean;
      ownerId?: string | null;
      type: CommunityType;
      createdAt: string;
      updatedAt: string;
    } | null;
    owner?: string | null;
    profileUrl?: string | null;
    type: EventType;
    title: string;
    description?: string | null;
    about?: string | null;
    datetimeFrom?: string | null;
    datetimeTo?: string | null;
    externalLink?: string | null;
    location?: string | null;
    noteTakers?: {
      __typename: 'ModelNoteTakersConnection';
      nextToken?: string | null;
    } | null;
    employeeSpeakers?: Array<{
      __typename: 'Employee';
      id: string;
      organizationId?: string | null;
      organizationUnitId?: string | null;
      userId: string;
      nik: string;
      status: EmploymentStatus;
      domicile?: string | null;
      managerId?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null> | null;
    externalSpeakers?: Array<{
      __typename: 'EventSpeaker';
      id: string;
      name?: string | null;
      jobTitle?: string | null;
      company?: string | null;
      photo_url?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null> | null;
    committees?: {
      __typename: 'ModelComitteeConnection';
      nextToken?: string | null;
    } | null;
    documentations?: {
      __typename: 'ModelCommunityDocumentationConnection';
      nextToken?: string | null;
    } | null;
    attendeeIds?: {
      __typename: 'ModelAttendeeConnection';
      nextToken?: string | null;
    } | null;
    messages?: {
      __typename: 'ModelEventMessageConnection';
      nextToken?: string | null;
    } | null;
    createdAt: string;
    updatedAt: string;
  } | null;
};

export type UpdateEventMutationVariables = {
  input: UpdateEventInput;
  condition?: ModelEventConditionInput | null;
};

export type UpdateEventMutation = {
  updateEvent?: {
    __typename: 'Event';
    id: string;
    eventId?: string | null;
    communityId?: string | null;
    community?: {
      __typename: 'Community';
      id: string;
      coverUrl?: string | null;
      profileUrl?: string | null;
      name: string;
      description: string;
      tags?: Array<string | null> | null;
      categoryId?: string | null;
      unitId?: string | null;
      knowledgeFocus?: Array<string | null> | null;
      objective?: Array<string | null> | null;
      kpi?: Array<string | null> | null;
      policy?: Array<string | null> | null;
      memberCanInvite: boolean;
      reviewNewPost: boolean;
      ownerId?: string | null;
      type: CommunityType;
      createdAt: string;
      updatedAt: string;
    } | null;
    owner?: string | null;
    profileUrl?: string | null;
    type: EventType;
    title: string;
    description?: string | null;
    about?: string | null;
    datetimeFrom?: string | null;
    datetimeTo?: string | null;
    externalLink?: string | null;
    location?: string | null;
    noteTakers?: {
      __typename: 'ModelNoteTakersConnection';
      nextToken?: string | null;
    } | null;
    employeeSpeakers?: Array<{
      __typename: 'Employee';
      id: string;
      organizationId?: string | null;
      organizationUnitId?: string | null;
      userId: string;
      nik: string;
      status: EmploymentStatus;
      domicile?: string | null;
      managerId?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null> | null;
    externalSpeakers?: Array<{
      __typename: 'EventSpeaker';
      id: string;
      name?: string | null;
      jobTitle?: string | null;
      company?: string | null;
      photo_url?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null> | null;
    committees?: {
      __typename: 'ModelComitteeConnection';
      nextToken?: string | null;
    } | null;
    documentations?: {
      __typename: 'ModelCommunityDocumentationConnection';
      nextToken?: string | null;
    } | null;
    attendeeIds?: {
      __typename: 'ModelAttendeeConnection';
      nextToken?: string | null;
    } | null;
    messages?: {
      __typename: 'ModelEventMessageConnection';
      nextToken?: string | null;
    } | null;
    createdAt: string;
    updatedAt: string;
  } | null;
};

export type DeleteEventMutationVariables = {
  input: DeleteEventInput;
  condition?: ModelEventConditionInput | null;
};

export type DeleteEventMutation = {
  deleteEvent?: {
    __typename: 'Event';
    id: string;
    eventId?: string | null;
    communityId?: string | null;
    community?: {
      __typename: 'Community';
      id: string;
      coverUrl?: string | null;
      profileUrl?: string | null;
      name: string;
      description: string;
      tags?: Array<string | null> | null;
      categoryId?: string | null;
      unitId?: string | null;
      knowledgeFocus?: Array<string | null> | null;
      objective?: Array<string | null> | null;
      kpi?: Array<string | null> | null;
      policy?: Array<string | null> | null;
      memberCanInvite: boolean;
      reviewNewPost: boolean;
      ownerId?: string | null;
      type: CommunityType;
      createdAt: string;
      updatedAt: string;
    } | null;
    owner?: string | null;
    profileUrl?: string | null;
    type: EventType;
    title: string;
    description?: string | null;
    about?: string | null;
    datetimeFrom?: string | null;
    datetimeTo?: string | null;
    externalLink?: string | null;
    location?: string | null;
    noteTakers?: {
      __typename: 'ModelNoteTakersConnection';
      nextToken?: string | null;
    } | null;
    employeeSpeakers?: Array<{
      __typename: 'Employee';
      id: string;
      organizationId?: string | null;
      organizationUnitId?: string | null;
      userId: string;
      nik: string;
      status: EmploymentStatus;
      domicile?: string | null;
      managerId?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null> | null;
    externalSpeakers?: Array<{
      __typename: 'EventSpeaker';
      id: string;
      name?: string | null;
      jobTitle?: string | null;
      company?: string | null;
      photo_url?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null> | null;
    committees?: {
      __typename: 'ModelComitteeConnection';
      nextToken?: string | null;
    } | null;
    documentations?: {
      __typename: 'ModelCommunityDocumentationConnection';
      nextToken?: string | null;
    } | null;
    attendeeIds?: {
      __typename: 'ModelAttendeeConnection';
      nextToken?: string | null;
    } | null;
    messages?: {
      __typename: 'ModelEventMessageConnection';
      nextToken?: string | null;
    } | null;
    createdAt: string;
    updatedAt: string;
  } | null;
};

export type CreateNoteTakersMutationVariables = {
  input: CreateNoteTakersInput;
  condition?: ModelNoteTakersConditionInput | null;
};

export type CreateNoteTakersMutation = {
  createNoteTakers?: {
    __typename: 'NoteTakers';
    id: string;
    eventId?: string | null;
    employeeId?: string | null;
    employee?: {
      __typename: 'Employee';
      id: string;
      organizationId?: string | null;
      organizationUnitId?: string | null;
      userId: string;
      nik: string;
      status: EmploymentStatus;
      domicile?: string | null;
      managerId?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    createdAt: string;
    updatedAt: string;
  } | null;
};

export type UpdateNoteTakersMutationVariables = {
  input: UpdateNoteTakersInput;
  condition?: ModelNoteTakersConditionInput | null;
};

export type UpdateNoteTakersMutation = {
  updateNoteTakers?: {
    __typename: 'NoteTakers';
    id: string;
    eventId?: string | null;
    employeeId?: string | null;
    employee?: {
      __typename: 'Employee';
      id: string;
      organizationId?: string | null;
      organizationUnitId?: string | null;
      userId: string;
      nik: string;
      status: EmploymentStatus;
      domicile?: string | null;
      managerId?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    createdAt: string;
    updatedAt: string;
  } | null;
};

export type DeleteNoteTakersMutationVariables = {
  input: DeleteNoteTakersInput;
  condition?: ModelNoteTakersConditionInput | null;
};

export type DeleteNoteTakersMutation = {
  deleteNoteTakers?: {
    __typename: 'NoteTakers';
    id: string;
    eventId?: string | null;
    employeeId?: string | null;
    employee?: {
      __typename: 'Employee';
      id: string;
      organizationId?: string | null;
      organizationUnitId?: string | null;
      userId: string;
      nik: string;
      status: EmploymentStatus;
      domicile?: string | null;
      managerId?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    createdAt: string;
    updatedAt: string;
  } | null;
};

export type CreateComitteeMutationVariables = {
  input: CreateComitteeInput;
  condition?: ModelComitteeConditionInput | null;
};

export type CreateComitteeMutation = {
  createComittee?: {
    __typename: 'Comittee';
    id: string;
    eventId?: string | null;
    employeeId?: string | null;
    employee?: {
      __typename: 'Employee';
      id: string;
      organizationId?: string | null;
      organizationUnitId?: string | null;
      userId: string;
      nik: string;
      status: EmploymentStatus;
      domicile?: string | null;
      managerId?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    createdAt: string;
    updatedAt: string;
  } | null;
};

export type UpdateComitteeMutationVariables = {
  input: UpdateComitteeInput;
  condition?: ModelComitteeConditionInput | null;
};

export type UpdateComitteeMutation = {
  updateComittee?: {
    __typename: 'Comittee';
    id: string;
    eventId?: string | null;
    employeeId?: string | null;
    employee?: {
      __typename: 'Employee';
      id: string;
      organizationId?: string | null;
      organizationUnitId?: string | null;
      userId: string;
      nik: string;
      status: EmploymentStatus;
      domicile?: string | null;
      managerId?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    createdAt: string;
    updatedAt: string;
  } | null;
};

export type DeleteComitteeMutationVariables = {
  input: DeleteComitteeInput;
  condition?: ModelComitteeConditionInput | null;
};

export type DeleteComitteeMutation = {
  deleteComittee?: {
    __typename: 'Comittee';
    id: string;
    eventId?: string | null;
    employeeId?: string | null;
    employee?: {
      __typename: 'Employee';
      id: string;
      organizationId?: string | null;
      organizationUnitId?: string | null;
      userId: string;
      nik: string;
      status: EmploymentStatus;
      domicile?: string | null;
      managerId?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    createdAt: string;
    updatedAt: string;
  } | null;
};

export type CreateAttendeeMutationVariables = {
  input: CreateAttendeeInput;
  condition?: ModelAttendeeConditionInput | null;
};

export type CreateAttendeeMutation = {
  createAttendee?: {
    __typename: 'Attendee';
    id: string;
    employeeId?: string | null;
    employee?: {
      __typename: 'Employee';
      id: string;
      organizationId?: string | null;
      organizationUnitId?: string | null;
      userId: string;
      nik: string;
      status: EmploymentStatus;
      domicile?: string | null;
      managerId?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    createdAt: string;
    updatedAt: string;
  } | null;
};

export type UpdateAttendeeMutationVariables = {
  input: UpdateAttendeeInput;
  condition?: ModelAttendeeConditionInput | null;
};

export type UpdateAttendeeMutation = {
  updateAttendee?: {
    __typename: 'Attendee';
    id: string;
    employeeId?: string | null;
    employee?: {
      __typename: 'Employee';
      id: string;
      organizationId?: string | null;
      organizationUnitId?: string | null;
      userId: string;
      nik: string;
      status: EmploymentStatus;
      domicile?: string | null;
      managerId?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    createdAt: string;
    updatedAt: string;
  } | null;
};

export type DeleteAttendeeMutationVariables = {
  input: DeleteAttendeeInput;
  condition?: ModelAttendeeConditionInput | null;
};

export type DeleteAttendeeMutation = {
  deleteAttendee?: {
    __typename: 'Attendee';
    id: string;
    employeeId?: string | null;
    employee?: {
      __typename: 'Employee';
      id: string;
      organizationId?: string | null;
      organizationUnitId?: string | null;
      userId: string;
      nik: string;
      status: EmploymentStatus;
      domicile?: string | null;
      managerId?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    createdAt: string;
    updatedAt: string;
  } | null;
};

export type CreateEmployeeSpeakerMutationVariables = {
  input: CreateEmployeeSpeakerInput;
  condition?: ModelEmployeeSpeakerConditionInput | null;
};

export type CreateEmployeeSpeakerMutation = {
  createEmployeeSpeaker?: {
    __typename: 'EmployeeSpeaker';
    id: string;
    employeeId?: string | null;
    employe?: {
      __typename: 'Employee';
      id: string;
      organizationId?: string | null;
      organizationUnitId?: string | null;
      userId: string;
      nik: string;
      status: EmploymentStatus;
      domicile?: string | null;
      managerId?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    createdAt: string;
    updatedAt: string;
  } | null;
};

export type UpdateEmployeeSpeakerMutationVariables = {
  input: UpdateEmployeeSpeakerInput;
  condition?: ModelEmployeeSpeakerConditionInput | null;
};

export type UpdateEmployeeSpeakerMutation = {
  updateEmployeeSpeaker?: {
    __typename: 'EmployeeSpeaker';
    id: string;
    employeeId?: string | null;
    employe?: {
      __typename: 'Employee';
      id: string;
      organizationId?: string | null;
      organizationUnitId?: string | null;
      userId: string;
      nik: string;
      status: EmploymentStatus;
      domicile?: string | null;
      managerId?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    createdAt: string;
    updatedAt: string;
  } | null;
};

export type DeleteEmployeeSpeakerMutationVariables = {
  input: DeleteEmployeeSpeakerInput;
  condition?: ModelEmployeeSpeakerConditionInput | null;
};

export type DeleteEmployeeSpeakerMutation = {
  deleteEmployeeSpeaker?: {
    __typename: 'EmployeeSpeaker';
    id: string;
    employeeId?: string | null;
    employe?: {
      __typename: 'Employee';
      id: string;
      organizationId?: string | null;
      organizationUnitId?: string | null;
      userId: string;
      nik: string;
      status: EmploymentStatus;
      domicile?: string | null;
      managerId?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    createdAt: string;
    updatedAt: string;
  } | null;
};

export type CreateEventSpeakerMutationVariables = {
  input: CreateEventSpeakerInput;
  condition?: ModelEventSpeakerConditionInput | null;
};

export type CreateEventSpeakerMutation = {
  createEventSpeaker?: {
    __typename: 'EventSpeaker';
    id: string;
    name?: string | null;
    jobTitle?: string | null;
    company?: string | null;
    photo_url?: string | null;
    createdAt: string;
    updatedAt: string;
  } | null;
};

export type UpdateEventSpeakerMutationVariables = {
  input: UpdateEventSpeakerInput;
  condition?: ModelEventSpeakerConditionInput | null;
};

export type UpdateEventSpeakerMutation = {
  updateEventSpeaker?: {
    __typename: 'EventSpeaker';
    id: string;
    name?: string | null;
    jobTitle?: string | null;
    company?: string | null;
    photo_url?: string | null;
    createdAt: string;
    updatedAt: string;
  } | null;
};

export type DeleteEventSpeakerMutationVariables = {
  input: DeleteEventSpeakerInput;
  condition?: ModelEventSpeakerConditionInput | null;
};

export type DeleteEventSpeakerMutation = {
  deleteEventSpeaker?: {
    __typename: 'EventSpeaker';
    id: string;
    name?: string | null;
    jobTitle?: string | null;
    company?: string | null;
    photo_url?: string | null;
    createdAt: string;
    updatedAt: string;
  } | null;
};

export type CreateEventMessageMutationVariables = {
  input: CreateEventMessageInput;
  condition?: ModelEventMessageConditionInput | null;
};

export type CreateEventMessageMutation = {
  createEventMessage?: {
    __typename: 'EventMessage';
    id: string;
    eventId?: string | null;
    from?: {
      __typename: 'Employee';
      id: string;
      organizationId?: string | null;
      organizationUnitId?: string | null;
      userId: string;
      nik: string;
      status: EmploymentStatus;
      domicile?: string | null;
      managerId?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    toId?: {
      __typename: 'Employee';
      id: string;
      organizationId?: string | null;
      organizationUnitId?: string | null;
      userId: string;
      nik: string;
      status: EmploymentStatus;
      domicile?: string | null;
      managerId?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    message?: string | null;
    parentId?: string | null;
    parent?: {
      __typename: 'EventMessage';
      id: string;
      eventId?: string | null;
      message?: string | null;
      parentId?: string | null;
      attachmentUrl?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    replies?: {
      __typename: 'ModelEventMessageConnection';
      nextToken?: string | null;
    } | null;
    attachmentUrl?: string | null;
    createdAt: string;
    updatedAt: string;
  } | null;
};

export type UpdateEventMessageMutationVariables = {
  input: UpdateEventMessageInput;
  condition?: ModelEventMessageConditionInput | null;
};

export type UpdateEventMessageMutation = {
  updateEventMessage?: {
    __typename: 'EventMessage';
    id: string;
    eventId?: string | null;
    from?: {
      __typename: 'Employee';
      id: string;
      organizationId?: string | null;
      organizationUnitId?: string | null;
      userId: string;
      nik: string;
      status: EmploymentStatus;
      domicile?: string | null;
      managerId?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    toId?: {
      __typename: 'Employee';
      id: string;
      organizationId?: string | null;
      organizationUnitId?: string | null;
      userId: string;
      nik: string;
      status: EmploymentStatus;
      domicile?: string | null;
      managerId?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    message?: string | null;
    parentId?: string | null;
    parent?: {
      __typename: 'EventMessage';
      id: string;
      eventId?: string | null;
      message?: string | null;
      parentId?: string | null;
      attachmentUrl?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    replies?: {
      __typename: 'ModelEventMessageConnection';
      nextToken?: string | null;
    } | null;
    attachmentUrl?: string | null;
    createdAt: string;
    updatedAt: string;
  } | null;
};

export type DeleteEventMessageMutationVariables = {
  input: DeleteEventMessageInput;
  condition?: ModelEventMessageConditionInput | null;
};

export type DeleteEventMessageMutation = {
  deleteEventMessage?: {
    __typename: 'EventMessage';
    id: string;
    eventId?: string | null;
    from?: {
      __typename: 'Employee';
      id: string;
      organizationId?: string | null;
      organizationUnitId?: string | null;
      userId: string;
      nik: string;
      status: EmploymentStatus;
      domicile?: string | null;
      managerId?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    toId?: {
      __typename: 'Employee';
      id: string;
      organizationId?: string | null;
      organizationUnitId?: string | null;
      userId: string;
      nik: string;
      status: EmploymentStatus;
      domicile?: string | null;
      managerId?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    message?: string | null;
    parentId?: string | null;
    parent?: {
      __typename: 'EventMessage';
      id: string;
      eventId?: string | null;
      message?: string | null;
      parentId?: string | null;
      attachmentUrl?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    replies?: {
      __typename: 'ModelEventMessageConnection';
      nextToken?: string | null;
    } | null;
    attachmentUrl?: string | null;
    createdAt: string;
    updatedAt: string;
  } | null;
};

export type CreateArticleMutationVariables = {
  input: CreateArticleInput;
  condition?: ModelArticleConditionInput | null;
};

export type CreateArticleMutation = {
  createArticle?: {
    __typename: 'Article';
    id: string;
    profileUrl?: string | null;
    status: ArticleStatus;
    owner?: {
      __typename: 'User';
      id: string;
      username: string;
      name: string;
      email: string;
      createdAt: string;
      updatedAt: string;
    } | null;
    title: string;
    content: string;
    createdAt?: string | null;
    createdBy?: {
      __typename: 'User';
      id: string;
      username: string;
      name: string;
      email: string;
      createdAt: string;
      updatedAt: string;
    } | null;
    updatedAt?: string | null;
    updatedBy?: {
      __typename: 'User';
      id: string;
      username: string;
      name: string;
      email: string;
      createdAt: string;
      updatedAt: string;
    } | null;
  } | null;
};

export type UpdateArticleMutationVariables = {
  input: UpdateArticleInput;
  condition?: ModelArticleConditionInput | null;
};

export type UpdateArticleMutation = {
  updateArticle?: {
    __typename: 'Article';
    id: string;
    profileUrl?: string | null;
    status: ArticleStatus;
    owner?: {
      __typename: 'User';
      id: string;
      username: string;
      name: string;
      email: string;
      createdAt: string;
      updatedAt: string;
    } | null;
    title: string;
    content: string;
    createdAt?: string | null;
    createdBy?: {
      __typename: 'User';
      id: string;
      username: string;
      name: string;
      email: string;
      createdAt: string;
      updatedAt: string;
    } | null;
    updatedAt?: string | null;
    updatedBy?: {
      __typename: 'User';
      id: string;
      username: string;
      name: string;
      email: string;
      createdAt: string;
      updatedAt: string;
    } | null;
  } | null;
};

export type DeleteArticleMutationVariables = {
  input: DeleteArticleInput;
  condition?: ModelArticleConditionInput | null;
};

export type DeleteArticleMutation = {
  deleteArticle?: {
    __typename: 'Article';
    id: string;
    profileUrl?: string | null;
    status: ArticleStatus;
    owner?: {
      __typename: 'User';
      id: string;
      username: string;
      name: string;
      email: string;
      createdAt: string;
      updatedAt: string;
    } | null;
    title: string;
    content: string;
    createdAt?: string | null;
    createdBy?: {
      __typename: 'User';
      id: string;
      username: string;
      name: string;
      email: string;
      createdAt: string;
      updatedAt: string;
    } | null;
    updatedAt?: string | null;
    updatedBy?: {
      __typename: 'User';
      id: string;
      username: string;
      name: string;
      email: string;
      createdAt: string;
      updatedAt: string;
    } | null;
  } | null;
};

export type CreateSurveyMutationVariables = {
  input: CreateSurveyInput;
  condition?: ModelSurveyConditionInput | null;
};

export type CreateSurveyMutation = {
  createSurvey?: {
    __typename: 'Survey';
    id: string;
    name: string;
    datetimeStart?: string | null;
    datetimeEnd?: string | null;
    options?: {
      __typename: 'ModelSurveyOptionConnection';
      nextToken?: string | null;
    } | null;
    createdAt: string;
    updatedAt: string;
  } | null;
};

export type UpdateSurveyMutationVariables = {
  input: UpdateSurveyInput;
  condition?: ModelSurveyConditionInput | null;
};

export type UpdateSurveyMutation = {
  updateSurvey?: {
    __typename: 'Survey';
    id: string;
    name: string;
    datetimeStart?: string | null;
    datetimeEnd?: string | null;
    options?: {
      __typename: 'ModelSurveyOptionConnection';
      nextToken?: string | null;
    } | null;
    createdAt: string;
    updatedAt: string;
  } | null;
};

export type DeleteSurveyMutationVariables = {
  input: DeleteSurveyInput;
  condition?: ModelSurveyConditionInput | null;
};

export type DeleteSurveyMutation = {
  deleteSurvey?: {
    __typename: 'Survey';
    id: string;
    name: string;
    datetimeStart?: string | null;
    datetimeEnd?: string | null;
    options?: {
      __typename: 'ModelSurveyOptionConnection';
      nextToken?: string | null;
    } | null;
    createdAt: string;
    updatedAt: string;
  } | null;
};

export type CreateSurveyOptionMutationVariables = {
  input: CreateSurveyOptionInput;
  condition?: ModelSurveyOptionConditionInput | null;
};

export type CreateSurveyOptionMutation = {
  createSurveyOption?: {
    __typename: 'SurveyOption';
    id: string;
    surveyOptionId?: string | null;
    caption?: string | null;
    totalVote?: number | null;
    createdAt: string;
    updatedAt: string;
  } | null;
};

export type UpdateSurveyOptionMutationVariables = {
  input: UpdateSurveyOptionInput;
  condition?: ModelSurveyOptionConditionInput | null;
};

export type UpdateSurveyOptionMutation = {
  updateSurveyOption?: {
    __typename: 'SurveyOption';
    id: string;
    surveyOptionId?: string | null;
    caption?: string | null;
    totalVote?: number | null;
    createdAt: string;
    updatedAt: string;
  } | null;
};

export type DeleteSurveyOptionMutationVariables = {
  input: DeleteSurveyOptionInput;
  condition?: ModelSurveyOptionConditionInput | null;
};

export type DeleteSurveyOptionMutation = {
  deleteSurveyOption?: {
    __typename: 'SurveyOption';
    id: string;
    surveyOptionId?: string | null;
    caption?: string | null;
    totalVote?: number | null;
    createdAt: string;
    updatedAt: string;
  } | null;
};

export type GetOrganizationQueryVariables = {
  id: string;
};

export type GetOrganizationQuery = {
  getOrganization?: {
    __typename: 'Organization';
    id: string;
    employees?: ModelEmployeeConnection | null;
    name: string;
    address?: string | null;
    objectives?: ModelObjectiveConnection | null;
    createdAt: string;
    updatedAt: string;
  } | null;
};

export type ListOrganizationsQueryVariables = {
  filter?: ModelOrganizationFilterInput | null;
  limit?: number | null;
  nextToken?: string | null;
};

export type ListOrganizationsQuery = {
  listOrganizations?: {
    __typename: 'ModelOrganizationConnection';
    items: Array<{
      __typename: 'Organization';
      id: string;
      name: string;
      address?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null>;
    nextToken?: string | null;
  } | null;
};

export type GetEmployeeQueryVariables = {
  id: string;
};

export type GetEmployeeQuery = {
  getEmployee?: {
    __typename: 'Employee';
    id: string;
    organizationId?: string | null;
    organizationUnitId?: string | null;
    organizationUnit?: {
      __typename: 'OrganizationUnit';
      id: string;
      organizationId?: string | null;
      name: string;
      parentId?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    userId: string;
    user?: {
      __typename: 'User';
      id: string;
      username: string;
      name: string;
      email: string;
      createdAt: string;
      updatedAt: string;
    } | null;
    nik: string;
    status: EmploymentStatus;
    domicile?: string | null;
    managerId?: string | null;
    manager?: {
      __typename: 'Employee';
      id: string;
      organizationId?: string | null;
      organizationUnitId?: string | null;
      userId: string;
      nik: string;
      status: EmploymentStatus;
      domicile?: string | null;
      managerId?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    jobTitles?: {
      __typename: 'ModelEmployeeJobTitleConnection';
      nextToken?: string | null;
    } | null;
    socialMedias?: {
      __typename: 'ModelEmployeeSocialMediaConnection';
      nextToken?: string | null;
    } | null;
    positionHistories?: {
      __typename: 'ModelEmployeePositionHistoryConnection';
      nextToken?: string | null;
    } | null;
    educationHistories?: {
      __typename: 'ModelEmployeeEducationHistoryConnection';
      nextToken?: string | null;
    } | null;
    assignmentHistories?: {
      __typename: 'ModelEmployeeAssignmentHistoryConnection';
      nextToken?: string | null;
    } | null;
    activities?: {
      __typename: 'ModelEmployeeActivityConnection';
      nextToken?: string | null;
    } | null;
    badges?: {
      __typename: 'ModelEmployeeBadgeConnection';
      nextToken?: string | null;
    } | null;
    skills?: {
      __typename: 'ModelEmployeeSkillConnection';
      nextToken?: string | null;
    } | null;
    trainings?: {
      __typename: 'ModelEmployeeTrainingConnection';
      nextToken?: string | null;
    } | null;
    rewards?: {
      __typename: 'ModelEmployeeRewardConnection';
      nextToken?: string | null;
    } | null;
    objectives?: {
      __typename: 'ModelObjectiveConnection';
      nextToken?: string | null;
    } | null;
    createdAt: string;
    updatedAt: string;
  } | null;
};

export type ListEmployeesQueryVariables = {
  filter?: ModelEmployeeFilterInput | null;
  limit?: number | null;
  nextToken?: string | null;
};

export type ListEmployeesQuery = {
  listEmployees?: {
    __typename: 'ModelEmployeeConnection';
    items: Array<{
      __typename: 'Employee';
      id: string;
      organizationId?: string | null;
      organizationUnitId?: string | null;
      userId: string;
      nik: string;
      status: EmploymentStatus;
      domicile?: string | null;
      managerId?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null>;
    nextToken?: string | null;
  } | null;
};

export type GetEmployeeJobTitleQueryVariables = {
  id: string;
};

export type GetEmployeeJobTitleQuery = {
  getEmployeeJobTitle?: {
    __typename: 'EmployeeJobTitle';
    id: string;
    employeeId?: string | null;
    jobTitleId?: string | null;
    jobTitle?: {
      __typename: 'JobTitle';
      id: string;
      organizationUnitId?: string | null;
      title?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    createdAt: string;
    updatedAt: string;
  } | null;
};

export type ListEmployeeJobTitlesQueryVariables = {
  filter?: ModelEmployeeJobTitleFilterInput | null;
  limit?: number | null;
  nextToken?: string | null;
};

export type ListEmployeeJobTitlesQuery = {
  listEmployeeJobTitles?: {
    __typename: 'ModelEmployeeJobTitleConnection';
    items: Array<{
      __typename: 'EmployeeJobTitle';
      id: string;
      employeeId?: string | null;
      jobTitleId?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null>;
    nextToken?: string | null;
  } | null;
};

export type GetObjectiveQueryVariables = {
  id: string;
};

export type GetObjectiveQuery = {
  getObjective?: {
    __typename: 'Objective';
    id: string;
    ownerId?: string | null;
    title: string;
    description?: string | null;
    createdAt: string;
    updatedAt: string;
  } | null;
};

export type ListObjectivesQueryVariables = {
  filter?: ModelObjectiveFilterInput | null;
  limit?: number | null;
  nextToken?: string | null;
};

export type ListObjectivesQuery = {
  listObjectives?: {
    __typename: 'ModelObjectiveConnection';
    items: Array<{
      __typename: 'Objective';
      id: string;
      ownerId?: string | null;
      title: string;
      description?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null>;
    nextToken?: string | null;
  } | null;
};

export type GetUserQueryVariables = {
  id: string;
};

export type GetUserQuery = {
  getUser?: {
    __typename: 'User';
    id: string;
    username: string;
    name: string;
    email: string;
    createdAt: string;
    updatedAt: string;
  } | null;
};

export type ListUsersQueryVariables = {
  filter?: ModelUserFilterInput | null;
  limit?: number | null;
  nextToken?: string | null;
};

export type ListUsersQuery = {
  listUsers?: {
    __typename: 'ModelUserConnection';
    items: Array<{
      __typename: 'User';
      id: string;
      username: string;
      name: string;
      email: string;
      createdAt: string;
      updatedAt: string;
    } | null>;
    nextToken?: string | null;
  } | null;
};

export type GetJobTitleQueryVariables = {
  id: string;
};

export type GetJobTitleQuery = {
  getJobTitle?: {
    __typename: 'JobTitle';
    id: string;
    organizationUnit?: {
      __typename: 'OrganizationUnit';
      id: string;
      organizationId?: string | null;
      name: string;
      parentId?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    organizationUnitId?: string | null;
    title?: string | null;
    createdAt: string;
    updatedAt: string;
  } | null;
};

export type ListJobTitlesQueryVariables = {
  filter?: ModelJobTitleFilterInput | null;
  limit?: number | null;
  nextToken?: string | null;
};

export type ListJobTitlesQuery = {
  listJobTitles?: {
    __typename: 'ModelJobTitleConnection';
    items: Array<{
      __typename: 'JobTitle';
      id: string;
      organizationUnitId?: string | null;
      title?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null>;
    nextToken?: string | null;
  } | null;
};

export type GetOrganizationUnitQueryVariables = {
  id: string;
};

export type GetOrganizationUnitQuery = {
  getOrganizationUnit?: {
    __typename: 'OrganizationUnit';
    id: string;
    organizationId?: string | null;
    name: string;
    parentId?: string | null;
    parent?: {
      __typename: 'OrganizationUnit';
      id: string;
      organizationId?: string | null;
      name: string;
      parentId?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    children?: {
      __typename: 'ModelOrganizationUnitConnection';
      nextToken?: string | null;
    } | null;
    objectives?: {
      __typename: 'ModelObjectiveConnection';
      nextToken?: string | null;
    } | null;
    createdAt: string;
    updatedAt: string;
  } | null;
};

export type ListOrganizationUnitsQueryVariables = {
  filter?: ModelOrganizationUnitFilterInput | null;
  limit?: number | null;
  nextToken?: string | null;
};

export type ListOrganizationUnitsQuery = {
  listOrganizationUnits?: {
    __typename: 'ModelOrganizationUnitConnection';
    items: Array<{
      __typename: 'OrganizationUnit';
      id: string;
      organizationId?: string | null;
      name: string;
      parentId?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null>;
    nextToken?: string | null;
  } | null;
};

export type GetSocialMediaQueryVariables = {
  id: string;
};

export type GetSocialMediaQuery = {
  getSocialMedia?: {
    __typename: 'SocialMedia';
    id: string;
    name: string;
    url?: string | null;
    iconUrl?: string | null;
    createdAt: string;
    updatedAt: string;
  } | null;
};

export type ListSocialMediasQueryVariables = {
  filter?: ModelSocialMediaFilterInput | null;
  limit?: number | null;
  nextToken?: string | null;
};

export type ListSocialMediasQuery = {
  listSocialMedias?: {
    __typename: 'ModelSocialMediaConnection';
    items: Array<{
      __typename: 'SocialMedia';
      id: string;
      name: string;
      url?: string | null;
      iconUrl?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null>;
    nextToken?: string | null;
  } | null;
};

export type GetEmployeeSocialMediaQueryVariables = {
  id: string;
};

export type GetEmployeeSocialMediaQuery = {
  getEmployeeSocialMedia?: {
    __typename: 'EmployeeSocialMedia';
    id: string;
    employeeId?: string | null;
    socialMediaId?: string | null;
    socialMedia?: {
      __typename: 'SocialMedia';
      id: string;
      name: string;
      url?: string | null;
      iconUrl?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    username: string;
    createdAt: string;
    updatedAt: string;
  } | null;
};

export type ListEmployeeSocialMediasQueryVariables = {
  filter?: ModelEmployeeSocialMediaFilterInput | null;
  limit?: number | null;
  nextToken?: string | null;
};

export type ListEmployeeSocialMediasQuery = {
  listEmployeeSocialMedias?: {
    __typename: 'ModelEmployeeSocialMediaConnection';
    items: Array<{
      __typename: 'EmployeeSocialMedia';
      id: string;
      employeeId?: string | null;
      socialMediaId?: string | null;
      username: string;
      createdAt: string;
      updatedAt: string;
    } | null>;
    nextToken?: string | null;
  } | null;
};

export type GetEmployeePositionHistoryQueryVariables = {
  id: string;
};

export type GetEmployeePositionHistoryQuery = {
  getEmployeePositionHistory?: {
    __typename: 'EmployeePositionHistory';
    id: string;
    employeeId?: string | null;
    dateFrom?: string | null;
    dateUntil?: string | null;
    officeName?: string | null;
    location?: string | null;
    description?: string | null;
    internalPosition?: boolean | null;
    createdAt: string;
    updatedAt: string;
  } | null;
};

export type ListEmployeePositionHistoriesQueryVariables = {
  filter?: ModelEmployeePositionHistoryFilterInput | null;
  limit?: number | null;
  nextToken?: string | null;
};

export type ListEmployeePositionHistoriesQuery = {
  listEmployeePositionHistories?: {
    __typename: 'ModelEmployeePositionHistoryConnection';
    items: Array<{
      __typename: 'EmployeePositionHistory';
      id: string;
      employeeId?: string | null;
      dateFrom?: string | null;
      dateUntil?: string | null;
      officeName?: string | null;
      location?: string | null;
      description?: string | null;
      internalPosition?: boolean | null;
      createdAt: string;
      updatedAt: string;
    } | null>;
    nextToken?: string | null;
  } | null;
};

export type GetEmployeeEducationHistoryQueryVariables = {
  id: string;
};

export type GetEmployeeEducationHistoryQuery = {
  getEmployeeEducationHistory?: {
    __typename: 'EmployeeEducationHistory';
    id: string;
    employeeId?: string | null;
    schoolName?: string | null;
    entryYear?: number | null;
    graduationYear?: number | null;
    createdAt: string;
    updatedAt: string;
  } | null;
};

export type ListEmployeeEducationHistoriesQueryVariables = {
  filter?: ModelEmployeeEducationHistoryFilterInput | null;
  limit?: number | null;
  nextToken?: string | null;
};

export type ListEmployeeEducationHistoriesQuery = {
  listEmployeeEducationHistories?: {
    __typename: 'ModelEmployeeEducationHistoryConnection';
    items: Array<{
      __typename: 'EmployeeEducationHistory';
      id: string;
      employeeId?: string | null;
      schoolName?: string | null;
      entryYear?: number | null;
      graduationYear?: number | null;
      createdAt: string;
      updatedAt: string;
    } | null>;
    nextToken?: string | null;
  } | null;
};

export type GetEmployeeAssignmentHistoryQueryVariables = {
  id: string;
};

export type GetEmployeeAssignmentHistoryQuery = {
  getEmployeeAssignmentHistory?: {
    __typename: 'EmployeeAssignmentHistory';
    id: string;
    employeeId?: string | null;
    dateFrom?: string | null;
    dateUntil?: string | null;
    officeName?: string | null;
    location?: string | null;
    description?: string | null;
    bodRelated?: boolean | null;
    createdAt: string;
    updatedAt: string;
  } | null;
};

export type ListEmployeeAssignmentHistoriesQueryVariables = {
  filter?: ModelEmployeeAssignmentHistoryFilterInput | null;
  limit?: number | null;
  nextToken?: string | null;
};

export type ListEmployeeAssignmentHistoriesQuery = {
  listEmployeeAssignmentHistories?: {
    __typename: 'ModelEmployeeAssignmentHistoryConnection';
    items: Array<{
      __typename: 'EmployeeAssignmentHistory';
      id: string;
      employeeId?: string | null;
      dateFrom?: string | null;
      dateUntil?: string | null;
      officeName?: string | null;
      location?: string | null;
      description?: string | null;
      bodRelated?: boolean | null;
      createdAt: string;
      updatedAt: string;
    } | null>;
    nextToken?: string | null;
  } | null;
};

export type GetEmployeeActivityQueryVariables = {
  id: string;
};

export type GetEmployeeActivityQuery = {
  getEmployeeActivity?: {
    __typename: 'EmployeeActivity';
    id: string;
    employeeId?: string | null;
    activityId: string;
    activity?: {
      __typename: 'Activity';
      id: string;
      name?: string | null;
      point?: number | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    point?: number | null;
    datetime?: string | null;
    createdAt: string;
    updatedAt: string;
  } | null;
};

export type ListEmployeeActivitiesQueryVariables = {
  filter?: ModelEmployeeActivityFilterInput | null;
  limit?: number | null;
  nextToken?: string | null;
};

export type ListEmployeeActivitiesQuery = {
  listEmployeeActivities?: {
    __typename: 'ModelEmployeeActivityConnection';
    items: Array<{
      __typename: 'EmployeeActivity';
      id: string;
      employeeId?: string | null;
      activityId: string;
      point?: number | null;
      datetime?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null>;
    nextToken?: string | null;
  } | null;
};

export type GetEmployeeBadgeQueryVariables = {
  id: string;
};

export type GetEmployeeBadgeQuery = {
  getEmployeeBadge?: {
    __typename: 'EmployeeBadge';
    id: string;
    employeeId: string;
    badgeId: string;
    badge?: {
      __typename: 'Badge';
      id: string;
      name?: string | null;
      iconUrl?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    grantDate?: string | null;
    grantedById: string;
    grantedBy?: {
      __typename: 'Employee';
      id: string;
      organizationId?: string | null;
      organizationUnitId?: string | null;
      userId: string;
      nik: string;
      status: EmploymentStatus;
      domicile?: string | null;
      managerId?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    createdAt: string;
    updatedAt: string;
  } | null;
};

export type ListEmployeeBadgesQueryVariables = {
  filter?: ModelEmployeeBadgeFilterInput | null;
  limit?: number | null;
  nextToken?: string | null;
};

export type ListEmployeeBadgesQuery = {
  listEmployeeBadges?: {
    __typename: 'ModelEmployeeBadgeConnection';
    items: Array<{
      __typename: 'EmployeeBadge';
      id: string;
      employeeId: string;
      badgeId: string;
      grantDate?: string | null;
      grantedById: string;
      createdAt: string;
      updatedAt: string;
    } | null>;
    nextToken?: string | null;
  } | null;
};

export type GetEmployeeSkillQueryVariables = {
  id: string;
};

export type GetEmployeeSkillQuery = {
  getEmployeeSkill?: {
    __typename: 'EmployeeSkill';
    id: string;
    employeeId: string;
    skillGroup?: string | null;
    skill?: string | null;
    name?: string | null;
    level?: SkillLevel | null;
    progress?: number | null;
    createdAt: string;
    updatedAt: string;
  } | null;
};

export type ListEmployeeSkillsQueryVariables = {
  filter?: ModelEmployeeSkillFilterInput | null;
  limit?: number | null;
  nextToken?: string | null;
};

export type ListEmployeeSkillsQuery = {
  listEmployeeSkills?: {
    __typename: 'ModelEmployeeSkillConnection';
    items: Array<{
      __typename: 'EmployeeSkill';
      id: string;
      employeeId: string;
      skillGroup?: string | null;
      skill?: string | null;
      name?: string | null;
      level?: SkillLevel | null;
      progress?: number | null;
      createdAt: string;
      updatedAt: string;
    } | null>;
    nextToken?: string | null;
  } | null;
};

export type GetEmployeeTrainingQueryVariables = {
  id: string;
};

export type GetEmployeeTrainingQuery = {
  getEmployeeTraining?: {
    __typename: 'EmployeeTraining';
    id: string;
    employeeId: string;
    date?: string | null;
    name?: string | null;
    description?: string | null;
    type?: TrainingType | null;
    createdAt: string;
    updatedAt: string;
  } | null;
};

export type ListEmployeeTrainingsQueryVariables = {
  filter?: ModelEmployeeTrainingFilterInput | null;
  limit?: number | null;
  nextToken?: string | null;
};

export type ListEmployeeTrainingsQuery = {
  listEmployeeTrainings?: {
    __typename: 'ModelEmployeeTrainingConnection';
    items: Array<{
      __typename: 'EmployeeTraining';
      id: string;
      employeeId: string;
      date?: string | null;
      name?: string | null;
      description?: string | null;
      type?: TrainingType | null;
      createdAt: string;
      updatedAt: string;
    } | null>;
    nextToken?: string | null;
  } | null;
};

export type GetEmployeeRewardQueryVariables = {
  id: string;
};

export type GetEmployeeRewardQuery = {
  getEmployeeReward?: {
    __typename: 'EmployeeReward';
    id: string;
    employeeId: string;
    date?: string | null;
    name?: string | null;
    description?: string | null;
    type?: RewardType | null;
    createdAt: string;
    updatedAt: string;
  } | null;
};

export type ListEmployeeRewardsQueryVariables = {
  filter?: ModelEmployeeRewardFilterInput | null;
  limit?: number | null;
  nextToken?: string | null;
};

export type ListEmployeeRewardsQuery = {
  listEmployeeRewards?: {
    __typename: 'ModelEmployeeRewardConnection';
    items: Array<{
      __typename: 'EmployeeReward';
      id: string;
      employeeId: string;
      date?: string | null;
      name?: string | null;
      description?: string | null;
      type?: RewardType | null;
      createdAt: string;
      updatedAt: string;
    } | null>;
    nextToken?: string | null;
  } | null;
};

export type GetActivityQueryVariables = {
  id: string;
};

export type GetActivityQuery = {
  getActivity?: {
    __typename: 'Activity';
    id: string;
    name?: string | null;
    point?: number | null;
    createdAt: string;
    updatedAt: string;
  } | null;
};

export type ListActivitiesQueryVariables = {
  filter?: ModelActivityFilterInput | null;
  limit?: number | null;
  nextToken?: string | null;
};

export type ListActivitiesQuery = {
  listActivities?: {
    __typename: 'ModelActivityConnection';
    items: Array<{
      __typename: 'Activity';
      id: string;
      name?: string | null;
      point?: number | null;
      createdAt: string;
      updatedAt: string;
    } | null>;
    nextToken?: string | null;
  } | null;
};

export type GetBadgeQueryVariables = {
  id: string;
};

export type GetBadgeQuery = {
  getBadge?: {
    __typename: 'Badge';
    id: string;
    name?: string | null;
    iconUrl?: string | null;
    createdAt: string;
    updatedAt: string;
  } | null;
};

export type ListBadgesQueryVariables = {
  filter?: ModelBadgeFilterInput | null;
  limit?: number | null;
  nextToken?: string | null;
};

export type ListBadgesQuery = {
  listBadges?: {
    __typename: 'ModelBadgeConnection';
    items: Array<{
      __typename: 'Badge';
      id: string;
      name?: string | null;
      iconUrl?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null>;
    nextToken?: string | null;
  } | null;
};

export type GetKnowledgeMapQueryVariables = {
  id: string;
};

export type GetKnowledgeMapQuery = {
  getKnowledgeMap?: {
    __typename: 'KnowledgeMap';
    id: string;
    name?: string | null;
    ownerId: string;
    businessProcesses?: {
      __typename: 'ModelBusinessProcessConnection';
      nextToken?: string | null;
    } | null;
    collaborators?: {
      __typename: 'ModelKnowledgeMapCollaboratorConnection';
      nextToken?: string | null;
    } | null;
    createdAt: string;
    updatedAt: string;
  } | null;
};

export type ListKnowledgeMapsQueryVariables = {
  filter?: ModelKnowledgeMapFilterInput | null;
  limit?: number | null;
  nextToken?: string | null;
};

export type ListKnowledgeMapsQuery = {
  listKnowledgeMaps?: {
    __typename: 'ModelKnowledgeMapConnection';
    items: Array<{
      __typename: 'KnowledgeMap';
      id: string;
      name?: string | null;
      ownerId: string;
      createdAt: string;
      updatedAt: string;
    } | null>;
    nextToken?: string | null;
  } | null;
};

export type GetKnowledgeMapCollaboratorQueryVariables = {
  id: string;
};

export type GetKnowledgeMapCollaboratorQuery = {
  getKnowledgeMapCollaborator?: {
    __typename: 'KnowledgeMapCollaborator';
    id: string;
    employeeId?: string | null;
    employee?: {
      __typename: 'Employee';
      id: string;
      organizationId?: string | null;
      organizationUnitId?: string | null;
      userId: string;
      nik: string;
      status: EmploymentStatus;
      domicile?: string | null;
      managerId?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    knowledgeMapId: string;
    createdAt: string;
    updatedAt: string;
  } | null;
};

export type ListKnowledgeMapCollaboratorsQueryVariables = {
  filter?: ModelKnowledgeMapCollaboratorFilterInput | null;
  limit?: number | null;
  nextToken?: string | null;
};

export type ListKnowledgeMapCollaboratorsQuery = {
  listKnowledgeMapCollaborators?: {
    __typename: 'ModelKnowledgeMapCollaboratorConnection';
    items: Array<{
      __typename: 'KnowledgeMapCollaborator';
      id: string;
      employeeId?: string | null;
      knowledgeMapId: string;
      createdAt: string;
      updatedAt: string;
    } | null>;
    nextToken?: string | null;
  } | null;
};

export type GetBusinessProcessQueryVariables = {
  id: string;
};

export type GetBusinessProcessQuery = {
  getBusinessProcess?: {
    __typename: 'BusinessProcess';
    id: string;
    knowledgeMapId: string;
    title: string;
    description: string;
    strategicActivities?: {
      __typename: 'ModelStrategicActivityConnection';
      nextToken?: string | null;
    } | null;
    comments?: {
      __typename: 'ModelBusinessProcessCommentConnection';
      nextToken?: string | null;
    } | null;
    createdAt: string;
    updatedAt: string;
  } | null;
};

export type ListBusinessProcessesQueryVariables = {
  filter?: ModelBusinessProcessFilterInput | null;
  limit?: number | null;
  nextToken?: string | null;
};

export type ListBusinessProcessesQuery = {
  listBusinessProcesses?: {
    __typename: 'ModelBusinessProcessConnection';
    items: Array<{
      __typename: 'BusinessProcess';
      id: string;
      knowledgeMapId: string;
      title: string;
      description: string;
      createdAt: string;
      updatedAt: string;
    } | null>;
    nextToken?: string | null;
  } | null;
};

export type GetBusinessProcessCommentQueryVariables = {
  id: string;
};

export type GetBusinessProcessCommentQuery = {
  getBusinessProcessComment?: {
    __typename: 'BusinessProcessComment';
    id: string;
    businessProcessId: string;
    comment: string;
    createdById: string;
    createdBy?: {
      __typename: 'Employee';
      id: string;
      organizationId?: string | null;
      organizationUnitId?: string | null;
      userId: string;
      nik: string;
      status: EmploymentStatus;
      domicile?: string | null;
      managerId?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    parentId?: string | null;
    replies?: {
      __typename: 'ModelBusinessProcessCommentConnection';
      nextToken?: string | null;
    } | null;
    createdAt: string;
    updatedAt: string;
  } | null;
};

export type ListBusinessProcessCommentsQueryVariables = {
  filter?: ModelBusinessProcessCommentFilterInput | null;
  limit?: number | null;
  nextToken?: string | null;
};

export type ListBusinessProcessCommentsQuery = {
  listBusinessProcessComments?: {
    __typename: 'ModelBusinessProcessCommentConnection';
    items: Array<{
      __typename: 'BusinessProcessComment';
      id: string;
      businessProcessId: string;
      comment: string;
      createdById: string;
      parentId?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null>;
    nextToken?: string | null;
  } | null;
};

export type GetStrategicActivityQueryVariables = {
  id: string;
};

export type GetStrategicActivityQuery = {
  getStrategicActivity?: {
    __typename: 'StrategicActivity';
    id: string;
    businessProcessId: string;
    title: string;
    description: string;
    importantKnowledges?: {
      __typename: 'ModelImportantKnowledgeConnection';
      nextToken?: string | null;
    } | null;
    comments?: {
      __typename: 'ModelStrategicActivityCommentConnection';
      nextToken?: string | null;
    } | null;
    createdAt: string;
    updatedAt: string;
  } | null;
};

export type ListStrategicActivitiesQueryVariables = {
  filter?: ModelStrategicActivityFilterInput | null;
  limit?: number | null;
  nextToken?: string | null;
};

export type ListStrategicActivitiesQuery = {
  listStrategicActivities?: {
    __typename: 'ModelStrategicActivityConnection';
    items: Array<{
      __typename: 'StrategicActivity';
      id: string;
      businessProcessId: string;
      title: string;
      description: string;
      createdAt: string;
      updatedAt: string;
    } | null>;
    nextToken?: string | null;
  } | null;
};

export type GetStrategicActivityCommentQueryVariables = {
  id: string;
};

export type GetStrategicActivityCommentQuery = {
  getStrategicActivityComment?: {
    __typename: 'StrategicActivityComment';
    id: string;
    strategicActivityId: string;
    comment: string;
    createdById: string;
    createdBy?: {
      __typename: 'Employee';
      id: string;
      organizationId?: string | null;
      organizationUnitId?: string | null;
      userId: string;
      nik: string;
      status: EmploymentStatus;
      domicile?: string | null;
      managerId?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    parentId?: string | null;
    replies?: {
      __typename: 'ModelStrategicActivityCommentConnection';
      nextToken?: string | null;
    } | null;
    createdAt: string;
    updatedAt: string;
  } | null;
};

export type ListStrategicActivityCommentsQueryVariables = {
  filter?: ModelStrategicActivityCommentFilterInput | null;
  limit?: number | null;
  nextToken?: string | null;
};

export type ListStrategicActivityCommentsQuery = {
  listStrategicActivityComments?: {
    __typename: 'ModelStrategicActivityCommentConnection';
    items: Array<{
      __typename: 'StrategicActivityComment';
      id: string;
      strategicActivityId: string;
      comment: string;
      createdById: string;
      parentId?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null>;
    nextToken?: string | null;
  } | null;
};

export type GetImportantKnowledgeQueryVariables = {
  id: string;
};

export type GetImportantKnowledgeQuery = {
  getImportantKnowledge?: {
    __typename: 'ImportantKnowledge';
    id: string;
    strategicActivityId: string;
    title: string;
    description: string;
    documents?: {
      __typename: 'ModelImportantKnowledgeDocumentConnection';
      nextToken?: string | null;
    } | null;
    comments?: {
      __typename: 'ModelImportantKnowledgeCommentConnection';
      nextToken?: string | null;
    } | null;
    createdAt: string;
    updatedAt: string;
  } | null;
};

export type ListImportantKnowledgesQueryVariables = {
  filter?: ModelImportantKnowledgeFilterInput | null;
  limit?: number | null;
  nextToken?: string | null;
};

export type ListImportantKnowledgesQuery = {
  listImportantKnowledges?: {
    __typename: 'ModelImportantKnowledgeConnection';
    items: Array<{
      __typename: 'ImportantKnowledge';
      id: string;
      strategicActivityId: string;
      title: string;
      description: string;
      createdAt: string;
      updatedAt: string;
    } | null>;
    nextToken?: string | null;
  } | null;
};

export type GetImportantKnowledgeCommentQueryVariables = {
  id: string;
};

export type GetImportantKnowledgeCommentQuery = {
  getImportantKnowledgeComment?: {
    __typename: 'ImportantKnowledgeComment';
    id: string;
    importantKnowledgeId: string;
    comment: string;
    createdById: string;
    createdBy?: {
      __typename: 'Employee';
      id: string;
      organizationId?: string | null;
      organizationUnitId?: string | null;
      userId: string;
      nik: string;
      status: EmploymentStatus;
      domicile?: string | null;
      managerId?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    parentId?: string | null;
    replies?: {
      __typename: 'ModelImportantKnowledgeCommentConnection';
      nextToken?: string | null;
    } | null;
    createdAt: string;
    updatedAt: string;
  } | null;
};

export type ListImportantKnowledgeCommentsQueryVariables = {
  filter?: ModelImportantKnowledgeCommentFilterInput | null;
  limit?: number | null;
  nextToken?: string | null;
};

export type ListImportantKnowledgeCommentsQuery = {
  listImportantKnowledgeComments?: {
    __typename: 'ModelImportantKnowledgeCommentConnection';
    items: Array<{
      __typename: 'ImportantKnowledgeComment';
      id: string;
      importantKnowledgeId: string;
      comment: string;
      createdById: string;
      parentId?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null>;
    nextToken?: string | null;
  } | null;
};

export type GetImportantKnowledgeDocumentQueryVariables = {
  id: string;
};

export type GetImportantKnowledgeDocumentQuery = {
  getImportantKnowledgeDocument?: {
    __typename: 'ImportantKnowledgeDocument';
    id: string;
    importantKnowledgeId: string;
    documentType: ImportantKnowledgeDocumentType;
    documentId: string;
    document?: {
      __typename: 'RepositoryFile';
      id: string;
      folderId: string;
      filename?: string | null;
      filetype?: FileMediaType | null;
      createdById: string;
      createdAt: string;
      updatedAt: string;
    } | null;
    creatorId: string;
    creator?: {
      __typename: 'Employee';
      id: string;
      organizationId?: string | null;
      organizationUnitId?: string | null;
      userId: string;
      nik: string;
      status: EmploymentStatus;
      domicile?: string | null;
      managerId?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    createdAt: string;
    updatedAt: string;
  } | null;
};

export type ListImportantKnowledgeDocumentsQueryVariables = {
  filter?: ModelImportantKnowledgeDocumentFilterInput | null;
  limit?: number | null;
  nextToken?: string | null;
};

export type ListImportantKnowledgeDocumentsQuery = {
  listImportantKnowledgeDocuments?: {
    __typename: 'ModelImportantKnowledgeDocumentConnection';
    items: Array<{
      __typename: 'ImportantKnowledgeDocument';
      id: string;
      importantKnowledgeId: string;
      documentType: ImportantKnowledgeDocumentType;
      documentId: string;
      creatorId: string;
      createdAt: string;
      updatedAt: string;
    } | null>;
    nextToken?: string | null;
  } | null;
};

export type GetCompetencyFieldQueryVariables = {
  id: string;
};

export type GetCompetencyFieldQuery = {
  getCompetencyField?: {
    __typename: 'CompetencyField';
    id: string;
    name: string;
    createdAt: string;
    updatedAt: string;
  } | null;
};

export type ListCompetencyFieldsQueryVariables = {
  filter?: ModelCompetencyFieldFilterInput | null;
  limit?: number | null;
  nextToken?: string | null;
};

export type ListCompetencyFieldsQuery = {
  listCompetencyFields?: {
    __typename: 'ModelCompetencyFieldConnection';
    items: Array<{
      __typename: 'CompetencyField';
      id: string;
      name: string;
      createdAt: string;
      updatedAt: string;
    } | null>;
    nextToken?: string | null;
  } | null;
};

export type GetSubjectMatterExpertQueryVariables = {
  id: string;
};

export type GetSubjectMatterExpertQuery = {
  getSubjectMatterExpert?: {
    __typename: 'SubjectMatterExpert';
    id: string;
    employeeId: string;
    employee?: {
      __typename: 'Employee';
      id: string;
      organizationId?: string | null;
      organizationUnitId?: string | null;
      userId: string;
      nik: string;
      status: EmploymentStatus;
      domicile?: string | null;
      managerId?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    competencies?: {
      __typename: 'ModelSubjectMatterExpertCompetencyConnection';
      nextToken?: string | null;
    } | null;
    createdAt: string;
    updatedAt: string;
  } | null;
};

export type ListSubjectMatterExpertsQueryVariables = {
  filter?: ModelSubjectMatterExpertFilterInput | null;
  limit?: number | null;
  nextToken?: string | null;
};

export type ListSubjectMatterExpertsQuery = {
  listSubjectMatterExperts?: {
    __typename: 'ModelSubjectMatterExpertConnection';
    items: Array<{
      __typename: 'SubjectMatterExpert';
      id: string;
      employeeId: string;
      createdAt: string;
      updatedAt: string;
    } | null>;
    nextToken?: string | null;
  } | null;
};

export type GetSubjectMatterExpertCompetencyQueryVariables = {
  id: string;
};

export type GetSubjectMatterExpertCompetencyQuery = {
  getSubjectMatterExpertCompetency?: {
    __typename: 'SubjectMatterExpertCompetency';
    id: string;
    subjectMatterExpertId: string;
    competencyFieldId: string;
    competencyField?: {
      __typename: 'CompetencyField';
      id: string;
      name: string;
      createdAt: string;
      updatedAt: string;
    } | null;
    createdAt: string;
    updatedAt: string;
  } | null;
};

export type ListSubjectMatterExpertCompetenciesQueryVariables = {
  filter?: ModelSubjectMatterExpertCompetencyFilterInput | null;
  limit?: number | null;
  nextToken?: string | null;
};

export type ListSubjectMatterExpertCompetenciesQuery = {
  listSubjectMatterExpertCompetencies?: {
    __typename: 'ModelSubjectMatterExpertCompetencyConnection';
    items: Array<{
      __typename: 'SubjectMatterExpertCompetency';
      id: string;
      subjectMatterExpertId: string;
      competencyFieldId: string;
      createdAt: string;
      updatedAt: string;
    } | null>;
    nextToken?: string | null;
  } | null;
};

export type GetRepositoryFolderQueryVariables = {
  id: string;
};

export type GetRepositoryFolderQuery = {
  getRepositoryFolder?: {
    __typename: 'RepositoryFolder';
    id: string;
    files?: {
      __typename: 'ModelRepositoryFileConnection';
      nextToken?: string | null;
    } | null;
    foldername?: string | null;
    parentId?: string | null;
    parent?: {
      __typename: 'RepositoryFolder';
      id: string;
      foldername?: string | null;
      parentId?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    replies?: {
      __typename: 'ModelRepositoryFolderConnection';
      nextToken?: string | null;
    } | null;
    createdAt: string;
    updatedAt: string;
  } | null;
};

export type ListRepositoryFoldersQueryVariables = {
  filter?: ModelRepositoryFolderFilterInput | null;
  limit?: number | null;
  nextToken?: string | null;
};

export type ListRepositoryFoldersQuery = {
  listRepositoryFolders?: {
    __typename: 'ModelRepositoryFolderConnection';
    items: Array<{
      __typename: 'RepositoryFolder';
      id: string;
      foldername?: string | null;
      parentId?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null>;
    nextToken?: string | null;
  } | null;
};

export type GetRepositoryFileQueryVariables = {
  id: string;
};

export type GetRepositoryFileQuery = {
  getRepositoryFile?: {
    __typename: 'RepositoryFile';
    id: string;
    folderId: string;
    filename?: string | null;
    filetype?: FileMediaType | null;
    createdById: string;
    createdBy?: {
      __typename: 'Employee';
      id: string;
      organizationId?: string | null;
      organizationUnitId?: string | null;
      userId: string;
      nik: string;
      status: EmploymentStatus;
      domicile?: string | null;
      managerId?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    createdAt: string;
    updatedAt: string;
  } | null;
};

export type ListRepositoryFilesQueryVariables = {
  filter?: ModelRepositoryFileFilterInput | null;
  limit?: number | null;
  nextToken?: string | null;
};

export type ListRepositoryFilesQuery = {
  listRepositoryFiles?: {
    __typename: 'ModelRepositoryFileConnection';
    items: Array<{
      __typename: 'RepositoryFile';
      id: string;
      folderId: string;
      filename?: string | null;
      filetype?: FileMediaType | null;
      createdById: string;
      createdAt: string;
      updatedAt: string;
    } | null>;
    nextToken?: string | null;
  } | null;
};

export type GetCommunityCategoryQueryVariables = {
  id: string;
};

export type GetCommunityCategoryQuery = {
  getCommunityCategory?: {
    __typename: 'CommunityCategory';
    id: string;
    category?: string | null;
    createdAt: string;
    updatedAt: string;
  } | null;
};

export type ListCommunityCategoriesQueryVariables = {
  filter?: ModelCommunityCategoryFilterInput | null;
  limit?: number | null;
  nextToken?: string | null;
};

export type ListCommunityCategoriesQuery = {
  listCommunityCategories?: {
    __typename: 'ModelCommunityCategoryConnection';
    items: Array<{
      __typename: 'CommunityCategory';
      id: string;
      category?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null>;
    nextToken?: string | null;
  } | null;
};

export type GetCommunityQueryVariables = {
  id: string;
};

export type GetCommunityQuery = {
  getCommunity?: {
    __typename: 'Community';
    id: string;
    coverUrl?: string | null;
    profileUrl?: string | null;
    name: string;
    description: string;
    tags?: Array<string | null> | null;
    categoryId?: string | null;
    category?: {
      __typename: 'CommunityCategory';
      id: string;
      category?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    unitId?: string | null;
    unit?: {
      __typename: 'OrganizationUnit';
      id: string;
      organizationId?: string | null;
      name: string;
      parentId?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    knowledgeFocus?: Array<string | null> | null;
    objective?: Array<string | null> | null;
    kpi?: Array<string | null> | null;
    policy?: Array<string | null> | null;
    memberCanInvite: boolean;
    reviewNewPost: boolean;
    ownerId?: string | null;
    owner?: {
      __typename: 'User';
      id: string;
      username: string;
      name: string;
      email: string;
      createdAt: string;
      updatedAt: string;
    } | null;
    pendingCoreMembers?: {
      __typename: 'ModelPendingCoreMemberConnection';
      nextToken?: string | null;
    } | null;
    coreMembers?: {
      __typename: 'ModelCoreMemberConnection';
      nextToken?: string | null;
    } | null;
    followers?: {
      __typename: 'ModelCommunityFollowersConnection';
      nextToken?: string | null;
    } | null;
    documentations?: {
      __typename: 'ModelCommunityDocumentationConnection';
      nextToken?: string | null;
    } | null;
    posts?: {
      __typename: 'ModelPostConnection';
      nextToken?: string | null;
    } | null;
    events?: {
      __typename: 'ModelEventConnection';
      nextToken?: string | null;
    } | null;
    type: CommunityType;
    createdAt: string;
    updatedAt: string;
  } | null;
};

export type ListCommunitiesQueryVariables = {
  filter?: ModelCommunityFilterInput | null;
  limit?: number | null;
  nextToken?: string | null;
};

export type ListCommunitiesQuery = {
  listCommunities?: {
    __typename: 'ModelCommunityConnection';
    items: Array<{
      __typename: 'Community';
      id: string;
      coverUrl?: string | null;
      profileUrl?: string | null;
      name: string;
      description: string;
      tags?: Array<string | null> | null;
      categoryId?: string | null;
      unitId?: string | null;
      knowledgeFocus?: Array<string | null> | null;
      objective?: Array<string | null> | null;
      kpi?: Array<string | null> | null;
      policy?: Array<string | null> | null;
      memberCanInvite: boolean;
      reviewNewPost: boolean;
      ownerId?: string | null;
      type: CommunityType;
      createdAt: string;
      updatedAt: string;
    } | null>;
    nextToken?: string | null;
  } | null;
};

export type GetPendingCoreMemberQueryVariables = {
  id: string;
};

export type GetPendingCoreMemberQuery = {
  getPendingCoreMember?: {
    __typename: 'PendingCoreMember';
    id: string;
    communityId?: string | null;
    employeeId?: string | null;
    employee?: {
      __typename: 'Employee';
      id: string;
      organizationId?: string | null;
      organizationUnitId?: string | null;
      userId: string;
      nik: string;
      status: EmploymentStatus;
      domicile?: string | null;
      managerId?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    createdAt: string;
    updatedAt: string;
  } | null;
};

export type ListPendingCoreMembersQueryVariables = {
  filter?: ModelPendingCoreMemberFilterInput | null;
  limit?: number | null;
  nextToken?: string | null;
};

export type ListPendingCoreMembersQuery = {
  listPendingCoreMembers?: {
    __typename: 'ModelPendingCoreMemberConnection';
    items: Array<{
      __typename: 'PendingCoreMember';
      id: string;
      communityId?: string | null;
      employeeId?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null>;
    nextToken?: string | null;
  } | null;
};

export type GetCoreMemberQueryVariables = {
  id: string;
};

export type GetCoreMemberQuery = {
  getCoreMember?: {
    __typename: 'CoreMember';
    id: string;
    communityId?: string | null;
    employeeId?: string | null;
    employee?: {
      __typename: 'Employee';
      id: string;
      organizationId?: string | null;
      organizationUnitId?: string | null;
      userId: string;
      nik: string;
      status: EmploymentStatus;
      domicile?: string | null;
      managerId?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    createdAt: string;
    updatedAt: string;
  } | null;
};

export type ListCoreMembersQueryVariables = {
  filter?: ModelCoreMemberFilterInput | null;
  limit?: number | null;
  nextToken?: string | null;
};

export type ListCoreMembersQuery = {
  listCoreMembers?: {
    __typename: 'ModelCoreMemberConnection';
    items: Array<{
      __typename: 'CoreMember';
      id: string;
      communityId?: string | null;
      employeeId?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null>;
    nextToken?: string | null;
  } | null;
};

export type GetCommunityFollowersQueryVariables = {
  id: string;
};

export type GetCommunityFollowersQuery = {
  getCommunityFollowers?: {
    __typename: 'CommunityFollowers';
    id: string;
    communityId?: string | null;
    employeeId?: string | null;
    employee?: {
      __typename: 'Employee';
      id: string;
      organizationId?: string | null;
      organizationUnitId?: string | null;
      userId: string;
      nik: string;
      status: EmploymentStatus;
      domicile?: string | null;
      managerId?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    createdAt: string;
    updatedAt: string;
  } | null;
};

export type ListCommunityFollowersQueryVariables = {
  filter?: ModelCommunityFollowersFilterInput | null;
  limit?: number | null;
  nextToken?: string | null;
};

export type ListCommunityFollowersQuery = {
  listCommunityFollowers?: {
    __typename: 'ModelCommunityFollowersConnection';
    items: Array<{
      __typename: 'CommunityFollowers';
      id: string;
      communityId?: string | null;
      employeeId?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null>;
    nextToken?: string | null;
  } | null;
};

export type GetCommunityDocumentationQueryVariables = {
  id: string;
};

export type GetCommunityDocumentationQuery = {
  getCommunityDocumentation?: {
    __typename: 'CommunityDocumentation';
    id: string;
    communityId?: string | null;
    documentId?: string | null;
    document?: {
      __typename: 'RepositoryFile';
      id: string;
      folderId: string;
      filename?: string | null;
      filetype?: FileMediaType | null;
      createdById: string;
      createdAt: string;
      updatedAt: string;
    } | null;
    createdAt: string;
    updatedAt: string;
  } | null;
};

export type ListCommunityDocumentationsQueryVariables = {
  filter?: ModelCommunityDocumentationFilterInput | null;
  limit?: number | null;
  nextToken?: string | null;
};

export type ListCommunityDocumentationsQuery = {
  listCommunityDocumentations?: {
    __typename: 'ModelCommunityDocumentationConnection';
    items: Array<{
      __typename: 'CommunityDocumentation';
      id: string;
      communityId?: string | null;
      documentId?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null>;
    nextToken?: string | null;
  } | null;
};

export type GetPostQueryVariables = {
  id: string;
};

export type GetPostQuery = {
  getPost?: {
    __typename: 'Post';
    id: string;
    communityId?: string | null;
    creatorId?: string | null;
    creator?: {
      __typename: 'Employee';
      id: string;
      organizationId?: string | null;
      organizationUnitId?: string | null;
      userId: string;
      nik: string;
      status: EmploymentStatus;
      domicile?: string | null;
      managerId?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    content?: string | null;
    documentId?: string | null;
    eventId?: string | null;
    event?: {
      __typename: 'Event';
      id: string;
      eventId?: string | null;
      communityId?: string | null;
      owner?: string | null;
      profileUrl?: string | null;
      type: EventType;
      title: string;
      description?: string | null;
      about?: string | null;
      datetimeFrom?: string | null;
      datetimeTo?: string | null;
      externalLink?: string | null;
      location?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    articleId?: string | null;
    article?: {
      __typename: 'Article';
      id: string;
      profileUrl?: string | null;
      status: ArticleStatus;
      title: string;
      content: string;
      createdAt?: string | null;
      updatedAt?: string | null;
    } | null;
    surveyId?: string | null;
    survey?: {
      __typename: 'Survey';
      id: string;
      name: string;
      datetimeStart?: string | null;
      datetimeEnd?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    approvedBy?: {
      __typename: 'Employee';
      id: string;
      organizationId?: string | null;
      organizationUnitId?: string | null;
      userId: string;
      nik: string;
      status: EmploymentStatus;
      domicile?: string | null;
      managerId?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    createdAt: string;
    updatedAt: string;
  } | null;
};

export type ListPostsQueryVariables = {
  filter?: ModelPostFilterInput | null;
  limit?: number | null;
  nextToken?: string | null;
};

export type ListPostsQuery = {
  listPosts?: {
    __typename: 'ModelPostConnection';
    items: Array<{
      __typename: 'Post';
      id: string;
      communityId?: string | null;
      creatorId?: string | null;
      content?: string | null;
      documentId?: string | null;
      eventId?: string | null;
      articleId?: string | null;
      surveyId?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null>;
    nextToken?: string | null;
  } | null;
};

export type GetEventQueryVariables = {
  id: string;
};

export type GetEventQuery = {
  getEvent?: {
    __typename: 'Event';
    id: string;
    eventId?: string | null;
    communityId?: string | null;
    community?: {
      __typename: 'Community';
      id: string;
      coverUrl?: string | null;
      profileUrl?: string | null;
      name: string;
      description: string;
      tags?: Array<string | null> | null;
      categoryId?: string | null;
      unitId?: string | null;
      knowledgeFocus?: Array<string | null> | null;
      objective?: Array<string | null> | null;
      kpi?: Array<string | null> | null;
      policy?: Array<string | null> | null;
      memberCanInvite: boolean;
      reviewNewPost: boolean;
      ownerId?: string | null;
      type: CommunityType;
      createdAt: string;
      updatedAt: string;
    } | null;
    owner?: string | null;
    profileUrl?: string | null;
    type: EventType;
    title: string;
    description?: string | null;
    about?: string | null;
    datetimeFrom?: string | null;
    datetimeTo?: string | null;
    externalLink?: string | null;
    location?: string | null;
    noteTakers?: {
      __typename: 'ModelNoteTakersConnection';
      nextToken?: string | null;
    } | null;
    employeeSpeakers?: Array<{
      __typename: 'Employee';
      id: string;
      organizationId?: string | null;
      organizationUnitId?: string | null;
      userId: string;
      nik: string;
      status: EmploymentStatus;
      domicile?: string | null;
      managerId?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null> | null;
    externalSpeakers?: Array<{
      __typename: 'EventSpeaker';
      id: string;
      name?: string | null;
      jobTitle?: string | null;
      company?: string | null;
      photo_url?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null> | null;
    committees?: {
      __typename: 'ModelComitteeConnection';
      nextToken?: string | null;
    } | null;
    documentations?: {
      __typename: 'ModelCommunityDocumentationConnection';
      nextToken?: string | null;
    } | null;
    attendeeIds?: {
      __typename: 'ModelAttendeeConnection';
      nextToken?: string | null;
    } | null;
    messages?: {
      __typename: 'ModelEventMessageConnection';
      nextToken?: string | null;
    } | null;
    createdAt: string;
    updatedAt: string;
  } | null;
};

export type ListEventsQueryVariables = {
  filter?: ModelEventFilterInput | null;
  limit?: number | null;
  nextToken?: string | null;
};

export type ListEventsQuery = {
  listEvents?: {
    __typename: 'ModelEventConnection';
    items: Array<{
      __typename: 'Event';
      id: string;
      eventId?: string | null;
      communityId?: string | null;
      owner?: string | null;
      profileUrl?: string | null;
      type: EventType;
      title: string;
      description?: string | null;
      about?: string | null;
      datetimeFrom?: string | null;
      datetimeTo?: string | null;
      externalLink?: string | null;
      location?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null>;
    nextToken?: string | null;
  } | null;
};

export type GetNoteTakersQueryVariables = {
  id: string;
};

export type GetNoteTakersQuery = {
  getNoteTakers?: {
    __typename: 'NoteTakers';
    id: string;
    eventId?: string | null;
    employeeId?: string | null;
    employee?: {
      __typename: 'Employee';
      id: string;
      organizationId?: string | null;
      organizationUnitId?: string | null;
      userId: string;
      nik: string;
      status: EmploymentStatus;
      domicile?: string | null;
      managerId?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    createdAt: string;
    updatedAt: string;
  } | null;
};

export type ListNoteTakersQueryVariables = {
  filter?: ModelNoteTakersFilterInput | null;
  limit?: number | null;
  nextToken?: string | null;
};

export type ListNoteTakersQuery = {
  listNoteTakers?: {
    __typename: 'ModelNoteTakersConnection';
    items: Array<{
      __typename: 'NoteTakers';
      id: string;
      eventId?: string | null;
      employeeId?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null>;
    nextToken?: string | null;
  } | null;
};

export type GetComitteeQueryVariables = {
  id: string;
};

export type GetComitteeQuery = {
  getComittee?: {
    __typename: 'Comittee';
    id: string;
    eventId?: string | null;
    employeeId?: string | null;
    employee?: {
      __typename: 'Employee';
      id: string;
      organizationId?: string | null;
      organizationUnitId?: string | null;
      userId: string;
      nik: string;
      status: EmploymentStatus;
      domicile?: string | null;
      managerId?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    createdAt: string;
    updatedAt: string;
  } | null;
};

export type ListComitteesQueryVariables = {
  filter?: ModelComitteeFilterInput | null;
  limit?: number | null;
  nextToken?: string | null;
};

export type ListComitteesQuery = {
  listComittees?: {
    __typename: 'ModelComitteeConnection';
    items: Array<{
      __typename: 'Comittee';
      id: string;
      eventId?: string | null;
      employeeId?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null>;
    nextToken?: string | null;
  } | null;
};

export type GetAttendeeQueryVariables = {
  id: string;
};

export type GetAttendeeQuery = {
  getAttendee?: {
    __typename: 'Attendee';
    id: string;
    employeeId?: string | null;
    employee?: {
      __typename: 'Employee';
      id: string;
      organizationId?: string | null;
      organizationUnitId?: string | null;
      userId: string;
      nik: string;
      status: EmploymentStatus;
      domicile?: string | null;
      managerId?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    createdAt: string;
    updatedAt: string;
  } | null;
};

export type ListAttendeesQueryVariables = {
  filter?: ModelAttendeeFilterInput | null;
  limit?: number | null;
  nextToken?: string | null;
};

export type ListAttendeesQuery = {
  listAttendees?: {
    __typename: 'ModelAttendeeConnection';
    items: Array<{
      __typename: 'Attendee';
      id: string;
      employeeId?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null>;
    nextToken?: string | null;
  } | null;
};

export type GetEmployeeSpeakerQueryVariables = {
  id: string;
};

export type GetEmployeeSpeakerQuery = {
  getEmployeeSpeaker?: {
    __typename: 'EmployeeSpeaker';
    id: string;
    employeeId?: string | null;
    employe?: {
      __typename: 'Employee';
      id: string;
      organizationId?: string | null;
      organizationUnitId?: string | null;
      userId: string;
      nik: string;
      status: EmploymentStatus;
      domicile?: string | null;
      managerId?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    createdAt: string;
    updatedAt: string;
  } | null;
};

export type ListEmployeeSpeakersQueryVariables = {
  filter?: ModelEmployeeSpeakerFilterInput | null;
  limit?: number | null;
  nextToken?: string | null;
};

export type ListEmployeeSpeakersQuery = {
  listEmployeeSpeakers?: {
    __typename: 'ModelEmployeeSpeakerConnection';
    items: Array<{
      __typename: 'EmployeeSpeaker';
      id: string;
      employeeId?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null>;
    nextToken?: string | null;
  } | null;
};

export type GetEventSpeakerQueryVariables = {
  id: string;
};

export type GetEventSpeakerQuery = {
  getEventSpeaker?: {
    __typename: 'EventSpeaker';
    id: string;
    name?: string | null;
    jobTitle?: string | null;
    company?: string | null;
    photo_url?: string | null;
    createdAt: string;
    updatedAt: string;
  } | null;
};

export type ListEventSpeakersQueryVariables = {
  filter?: ModelEventSpeakerFilterInput | null;
  limit?: number | null;
  nextToken?: string | null;
};

export type ListEventSpeakersQuery = {
  listEventSpeakers?: {
    __typename: 'ModelEventSpeakerConnection';
    items: Array<{
      __typename: 'EventSpeaker';
      id: string;
      name?: string | null;
      jobTitle?: string | null;
      company?: string | null;
      photo_url?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null>;
    nextToken?: string | null;
  } | null;
};

export type GetEventMessageQueryVariables = {
  id: string;
};

export type GetEventMessageQuery = {
  getEventMessage?: {
    __typename: 'EventMessage';
    id: string;
    eventId?: string | null;
    from?: {
      __typename: 'Employee';
      id: string;
      organizationId?: string | null;
      organizationUnitId?: string | null;
      userId: string;
      nik: string;
      status: EmploymentStatus;
      domicile?: string | null;
      managerId?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    toId?: {
      __typename: 'Employee';
      id: string;
      organizationId?: string | null;
      organizationUnitId?: string | null;
      userId: string;
      nik: string;
      status: EmploymentStatus;
      domicile?: string | null;
      managerId?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    message?: string | null;
    parentId?: string | null;
    parent?: {
      __typename: 'EventMessage';
      id: string;
      eventId?: string | null;
      message?: string | null;
      parentId?: string | null;
      attachmentUrl?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    replies?: {
      __typename: 'ModelEventMessageConnection';
      nextToken?: string | null;
    } | null;
    attachmentUrl?: string | null;
    createdAt: string;
    updatedAt: string;
  } | null;
};

export type ListEventMessagesQueryVariables = {
  filter?: ModelEventMessageFilterInput | null;
  limit?: number | null;
  nextToken?: string | null;
};

export type ListEventMessagesQuery = {
  listEventMessages?: {
    __typename: 'ModelEventMessageConnection';
    items: Array<{
      __typename: 'EventMessage';
      id: string;
      eventId?: string | null;
      message?: string | null;
      parentId?: string | null;
      attachmentUrl?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null>;
    nextToken?: string | null;
  } | null;
};

export type GetArticleQueryVariables = {
  id: string;
};

export type GetArticleQuery = {
  getArticle?: {
    __typename: 'Article';
    id: string;
    profileUrl?: string | null;
    status: ArticleStatus;
    owner?: {
      __typename: 'User';
      id: string;
      username: string;
      name: string;
      email: string;
      createdAt: string;
      updatedAt: string;
    } | null;
    title: string;
    content: string;
    createdAt?: string | null;
    createdBy?: {
      __typename: 'User';
      id: string;
      username: string;
      name: string;
      email: string;
      createdAt: string;
      updatedAt: string;
    } | null;
    updatedAt?: string | null;
    updatedBy?: {
      __typename: 'User';
      id: string;
      username: string;
      name: string;
      email: string;
      createdAt: string;
      updatedAt: string;
    } | null;
  } | null;
};

export type ListArticlesQueryVariables = {
  filter?: ModelArticleFilterInput | null;
  limit?: number | null;
  nextToken?: string | null;
};

export type ListArticlesQuery = {
  listArticles?: {
    __typename: 'ModelArticleConnection';
    items: Array<{
      __typename: 'Article';
      id: string;
      profileUrl?: string | null;
      status: ArticleStatus;
      title: string;
      content: string;
      createdAt?: string | null;
      updatedAt?: string | null;
    } | null>;
    nextToken?: string | null;
  } | null;
};

export type GetSurveyQueryVariables = {
  id: string;
};

export type GetSurveyQuery = {
  getSurvey?: {
    __typename: 'Survey';
    id: string;
    name: string;
    datetimeStart?: string | null;
    datetimeEnd?: string | null;
    options?: {
      __typename: 'ModelSurveyOptionConnection';
      nextToken?: string | null;
    } | null;
    createdAt: string;
    updatedAt: string;
  } | null;
};

export type ListSurveysQueryVariables = {
  filter?: ModelSurveyFilterInput | null;
  limit?: number | null;
  nextToken?: string | null;
};

export type ListSurveysQuery = {
  listSurveys?: {
    __typename: 'ModelSurveyConnection';
    items: Array<{
      __typename: 'Survey';
      id: string;
      name: string;
      datetimeStart?: string | null;
      datetimeEnd?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null>;
    nextToken?: string | null;
  } | null;
};

export type GetSurveyOptionQueryVariables = {
  id: string;
};

export type GetSurveyOptionQuery = {
  getSurveyOption?: {
    __typename: 'SurveyOption';
    id: string;
    surveyOptionId?: string | null;
    caption?: string | null;
    totalVote?: number | null;
    createdAt: string;
    updatedAt: string;
  } | null;
};

export type ListSurveyOptionsQueryVariables = {
  filter?: ModelSurveyOptionFilterInput | null;
  limit?: number | null;
  nextToken?: string | null;
};

export type ListSurveyOptionsQuery = {
  listSurveyOptions?: {
    __typename: 'ModelSurveyOptionConnection';
    items: Array<{
      __typename: 'SurveyOption';
      id: string;
      surveyOptionId?: string | null;
      caption?: string | null;
      totalVote?: number | null;
      createdAt: string;
      updatedAt: string;
    } | null>;
    nextToken?: string | null;
  } | null;
};

export type EmployeesByOrganizationIdQueryVariables = {
  organizationId: string;
  sortDirection?: ModelSortDirection | null;
  filter?: ModelEmployeeFilterInput | null;
  limit?: number | null;
  nextToken?: string | null;
};

export type EmployeesByOrganizationIdQuery = {
  employeesByOrganizationId?: {
    __typename: 'ModelEmployeeConnection';
    items: Array<{
      __typename: 'Employee';
      id: string;
      organizationId?: string | null;
      organizationUnitId?: string | null;
      userId: string;
      nik: string;
      status: EmploymentStatus;
      domicile?: string | null;
      managerId?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null>;
    nextToken?: string | null;
  } | null;
};

export type EmployeesByUserIdQueryVariables = {
  userId: string;
  sortDirection?: ModelSortDirection | null;
  filter?: ModelEmployeeFilterInput | null;
  limit?: number | null;
  nextToken?: string | null;
};

export type EmployeesByUserIdQuery = {
  employeesByUserId?: {
    __typename: 'ModelEmployeeConnection';
    items: Array<{
      __typename: 'Employee';
      id: string;
      organizationId?: string | null;
      organizationUnitId?: string | null;
      userId: string;
      nik: string;
      status: EmploymentStatus;
      domicile?: string | null;
      managerId?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null>;
    nextToken?: string | null;
  } | null;
};

export type EmployeeJobTitlesByEmployeeIdQueryVariables = {
  employeeId: string;
  sortDirection?: ModelSortDirection | null;
  filter?: ModelEmployeeJobTitleFilterInput | null;
  limit?: number | null;
  nextToken?: string | null;
};

export type EmployeeJobTitlesByEmployeeIdQuery = {
  employeeJobTitlesByEmployeeId?: {
    __typename: 'ModelEmployeeJobTitleConnection';
    items: Array<{
      __typename: 'EmployeeJobTitle';
      id: string;
      employeeId?: string | null;
      jobTitleId?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null>;
    nextToken?: string | null;
  } | null;
};

export type EmployeeJobTitlesByJobTitleIdQueryVariables = {
  jobTitleId: string;
  sortDirection?: ModelSortDirection | null;
  filter?: ModelEmployeeJobTitleFilterInput | null;
  limit?: number | null;
  nextToken?: string | null;
};

export type EmployeeJobTitlesByJobTitleIdQuery = {
  employeeJobTitlesByJobTitleId?: {
    __typename: 'ModelEmployeeJobTitleConnection';
    items: Array<{
      __typename: 'EmployeeJobTitle';
      id: string;
      employeeId?: string | null;
      jobTitleId?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null>;
    nextToken?: string | null;
  } | null;
};

export type ObjectivesByOwnerIdQueryVariables = {
  ownerId: string;
  sortDirection?: ModelSortDirection | null;
  filter?: ModelObjectiveFilterInput | null;
  limit?: number | null;
  nextToken?: string | null;
};

export type ObjectivesByOwnerIdQuery = {
  objectivesByOwnerId?: {
    __typename: 'ModelObjectiveConnection';
    items: Array<{
      __typename: 'Objective';
      id: string;
      ownerId?: string | null;
      title: string;
      description?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null>;
    nextToken?: string | null;
  } | null;
};

export type OrganizationUnitsByOrganizationIdQueryVariables = {
  organizationId: string;
  sortDirection?: ModelSortDirection | null;
  filter?: ModelOrganizationUnitFilterInput | null;
  limit?: number | null;
  nextToken?: string | null;
};

export type OrganizationUnitsByOrganizationIdQuery = {
  organizationUnitsByOrganizationId?: {
    __typename: 'ModelOrganizationUnitConnection';
    items: Array<{
      __typename: 'OrganizationUnit';
      id: string;
      organizationId?: string | null;
      name: string;
      parentId?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null>;
    nextToken?: string | null;
  } | null;
};

export type OrganizationUnitsByParentIdQueryVariables = {
  parentId: string;
  sortDirection?: ModelSortDirection | null;
  filter?: ModelOrganizationUnitFilterInput | null;
  limit?: number | null;
  nextToken?: string | null;
};

export type OrganizationUnitsByParentIdQuery = {
  organizationUnitsByParentId?: {
    __typename: 'ModelOrganizationUnitConnection';
    items: Array<{
      __typename: 'OrganizationUnit';
      id: string;
      organizationId?: string | null;
      name: string;
      parentId?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null>;
    nextToken?: string | null;
  } | null;
};

export type EmployeeSocialMediasByEmployeeIdQueryVariables = {
  employeeId: string;
  sortDirection?: ModelSortDirection | null;
  filter?: ModelEmployeeSocialMediaFilterInput | null;
  limit?: number | null;
  nextToken?: string | null;
};

export type EmployeeSocialMediasByEmployeeIdQuery = {
  employeeSocialMediasByEmployeeId?: {
    __typename: 'ModelEmployeeSocialMediaConnection';
    items: Array<{
      __typename: 'EmployeeSocialMedia';
      id: string;
      employeeId?: string | null;
      socialMediaId?: string | null;
      username: string;
      createdAt: string;
      updatedAt: string;
    } | null>;
    nextToken?: string | null;
  } | null;
};

export type EmployeeSocialMediasBySocialMediaIdQueryVariables = {
  socialMediaId: string;
  sortDirection?: ModelSortDirection | null;
  filter?: ModelEmployeeSocialMediaFilterInput | null;
  limit?: number | null;
  nextToken?: string | null;
};

export type EmployeeSocialMediasBySocialMediaIdQuery = {
  employeeSocialMediasBySocialMediaId?: {
    __typename: 'ModelEmployeeSocialMediaConnection';
    items: Array<{
      __typename: 'EmployeeSocialMedia';
      id: string;
      employeeId?: string | null;
      socialMediaId?: string | null;
      username: string;
      createdAt: string;
      updatedAt: string;
    } | null>;
    nextToken?: string | null;
  } | null;
};

export type EmployeePositionHistoriesByEmployeeIdQueryVariables = {
  employeeId: string;
  sortDirection?: ModelSortDirection | null;
  filter?: ModelEmployeePositionHistoryFilterInput | null;
  limit?: number | null;
  nextToken?: string | null;
};

export type EmployeePositionHistoriesByEmployeeIdQuery = {
  employeePositionHistoriesByEmployeeId?: {
    __typename: 'ModelEmployeePositionHistoryConnection';
    items: Array<{
      __typename: 'EmployeePositionHistory';
      id: string;
      employeeId?: string | null;
      dateFrom?: string | null;
      dateUntil?: string | null;
      officeName?: string | null;
      location?: string | null;
      description?: string | null;
      internalPosition?: boolean | null;
      createdAt: string;
      updatedAt: string;
    } | null>;
    nextToken?: string | null;
  } | null;
};

export type EmployeeEducationHistoriesByEmployeeIdQueryVariables = {
  employeeId: string;
  sortDirection?: ModelSortDirection | null;
  filter?: ModelEmployeeEducationHistoryFilterInput | null;
  limit?: number | null;
  nextToken?: string | null;
};

export type EmployeeEducationHistoriesByEmployeeIdQuery = {
  employeeEducationHistoriesByEmployeeId?: {
    __typename: 'ModelEmployeeEducationHistoryConnection';
    items: Array<{
      __typename: 'EmployeeEducationHistory';
      id: string;
      employeeId?: string | null;
      schoolName?: string | null;
      entryYear?: number | null;
      graduationYear?: number | null;
      createdAt: string;
      updatedAt: string;
    } | null>;
    nextToken?: string | null;
  } | null;
};

export type EmployeeAssignmentHistoriesByEmployeeIdQueryVariables = {
  employeeId: string;
  sortDirection?: ModelSortDirection | null;
  filter?: ModelEmployeeAssignmentHistoryFilterInput | null;
  limit?: number | null;
  nextToken?: string | null;
};

export type EmployeeAssignmentHistoriesByEmployeeIdQuery = {
  employeeAssignmentHistoriesByEmployeeId?: {
    __typename: 'ModelEmployeeAssignmentHistoryConnection';
    items: Array<{
      __typename: 'EmployeeAssignmentHistory';
      id: string;
      employeeId?: string | null;
      dateFrom?: string | null;
      dateUntil?: string | null;
      officeName?: string | null;
      location?: string | null;
      description?: string | null;
      bodRelated?: boolean | null;
      createdAt: string;
      updatedAt: string;
    } | null>;
    nextToken?: string | null;
  } | null;
};

export type EmployeeActivitiesByEmployeeIdQueryVariables = {
  employeeId: string;
  sortDirection?: ModelSortDirection | null;
  filter?: ModelEmployeeActivityFilterInput | null;
  limit?: number | null;
  nextToken?: string | null;
};

export type EmployeeActivitiesByEmployeeIdQuery = {
  employeeActivitiesByEmployeeId?: {
    __typename: 'ModelEmployeeActivityConnection';
    items: Array<{
      __typename: 'EmployeeActivity';
      id: string;
      employeeId?: string | null;
      activityId: string;
      point?: number | null;
      datetime?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null>;
    nextToken?: string | null;
  } | null;
};

export type EmployeeBadgesByEmployeeIdQueryVariables = {
  employeeId: string;
  sortDirection?: ModelSortDirection | null;
  filter?: ModelEmployeeBadgeFilterInput | null;
  limit?: number | null;
  nextToken?: string | null;
};

export type EmployeeBadgesByEmployeeIdQuery = {
  employeeBadgesByEmployeeId?: {
    __typename: 'ModelEmployeeBadgeConnection';
    items: Array<{
      __typename: 'EmployeeBadge';
      id: string;
      employeeId: string;
      badgeId: string;
      grantDate?: string | null;
      grantedById: string;
      createdAt: string;
      updatedAt: string;
    } | null>;
    nextToken?: string | null;
  } | null;
};

export type EmployeeSkillsByEmployeeIdQueryVariables = {
  employeeId: string;
  sortDirection?: ModelSortDirection | null;
  filter?: ModelEmployeeSkillFilterInput | null;
  limit?: number | null;
  nextToken?: string | null;
};

export type EmployeeSkillsByEmployeeIdQuery = {
  employeeSkillsByEmployeeId?: {
    __typename: 'ModelEmployeeSkillConnection';
    items: Array<{
      __typename: 'EmployeeSkill';
      id: string;
      employeeId: string;
      skillGroup?: string | null;
      skill?: string | null;
      name?: string | null;
      level?: SkillLevel | null;
      progress?: number | null;
      createdAt: string;
      updatedAt: string;
    } | null>;
    nextToken?: string | null;
  } | null;
};

export type EmployeeTrainingsByEmployeeIdQueryVariables = {
  employeeId: string;
  sortDirection?: ModelSortDirection | null;
  filter?: ModelEmployeeTrainingFilterInput | null;
  limit?: number | null;
  nextToken?: string | null;
};

export type EmployeeTrainingsByEmployeeIdQuery = {
  employeeTrainingsByEmployeeId?: {
    __typename: 'ModelEmployeeTrainingConnection';
    items: Array<{
      __typename: 'EmployeeTraining';
      id: string;
      employeeId: string;
      date?: string | null;
      name?: string | null;
      description?: string | null;
      type?: TrainingType | null;
      createdAt: string;
      updatedAt: string;
    } | null>;
    nextToken?: string | null;
  } | null;
};

export type EmployeeRewardsByEmployeeIdQueryVariables = {
  employeeId: string;
  sortDirection?: ModelSortDirection | null;
  filter?: ModelEmployeeRewardFilterInput | null;
  limit?: number | null;
  nextToken?: string | null;
};

export type EmployeeRewardsByEmployeeIdQuery = {
  employeeRewardsByEmployeeId?: {
    __typename: 'ModelEmployeeRewardConnection';
    items: Array<{
      __typename: 'EmployeeReward';
      id: string;
      employeeId: string;
      date?: string | null;
      name?: string | null;
      description?: string | null;
      type?: RewardType | null;
      createdAt: string;
      updatedAt: string;
    } | null>;
    nextToken?: string | null;
  } | null;
};

export type KnowledgeMapsByOwnerIdQueryVariables = {
  ownerId: string;
  sortDirection?: ModelSortDirection | null;
  filter?: ModelKnowledgeMapFilterInput | null;
  limit?: number | null;
  nextToken?: string | null;
};

export type KnowledgeMapsByOwnerIdQuery = {
  knowledgeMapsByOwnerId?: {
    __typename: 'ModelKnowledgeMapConnection';
    items: Array<{
      __typename: 'KnowledgeMap';
      id: string;
      name?: string | null;
      ownerId: string;
      createdAt: string;
      updatedAt: string;
    } | null>;
    nextToken?: string | null;
  } | null;
};

export type KnowledgeMapCollaboratorsByEmployeeIdQueryVariables = {
  employeeId: string;
  sortDirection?: ModelSortDirection | null;
  filter?: ModelKnowledgeMapCollaboratorFilterInput | null;
  limit?: number | null;
  nextToken?: string | null;
};

export type KnowledgeMapCollaboratorsByEmployeeIdQuery = {
  knowledgeMapCollaboratorsByEmployeeId?: {
    __typename: 'ModelKnowledgeMapCollaboratorConnection';
    items: Array<{
      __typename: 'KnowledgeMapCollaborator';
      id: string;
      employeeId?: string | null;
      knowledgeMapId: string;
      createdAt: string;
      updatedAt: string;
    } | null>;
    nextToken?: string | null;
  } | null;
};

export type KnowledgeMapCollaboratorsByKnowledgeMapIdQueryVariables = {
  knowledgeMapId: string;
  sortDirection?: ModelSortDirection | null;
  filter?: ModelKnowledgeMapCollaboratorFilterInput | null;
  limit?: number | null;
  nextToken?: string | null;
};

export type KnowledgeMapCollaboratorsByKnowledgeMapIdQuery = {
  knowledgeMapCollaboratorsByKnowledgeMapId?: {
    __typename: 'ModelKnowledgeMapCollaboratorConnection';
    items: Array<{
      __typename: 'KnowledgeMapCollaborator';
      id: string;
      employeeId?: string | null;
      knowledgeMapId: string;
      createdAt: string;
      updatedAt: string;
    } | null>;
    nextToken?: string | null;
  } | null;
};

export type BusinessProcessesByKnowledgeMapIdQueryVariables = {
  knowledgeMapId: string;
  sortDirection?: ModelSortDirection | null;
  filter?: ModelBusinessProcessFilterInput | null;
  limit?: number | null;
  nextToken?: string | null;
};

export type BusinessProcessesByKnowledgeMapIdQuery = {
  businessProcessesByKnowledgeMapId?: {
    __typename: 'ModelBusinessProcessConnection';
    items: Array<{
      __typename: 'BusinessProcess';
      id: string;
      knowledgeMapId: string;
      title: string;
      description: string;
      createdAt: string;
      updatedAt: string;
    } | null>;
    nextToken?: string | null;
  } | null;
};

export type BusinessProcessCommentsByBusinessProcessIdQueryVariables = {
  businessProcessId: string;
  sortDirection?: ModelSortDirection | null;
  filter?: ModelBusinessProcessCommentFilterInput | null;
  limit?: number | null;
  nextToken?: string | null;
};

export type BusinessProcessCommentsByBusinessProcessIdQuery = {
  businessProcessCommentsByBusinessProcessId?: {
    __typename: 'ModelBusinessProcessCommentConnection';
    items: Array<{
      __typename: 'BusinessProcessComment';
      id: string;
      businessProcessId: string;
      comment: string;
      createdById: string;
      parentId?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null>;
    nextToken?: string | null;
  } | null;
};

export type BusinessProcessCommentsByParentIdQueryVariables = {
  parentId: string;
  sortDirection?: ModelSortDirection | null;
  filter?: ModelBusinessProcessCommentFilterInput | null;
  limit?: number | null;
  nextToken?: string | null;
};

export type BusinessProcessCommentsByParentIdQuery = {
  businessProcessCommentsByParentId?: {
    __typename: 'ModelBusinessProcessCommentConnection';
    items: Array<{
      __typename: 'BusinessProcessComment';
      id: string;
      businessProcessId: string;
      comment: string;
      createdById: string;
      parentId?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null>;
    nextToken?: string | null;
  } | null;
};

export type StrategicActivitiesByBusinessProcessIdQueryVariables = {
  businessProcessId: string;
  sortDirection?: ModelSortDirection | null;
  filter?: ModelStrategicActivityFilterInput | null;
  limit?: number | null;
  nextToken?: string | null;
};

export type StrategicActivitiesByBusinessProcessIdQuery = {
  strategicActivitiesByBusinessProcessId?: {
    __typename: 'ModelStrategicActivityConnection';
    items: Array<{
      __typename: 'StrategicActivity';
      id: string;
      businessProcessId: string;
      title: string;
      description: string;
      createdAt: string;
      updatedAt: string;
    } | null>;
    nextToken?: string | null;
  } | null;
};

export type StrategicActivityCommentsByStrategicActivityIdQueryVariables = {
  strategicActivityId: string;
  sortDirection?: ModelSortDirection | null;
  filter?: ModelStrategicActivityCommentFilterInput | null;
  limit?: number | null;
  nextToken?: string | null;
};

export type StrategicActivityCommentsByStrategicActivityIdQuery = {
  strategicActivityCommentsByStrategicActivityId?: {
    __typename: 'ModelStrategicActivityCommentConnection';
    items: Array<{
      __typename: 'StrategicActivityComment';
      id: string;
      strategicActivityId: string;
      comment: string;
      createdById: string;
      parentId?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null>;
    nextToken?: string | null;
  } | null;
};

export type StrategicActivityCommentsByParentIdQueryVariables = {
  parentId: string;
  sortDirection?: ModelSortDirection | null;
  filter?: ModelStrategicActivityCommentFilterInput | null;
  limit?: number | null;
  nextToken?: string | null;
};

export type StrategicActivityCommentsByParentIdQuery = {
  strategicActivityCommentsByParentId?: {
    __typename: 'ModelStrategicActivityCommentConnection';
    items: Array<{
      __typename: 'StrategicActivityComment';
      id: string;
      strategicActivityId: string;
      comment: string;
      createdById: string;
      parentId?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null>;
    nextToken?: string | null;
  } | null;
};

export type ImportantKnowledgesByStrategicActivityIdQueryVariables = {
  strategicActivityId: string;
  sortDirection?: ModelSortDirection | null;
  filter?: ModelImportantKnowledgeFilterInput | null;
  limit?: number | null;
  nextToken?: string | null;
};

export type ImportantKnowledgesByStrategicActivityIdQuery = {
  importantKnowledgesByStrategicActivityId?: {
    __typename: 'ModelImportantKnowledgeConnection';
    items: Array<{
      __typename: 'ImportantKnowledge';
      id: string;
      strategicActivityId: string;
      title: string;
      description: string;
      createdAt: string;
      updatedAt: string;
    } | null>;
    nextToken?: string | null;
  } | null;
};

export type ImportantKnowledgeCommentsByImportantKnowledgeIdQueryVariables = {
  importantKnowledgeId: string;
  sortDirection?: ModelSortDirection | null;
  filter?: ModelImportantKnowledgeCommentFilterInput | null;
  limit?: number | null;
  nextToken?: string | null;
};

export type ImportantKnowledgeCommentsByImportantKnowledgeIdQuery = {
  importantKnowledgeCommentsByImportantKnowledgeId?: {
    __typename: 'ModelImportantKnowledgeCommentConnection';
    items: Array<{
      __typename: 'ImportantKnowledgeComment';
      id: string;
      importantKnowledgeId: string;
      comment: string;
      createdById: string;
      parentId?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null>;
    nextToken?: string | null;
  } | null;
};

export type ImportantKnowledgeCommentsByParentIdQueryVariables = {
  parentId: string;
  sortDirection?: ModelSortDirection | null;
  filter?: ModelImportantKnowledgeCommentFilterInput | null;
  limit?: number | null;
  nextToken?: string | null;
};

export type ImportantKnowledgeCommentsByParentIdQuery = {
  importantKnowledgeCommentsByParentId?: {
    __typename: 'ModelImportantKnowledgeCommentConnection';
    items: Array<{
      __typename: 'ImportantKnowledgeComment';
      id: string;
      importantKnowledgeId: string;
      comment: string;
      createdById: string;
      parentId?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null>;
    nextToken?: string | null;
  } | null;
};

export type ImportantKnowledgeDocumentsByImportantKnowledgeIdQueryVariables = {
  importantKnowledgeId: string;
  sortDirection?: ModelSortDirection | null;
  filter?: ModelImportantKnowledgeDocumentFilterInput | null;
  limit?: number | null;
  nextToken?: string | null;
};

export type ImportantKnowledgeDocumentsByImportantKnowledgeIdQuery = {
  importantKnowledgeDocumentsByImportantKnowledgeId?: {
    __typename: 'ModelImportantKnowledgeDocumentConnection';
    items: Array<{
      __typename: 'ImportantKnowledgeDocument';
      id: string;
      importantKnowledgeId: string;
      documentType: ImportantKnowledgeDocumentType;
      documentId: string;
      creatorId: string;
      createdAt: string;
      updatedAt: string;
    } | null>;
    nextToken?: string | null;
  } | null;
};

export type SubjectMatterExpertCompetenciesBySubjectMatterExpertIdQueryVariables = {
  subjectMatterExpertId: string;
  sortDirection?: ModelSortDirection | null;
  filter?: ModelSubjectMatterExpertCompetencyFilterInput | null;
  limit?: number | null;
  nextToken?: string | null;
};

export type SubjectMatterExpertCompetenciesBySubjectMatterExpertIdQuery = {
  subjectMatterExpertCompetenciesBySubjectMatterExpertId?: {
    __typename: 'ModelSubjectMatterExpertCompetencyConnection';
    items: Array<{
      __typename: 'SubjectMatterExpertCompetency';
      id: string;
      subjectMatterExpertId: string;
      competencyFieldId: string;
      createdAt: string;
      updatedAt: string;
    } | null>;
    nextToken?: string | null;
  } | null;
};

export type RepositoryFoldersByParentIdQueryVariables = {
  parentId: string;
  sortDirection?: ModelSortDirection | null;
  filter?: ModelRepositoryFolderFilterInput | null;
  limit?: number | null;
  nextToken?: string | null;
};

export type RepositoryFoldersByParentIdQuery = {
  repositoryFoldersByParentId?: {
    __typename: 'ModelRepositoryFolderConnection';
    items: Array<{
      __typename: 'RepositoryFolder';
      id: string;
      foldername?: string | null;
      parentId?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null>;
    nextToken?: string | null;
  } | null;
};

export type RepositoryFilesByFolderIdQueryVariables = {
  folderId: string;
  sortDirection?: ModelSortDirection | null;
  filter?: ModelRepositoryFileFilterInput | null;
  limit?: number | null;
  nextToken?: string | null;
};

export type RepositoryFilesByFolderIdQuery = {
  repositoryFilesByFolderId?: {
    __typename: 'ModelRepositoryFileConnection';
    items: Array<{
      __typename: 'RepositoryFile';
      id: string;
      folderId: string;
      filename?: string | null;
      filetype?: FileMediaType | null;
      createdById: string;
      createdAt: string;
      updatedAt: string;
    } | null>;
    nextToken?: string | null;
  } | null;
};

export type PendingCoreMembersByCommunityIdQueryVariables = {
  communityId: string;
  sortDirection?: ModelSortDirection | null;
  filter?: ModelPendingCoreMemberFilterInput | null;
  limit?: number | null;
  nextToken?: string | null;
};

export type PendingCoreMembersByCommunityIdQuery = {
  pendingCoreMembersByCommunityId?: {
    __typename: 'ModelPendingCoreMemberConnection';
    items: Array<{
      __typename: 'PendingCoreMember';
      id: string;
      communityId?: string | null;
      employeeId?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null>;
    nextToken?: string | null;
  } | null;
};

export type CoreMembersByCommunityIdQueryVariables = {
  communityId: string;
  sortDirection?: ModelSortDirection | null;
  filter?: ModelCoreMemberFilterInput | null;
  limit?: number | null;
  nextToken?: string | null;
};

export type CoreMembersByCommunityIdQuery = {
  coreMembersByCommunityId?: {
    __typename: 'ModelCoreMemberConnection';
    items: Array<{
      __typename: 'CoreMember';
      id: string;
      communityId?: string | null;
      employeeId?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null>;
    nextToken?: string | null;
  } | null;
};

export type CommunityFollowersByCommunityIdQueryVariables = {
  communityId: string;
  sortDirection?: ModelSortDirection | null;
  filter?: ModelCommunityFollowersFilterInput | null;
  limit?: number | null;
  nextToken?: string | null;
};

export type CommunityFollowersByCommunityIdQuery = {
  communityFollowersByCommunityId?: {
    __typename: 'ModelCommunityFollowersConnection';
    items: Array<{
      __typename: 'CommunityFollowers';
      id: string;
      communityId?: string | null;
      employeeId?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null>;
    nextToken?: string | null;
  } | null;
};

export type CommunityDocumentationsByCommunityIdQueryVariables = {
  communityId: string;
  sortDirection?: ModelSortDirection | null;
  filter?: ModelCommunityDocumentationFilterInput | null;
  limit?: number | null;
  nextToken?: string | null;
};

export type CommunityDocumentationsByCommunityIdQuery = {
  communityDocumentationsByCommunityId?: {
    __typename: 'ModelCommunityDocumentationConnection';
    items: Array<{
      __typename: 'CommunityDocumentation';
      id: string;
      communityId?: string | null;
      documentId?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null>;
    nextToken?: string | null;
  } | null;
};

export type PostsByCommunityIdQueryVariables = {
  communityId: string;
  sortDirection?: ModelSortDirection | null;
  filter?: ModelPostFilterInput | null;
  limit?: number | null;
  nextToken?: string | null;
};

export type PostsByCommunityIdQuery = {
  postsByCommunityId?: {
    __typename: 'ModelPostConnection';
    items: Array<{
      __typename: 'Post';
      id: string;
      communityId?: string | null;
      creatorId?: string | null;
      content?: string | null;
      documentId?: string | null;
      eventId?: string | null;
      articleId?: string | null;
      surveyId?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null>;
    nextToken?: string | null;
  } | null;
};

export type EventsByCommunityIdQueryVariables = {
  communityId: string;
  sortDirection?: ModelSortDirection | null;
  filter?: ModelEventFilterInput | null;
  limit?: number | null;
  nextToken?: string | null;
};

export type EventsByCommunityIdQuery = {
  eventsByCommunityId?: {
    __typename: 'ModelEventConnection';
    items: Array<{
      __typename: 'Event';
      id: string;
      eventId?: string | null;
      communityId?: string | null;
      owner?: string | null;
      profileUrl?: string | null;
      type: EventType;
      title: string;
      description?: string | null;
      about?: string | null;
      datetimeFrom?: string | null;
      datetimeTo?: string | null;
      externalLink?: string | null;
      location?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null>;
    nextToken?: string | null;
  } | null;
};

export type NoteTakersByEventIdQueryVariables = {
  eventId: string;
  sortDirection?: ModelSortDirection | null;
  filter?: ModelNoteTakersFilterInput | null;
  limit?: number | null;
  nextToken?: string | null;
};

export type NoteTakersByEventIdQuery = {
  noteTakersByEventId?: {
    __typename: 'ModelNoteTakersConnection';
    items: Array<{
      __typename: 'NoteTakers';
      id: string;
      eventId?: string | null;
      employeeId?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null>;
    nextToken?: string | null;
  } | null;
};

export type ComitteesByEventIdQueryVariables = {
  eventId: string;
  sortDirection?: ModelSortDirection | null;
  filter?: ModelComitteeFilterInput | null;
  limit?: number | null;
  nextToken?: string | null;
};

export type ComitteesByEventIdQuery = {
  comitteesByEventId?: {
    __typename: 'ModelComitteeConnection';
    items: Array<{
      __typename: 'Comittee';
      id: string;
      eventId?: string | null;
      employeeId?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null>;
    nextToken?: string | null;
  } | null;
};

export type AttendeesByEmployeeIdQueryVariables = {
  employeeId: string;
  sortDirection?: ModelSortDirection | null;
  filter?: ModelAttendeeFilterInput | null;
  limit?: number | null;
  nextToken?: string | null;
};

export type AttendeesByEmployeeIdQuery = {
  attendeesByEmployeeId?: {
    __typename: 'ModelAttendeeConnection';
    items: Array<{
      __typename: 'Attendee';
      id: string;
      employeeId?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null>;
    nextToken?: string | null;
  } | null;
};

export type EmployeeSpeakersByEmployeeIdQueryVariables = {
  employeeId: string;
  sortDirection?: ModelSortDirection | null;
  filter?: ModelEmployeeSpeakerFilterInput | null;
  limit?: number | null;
  nextToken?: string | null;
};

export type EmployeeSpeakersByEmployeeIdQuery = {
  employeeSpeakersByEmployeeId?: {
    __typename: 'ModelEmployeeSpeakerConnection';
    items: Array<{
      __typename: 'EmployeeSpeaker';
      id: string;
      employeeId?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null>;
    nextToken?: string | null;
  } | null;
};

export type EventMessagesByEventIdQueryVariables = {
  eventId: string;
  sortDirection?: ModelSortDirection | null;
  filter?: ModelEventMessageFilterInput | null;
  limit?: number | null;
  nextToken?: string | null;
};

export type EventMessagesByEventIdQuery = {
  eventMessagesByEventId?: {
    __typename: 'ModelEventMessageConnection';
    items: Array<{
      __typename: 'EventMessage';
      id: string;
      eventId?: string | null;
      message?: string | null;
      parentId?: string | null;
      attachmentUrl?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null>;
    nextToken?: string | null;
  } | null;
};

export type EventMessagesByParentIdQueryVariables = {
  parentId: string;
  sortDirection?: ModelSortDirection | null;
  filter?: ModelEventMessageFilterInput | null;
  limit?: number | null;
  nextToken?: string | null;
};

export type EventMessagesByParentIdQuery = {
  eventMessagesByParentId?: {
    __typename: 'ModelEventMessageConnection';
    items: Array<{
      __typename: 'EventMessage';
      id: string;
      eventId?: string | null;
      message?: string | null;
      parentId?: string | null;
      attachmentUrl?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null>;
    nextToken?: string | null;
  } | null;
};

export type SurveyOptionsBySurveyOptionIdQueryVariables = {
  surveyOptionId: string;
  sortDirection?: ModelSortDirection | null;
  filter?: ModelSurveyOptionFilterInput | null;
  limit?: number | null;
  nextToken?: string | null;
};

export type SurveyOptionsBySurveyOptionIdQuery = {
  surveyOptionsBySurveyOptionId?: {
    __typename: 'ModelSurveyOptionConnection';
    items: Array<{
      __typename: 'SurveyOption';
      id: string;
      surveyOptionId?: string | null;
      caption?: string | null;
      totalVote?: number | null;
      createdAt: string;
      updatedAt: string;
    } | null>;
    nextToken?: string | null;
  } | null;
};

export type OnCreateOrganizationSubscriptionVariables = {
  filter?: ModelSubscriptionOrganizationFilterInput | null;
};

export type OnCreateOrganizationSubscription = {
  onCreateOrganization?: {
    __typename: 'Organization';
    id: string;
    employees?: {
      __typename: 'ModelEmployeeConnection';
      nextToken?: string | null;
    } | null;
    name: string;
    address?: string | null;
    objectives?: {
      __typename: 'ModelObjectiveConnection';
      nextToken?: string | null;
    } | null;
    createdAt: string;
    updatedAt: string;
  } | null;
};

export type OnUpdateOrganizationSubscriptionVariables = {
  filter?: ModelSubscriptionOrganizationFilterInput | null;
};

export type OnUpdateOrganizationSubscription = {
  onUpdateOrganization?: {
    __typename: 'Organization';
    id: string;
    employees?: {
      __typename: 'ModelEmployeeConnection';
      nextToken?: string | null;
    } | null;
    name: string;
    address?: string | null;
    objectives?: {
      __typename: 'ModelObjectiveConnection';
      nextToken?: string | null;
    } | null;
    createdAt: string;
    updatedAt: string;
  } | null;
};

export type OnDeleteOrganizationSubscriptionVariables = {
  filter?: ModelSubscriptionOrganizationFilterInput | null;
};

export type OnDeleteOrganizationSubscription = {
  onDeleteOrganization?: {
    __typename: 'Organization';
    id: string;
    employees?: {
      __typename: 'ModelEmployeeConnection';
      nextToken?: string | null;
    } | null;
    name: string;
    address?: string | null;
    objectives?: {
      __typename: 'ModelObjectiveConnection';
      nextToken?: string | null;
    } | null;
    createdAt: string;
    updatedAt: string;
  } | null;
};

export type OnCreateEmployeeSubscriptionVariables = {
  filter?: ModelSubscriptionEmployeeFilterInput | null;
};

export type OnCreateEmployeeSubscription = {
  onCreateEmployee?: {
    __typename: 'Employee';
    id: string;
    organizationId?: string | null;
    organizationUnitId?: string | null;
    organizationUnit?: {
      __typename: 'OrganizationUnit';
      id: string;
      organizationId?: string | null;
      name: string;
      parentId?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    userId: string;
    user?: {
      __typename: 'User';
      id: string;
      username: string;
      name: string;
      email: string;
      createdAt: string;
      updatedAt: string;
    } | null;
    nik: string;
    status: EmploymentStatus;
    domicile?: string | null;
    managerId?: string | null;
    manager?: {
      __typename: 'Employee';
      id: string;
      organizationId?: string | null;
      organizationUnitId?: string | null;
      userId: string;
      nik: string;
      status: EmploymentStatus;
      domicile?: string | null;
      managerId?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    jobTitles?: {
      __typename: 'ModelEmployeeJobTitleConnection';
      nextToken?: string | null;
    } | null;
    socialMedias?: {
      __typename: 'ModelEmployeeSocialMediaConnection';
      nextToken?: string | null;
    } | null;
    positionHistories?: {
      __typename: 'ModelEmployeePositionHistoryConnection';
      nextToken?: string | null;
    } | null;
    educationHistories?: {
      __typename: 'ModelEmployeeEducationHistoryConnection';
      nextToken?: string | null;
    } | null;
    assignmentHistories?: {
      __typename: 'ModelEmployeeAssignmentHistoryConnection';
      nextToken?: string | null;
    } | null;
    activities?: {
      __typename: 'ModelEmployeeActivityConnection';
      nextToken?: string | null;
    } | null;
    badges?: {
      __typename: 'ModelEmployeeBadgeConnection';
      nextToken?: string | null;
    } | null;
    skills?: {
      __typename: 'ModelEmployeeSkillConnection';
      nextToken?: string | null;
    } | null;
    trainings?: {
      __typename: 'ModelEmployeeTrainingConnection';
      nextToken?: string | null;
    } | null;
    rewards?: {
      __typename: 'ModelEmployeeRewardConnection';
      nextToken?: string | null;
    } | null;
    objectives?: {
      __typename: 'ModelObjectiveConnection';
      nextToken?: string | null;
    } | null;
    createdAt: string;
    updatedAt: string;
  } | null;
};

export type OnUpdateEmployeeSubscriptionVariables = {
  filter?: ModelSubscriptionEmployeeFilterInput | null;
};

export type OnUpdateEmployeeSubscription = {
  onUpdateEmployee?: {
    __typename: 'Employee';
    id: string;
    organizationId?: string | null;
    organizationUnitId?: string | null;
    organizationUnit?: {
      __typename: 'OrganizationUnit';
      id: string;
      organizationId?: string | null;
      name: string;
      parentId?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    userId: string;
    user?: {
      __typename: 'User';
      id: string;
      username: string;
      name: string;
      email: string;
      createdAt: string;
      updatedAt: string;
    } | null;
    nik: string;
    status: EmploymentStatus;
    domicile?: string | null;
    managerId?: string | null;
    manager?: {
      __typename: 'Employee';
      id: string;
      organizationId?: string | null;
      organizationUnitId?: string | null;
      userId: string;
      nik: string;
      status: EmploymentStatus;
      domicile?: string | null;
      managerId?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    jobTitles?: {
      __typename: 'ModelEmployeeJobTitleConnection';
      nextToken?: string | null;
    } | null;
    socialMedias?: {
      __typename: 'ModelEmployeeSocialMediaConnection';
      nextToken?: string | null;
    } | null;
    positionHistories?: {
      __typename: 'ModelEmployeePositionHistoryConnection';
      nextToken?: string | null;
    } | null;
    educationHistories?: {
      __typename: 'ModelEmployeeEducationHistoryConnection';
      nextToken?: string | null;
    } | null;
    assignmentHistories?: {
      __typename: 'ModelEmployeeAssignmentHistoryConnection';
      nextToken?: string | null;
    } | null;
    activities?: {
      __typename: 'ModelEmployeeActivityConnection';
      nextToken?: string | null;
    } | null;
    badges?: {
      __typename: 'ModelEmployeeBadgeConnection';
      nextToken?: string | null;
    } | null;
    skills?: {
      __typename: 'ModelEmployeeSkillConnection';
      nextToken?: string | null;
    } | null;
    trainings?: {
      __typename: 'ModelEmployeeTrainingConnection';
      nextToken?: string | null;
    } | null;
    rewards?: {
      __typename: 'ModelEmployeeRewardConnection';
      nextToken?: string | null;
    } | null;
    objectives?: {
      __typename: 'ModelObjectiveConnection';
      nextToken?: string | null;
    } | null;
    createdAt: string;
    updatedAt: string;
  } | null;
};

export type OnDeleteEmployeeSubscriptionVariables = {
  filter?: ModelSubscriptionEmployeeFilterInput | null;
};

export type OnDeleteEmployeeSubscription = {
  onDeleteEmployee?: {
    __typename: 'Employee';
    id: string;
    organizationId?: string | null;
    organizationUnitId?: string | null;
    organizationUnit?: {
      __typename: 'OrganizationUnit';
      id: string;
      organizationId?: string | null;
      name: string;
      parentId?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    userId: string;
    user?: {
      __typename: 'User';
      id: string;
      username: string;
      name: string;
      email: string;
      createdAt: string;
      updatedAt: string;
    } | null;
    nik: string;
    status: EmploymentStatus;
    domicile?: string | null;
    managerId?: string | null;
    manager?: {
      __typename: 'Employee';
      id: string;
      organizationId?: string | null;
      organizationUnitId?: string | null;
      userId: string;
      nik: string;
      status: EmploymentStatus;
      domicile?: string | null;
      managerId?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    jobTitles?: {
      __typename: 'ModelEmployeeJobTitleConnection';
      nextToken?: string | null;
    } | null;
    socialMedias?: {
      __typename: 'ModelEmployeeSocialMediaConnection';
      nextToken?: string | null;
    } | null;
    positionHistories?: {
      __typename: 'ModelEmployeePositionHistoryConnection';
      nextToken?: string | null;
    } | null;
    educationHistories?: {
      __typename: 'ModelEmployeeEducationHistoryConnection';
      nextToken?: string | null;
    } | null;
    assignmentHistories?: {
      __typename: 'ModelEmployeeAssignmentHistoryConnection';
      nextToken?: string | null;
    } | null;
    activities?: {
      __typename: 'ModelEmployeeActivityConnection';
      nextToken?: string | null;
    } | null;
    badges?: {
      __typename: 'ModelEmployeeBadgeConnection';
      nextToken?: string | null;
    } | null;
    skills?: {
      __typename: 'ModelEmployeeSkillConnection';
      nextToken?: string | null;
    } | null;
    trainings?: {
      __typename: 'ModelEmployeeTrainingConnection';
      nextToken?: string | null;
    } | null;
    rewards?: {
      __typename: 'ModelEmployeeRewardConnection';
      nextToken?: string | null;
    } | null;
    objectives?: {
      __typename: 'ModelObjectiveConnection';
      nextToken?: string | null;
    } | null;
    createdAt: string;
    updatedAt: string;
  } | null;
};

export type OnCreateEmployeeJobTitleSubscriptionVariables = {
  filter?: ModelSubscriptionEmployeeJobTitleFilterInput | null;
};

export type OnCreateEmployeeJobTitleSubscription = {
  onCreateEmployeeJobTitle?: {
    __typename: 'EmployeeJobTitle';
    id: string;
    employeeId?: string | null;
    jobTitleId?: string | null;
    jobTitle?: {
      __typename: 'JobTitle';
      id: string;
      organizationUnitId?: string | null;
      title?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    createdAt: string;
    updatedAt: string;
  } | null;
};

export type OnUpdateEmployeeJobTitleSubscriptionVariables = {
  filter?: ModelSubscriptionEmployeeJobTitleFilterInput | null;
};

export type OnUpdateEmployeeJobTitleSubscription = {
  onUpdateEmployeeJobTitle?: {
    __typename: 'EmployeeJobTitle';
    id: string;
    employeeId?: string | null;
    jobTitleId?: string | null;
    jobTitle?: {
      __typename: 'JobTitle';
      id: string;
      organizationUnitId?: string | null;
      title?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    createdAt: string;
    updatedAt: string;
  } | null;
};

export type OnDeleteEmployeeJobTitleSubscriptionVariables = {
  filter?: ModelSubscriptionEmployeeJobTitleFilterInput | null;
};

export type OnDeleteEmployeeJobTitleSubscription = {
  onDeleteEmployeeJobTitle?: {
    __typename: 'EmployeeJobTitle';
    id: string;
    employeeId?: string | null;
    jobTitleId?: string | null;
    jobTitle?: {
      __typename: 'JobTitle';
      id: string;
      organizationUnitId?: string | null;
      title?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    createdAt: string;
    updatedAt: string;
  } | null;
};

export type OnCreateObjectiveSubscriptionVariables = {
  filter?: ModelSubscriptionObjectiveFilterInput | null;
};

export type OnCreateObjectiveSubscription = {
  onCreateObjective?: {
    __typename: 'Objective';
    id: string;
    ownerId?: string | null;
    title: string;
    description?: string | null;
    createdAt: string;
    updatedAt: string;
  } | null;
};

export type OnUpdateObjectiveSubscriptionVariables = {
  filter?: ModelSubscriptionObjectiveFilterInput | null;
};

export type OnUpdateObjectiveSubscription = {
  onUpdateObjective?: {
    __typename: 'Objective';
    id: string;
    ownerId?: string | null;
    title: string;
    description?: string | null;
    createdAt: string;
    updatedAt: string;
  } | null;
};

export type OnDeleteObjectiveSubscriptionVariables = {
  filter?: ModelSubscriptionObjectiveFilterInput | null;
};

export type OnDeleteObjectiveSubscription = {
  onDeleteObjective?: {
    __typename: 'Objective';
    id: string;
    ownerId?: string | null;
    title: string;
    description?: string | null;
    createdAt: string;
    updatedAt: string;
  } | null;
};

export type OnCreateUserSubscriptionVariables = {
  filter?: ModelSubscriptionUserFilterInput | null;
};

export type OnCreateUserSubscription = {
  onCreateUser?: {
    __typename: 'User';
    id: string;
    username: string;
    name: string;
    email: string;
    createdAt: string;
    updatedAt: string;
  } | null;
};

export type OnUpdateUserSubscriptionVariables = {
  filter?: ModelSubscriptionUserFilterInput | null;
};

export type OnUpdateUserSubscription = {
  onUpdateUser?: {
    __typename: 'User';
    id: string;
    username: string;
    name: string;
    email: string;
    createdAt: string;
    updatedAt: string;
  } | null;
};

export type OnDeleteUserSubscriptionVariables = {
  filter?: ModelSubscriptionUserFilterInput | null;
};

export type OnDeleteUserSubscription = {
  onDeleteUser?: {
    __typename: 'User';
    id: string;
    username: string;
    name: string;
    email: string;
    createdAt: string;
    updatedAt: string;
  } | null;
};

export type OnCreateJobTitleSubscriptionVariables = {
  filter?: ModelSubscriptionJobTitleFilterInput | null;
};

export type OnCreateJobTitleSubscription = {
  onCreateJobTitle?: {
    __typename: 'JobTitle';
    id: string;
    organizationUnit?: {
      __typename: 'OrganizationUnit';
      id: string;
      organizationId?: string | null;
      name: string;
      parentId?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    organizationUnitId?: string | null;
    title?: string | null;
    createdAt: string;
    updatedAt: string;
  } | null;
};

export type OnUpdateJobTitleSubscriptionVariables = {
  filter?: ModelSubscriptionJobTitleFilterInput | null;
};

export type OnUpdateJobTitleSubscription = {
  onUpdateJobTitle?: {
    __typename: 'JobTitle';
    id: string;
    organizationUnit?: {
      __typename: 'OrganizationUnit';
      id: string;
      organizationId?: string | null;
      name: string;
      parentId?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    organizationUnitId?: string | null;
    title?: string | null;
    createdAt: string;
    updatedAt: string;
  } | null;
};

export type OnDeleteJobTitleSubscriptionVariables = {
  filter?: ModelSubscriptionJobTitleFilterInput | null;
};

export type OnDeleteJobTitleSubscription = {
  onDeleteJobTitle?: {
    __typename: 'JobTitle';
    id: string;
    organizationUnit?: {
      __typename: 'OrganizationUnit';
      id: string;
      organizationId?: string | null;
      name: string;
      parentId?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    organizationUnitId?: string | null;
    title?: string | null;
    createdAt: string;
    updatedAt: string;
  } | null;
};

export type OnCreateOrganizationUnitSubscriptionVariables = {
  filter?: ModelSubscriptionOrganizationUnitFilterInput | null;
};

export type OnCreateOrganizationUnitSubscription = {
  onCreateOrganizationUnit?: {
    __typename: 'OrganizationUnit';
    id: string;
    organizationId?: string | null;
    name: string;
    parentId?: string | null;
    parent?: {
      __typename: 'OrganizationUnit';
      id: string;
      organizationId?: string | null;
      name: string;
      parentId?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    children?: {
      __typename: 'ModelOrganizationUnitConnection';
      nextToken?: string | null;
    } | null;
    objectives?: {
      __typename: 'ModelObjectiveConnection';
      nextToken?: string | null;
    } | null;
    createdAt: string;
    updatedAt: string;
  } | null;
};

export type OnUpdateOrganizationUnitSubscriptionVariables = {
  filter?: ModelSubscriptionOrganizationUnitFilterInput | null;
};

export type OnUpdateOrganizationUnitSubscription = {
  onUpdateOrganizationUnit?: {
    __typename: 'OrganizationUnit';
    id: string;
    organizationId?: string | null;
    name: string;
    parentId?: string | null;
    parent?: {
      __typename: 'OrganizationUnit';
      id: string;
      organizationId?: string | null;
      name: string;
      parentId?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    children?: {
      __typename: 'ModelOrganizationUnitConnection';
      nextToken?: string | null;
    } | null;
    objectives?: {
      __typename: 'ModelObjectiveConnection';
      nextToken?: string | null;
    } | null;
    createdAt: string;
    updatedAt: string;
  } | null;
};

export type OnDeleteOrganizationUnitSubscriptionVariables = {
  filter?: ModelSubscriptionOrganizationUnitFilterInput | null;
};

export type OnDeleteOrganizationUnitSubscription = {
  onDeleteOrganizationUnit?: {
    __typename: 'OrganizationUnit';
    id: string;
    organizationId?: string | null;
    name: string;
    parentId?: string | null;
    parent?: {
      __typename: 'OrganizationUnit';
      id: string;
      organizationId?: string | null;
      name: string;
      parentId?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    children?: {
      __typename: 'ModelOrganizationUnitConnection';
      nextToken?: string | null;
    } | null;
    objectives?: {
      __typename: 'ModelObjectiveConnection';
      nextToken?: string | null;
    } | null;
    createdAt: string;
    updatedAt: string;
  } | null;
};

export type OnCreateSocialMediaSubscriptionVariables = {
  filter?: ModelSubscriptionSocialMediaFilterInput | null;
};

export type OnCreateSocialMediaSubscription = {
  onCreateSocialMedia?: {
    __typename: 'SocialMedia';
    id: string;
    name: string;
    url?: string | null;
    iconUrl?: string | null;
    createdAt: string;
    updatedAt: string;
  } | null;
};

export type OnUpdateSocialMediaSubscriptionVariables = {
  filter?: ModelSubscriptionSocialMediaFilterInput | null;
};

export type OnUpdateSocialMediaSubscription = {
  onUpdateSocialMedia?: {
    __typename: 'SocialMedia';
    id: string;
    name: string;
    url?: string | null;
    iconUrl?: string | null;
    createdAt: string;
    updatedAt: string;
  } | null;
};

export type OnDeleteSocialMediaSubscriptionVariables = {
  filter?: ModelSubscriptionSocialMediaFilterInput | null;
};

export type OnDeleteSocialMediaSubscription = {
  onDeleteSocialMedia?: {
    __typename: 'SocialMedia';
    id: string;
    name: string;
    url?: string | null;
    iconUrl?: string | null;
    createdAt: string;
    updatedAt: string;
  } | null;
};

export type OnCreateEmployeeSocialMediaSubscriptionVariables = {
  filter?: ModelSubscriptionEmployeeSocialMediaFilterInput | null;
};

export type OnCreateEmployeeSocialMediaSubscription = {
  onCreateEmployeeSocialMedia?: {
    __typename: 'EmployeeSocialMedia';
    id: string;
    employeeId?: string | null;
    socialMediaId?: string | null;
    socialMedia?: {
      __typename: 'SocialMedia';
      id: string;
      name: string;
      url?: string | null;
      iconUrl?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    username: string;
    createdAt: string;
    updatedAt: string;
  } | null;
};

export type OnUpdateEmployeeSocialMediaSubscriptionVariables = {
  filter?: ModelSubscriptionEmployeeSocialMediaFilterInput | null;
};

export type OnUpdateEmployeeSocialMediaSubscription = {
  onUpdateEmployeeSocialMedia?: {
    __typename: 'EmployeeSocialMedia';
    id: string;
    employeeId?: string | null;
    socialMediaId?: string | null;
    socialMedia?: {
      __typename: 'SocialMedia';
      id: string;
      name: string;
      url?: string | null;
      iconUrl?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    username: string;
    createdAt: string;
    updatedAt: string;
  } | null;
};

export type OnDeleteEmployeeSocialMediaSubscriptionVariables = {
  filter?: ModelSubscriptionEmployeeSocialMediaFilterInput | null;
};

export type OnDeleteEmployeeSocialMediaSubscription = {
  onDeleteEmployeeSocialMedia?: {
    __typename: 'EmployeeSocialMedia';
    id: string;
    employeeId?: string | null;
    socialMediaId?: string | null;
    socialMedia?: {
      __typename: 'SocialMedia';
      id: string;
      name: string;
      url?: string | null;
      iconUrl?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    username: string;
    createdAt: string;
    updatedAt: string;
  } | null;
};

export type OnCreateEmployeePositionHistorySubscriptionVariables = {
  filter?: ModelSubscriptionEmployeePositionHistoryFilterInput | null;
};

export type OnCreateEmployeePositionHistorySubscription = {
  onCreateEmployeePositionHistory?: {
    __typename: 'EmployeePositionHistory';
    id: string;
    employeeId?: string | null;
    dateFrom?: string | null;
    dateUntil?: string | null;
    officeName?: string | null;
    location?: string | null;
    description?: string | null;
    internalPosition?: boolean | null;
    createdAt: string;
    updatedAt: string;
  } | null;
};

export type OnUpdateEmployeePositionHistorySubscriptionVariables = {
  filter?: ModelSubscriptionEmployeePositionHistoryFilterInput | null;
};

export type OnUpdateEmployeePositionHistorySubscription = {
  onUpdateEmployeePositionHistory?: {
    __typename: 'EmployeePositionHistory';
    id: string;
    employeeId?: string | null;
    dateFrom?: string | null;
    dateUntil?: string | null;
    officeName?: string | null;
    location?: string | null;
    description?: string | null;
    internalPosition?: boolean | null;
    createdAt: string;
    updatedAt: string;
  } | null;
};

export type OnDeleteEmployeePositionHistorySubscriptionVariables = {
  filter?: ModelSubscriptionEmployeePositionHistoryFilterInput | null;
};

export type OnDeleteEmployeePositionHistorySubscription = {
  onDeleteEmployeePositionHistory?: {
    __typename: 'EmployeePositionHistory';
    id: string;
    employeeId?: string | null;
    dateFrom?: string | null;
    dateUntil?: string | null;
    officeName?: string | null;
    location?: string | null;
    description?: string | null;
    internalPosition?: boolean | null;
    createdAt: string;
    updatedAt: string;
  } | null;
};

export type OnCreateEmployeeEducationHistorySubscriptionVariables = {
  filter?: ModelSubscriptionEmployeeEducationHistoryFilterInput | null;
};

export type OnCreateEmployeeEducationHistorySubscription = {
  onCreateEmployeeEducationHistory?: {
    __typename: 'EmployeeEducationHistory';
    id: string;
    employeeId?: string | null;
    schoolName?: string | null;
    entryYear?: number | null;
    graduationYear?: number | null;
    createdAt: string;
    updatedAt: string;
  } | null;
};

export type OnUpdateEmployeeEducationHistorySubscriptionVariables = {
  filter?: ModelSubscriptionEmployeeEducationHistoryFilterInput | null;
};

export type OnUpdateEmployeeEducationHistorySubscription = {
  onUpdateEmployeeEducationHistory?: {
    __typename: 'EmployeeEducationHistory';
    id: string;
    employeeId?: string | null;
    schoolName?: string | null;
    entryYear?: number | null;
    graduationYear?: number | null;
    createdAt: string;
    updatedAt: string;
  } | null;
};

export type OnDeleteEmployeeEducationHistorySubscriptionVariables = {
  filter?: ModelSubscriptionEmployeeEducationHistoryFilterInput | null;
};

export type OnDeleteEmployeeEducationHistorySubscription = {
  onDeleteEmployeeEducationHistory?: {
    __typename: 'EmployeeEducationHistory';
    id: string;
    employeeId?: string | null;
    schoolName?: string | null;
    entryYear?: number | null;
    graduationYear?: number | null;
    createdAt: string;
    updatedAt: string;
  } | null;
};

export type OnCreateEmployeeAssignmentHistorySubscriptionVariables = {
  filter?: ModelSubscriptionEmployeeAssignmentHistoryFilterInput | null;
};

export type OnCreateEmployeeAssignmentHistorySubscription = {
  onCreateEmployeeAssignmentHistory?: {
    __typename: 'EmployeeAssignmentHistory';
    id: string;
    employeeId?: string | null;
    dateFrom?: string | null;
    dateUntil?: string | null;
    officeName?: string | null;
    location?: string | null;
    description?: string | null;
    bodRelated?: boolean | null;
    createdAt: string;
    updatedAt: string;
  } | null;
};

export type OnUpdateEmployeeAssignmentHistorySubscriptionVariables = {
  filter?: ModelSubscriptionEmployeeAssignmentHistoryFilterInput | null;
};

export type OnUpdateEmployeeAssignmentHistorySubscription = {
  onUpdateEmployeeAssignmentHistory?: {
    __typename: 'EmployeeAssignmentHistory';
    id: string;
    employeeId?: string | null;
    dateFrom?: string | null;
    dateUntil?: string | null;
    officeName?: string | null;
    location?: string | null;
    description?: string | null;
    bodRelated?: boolean | null;
    createdAt: string;
    updatedAt: string;
  } | null;
};

export type OnDeleteEmployeeAssignmentHistorySubscriptionVariables = {
  filter?: ModelSubscriptionEmployeeAssignmentHistoryFilterInput | null;
};

export type OnDeleteEmployeeAssignmentHistorySubscription = {
  onDeleteEmployeeAssignmentHistory?: {
    __typename: 'EmployeeAssignmentHistory';
    id: string;
    employeeId?: string | null;
    dateFrom?: string | null;
    dateUntil?: string | null;
    officeName?: string | null;
    location?: string | null;
    description?: string | null;
    bodRelated?: boolean | null;
    createdAt: string;
    updatedAt: string;
  } | null;
};

export type OnCreateEmployeeActivitySubscriptionVariables = {
  filter?: ModelSubscriptionEmployeeActivityFilterInput | null;
};

export type OnCreateEmployeeActivitySubscription = {
  onCreateEmployeeActivity?: {
    __typename: 'EmployeeActivity';
    id: string;
    employeeId?: string | null;
    activityId: string;
    activity?: {
      __typename: 'Activity';
      id: string;
      name?: string | null;
      point?: number | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    point?: number | null;
    datetime?: string | null;
    createdAt: string;
    updatedAt: string;
  } | null;
};

export type OnUpdateEmployeeActivitySubscriptionVariables = {
  filter?: ModelSubscriptionEmployeeActivityFilterInput | null;
};

export type OnUpdateEmployeeActivitySubscription = {
  onUpdateEmployeeActivity?: {
    __typename: 'EmployeeActivity';
    id: string;
    employeeId?: string | null;
    activityId: string;
    activity?: {
      __typename: 'Activity';
      id: string;
      name?: string | null;
      point?: number | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    point?: number | null;
    datetime?: string | null;
    createdAt: string;
    updatedAt: string;
  } | null;
};

export type OnDeleteEmployeeActivitySubscriptionVariables = {
  filter?: ModelSubscriptionEmployeeActivityFilterInput | null;
};

export type OnDeleteEmployeeActivitySubscription = {
  onDeleteEmployeeActivity?: {
    __typename: 'EmployeeActivity';
    id: string;
    employeeId?: string | null;
    activityId: string;
    activity?: {
      __typename: 'Activity';
      id: string;
      name?: string | null;
      point?: number | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    point?: number | null;
    datetime?: string | null;
    createdAt: string;
    updatedAt: string;
  } | null;
};

export type OnCreateEmployeeBadgeSubscriptionVariables = {
  filter?: ModelSubscriptionEmployeeBadgeFilterInput | null;
};

export type OnCreateEmployeeBadgeSubscription = {
  onCreateEmployeeBadge?: {
    __typename: 'EmployeeBadge';
    id: string;
    employeeId: string;
    badgeId: string;
    badge?: {
      __typename: 'Badge';
      id: string;
      name?: string | null;
      iconUrl?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    grantDate?: string | null;
    grantedById: string;
    grantedBy?: {
      __typename: 'Employee';
      id: string;
      organizationId?: string | null;
      organizationUnitId?: string | null;
      userId: string;
      nik: string;
      status: EmploymentStatus;
      domicile?: string | null;
      managerId?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    createdAt: string;
    updatedAt: string;
  } | null;
};

export type OnUpdateEmployeeBadgeSubscriptionVariables = {
  filter?: ModelSubscriptionEmployeeBadgeFilterInput | null;
};

export type OnUpdateEmployeeBadgeSubscription = {
  onUpdateEmployeeBadge?: {
    __typename: 'EmployeeBadge';
    id: string;
    employeeId: string;
    badgeId: string;
    badge?: {
      __typename: 'Badge';
      id: string;
      name?: string | null;
      iconUrl?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    grantDate?: string | null;
    grantedById: string;
    grantedBy?: {
      __typename: 'Employee';
      id: string;
      organizationId?: string | null;
      organizationUnitId?: string | null;
      userId: string;
      nik: string;
      status: EmploymentStatus;
      domicile?: string | null;
      managerId?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    createdAt: string;
    updatedAt: string;
  } | null;
};

export type OnDeleteEmployeeBadgeSubscriptionVariables = {
  filter?: ModelSubscriptionEmployeeBadgeFilterInput | null;
};

export type OnDeleteEmployeeBadgeSubscription = {
  onDeleteEmployeeBadge?: {
    __typename: 'EmployeeBadge';
    id: string;
    employeeId: string;
    badgeId: string;
    badge?: {
      __typename: 'Badge';
      id: string;
      name?: string | null;
      iconUrl?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    grantDate?: string | null;
    grantedById: string;
    grantedBy?: {
      __typename: 'Employee';
      id: string;
      organizationId?: string | null;
      organizationUnitId?: string | null;
      userId: string;
      nik: string;
      status: EmploymentStatus;
      domicile?: string | null;
      managerId?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    createdAt: string;
    updatedAt: string;
  } | null;
};

export type OnCreateEmployeeSkillSubscriptionVariables = {
  filter?: ModelSubscriptionEmployeeSkillFilterInput | null;
};

export type OnCreateEmployeeSkillSubscription = {
  onCreateEmployeeSkill?: {
    __typename: 'EmployeeSkill';
    id: string;
    employeeId: string;
    skillGroup?: string | null;
    skill?: string | null;
    name?: string | null;
    level?: SkillLevel | null;
    progress?: number | null;
    createdAt: string;
    updatedAt: string;
  } | null;
};

export type OnUpdateEmployeeSkillSubscriptionVariables = {
  filter?: ModelSubscriptionEmployeeSkillFilterInput | null;
};

export type OnUpdateEmployeeSkillSubscription = {
  onUpdateEmployeeSkill?: {
    __typename: 'EmployeeSkill';
    id: string;
    employeeId: string;
    skillGroup?: string | null;
    skill?: string | null;
    name?: string | null;
    level?: SkillLevel | null;
    progress?: number | null;
    createdAt: string;
    updatedAt: string;
  } | null;
};

export type OnDeleteEmployeeSkillSubscriptionVariables = {
  filter?: ModelSubscriptionEmployeeSkillFilterInput | null;
};

export type OnDeleteEmployeeSkillSubscription = {
  onDeleteEmployeeSkill?: {
    __typename: 'EmployeeSkill';
    id: string;
    employeeId: string;
    skillGroup?: string | null;
    skill?: string | null;
    name?: string | null;
    level?: SkillLevel | null;
    progress?: number | null;
    createdAt: string;
    updatedAt: string;
  } | null;
};

export type OnCreateEmployeeTrainingSubscriptionVariables = {
  filter?: ModelSubscriptionEmployeeTrainingFilterInput | null;
};

export type OnCreateEmployeeTrainingSubscription = {
  onCreateEmployeeTraining?: {
    __typename: 'EmployeeTraining';
    id: string;
    employeeId: string;
    date?: string | null;
    name?: string | null;
    description?: string | null;
    type?: TrainingType | null;
    createdAt: string;
    updatedAt: string;
  } | null;
};

export type OnUpdateEmployeeTrainingSubscriptionVariables = {
  filter?: ModelSubscriptionEmployeeTrainingFilterInput | null;
};

export type OnUpdateEmployeeTrainingSubscription = {
  onUpdateEmployeeTraining?: {
    __typename: 'EmployeeTraining';
    id: string;
    employeeId: string;
    date?: string | null;
    name?: string | null;
    description?: string | null;
    type?: TrainingType | null;
    createdAt: string;
    updatedAt: string;
  } | null;
};

export type OnDeleteEmployeeTrainingSubscriptionVariables = {
  filter?: ModelSubscriptionEmployeeTrainingFilterInput | null;
};

export type OnDeleteEmployeeTrainingSubscription = {
  onDeleteEmployeeTraining?: {
    __typename: 'EmployeeTraining';
    id: string;
    employeeId: string;
    date?: string | null;
    name?: string | null;
    description?: string | null;
    type?: TrainingType | null;
    createdAt: string;
    updatedAt: string;
  } | null;
};

export type OnCreateEmployeeRewardSubscriptionVariables = {
  filter?: ModelSubscriptionEmployeeRewardFilterInput | null;
};

export type OnCreateEmployeeRewardSubscription = {
  onCreateEmployeeReward?: {
    __typename: 'EmployeeReward';
    id: string;
    employeeId: string;
    date?: string | null;
    name?: string | null;
    description?: string | null;
    type?: RewardType | null;
    createdAt: string;
    updatedAt: string;
  } | null;
};

export type OnUpdateEmployeeRewardSubscriptionVariables = {
  filter?: ModelSubscriptionEmployeeRewardFilterInput | null;
};

export type OnUpdateEmployeeRewardSubscription = {
  onUpdateEmployeeReward?: {
    __typename: 'EmployeeReward';
    id: string;
    employeeId: string;
    date?: string | null;
    name?: string | null;
    description?: string | null;
    type?: RewardType | null;
    createdAt: string;
    updatedAt: string;
  } | null;
};

export type OnDeleteEmployeeRewardSubscriptionVariables = {
  filter?: ModelSubscriptionEmployeeRewardFilterInput | null;
};

export type OnDeleteEmployeeRewardSubscription = {
  onDeleteEmployeeReward?: {
    __typename: 'EmployeeReward';
    id: string;
    employeeId: string;
    date?: string | null;
    name?: string | null;
    description?: string | null;
    type?: RewardType | null;
    createdAt: string;
    updatedAt: string;
  } | null;
};

export type OnCreateActivitySubscriptionVariables = {
  filter?: ModelSubscriptionActivityFilterInput | null;
};

export type OnCreateActivitySubscription = {
  onCreateActivity?: {
    __typename: 'Activity';
    id: string;
    name?: string | null;
    point?: number | null;
    createdAt: string;
    updatedAt: string;
  } | null;
};

export type OnUpdateActivitySubscriptionVariables = {
  filter?: ModelSubscriptionActivityFilterInput | null;
};

export type OnUpdateActivitySubscription = {
  onUpdateActivity?: {
    __typename: 'Activity';
    id: string;
    name?: string | null;
    point?: number | null;
    createdAt: string;
    updatedAt: string;
  } | null;
};

export type OnDeleteActivitySubscriptionVariables = {
  filter?: ModelSubscriptionActivityFilterInput | null;
};

export type OnDeleteActivitySubscription = {
  onDeleteActivity?: {
    __typename: 'Activity';
    id: string;
    name?: string | null;
    point?: number | null;
    createdAt: string;
    updatedAt: string;
  } | null;
};

export type OnCreateBadgeSubscriptionVariables = {
  filter?: ModelSubscriptionBadgeFilterInput | null;
};

export type OnCreateBadgeSubscription = {
  onCreateBadge?: {
    __typename: 'Badge';
    id: string;
    name?: string | null;
    iconUrl?: string | null;
    createdAt: string;
    updatedAt: string;
  } | null;
};

export type OnUpdateBadgeSubscriptionVariables = {
  filter?: ModelSubscriptionBadgeFilterInput | null;
};

export type OnUpdateBadgeSubscription = {
  onUpdateBadge?: {
    __typename: 'Badge';
    id: string;
    name?: string | null;
    iconUrl?: string | null;
    createdAt: string;
    updatedAt: string;
  } | null;
};

export type OnDeleteBadgeSubscriptionVariables = {
  filter?: ModelSubscriptionBadgeFilterInput | null;
};

export type OnDeleteBadgeSubscription = {
  onDeleteBadge?: {
    __typename: 'Badge';
    id: string;
    name?: string | null;
    iconUrl?: string | null;
    createdAt: string;
    updatedAt: string;
  } | null;
};

export type OnCreateKnowledgeMapSubscriptionVariables = {
  filter?: ModelSubscriptionKnowledgeMapFilterInput | null;
};

export type OnCreateKnowledgeMapSubscription = {
  onCreateKnowledgeMap?: {
    __typename: 'KnowledgeMap';
    id: string;
    name?: string | null;
    ownerId: string;
    businessProcesses?: {
      __typename: 'ModelBusinessProcessConnection';
      nextToken?: string | null;
    } | null;
    collaborators?: {
      __typename: 'ModelKnowledgeMapCollaboratorConnection';
      nextToken?: string | null;
    } | null;
    createdAt: string;
    updatedAt: string;
  } | null;
};

export type OnUpdateKnowledgeMapSubscriptionVariables = {
  filter?: ModelSubscriptionKnowledgeMapFilterInput | null;
};

export type OnUpdateKnowledgeMapSubscription = {
  onUpdateKnowledgeMap?: {
    __typename: 'KnowledgeMap';
    id: string;
    name?: string | null;
    ownerId: string;
    businessProcesses?: {
      __typename: 'ModelBusinessProcessConnection';
      nextToken?: string | null;
    } | null;
    collaborators?: {
      __typename: 'ModelKnowledgeMapCollaboratorConnection';
      nextToken?: string | null;
    } | null;
    createdAt: string;
    updatedAt: string;
  } | null;
};

export type OnDeleteKnowledgeMapSubscriptionVariables = {
  filter?: ModelSubscriptionKnowledgeMapFilterInput | null;
};

export type OnDeleteKnowledgeMapSubscription = {
  onDeleteKnowledgeMap?: {
    __typename: 'KnowledgeMap';
    id: string;
    name?: string | null;
    ownerId: string;
    businessProcesses?: {
      __typename: 'ModelBusinessProcessConnection';
      nextToken?: string | null;
    } | null;
    collaborators?: {
      __typename: 'ModelKnowledgeMapCollaboratorConnection';
      nextToken?: string | null;
    } | null;
    createdAt: string;
    updatedAt: string;
  } | null;
};

export type OnCreateKnowledgeMapCollaboratorSubscriptionVariables = {
  filter?: ModelSubscriptionKnowledgeMapCollaboratorFilterInput | null;
};

export type OnCreateKnowledgeMapCollaboratorSubscription = {
  onCreateKnowledgeMapCollaborator?: {
    __typename: 'KnowledgeMapCollaborator';
    id: string;
    employeeId?: string | null;
    employee?: {
      __typename: 'Employee';
      id: string;
      organizationId?: string | null;
      organizationUnitId?: string | null;
      userId: string;
      nik: string;
      status: EmploymentStatus;
      domicile?: string | null;
      managerId?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    knowledgeMapId: string;
    createdAt: string;
    updatedAt: string;
  } | null;
};

export type OnUpdateKnowledgeMapCollaboratorSubscriptionVariables = {
  filter?: ModelSubscriptionKnowledgeMapCollaboratorFilterInput | null;
};

export type OnUpdateKnowledgeMapCollaboratorSubscription = {
  onUpdateKnowledgeMapCollaborator?: {
    __typename: 'KnowledgeMapCollaborator';
    id: string;
    employeeId?: string | null;
    employee?: {
      __typename: 'Employee';
      id: string;
      organizationId?: string | null;
      organizationUnitId?: string | null;
      userId: string;
      nik: string;
      status: EmploymentStatus;
      domicile?: string | null;
      managerId?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    knowledgeMapId: string;
    createdAt: string;
    updatedAt: string;
  } | null;
};

export type OnDeleteKnowledgeMapCollaboratorSubscriptionVariables = {
  filter?: ModelSubscriptionKnowledgeMapCollaboratorFilterInput | null;
};

export type OnDeleteKnowledgeMapCollaboratorSubscription = {
  onDeleteKnowledgeMapCollaborator?: {
    __typename: 'KnowledgeMapCollaborator';
    id: string;
    employeeId?: string | null;
    employee?: {
      __typename: 'Employee';
      id: string;
      organizationId?: string | null;
      organizationUnitId?: string | null;
      userId: string;
      nik: string;
      status: EmploymentStatus;
      domicile?: string | null;
      managerId?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    knowledgeMapId: string;
    createdAt: string;
    updatedAt: string;
  } | null;
};

export type OnCreateBusinessProcessSubscriptionVariables = {
  filter?: ModelSubscriptionBusinessProcessFilterInput | null;
};

export type OnCreateBusinessProcessSubscription = {
  onCreateBusinessProcess?: {
    __typename: 'BusinessProcess';
    id: string;
    knowledgeMapId: string;
    title: string;
    description: string;
    strategicActivities?: {
      __typename: 'ModelStrategicActivityConnection';
      nextToken?: string | null;
    } | null;
    comments?: {
      __typename: 'ModelBusinessProcessCommentConnection';
      nextToken?: string | null;
    } | null;
    createdAt: string;
    updatedAt: string;
  } | null;
};

export type OnUpdateBusinessProcessSubscriptionVariables = {
  filter?: ModelSubscriptionBusinessProcessFilterInput | null;
};

export type OnUpdateBusinessProcessSubscription = {
  onUpdateBusinessProcess?: {
    __typename: 'BusinessProcess';
    id: string;
    knowledgeMapId: string;
    title: string;
    description: string;
    strategicActivities?: {
      __typename: 'ModelStrategicActivityConnection';
      nextToken?: string | null;
    } | null;
    comments?: {
      __typename: 'ModelBusinessProcessCommentConnection';
      nextToken?: string | null;
    } | null;
    createdAt: string;
    updatedAt: string;
  } | null;
};

export type OnDeleteBusinessProcessSubscriptionVariables = {
  filter?: ModelSubscriptionBusinessProcessFilterInput | null;
};

export type OnDeleteBusinessProcessSubscription = {
  onDeleteBusinessProcess?: {
    __typename: 'BusinessProcess';
    id: string;
    knowledgeMapId: string;
    title: string;
    description: string;
    strategicActivities?: {
      __typename: 'ModelStrategicActivityConnection';
      nextToken?: string | null;
    } | null;
    comments?: {
      __typename: 'ModelBusinessProcessCommentConnection';
      nextToken?: string | null;
    } | null;
    createdAt: string;
    updatedAt: string;
  } | null;
};

export type OnCreateBusinessProcessCommentSubscriptionVariables = {
  filter?: ModelSubscriptionBusinessProcessCommentFilterInput | null;
};

export type OnCreateBusinessProcessCommentSubscription = {
  onCreateBusinessProcessComment?: {
    __typename: 'BusinessProcessComment';
    id: string;
    businessProcessId: string;
    comment: string;
    createdById: string;
    createdBy?: {
      __typename: 'Employee';
      id: string;
      organizationId?: string | null;
      organizationUnitId?: string | null;
      userId: string;
      nik: string;
      status: EmploymentStatus;
      domicile?: string | null;
      managerId?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    parentId?: string | null;
    replies?: {
      __typename: 'ModelBusinessProcessCommentConnection';
      nextToken?: string | null;
    } | null;
    createdAt: string;
    updatedAt: string;
  } | null;
};

export type OnUpdateBusinessProcessCommentSubscriptionVariables = {
  filter?: ModelSubscriptionBusinessProcessCommentFilterInput | null;
};

export type OnUpdateBusinessProcessCommentSubscription = {
  onUpdateBusinessProcessComment?: {
    __typename: 'BusinessProcessComment';
    id: string;
    businessProcessId: string;
    comment: string;
    createdById: string;
    createdBy?: {
      __typename: 'Employee';
      id: string;
      organizationId?: string | null;
      organizationUnitId?: string | null;
      userId: string;
      nik: string;
      status: EmploymentStatus;
      domicile?: string | null;
      managerId?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    parentId?: string | null;
    replies?: {
      __typename: 'ModelBusinessProcessCommentConnection';
      nextToken?: string | null;
    } | null;
    createdAt: string;
    updatedAt: string;
  } | null;
};

export type OnDeleteBusinessProcessCommentSubscriptionVariables = {
  filter?: ModelSubscriptionBusinessProcessCommentFilterInput | null;
};

export type OnDeleteBusinessProcessCommentSubscription = {
  onDeleteBusinessProcessComment?: {
    __typename: 'BusinessProcessComment';
    id: string;
    businessProcessId: string;
    comment: string;
    createdById: string;
    createdBy?: {
      __typename: 'Employee';
      id: string;
      organizationId?: string | null;
      organizationUnitId?: string | null;
      userId: string;
      nik: string;
      status: EmploymentStatus;
      domicile?: string | null;
      managerId?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    parentId?: string | null;
    replies?: {
      __typename: 'ModelBusinessProcessCommentConnection';
      nextToken?: string | null;
    } | null;
    createdAt: string;
    updatedAt: string;
  } | null;
};

export type OnCreateStrategicActivitySubscriptionVariables = {
  filter?: ModelSubscriptionStrategicActivityFilterInput | null;
};

export type OnCreateStrategicActivitySubscription = {
  onCreateStrategicActivity?: {
    __typename: 'StrategicActivity';
    id: string;
    businessProcessId: string;
    title: string;
    description: string;
    importantKnowledges?: {
      __typename: 'ModelImportantKnowledgeConnection';
      nextToken?: string | null;
    } | null;
    comments?: {
      __typename: 'ModelStrategicActivityCommentConnection';
      nextToken?: string | null;
    } | null;
    createdAt: string;
    updatedAt: string;
  } | null;
};

export type OnUpdateStrategicActivitySubscriptionVariables = {
  filter?: ModelSubscriptionStrategicActivityFilterInput | null;
};

export type OnUpdateStrategicActivitySubscription = {
  onUpdateStrategicActivity?: {
    __typename: 'StrategicActivity';
    id: string;
    businessProcessId: string;
    title: string;
    description: string;
    importantKnowledges?: {
      __typename: 'ModelImportantKnowledgeConnection';
      nextToken?: string | null;
    } | null;
    comments?: {
      __typename: 'ModelStrategicActivityCommentConnection';
      nextToken?: string | null;
    } | null;
    createdAt: string;
    updatedAt: string;
  } | null;
};

export type OnDeleteStrategicActivitySubscriptionVariables = {
  filter?: ModelSubscriptionStrategicActivityFilterInput | null;
};

export type OnDeleteStrategicActivitySubscription = {
  onDeleteStrategicActivity?: {
    __typename: 'StrategicActivity';
    id: string;
    businessProcessId: string;
    title: string;
    description: string;
    importantKnowledges?: {
      __typename: 'ModelImportantKnowledgeConnection';
      nextToken?: string | null;
    } | null;
    comments?: {
      __typename: 'ModelStrategicActivityCommentConnection';
      nextToken?: string | null;
    } | null;
    createdAt: string;
    updatedAt: string;
  } | null;
};

export type OnCreateStrategicActivityCommentSubscriptionVariables = {
  filter?: ModelSubscriptionStrategicActivityCommentFilterInput | null;
};

export type OnCreateStrategicActivityCommentSubscription = {
  onCreateStrategicActivityComment?: {
    __typename: 'StrategicActivityComment';
    id: string;
    strategicActivityId: string;
    comment: string;
    createdById: string;
    createdBy?: {
      __typename: 'Employee';
      id: string;
      organizationId?: string | null;
      organizationUnitId?: string | null;
      userId: string;
      nik: string;
      status: EmploymentStatus;
      domicile?: string | null;
      managerId?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    parentId?: string | null;
    replies?: {
      __typename: 'ModelStrategicActivityCommentConnection';
      nextToken?: string | null;
    } | null;
    createdAt: string;
    updatedAt: string;
  } | null;
};

export type OnUpdateStrategicActivityCommentSubscriptionVariables = {
  filter?: ModelSubscriptionStrategicActivityCommentFilterInput | null;
};

export type OnUpdateStrategicActivityCommentSubscription = {
  onUpdateStrategicActivityComment?: {
    __typename: 'StrategicActivityComment';
    id: string;
    strategicActivityId: string;
    comment: string;
    createdById: string;
    createdBy?: {
      __typename: 'Employee';
      id: string;
      organizationId?: string | null;
      organizationUnitId?: string | null;
      userId: string;
      nik: string;
      status: EmploymentStatus;
      domicile?: string | null;
      managerId?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    parentId?: string | null;
    replies?: {
      __typename: 'ModelStrategicActivityCommentConnection';
      nextToken?: string | null;
    } | null;
    createdAt: string;
    updatedAt: string;
  } | null;
};

export type OnDeleteStrategicActivityCommentSubscriptionVariables = {
  filter?: ModelSubscriptionStrategicActivityCommentFilterInput | null;
};

export type OnDeleteStrategicActivityCommentSubscription = {
  onDeleteStrategicActivityComment?: {
    __typename: 'StrategicActivityComment';
    id: string;
    strategicActivityId: string;
    comment: string;
    createdById: string;
    createdBy?: {
      __typename: 'Employee';
      id: string;
      organizationId?: string | null;
      organizationUnitId?: string | null;
      userId: string;
      nik: string;
      status: EmploymentStatus;
      domicile?: string | null;
      managerId?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    parentId?: string | null;
    replies?: {
      __typename: 'ModelStrategicActivityCommentConnection';
      nextToken?: string | null;
    } | null;
    createdAt: string;
    updatedAt: string;
  } | null;
};

export type OnCreateImportantKnowledgeSubscriptionVariables = {
  filter?: ModelSubscriptionImportantKnowledgeFilterInput | null;
};

export type OnCreateImportantKnowledgeSubscription = {
  onCreateImportantKnowledge?: {
    __typename: 'ImportantKnowledge';
    id: string;
    strategicActivityId: string;
    title: string;
    description: string;
    documents?: {
      __typename: 'ModelImportantKnowledgeDocumentConnection';
      nextToken?: string | null;
    } | null;
    comments?: {
      __typename: 'ModelImportantKnowledgeCommentConnection';
      nextToken?: string | null;
    } | null;
    createdAt: string;
    updatedAt: string;
  } | null;
};

export type OnUpdateImportantKnowledgeSubscriptionVariables = {
  filter?: ModelSubscriptionImportantKnowledgeFilterInput | null;
};

export type OnUpdateImportantKnowledgeSubscription = {
  onUpdateImportantKnowledge?: {
    __typename: 'ImportantKnowledge';
    id: string;
    strategicActivityId: string;
    title: string;
    description: string;
    documents?: {
      __typename: 'ModelImportantKnowledgeDocumentConnection';
      nextToken?: string | null;
    } | null;
    comments?: {
      __typename: 'ModelImportantKnowledgeCommentConnection';
      nextToken?: string | null;
    } | null;
    createdAt: string;
    updatedAt: string;
  } | null;
};

export type OnDeleteImportantKnowledgeSubscriptionVariables = {
  filter?: ModelSubscriptionImportantKnowledgeFilterInput | null;
};

export type OnDeleteImportantKnowledgeSubscription = {
  onDeleteImportantKnowledge?: {
    __typename: 'ImportantKnowledge';
    id: string;
    strategicActivityId: string;
    title: string;
    description: string;
    documents?: {
      __typename: 'ModelImportantKnowledgeDocumentConnection';
      nextToken?: string | null;
    } | null;
    comments?: {
      __typename: 'ModelImportantKnowledgeCommentConnection';
      nextToken?: string | null;
    } | null;
    createdAt: string;
    updatedAt: string;
  } | null;
};

export type OnCreateImportantKnowledgeCommentSubscriptionVariables = {
  filter?: ModelSubscriptionImportantKnowledgeCommentFilterInput | null;
};

export type OnCreateImportantKnowledgeCommentSubscription = {
  onCreateImportantKnowledgeComment?: {
    __typename: 'ImportantKnowledgeComment';
    id: string;
    importantKnowledgeId: string;
    comment: string;
    createdById: string;
    createdBy?: {
      __typename: 'Employee';
      id: string;
      organizationId?: string | null;
      organizationUnitId?: string | null;
      userId: string;
      nik: string;
      status: EmploymentStatus;
      domicile?: string | null;
      managerId?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    parentId?: string | null;
    replies?: {
      __typename: 'ModelImportantKnowledgeCommentConnection';
      nextToken?: string | null;
    } | null;
    createdAt: string;
    updatedAt: string;
  } | null;
};

export type OnUpdateImportantKnowledgeCommentSubscriptionVariables = {
  filter?: ModelSubscriptionImportantKnowledgeCommentFilterInput | null;
};

export type OnUpdateImportantKnowledgeCommentSubscription = {
  onUpdateImportantKnowledgeComment?: {
    __typename: 'ImportantKnowledgeComment';
    id: string;
    importantKnowledgeId: string;
    comment: string;
    createdById: string;
    createdBy?: {
      __typename: 'Employee';
      id: string;
      organizationId?: string | null;
      organizationUnitId?: string | null;
      userId: string;
      nik: string;
      status: EmploymentStatus;
      domicile?: string | null;
      managerId?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    parentId?: string | null;
    replies?: {
      __typename: 'ModelImportantKnowledgeCommentConnection';
      nextToken?: string | null;
    } | null;
    createdAt: string;
    updatedAt: string;
  } | null;
};

export type OnDeleteImportantKnowledgeCommentSubscriptionVariables = {
  filter?: ModelSubscriptionImportantKnowledgeCommentFilterInput | null;
};

export type OnDeleteImportantKnowledgeCommentSubscription = {
  onDeleteImportantKnowledgeComment?: {
    __typename: 'ImportantKnowledgeComment';
    id: string;
    importantKnowledgeId: string;
    comment: string;
    createdById: string;
    createdBy?: {
      __typename: 'Employee';
      id: string;
      organizationId?: string | null;
      organizationUnitId?: string | null;
      userId: string;
      nik: string;
      status: EmploymentStatus;
      domicile?: string | null;
      managerId?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    parentId?: string | null;
    replies?: {
      __typename: 'ModelImportantKnowledgeCommentConnection';
      nextToken?: string | null;
    } | null;
    createdAt: string;
    updatedAt: string;
  } | null;
};

export type OnCreateImportantKnowledgeDocumentSubscriptionVariables = {
  filter?: ModelSubscriptionImportantKnowledgeDocumentFilterInput | null;
};

export type OnCreateImportantKnowledgeDocumentSubscription = {
  onCreateImportantKnowledgeDocument?: {
    __typename: 'ImportantKnowledgeDocument';
    id: string;
    importantKnowledgeId: string;
    documentType: ImportantKnowledgeDocumentType;
    documentId: string;
    document?: {
      __typename: 'RepositoryFile';
      id: string;
      folderId: string;
      filename?: string | null;
      filetype?: FileMediaType | null;
      createdById: string;
      createdAt: string;
      updatedAt: string;
    } | null;
    creatorId: string;
    creator?: {
      __typename: 'Employee';
      id: string;
      organizationId?: string | null;
      organizationUnitId?: string | null;
      userId: string;
      nik: string;
      status: EmploymentStatus;
      domicile?: string | null;
      managerId?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    createdAt: string;
    updatedAt: string;
  } | null;
};

export type OnUpdateImportantKnowledgeDocumentSubscriptionVariables = {
  filter?: ModelSubscriptionImportantKnowledgeDocumentFilterInput | null;
};

export type OnUpdateImportantKnowledgeDocumentSubscription = {
  onUpdateImportantKnowledgeDocument?: {
    __typename: 'ImportantKnowledgeDocument';
    id: string;
    importantKnowledgeId: string;
    documentType: ImportantKnowledgeDocumentType;
    documentId: string;
    document?: {
      __typename: 'RepositoryFile';
      id: string;
      folderId: string;
      filename?: string | null;
      filetype?: FileMediaType | null;
      createdById: string;
      createdAt: string;
      updatedAt: string;
    } | null;
    creatorId: string;
    creator?: {
      __typename: 'Employee';
      id: string;
      organizationId?: string | null;
      organizationUnitId?: string | null;
      userId: string;
      nik: string;
      status: EmploymentStatus;
      domicile?: string | null;
      managerId?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    createdAt: string;
    updatedAt: string;
  } | null;
};

export type OnDeleteImportantKnowledgeDocumentSubscriptionVariables = {
  filter?: ModelSubscriptionImportantKnowledgeDocumentFilterInput | null;
};

export type OnDeleteImportantKnowledgeDocumentSubscription = {
  onDeleteImportantKnowledgeDocument?: {
    __typename: 'ImportantKnowledgeDocument';
    id: string;
    importantKnowledgeId: string;
    documentType: ImportantKnowledgeDocumentType;
    documentId: string;
    document?: {
      __typename: 'RepositoryFile';
      id: string;
      folderId: string;
      filename?: string | null;
      filetype?: FileMediaType | null;
      createdById: string;
      createdAt: string;
      updatedAt: string;
    } | null;
    creatorId: string;
    creator?: {
      __typename: 'Employee';
      id: string;
      organizationId?: string | null;
      organizationUnitId?: string | null;
      userId: string;
      nik: string;
      status: EmploymentStatus;
      domicile?: string | null;
      managerId?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    createdAt: string;
    updatedAt: string;
  } | null;
};

export type OnCreateCompetencyFieldSubscriptionVariables = {
  filter?: ModelSubscriptionCompetencyFieldFilterInput | null;
};

export type OnCreateCompetencyFieldSubscription = {
  onCreateCompetencyField?: {
    __typename: 'CompetencyField';
    id: string;
    name: string;
    createdAt: string;
    updatedAt: string;
  } | null;
};

export type OnUpdateCompetencyFieldSubscriptionVariables = {
  filter?: ModelSubscriptionCompetencyFieldFilterInput | null;
};

export type OnUpdateCompetencyFieldSubscription = {
  onUpdateCompetencyField?: {
    __typename: 'CompetencyField';
    id: string;
    name: string;
    createdAt: string;
    updatedAt: string;
  } | null;
};

export type OnDeleteCompetencyFieldSubscriptionVariables = {
  filter?: ModelSubscriptionCompetencyFieldFilterInput | null;
};

export type OnDeleteCompetencyFieldSubscription = {
  onDeleteCompetencyField?: {
    __typename: 'CompetencyField';
    id: string;
    name: string;
    createdAt: string;
    updatedAt: string;
  } | null;
};

export type OnCreateSubjectMatterExpertSubscriptionVariables = {
  filter?: ModelSubscriptionSubjectMatterExpertFilterInput | null;
};

export type OnCreateSubjectMatterExpertSubscription = {
  onCreateSubjectMatterExpert?: {
    __typename: 'SubjectMatterExpert';
    id: string;
    employeeId: string;
    employee?: {
      __typename: 'Employee';
      id: string;
      organizationId?: string | null;
      organizationUnitId?: string | null;
      userId: string;
      nik: string;
      status: EmploymentStatus;
      domicile?: string | null;
      managerId?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    competencies?: {
      __typename: 'ModelSubjectMatterExpertCompetencyConnection';
      nextToken?: string | null;
    } | null;
    createdAt: string;
    updatedAt: string;
  } | null;
};

export type OnUpdateSubjectMatterExpertSubscriptionVariables = {
  filter?: ModelSubscriptionSubjectMatterExpertFilterInput | null;
};

export type OnUpdateSubjectMatterExpertSubscription = {
  onUpdateSubjectMatterExpert?: {
    __typename: 'SubjectMatterExpert';
    id: string;
    employeeId: string;
    employee?: {
      __typename: 'Employee';
      id: string;
      organizationId?: string | null;
      organizationUnitId?: string | null;
      userId: string;
      nik: string;
      status: EmploymentStatus;
      domicile?: string | null;
      managerId?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    competencies?: {
      __typename: 'ModelSubjectMatterExpertCompetencyConnection';
      nextToken?: string | null;
    } | null;
    createdAt: string;
    updatedAt: string;
  } | null;
};

export type OnDeleteSubjectMatterExpertSubscriptionVariables = {
  filter?: ModelSubscriptionSubjectMatterExpertFilterInput | null;
};

export type OnDeleteSubjectMatterExpertSubscription = {
  onDeleteSubjectMatterExpert?: {
    __typename: 'SubjectMatterExpert';
    id: string;
    employeeId: string;
    employee?: {
      __typename: 'Employee';
      id: string;
      organizationId?: string | null;
      organizationUnitId?: string | null;
      userId: string;
      nik: string;
      status: EmploymentStatus;
      domicile?: string | null;
      managerId?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    competencies?: {
      __typename: 'ModelSubjectMatterExpertCompetencyConnection';
      nextToken?: string | null;
    } | null;
    createdAt: string;
    updatedAt: string;
  } | null;
};

export type OnCreateSubjectMatterExpertCompetencySubscriptionVariables = {
  filter?: ModelSubscriptionSubjectMatterExpertCompetencyFilterInput | null;
};

export type OnCreateSubjectMatterExpertCompetencySubscription = {
  onCreateSubjectMatterExpertCompetency?: {
    __typename: 'SubjectMatterExpertCompetency';
    id: string;
    subjectMatterExpertId: string;
    competencyFieldId: string;
    competencyField?: {
      __typename: 'CompetencyField';
      id: string;
      name: string;
      createdAt: string;
      updatedAt: string;
    } | null;
    createdAt: string;
    updatedAt: string;
  } | null;
};

export type OnUpdateSubjectMatterExpertCompetencySubscriptionVariables = {
  filter?: ModelSubscriptionSubjectMatterExpertCompetencyFilterInput | null;
};

export type OnUpdateSubjectMatterExpertCompetencySubscription = {
  onUpdateSubjectMatterExpertCompetency?: {
    __typename: 'SubjectMatterExpertCompetency';
    id: string;
    subjectMatterExpertId: string;
    competencyFieldId: string;
    competencyField?: {
      __typename: 'CompetencyField';
      id: string;
      name: string;
      createdAt: string;
      updatedAt: string;
    } | null;
    createdAt: string;
    updatedAt: string;
  } | null;
};

export type OnDeleteSubjectMatterExpertCompetencySubscriptionVariables = {
  filter?: ModelSubscriptionSubjectMatterExpertCompetencyFilterInput | null;
};

export type OnDeleteSubjectMatterExpertCompetencySubscription = {
  onDeleteSubjectMatterExpertCompetency?: {
    __typename: 'SubjectMatterExpertCompetency';
    id: string;
    subjectMatterExpertId: string;
    competencyFieldId: string;
    competencyField?: {
      __typename: 'CompetencyField';
      id: string;
      name: string;
      createdAt: string;
      updatedAt: string;
    } | null;
    createdAt: string;
    updatedAt: string;
  } | null;
};

export type OnCreateRepositoryFolderSubscriptionVariables = {
  filter?: ModelSubscriptionRepositoryFolderFilterInput | null;
};

export type OnCreateRepositoryFolderSubscription = {
  onCreateRepositoryFolder?: {
    __typename: 'RepositoryFolder';
    id: string;
    files?: {
      __typename: 'ModelRepositoryFileConnection';
      nextToken?: string | null;
    } | null;
    foldername?: string | null;
    parentId?: string | null;
    parent?: {
      __typename: 'RepositoryFolder';
      id: string;
      foldername?: string | null;
      parentId?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    replies?: {
      __typename: 'ModelRepositoryFolderConnection';
      nextToken?: string | null;
    } | null;
    createdAt: string;
    updatedAt: string;
  } | null;
};

export type OnUpdateRepositoryFolderSubscriptionVariables = {
  filter?: ModelSubscriptionRepositoryFolderFilterInput | null;
};

export type OnUpdateRepositoryFolderSubscription = {
  onUpdateRepositoryFolder?: {
    __typename: 'RepositoryFolder';
    id: string;
    files?: {
      __typename: 'ModelRepositoryFileConnection';
      nextToken?: string | null;
    } | null;
    foldername?: string | null;
    parentId?: string | null;
    parent?: {
      __typename: 'RepositoryFolder';
      id: string;
      foldername?: string | null;
      parentId?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    replies?: {
      __typename: 'ModelRepositoryFolderConnection';
      nextToken?: string | null;
    } | null;
    createdAt: string;
    updatedAt: string;
  } | null;
};

export type OnDeleteRepositoryFolderSubscriptionVariables = {
  filter?: ModelSubscriptionRepositoryFolderFilterInput | null;
};

export type OnDeleteRepositoryFolderSubscription = {
  onDeleteRepositoryFolder?: {
    __typename: 'RepositoryFolder';
    id: string;
    files?: {
      __typename: 'ModelRepositoryFileConnection';
      nextToken?: string | null;
    } | null;
    foldername?: string | null;
    parentId?: string | null;
    parent?: {
      __typename: 'RepositoryFolder';
      id: string;
      foldername?: string | null;
      parentId?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    replies?: {
      __typename: 'ModelRepositoryFolderConnection';
      nextToken?: string | null;
    } | null;
    createdAt: string;
    updatedAt: string;
  } | null;
};

export type OnCreateRepositoryFileSubscriptionVariables = {
  filter?: ModelSubscriptionRepositoryFileFilterInput | null;
};

export type OnCreateRepositoryFileSubscription = {
  onCreateRepositoryFile?: {
    __typename: 'RepositoryFile';
    id: string;
    folderId: string;
    filename?: string | null;
    filetype?: FileMediaType | null;
    createdById: string;
    createdBy?: {
      __typename: 'Employee';
      id: string;
      organizationId?: string | null;
      organizationUnitId?: string | null;
      userId: string;
      nik: string;
      status: EmploymentStatus;
      domicile?: string | null;
      managerId?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    createdAt: string;
    updatedAt: string;
  } | null;
};

export type OnUpdateRepositoryFileSubscriptionVariables = {
  filter?: ModelSubscriptionRepositoryFileFilterInput | null;
};

export type OnUpdateRepositoryFileSubscription = {
  onUpdateRepositoryFile?: {
    __typename: 'RepositoryFile';
    id: string;
    folderId: string;
    filename?: string | null;
    filetype?: FileMediaType | null;
    createdById: string;
    createdBy?: {
      __typename: 'Employee';
      id: string;
      organizationId?: string | null;
      organizationUnitId?: string | null;
      userId: string;
      nik: string;
      status: EmploymentStatus;
      domicile?: string | null;
      managerId?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    createdAt: string;
    updatedAt: string;
  } | null;
};

export type OnDeleteRepositoryFileSubscriptionVariables = {
  filter?: ModelSubscriptionRepositoryFileFilterInput | null;
};

export type OnDeleteRepositoryFileSubscription = {
  onDeleteRepositoryFile?: {
    __typename: 'RepositoryFile';
    id: string;
    folderId: string;
    filename?: string | null;
    filetype?: FileMediaType | null;
    createdById: string;
    createdBy?: {
      __typename: 'Employee';
      id: string;
      organizationId?: string | null;
      organizationUnitId?: string | null;
      userId: string;
      nik: string;
      status: EmploymentStatus;
      domicile?: string | null;
      managerId?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    createdAt: string;
    updatedAt: string;
  } | null;
};

export type OnCreateCommunityCategorySubscriptionVariables = {
  filter?: ModelSubscriptionCommunityCategoryFilterInput | null;
};

export type OnCreateCommunityCategorySubscription = {
  onCreateCommunityCategory?: {
    __typename: 'CommunityCategory';
    id: string;
    category?: string | null;
    createdAt: string;
    updatedAt: string;
  } | null;
};

export type OnUpdateCommunityCategorySubscriptionVariables = {
  filter?: ModelSubscriptionCommunityCategoryFilterInput | null;
};

export type OnUpdateCommunityCategorySubscription = {
  onUpdateCommunityCategory?: {
    __typename: 'CommunityCategory';
    id: string;
    category?: string | null;
    createdAt: string;
    updatedAt: string;
  } | null;
};

export type OnDeleteCommunityCategorySubscriptionVariables = {
  filter?: ModelSubscriptionCommunityCategoryFilterInput | null;
};

export type OnDeleteCommunityCategorySubscription = {
  onDeleteCommunityCategory?: {
    __typename: 'CommunityCategory';
    id: string;
    category?: string | null;
    createdAt: string;
    updatedAt: string;
  } | null;
};

export type OnCreateCommunitySubscriptionVariables = {
  filter?: ModelSubscriptionCommunityFilterInput | null;
};

export type OnCreateCommunitySubscription = {
  onCreateCommunity?: {
    __typename: 'Community';
    id: string;
    coverUrl?: string | null;
    profileUrl?: string | null;
    name: string;
    description: string;
    tags?: Array<string | null> | null;
    categoryId?: string | null;
    category?: {
      __typename: 'CommunityCategory';
      id: string;
      category?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    unitId?: string | null;
    unit?: {
      __typename: 'OrganizationUnit';
      id: string;
      organizationId?: string | null;
      name: string;
      parentId?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    knowledgeFocus?: Array<string | null> | null;
    objective?: Array<string | null> | null;
    kpi?: Array<string | null> | null;
    policy?: Array<string | null> | null;
    memberCanInvite: boolean;
    reviewNewPost: boolean;
    ownerId?: string | null;
    owner?: {
      __typename: 'User';
      id: string;
      username: string;
      name: string;
      email: string;
      createdAt: string;
      updatedAt: string;
    } | null;
    pendingCoreMembers?: {
      __typename: 'ModelPendingCoreMemberConnection';
      nextToken?: string | null;
    } | null;
    coreMembers?: {
      __typename: 'ModelCoreMemberConnection';
      nextToken?: string | null;
    } | null;
    followers?: {
      __typename: 'ModelCommunityFollowersConnection';
      nextToken?: string | null;
    } | null;
    documentations?: {
      __typename: 'ModelCommunityDocumentationConnection';
      nextToken?: string | null;
    } | null;
    posts?: {
      __typename: 'ModelPostConnection';
      nextToken?: string | null;
    } | null;
    events?: {
      __typename: 'ModelEventConnection';
      nextToken?: string | null;
    } | null;
    type: CommunityType;
    createdAt: string;
    updatedAt: string;
  } | null;
};

export type OnUpdateCommunitySubscriptionVariables = {
  filter?: ModelSubscriptionCommunityFilterInput | null;
};

export type OnUpdateCommunitySubscription = {
  onUpdateCommunity?: {
    __typename: 'Community';
    id: string;
    coverUrl?: string | null;
    profileUrl?: string | null;
    name: string;
    description: string;
    tags?: Array<string | null> | null;
    categoryId?: string | null;
    category?: {
      __typename: 'CommunityCategory';
      id: string;
      category?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    unitId?: string | null;
    unit?: {
      __typename: 'OrganizationUnit';
      id: string;
      organizationId?: string | null;
      name: string;
      parentId?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    knowledgeFocus?: Array<string | null> | null;
    objective?: Array<string | null> | null;
    kpi?: Array<string | null> | null;
    policy?: Array<string | null> | null;
    memberCanInvite: boolean;
    reviewNewPost: boolean;
    ownerId?: string | null;
    owner?: {
      __typename: 'User';
      id: string;
      username: string;
      name: string;
      email: string;
      createdAt: string;
      updatedAt: string;
    } | null;
    pendingCoreMembers?: {
      __typename: 'ModelPendingCoreMemberConnection';
      nextToken?: string | null;
    } | null;
    coreMembers?: {
      __typename: 'ModelCoreMemberConnection';
      nextToken?: string | null;
    } | null;
    followers?: {
      __typename: 'ModelCommunityFollowersConnection';
      nextToken?: string | null;
    } | null;
    documentations?: {
      __typename: 'ModelCommunityDocumentationConnection';
      nextToken?: string | null;
    } | null;
    posts?: {
      __typename: 'ModelPostConnection';
      nextToken?: string | null;
    } | null;
    events?: {
      __typename: 'ModelEventConnection';
      nextToken?: string | null;
    } | null;
    type: CommunityType;
    createdAt: string;
    updatedAt: string;
  } | null;
};

export type OnDeleteCommunitySubscriptionVariables = {
  filter?: ModelSubscriptionCommunityFilterInput | null;
};

export type OnDeleteCommunitySubscription = {
  onDeleteCommunity?: {
    __typename: 'Community';
    id: string;
    coverUrl?: string | null;
    profileUrl?: string | null;
    name: string;
    description: string;
    tags?: Array<string | null> | null;
    categoryId?: string | null;
    category?: {
      __typename: 'CommunityCategory';
      id: string;
      category?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    unitId?: string | null;
    unit?: {
      __typename: 'OrganizationUnit';
      id: string;
      organizationId?: string | null;
      name: string;
      parentId?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    knowledgeFocus?: Array<string | null> | null;
    objective?: Array<string | null> | null;
    kpi?: Array<string | null> | null;
    policy?: Array<string | null> | null;
    memberCanInvite: boolean;
    reviewNewPost: boolean;
    ownerId?: string | null;
    owner?: {
      __typename: 'User';
      id: string;
      username: string;
      name: string;
      email: string;
      createdAt: string;
      updatedAt: string;
    } | null;
    pendingCoreMembers?: {
      __typename: 'ModelPendingCoreMemberConnection';
      nextToken?: string | null;
    } | null;
    coreMembers?: {
      __typename: 'ModelCoreMemberConnection';
      nextToken?: string | null;
    } | null;
    followers?: {
      __typename: 'ModelCommunityFollowersConnection';
      nextToken?: string | null;
    } | null;
    documentations?: {
      __typename: 'ModelCommunityDocumentationConnection';
      nextToken?: string | null;
    } | null;
    posts?: {
      __typename: 'ModelPostConnection';
      nextToken?: string | null;
    } | null;
    events?: {
      __typename: 'ModelEventConnection';
      nextToken?: string | null;
    } | null;
    type: CommunityType;
    createdAt: string;
    updatedAt: string;
  } | null;
};

export type OnCreatePendingCoreMemberSubscriptionVariables = {
  filter?: ModelSubscriptionPendingCoreMemberFilterInput | null;
};

export type OnCreatePendingCoreMemberSubscription = {
  onCreatePendingCoreMember?: {
    __typename: 'PendingCoreMember';
    id: string;
    communityId?: string | null;
    employeeId?: string | null;
    employee?: {
      __typename: 'Employee';
      id: string;
      organizationId?: string | null;
      organizationUnitId?: string | null;
      userId: string;
      nik: string;
      status: EmploymentStatus;
      domicile?: string | null;
      managerId?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    createdAt: string;
    updatedAt: string;
  } | null;
};

export type OnUpdatePendingCoreMemberSubscriptionVariables = {
  filter?: ModelSubscriptionPendingCoreMemberFilterInput | null;
};

export type OnUpdatePendingCoreMemberSubscription = {
  onUpdatePendingCoreMember?: {
    __typename: 'PendingCoreMember';
    id: string;
    communityId?: string | null;
    employeeId?: string | null;
    employee?: {
      __typename: 'Employee';
      id: string;
      organizationId?: string | null;
      organizationUnitId?: string | null;
      userId: string;
      nik: string;
      status: EmploymentStatus;
      domicile?: string | null;
      managerId?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    createdAt: string;
    updatedAt: string;
  } | null;
};

export type OnDeletePendingCoreMemberSubscriptionVariables = {
  filter?: ModelSubscriptionPendingCoreMemberFilterInput | null;
};

export type OnDeletePendingCoreMemberSubscription = {
  onDeletePendingCoreMember?: {
    __typename: 'PendingCoreMember';
    id: string;
    communityId?: string | null;
    employeeId?: string | null;
    employee?: {
      __typename: 'Employee';
      id: string;
      organizationId?: string | null;
      organizationUnitId?: string | null;
      userId: string;
      nik: string;
      status: EmploymentStatus;
      domicile?: string | null;
      managerId?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    createdAt: string;
    updatedAt: string;
  } | null;
};

export type OnCreateCoreMemberSubscriptionVariables = {
  filter?: ModelSubscriptionCoreMemberFilterInput | null;
};

export type OnCreateCoreMemberSubscription = {
  onCreateCoreMember?: {
    __typename: 'CoreMember';
    id: string;
    communityId?: string | null;
    employeeId?: string | null;
    employee?: {
      __typename: 'Employee';
      id: string;
      organizationId?: string | null;
      organizationUnitId?: string | null;
      userId: string;
      nik: string;
      status: EmploymentStatus;
      domicile?: string | null;
      managerId?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    createdAt: string;
    updatedAt: string;
  } | null;
};

export type OnUpdateCoreMemberSubscriptionVariables = {
  filter?: ModelSubscriptionCoreMemberFilterInput | null;
};

export type OnUpdateCoreMemberSubscription = {
  onUpdateCoreMember?: {
    __typename: 'CoreMember';
    id: string;
    communityId?: string | null;
    employeeId?: string | null;
    employee?: {
      __typename: 'Employee';
      id: string;
      organizationId?: string | null;
      organizationUnitId?: string | null;
      userId: string;
      nik: string;
      status: EmploymentStatus;
      domicile?: string | null;
      managerId?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    createdAt: string;
    updatedAt: string;
  } | null;
};

export type OnDeleteCoreMemberSubscriptionVariables = {
  filter?: ModelSubscriptionCoreMemberFilterInput | null;
};

export type OnDeleteCoreMemberSubscription = {
  onDeleteCoreMember?: {
    __typename: 'CoreMember';
    id: string;
    communityId?: string | null;
    employeeId?: string | null;
    employee?: {
      __typename: 'Employee';
      id: string;
      organizationId?: string | null;
      organizationUnitId?: string | null;
      userId: string;
      nik: string;
      status: EmploymentStatus;
      domicile?: string | null;
      managerId?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    createdAt: string;
    updatedAt: string;
  } | null;
};

export type OnCreateCommunityFollowersSubscriptionVariables = {
  filter?: ModelSubscriptionCommunityFollowersFilterInput | null;
};

export type OnCreateCommunityFollowersSubscription = {
  onCreateCommunityFollowers?: {
    __typename: 'CommunityFollowers';
    id: string;
    communityId?: string | null;
    employeeId?: string | null;
    employee?: {
      __typename: 'Employee';
      id: string;
      organizationId?: string | null;
      organizationUnitId?: string | null;
      userId: string;
      nik: string;
      status: EmploymentStatus;
      domicile?: string | null;
      managerId?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    createdAt: string;
    updatedAt: string;
  } | null;
};

export type OnUpdateCommunityFollowersSubscriptionVariables = {
  filter?: ModelSubscriptionCommunityFollowersFilterInput | null;
};

export type OnUpdateCommunityFollowersSubscription = {
  onUpdateCommunityFollowers?: {
    __typename: 'CommunityFollowers';
    id: string;
    communityId?: string | null;
    employeeId?: string | null;
    employee?: {
      __typename: 'Employee';
      id: string;
      organizationId?: string | null;
      organizationUnitId?: string | null;
      userId: string;
      nik: string;
      status: EmploymentStatus;
      domicile?: string | null;
      managerId?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    createdAt: string;
    updatedAt: string;
  } | null;
};

export type OnDeleteCommunityFollowersSubscriptionVariables = {
  filter?: ModelSubscriptionCommunityFollowersFilterInput | null;
};

export type OnDeleteCommunityFollowersSubscription = {
  onDeleteCommunityFollowers?: {
    __typename: 'CommunityFollowers';
    id: string;
    communityId?: string | null;
    employeeId?: string | null;
    employee?: {
      __typename: 'Employee';
      id: string;
      organizationId?: string | null;
      organizationUnitId?: string | null;
      userId: string;
      nik: string;
      status: EmploymentStatus;
      domicile?: string | null;
      managerId?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    createdAt: string;
    updatedAt: string;
  } | null;
};

export type OnCreateCommunityDocumentationSubscriptionVariables = {
  filter?: ModelSubscriptionCommunityDocumentationFilterInput | null;
};

export type OnCreateCommunityDocumentationSubscription = {
  onCreateCommunityDocumentation?: {
    __typename: 'CommunityDocumentation';
    id: string;
    communityId?: string | null;
    documentId?: string | null;
    document?: {
      __typename: 'RepositoryFile';
      id: string;
      folderId: string;
      filename?: string | null;
      filetype?: FileMediaType | null;
      createdById: string;
      createdAt: string;
      updatedAt: string;
    } | null;
    createdAt: string;
    updatedAt: string;
  } | null;
};

export type OnUpdateCommunityDocumentationSubscriptionVariables = {
  filter?: ModelSubscriptionCommunityDocumentationFilterInput | null;
};

export type OnUpdateCommunityDocumentationSubscription = {
  onUpdateCommunityDocumentation?: {
    __typename: 'CommunityDocumentation';
    id: string;
    communityId?: string | null;
    documentId?: string | null;
    document?: {
      __typename: 'RepositoryFile';
      id: string;
      folderId: string;
      filename?: string | null;
      filetype?: FileMediaType | null;
      createdById: string;
      createdAt: string;
      updatedAt: string;
    } | null;
    createdAt: string;
    updatedAt: string;
  } | null;
};

export type OnDeleteCommunityDocumentationSubscriptionVariables = {
  filter?: ModelSubscriptionCommunityDocumentationFilterInput | null;
};

export type OnDeleteCommunityDocumentationSubscription = {
  onDeleteCommunityDocumentation?: {
    __typename: 'CommunityDocumentation';
    id: string;
    communityId?: string | null;
    documentId?: string | null;
    document?: {
      __typename: 'RepositoryFile';
      id: string;
      folderId: string;
      filename?: string | null;
      filetype?: FileMediaType | null;
      createdById: string;
      createdAt: string;
      updatedAt: string;
    } | null;
    createdAt: string;
    updatedAt: string;
  } | null;
};

export type OnCreatePostSubscriptionVariables = {
  filter?: ModelSubscriptionPostFilterInput | null;
};

export type OnCreatePostSubscription = {
  onCreatePost?: {
    __typename: 'Post';
    id: string;
    communityId?: string | null;
    creatorId?: string | null;
    creator?: {
      __typename: 'Employee';
      id: string;
      organizationId?: string | null;
      organizationUnitId?: string | null;
      userId: string;
      nik: string;
      status: EmploymentStatus;
      domicile?: string | null;
      managerId?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    content?: string | null;
    documentId?: string | null;
    eventId?: string | null;
    event?: {
      __typename: 'Event';
      id: string;
      eventId?: string | null;
      communityId?: string | null;
      owner?: string | null;
      profileUrl?: string | null;
      type: EventType;
      title: string;
      description?: string | null;
      about?: string | null;
      datetimeFrom?: string | null;
      datetimeTo?: string | null;
      externalLink?: string | null;
      location?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    articleId?: string | null;
    article?: {
      __typename: 'Article';
      id: string;
      profileUrl?: string | null;
      status: ArticleStatus;
      title: string;
      content: string;
      createdAt?: string | null;
      updatedAt?: string | null;
    } | null;
    surveyId?: string | null;
    survey?: {
      __typename: 'Survey';
      id: string;
      name: string;
      datetimeStart?: string | null;
      datetimeEnd?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    approvedBy?: {
      __typename: 'Employee';
      id: string;
      organizationId?: string | null;
      organizationUnitId?: string | null;
      userId: string;
      nik: string;
      status: EmploymentStatus;
      domicile?: string | null;
      managerId?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    createdAt: string;
    updatedAt: string;
  } | null;
};

export type OnUpdatePostSubscriptionVariables = {
  filter?: ModelSubscriptionPostFilterInput | null;
};

export type OnUpdatePostSubscription = {
  onUpdatePost?: {
    __typename: 'Post';
    id: string;
    communityId?: string | null;
    creatorId?: string | null;
    creator?: {
      __typename: 'Employee';
      id: string;
      organizationId?: string | null;
      organizationUnitId?: string | null;
      userId: string;
      nik: string;
      status: EmploymentStatus;
      domicile?: string | null;
      managerId?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    content?: string | null;
    documentId?: string | null;
    eventId?: string | null;
    event?: {
      __typename: 'Event';
      id: string;
      eventId?: string | null;
      communityId?: string | null;
      owner?: string | null;
      profileUrl?: string | null;
      type: EventType;
      title: string;
      description?: string | null;
      about?: string | null;
      datetimeFrom?: string | null;
      datetimeTo?: string | null;
      externalLink?: string | null;
      location?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    articleId?: string | null;
    article?: {
      __typename: 'Article';
      id: string;
      profileUrl?: string | null;
      status: ArticleStatus;
      title: string;
      content: string;
      createdAt?: string | null;
      updatedAt?: string | null;
    } | null;
    surveyId?: string | null;
    survey?: {
      __typename: 'Survey';
      id: string;
      name: string;
      datetimeStart?: string | null;
      datetimeEnd?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    approvedBy?: {
      __typename: 'Employee';
      id: string;
      organizationId?: string | null;
      organizationUnitId?: string | null;
      userId: string;
      nik: string;
      status: EmploymentStatus;
      domicile?: string | null;
      managerId?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    createdAt: string;
    updatedAt: string;
  } | null;
};

export type OnDeletePostSubscriptionVariables = {
  filter?: ModelSubscriptionPostFilterInput | null;
};

export type OnDeletePostSubscription = {
  onDeletePost?: {
    __typename: 'Post';
    id: string;
    communityId?: string | null;
    creatorId?: string | null;
    creator?: {
      __typename: 'Employee';
      id: string;
      organizationId?: string | null;
      organizationUnitId?: string | null;
      userId: string;
      nik: string;
      status: EmploymentStatus;
      domicile?: string | null;
      managerId?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    content?: string | null;
    documentId?: string | null;
    eventId?: string | null;
    event?: {
      __typename: 'Event';
      id: string;
      eventId?: string | null;
      communityId?: string | null;
      owner?: string | null;
      profileUrl?: string | null;
      type: EventType;
      title: string;
      description?: string | null;
      about?: string | null;
      datetimeFrom?: string | null;
      datetimeTo?: string | null;
      externalLink?: string | null;
      location?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    articleId?: string | null;
    article?: {
      __typename: 'Article';
      id: string;
      profileUrl?: string | null;
      status: ArticleStatus;
      title: string;
      content: string;
      createdAt?: string | null;
      updatedAt?: string | null;
    } | null;
    surveyId?: string | null;
    survey?: {
      __typename: 'Survey';
      id: string;
      name: string;
      datetimeStart?: string | null;
      datetimeEnd?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    approvedBy?: {
      __typename: 'Employee';
      id: string;
      organizationId?: string | null;
      organizationUnitId?: string | null;
      userId: string;
      nik: string;
      status: EmploymentStatus;
      domicile?: string | null;
      managerId?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    createdAt: string;
    updatedAt: string;
  } | null;
};

export type OnCreateEventSubscriptionVariables = {
  filter?: ModelSubscriptionEventFilterInput | null;
};

export type OnCreateEventSubscription = {
  onCreateEvent?: {
    __typename: 'Event';
    id: string;
    eventId?: string | null;
    communityId?: string | null;
    community?: {
      __typename: 'Community';
      id: string;
      coverUrl?: string | null;
      profileUrl?: string | null;
      name: string;
      description: string;
      tags?: Array<string | null> | null;
      categoryId?: string | null;
      unitId?: string | null;
      knowledgeFocus?: Array<string | null> | null;
      objective?: Array<string | null> | null;
      kpi?: Array<string | null> | null;
      policy?: Array<string | null> | null;
      memberCanInvite: boolean;
      reviewNewPost: boolean;
      ownerId?: string | null;
      type: CommunityType;
      createdAt: string;
      updatedAt: string;
    } | null;
    owner?: string | null;
    profileUrl?: string | null;
    type: EventType;
    title: string;
    description?: string | null;
    about?: string | null;
    datetimeFrom?: string | null;
    datetimeTo?: string | null;
    externalLink?: string | null;
    location?: string | null;
    noteTakers?: {
      __typename: 'ModelNoteTakersConnection';
      nextToken?: string | null;
    } | null;
    employeeSpeakers?: Array<{
      __typename: 'Employee';
      id: string;
      organizationId?: string | null;
      organizationUnitId?: string | null;
      userId: string;
      nik: string;
      status: EmploymentStatus;
      domicile?: string | null;
      managerId?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null> | null;
    externalSpeakers?: Array<{
      __typename: 'EventSpeaker';
      id: string;
      name?: string | null;
      jobTitle?: string | null;
      company?: string | null;
      photo_url?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null> | null;
    committees?: {
      __typename: 'ModelComitteeConnection';
      nextToken?: string | null;
    } | null;
    documentations?: {
      __typename: 'ModelCommunityDocumentationConnection';
      nextToken?: string | null;
    } | null;
    attendeeIds?: {
      __typename: 'ModelAttendeeConnection';
      nextToken?: string | null;
    } | null;
    messages?: {
      __typename: 'ModelEventMessageConnection';
      nextToken?: string | null;
    } | null;
    createdAt: string;
    updatedAt: string;
  } | null;
};

export type OnUpdateEventSubscriptionVariables = {
  filter?: ModelSubscriptionEventFilterInput | null;
};

export type OnUpdateEventSubscription = {
  onUpdateEvent?: {
    __typename: 'Event';
    id: string;
    eventId?: string | null;
    communityId?: string | null;
    community?: {
      __typename: 'Community';
      id: string;
      coverUrl?: string | null;
      profileUrl?: string | null;
      name: string;
      description: string;
      tags?: Array<string | null> | null;
      categoryId?: string | null;
      unitId?: string | null;
      knowledgeFocus?: Array<string | null> | null;
      objective?: Array<string | null> | null;
      kpi?: Array<string | null> | null;
      policy?: Array<string | null> | null;
      memberCanInvite: boolean;
      reviewNewPost: boolean;
      ownerId?: string | null;
      type: CommunityType;
      createdAt: string;
      updatedAt: string;
    } | null;
    owner?: string | null;
    profileUrl?: string | null;
    type: EventType;
    title: string;
    description?: string | null;
    about?: string | null;
    datetimeFrom?: string | null;
    datetimeTo?: string | null;
    externalLink?: string | null;
    location?: string | null;
    noteTakers?: {
      __typename: 'ModelNoteTakersConnection';
      nextToken?: string | null;
    } | null;
    employeeSpeakers?: Array<{
      __typename: 'Employee';
      id: string;
      organizationId?: string | null;
      organizationUnitId?: string | null;
      userId: string;
      nik: string;
      status: EmploymentStatus;
      domicile?: string | null;
      managerId?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null> | null;
    externalSpeakers?: Array<{
      __typename: 'EventSpeaker';
      id: string;
      name?: string | null;
      jobTitle?: string | null;
      company?: string | null;
      photo_url?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null> | null;
    committees?: {
      __typename: 'ModelComitteeConnection';
      nextToken?: string | null;
    } | null;
    documentations?: {
      __typename: 'ModelCommunityDocumentationConnection';
      nextToken?: string | null;
    } | null;
    attendeeIds?: {
      __typename: 'ModelAttendeeConnection';
      nextToken?: string | null;
    } | null;
    messages?: {
      __typename: 'ModelEventMessageConnection';
      nextToken?: string | null;
    } | null;
    createdAt: string;
    updatedAt: string;
  } | null;
};

export type OnDeleteEventSubscriptionVariables = {
  filter?: ModelSubscriptionEventFilterInput | null;
};

export type OnDeleteEventSubscription = {
  onDeleteEvent?: {
    __typename: 'Event';
    id: string;
    eventId?: string | null;
    communityId?: string | null;
    community?: {
      __typename: 'Community';
      id: string;
      coverUrl?: string | null;
      profileUrl?: string | null;
      name: string;
      description: string;
      tags?: Array<string | null> | null;
      categoryId?: string | null;
      unitId?: string | null;
      knowledgeFocus?: Array<string | null> | null;
      objective?: Array<string | null> | null;
      kpi?: Array<string | null> | null;
      policy?: Array<string | null> | null;
      memberCanInvite: boolean;
      reviewNewPost: boolean;
      ownerId?: string | null;
      type: CommunityType;
      createdAt: string;
      updatedAt: string;
    } | null;
    owner?: string | null;
    profileUrl?: string | null;
    type: EventType;
    title: string;
    description?: string | null;
    about?: string | null;
    datetimeFrom?: string | null;
    datetimeTo?: string | null;
    externalLink?: string | null;
    location?: string | null;
    noteTakers?: {
      __typename: 'ModelNoteTakersConnection';
      nextToken?: string | null;
    } | null;
    employeeSpeakers?: Array<{
      __typename: 'Employee';
      id: string;
      organizationId?: string | null;
      organizationUnitId?: string | null;
      userId: string;
      nik: string;
      status: EmploymentStatus;
      domicile?: string | null;
      managerId?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null> | null;
    externalSpeakers?: Array<{
      __typename: 'EventSpeaker';
      id: string;
      name?: string | null;
      jobTitle?: string | null;
      company?: string | null;
      photo_url?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null> | null;
    committees?: {
      __typename: 'ModelComitteeConnection';
      nextToken?: string | null;
    } | null;
    documentations?: {
      __typename: 'ModelCommunityDocumentationConnection';
      nextToken?: string | null;
    } | null;
    attendeeIds?: {
      __typename: 'ModelAttendeeConnection';
      nextToken?: string | null;
    } | null;
    messages?: {
      __typename: 'ModelEventMessageConnection';
      nextToken?: string | null;
    } | null;
    createdAt: string;
    updatedAt: string;
  } | null;
};

export type OnCreateNoteTakersSubscriptionVariables = {
  filter?: ModelSubscriptionNoteTakersFilterInput | null;
};

export type OnCreateNoteTakersSubscription = {
  onCreateNoteTakers?: {
    __typename: 'NoteTakers';
    id: string;
    eventId?: string | null;
    employeeId?: string | null;
    employee?: {
      __typename: 'Employee';
      id: string;
      organizationId?: string | null;
      organizationUnitId?: string | null;
      userId: string;
      nik: string;
      status: EmploymentStatus;
      domicile?: string | null;
      managerId?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    createdAt: string;
    updatedAt: string;
  } | null;
};

export type OnUpdateNoteTakersSubscriptionVariables = {
  filter?: ModelSubscriptionNoteTakersFilterInput | null;
};

export type OnUpdateNoteTakersSubscription = {
  onUpdateNoteTakers?: {
    __typename: 'NoteTakers';
    id: string;
    eventId?: string | null;
    employeeId?: string | null;
    employee?: {
      __typename: 'Employee';
      id: string;
      organizationId?: string | null;
      organizationUnitId?: string | null;
      userId: string;
      nik: string;
      status: EmploymentStatus;
      domicile?: string | null;
      managerId?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    createdAt: string;
    updatedAt: string;
  } | null;
};

export type OnDeleteNoteTakersSubscriptionVariables = {
  filter?: ModelSubscriptionNoteTakersFilterInput | null;
};

export type OnDeleteNoteTakersSubscription = {
  onDeleteNoteTakers?: {
    __typename: 'NoteTakers';
    id: string;
    eventId?: string | null;
    employeeId?: string | null;
    employee?: {
      __typename: 'Employee';
      id: string;
      organizationId?: string | null;
      organizationUnitId?: string | null;
      userId: string;
      nik: string;
      status: EmploymentStatus;
      domicile?: string | null;
      managerId?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    createdAt: string;
    updatedAt: string;
  } | null;
};

export type OnCreateComitteeSubscriptionVariables = {
  filter?: ModelSubscriptionComitteeFilterInput | null;
};

export type OnCreateComitteeSubscription = {
  onCreateComittee?: {
    __typename: 'Comittee';
    id: string;
    eventId?: string | null;
    employeeId?: string | null;
    employee?: {
      __typename: 'Employee';
      id: string;
      organizationId?: string | null;
      organizationUnitId?: string | null;
      userId: string;
      nik: string;
      status: EmploymentStatus;
      domicile?: string | null;
      managerId?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    createdAt: string;
    updatedAt: string;
  } | null;
};

export type OnUpdateComitteeSubscriptionVariables = {
  filter?: ModelSubscriptionComitteeFilterInput | null;
};

export type OnUpdateComitteeSubscription = {
  onUpdateComittee?: {
    __typename: 'Comittee';
    id: string;
    eventId?: string | null;
    employeeId?: string | null;
    employee?: {
      __typename: 'Employee';
      id: string;
      organizationId?: string | null;
      organizationUnitId?: string | null;
      userId: string;
      nik: string;
      status: EmploymentStatus;
      domicile?: string | null;
      managerId?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    createdAt: string;
    updatedAt: string;
  } | null;
};

export type OnDeleteComitteeSubscriptionVariables = {
  filter?: ModelSubscriptionComitteeFilterInput | null;
};

export type OnDeleteComitteeSubscription = {
  onDeleteComittee?: {
    __typename: 'Comittee';
    id: string;
    eventId?: string | null;
    employeeId?: string | null;
    employee?: {
      __typename: 'Employee';
      id: string;
      organizationId?: string | null;
      organizationUnitId?: string | null;
      userId: string;
      nik: string;
      status: EmploymentStatus;
      domicile?: string | null;
      managerId?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    createdAt: string;
    updatedAt: string;
  } | null;
};

export type OnCreateAttendeeSubscriptionVariables = {
  filter?: ModelSubscriptionAttendeeFilterInput | null;
};

export type OnCreateAttendeeSubscription = {
  onCreateAttendee?: {
    __typename: 'Attendee';
    id: string;
    employeeId?: string | null;
    employee?: {
      __typename: 'Employee';
      id: string;
      organizationId?: string | null;
      organizationUnitId?: string | null;
      userId: string;
      nik: string;
      status: EmploymentStatus;
      domicile?: string | null;
      managerId?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    createdAt: string;
    updatedAt: string;
  } | null;
};

export type OnUpdateAttendeeSubscriptionVariables = {
  filter?: ModelSubscriptionAttendeeFilterInput | null;
};

export type OnUpdateAttendeeSubscription = {
  onUpdateAttendee?: {
    __typename: 'Attendee';
    id: string;
    employeeId?: string | null;
    employee?: {
      __typename: 'Employee';
      id: string;
      organizationId?: string | null;
      organizationUnitId?: string | null;
      userId: string;
      nik: string;
      status: EmploymentStatus;
      domicile?: string | null;
      managerId?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    createdAt: string;
    updatedAt: string;
  } | null;
};

export type OnDeleteAttendeeSubscriptionVariables = {
  filter?: ModelSubscriptionAttendeeFilterInput | null;
};

export type OnDeleteAttendeeSubscription = {
  onDeleteAttendee?: {
    __typename: 'Attendee';
    id: string;
    employeeId?: string | null;
    employee?: {
      __typename: 'Employee';
      id: string;
      organizationId?: string | null;
      organizationUnitId?: string | null;
      userId: string;
      nik: string;
      status: EmploymentStatus;
      domicile?: string | null;
      managerId?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    createdAt: string;
    updatedAt: string;
  } | null;
};

export type OnCreateEmployeeSpeakerSubscriptionVariables = {
  filter?: ModelSubscriptionEmployeeSpeakerFilterInput | null;
};

export type OnCreateEmployeeSpeakerSubscription = {
  onCreateEmployeeSpeaker?: {
    __typename: 'EmployeeSpeaker';
    id: string;
    employeeId?: string | null;
    employe?: {
      __typename: 'Employee';
      id: string;
      organizationId?: string | null;
      organizationUnitId?: string | null;
      userId: string;
      nik: string;
      status: EmploymentStatus;
      domicile?: string | null;
      managerId?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    createdAt: string;
    updatedAt: string;
  } | null;
};

export type OnUpdateEmployeeSpeakerSubscriptionVariables = {
  filter?: ModelSubscriptionEmployeeSpeakerFilterInput | null;
};

export type OnUpdateEmployeeSpeakerSubscription = {
  onUpdateEmployeeSpeaker?: {
    __typename: 'EmployeeSpeaker';
    id: string;
    employeeId?: string | null;
    employe?: {
      __typename: 'Employee';
      id: string;
      organizationId?: string | null;
      organizationUnitId?: string | null;
      userId: string;
      nik: string;
      status: EmploymentStatus;
      domicile?: string | null;
      managerId?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    createdAt: string;
    updatedAt: string;
  } | null;
};

export type OnDeleteEmployeeSpeakerSubscriptionVariables = {
  filter?: ModelSubscriptionEmployeeSpeakerFilterInput | null;
};

export type OnDeleteEmployeeSpeakerSubscription = {
  onDeleteEmployeeSpeaker?: {
    __typename: 'EmployeeSpeaker';
    id: string;
    employeeId?: string | null;
    employe?: {
      __typename: 'Employee';
      id: string;
      organizationId?: string | null;
      organizationUnitId?: string | null;
      userId: string;
      nik: string;
      status: EmploymentStatus;
      domicile?: string | null;
      managerId?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    createdAt: string;
    updatedAt: string;
  } | null;
};

export type OnCreateEventSpeakerSubscriptionVariables = {
  filter?: ModelSubscriptionEventSpeakerFilterInput | null;
};

export type OnCreateEventSpeakerSubscription = {
  onCreateEventSpeaker?: {
    __typename: 'EventSpeaker';
    id: string;
    name?: string | null;
    jobTitle?: string | null;
    company?: string | null;
    photo_url?: string | null;
    createdAt: string;
    updatedAt: string;
  } | null;
};

export type OnUpdateEventSpeakerSubscriptionVariables = {
  filter?: ModelSubscriptionEventSpeakerFilterInput | null;
};

export type OnUpdateEventSpeakerSubscription = {
  onUpdateEventSpeaker?: {
    __typename: 'EventSpeaker';
    id: string;
    name?: string | null;
    jobTitle?: string | null;
    company?: string | null;
    photo_url?: string | null;
    createdAt: string;
    updatedAt: string;
  } | null;
};

export type OnDeleteEventSpeakerSubscriptionVariables = {
  filter?: ModelSubscriptionEventSpeakerFilterInput | null;
};

export type OnDeleteEventSpeakerSubscription = {
  onDeleteEventSpeaker?: {
    __typename: 'EventSpeaker';
    id: string;
    name?: string | null;
    jobTitle?: string | null;
    company?: string | null;
    photo_url?: string | null;
    createdAt: string;
    updatedAt: string;
  } | null;
};

export type OnCreateEventMessageSubscriptionVariables = {
  filter?: ModelSubscriptionEventMessageFilterInput | null;
};

export type OnCreateEventMessageSubscription = {
  onCreateEventMessage?: {
    __typename: 'EventMessage';
    id: string;
    eventId?: string | null;
    from?: {
      __typename: 'Employee';
      id: string;
      organizationId?: string | null;
      organizationUnitId?: string | null;
      userId: string;
      nik: string;
      status: EmploymentStatus;
      domicile?: string | null;
      managerId?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    toId?: {
      __typename: 'Employee';
      id: string;
      organizationId?: string | null;
      organizationUnitId?: string | null;
      userId: string;
      nik: string;
      status: EmploymentStatus;
      domicile?: string | null;
      managerId?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    message?: string | null;
    parentId?: string | null;
    parent?: {
      __typename: 'EventMessage';
      id: string;
      eventId?: string | null;
      message?: string | null;
      parentId?: string | null;
      attachmentUrl?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    replies?: {
      __typename: 'ModelEventMessageConnection';
      nextToken?: string | null;
    } | null;
    attachmentUrl?: string | null;
    createdAt: string;
    updatedAt: string;
  } | null;
};

export type OnUpdateEventMessageSubscriptionVariables = {
  filter?: ModelSubscriptionEventMessageFilterInput | null;
};

export type OnUpdateEventMessageSubscription = {
  onUpdateEventMessage?: {
    __typename: 'EventMessage';
    id: string;
    eventId?: string | null;
    from?: {
      __typename: 'Employee';
      id: string;
      organizationId?: string | null;
      organizationUnitId?: string | null;
      userId: string;
      nik: string;
      status: EmploymentStatus;
      domicile?: string | null;
      managerId?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    toId?: {
      __typename: 'Employee';
      id: string;
      organizationId?: string | null;
      organizationUnitId?: string | null;
      userId: string;
      nik: string;
      status: EmploymentStatus;
      domicile?: string | null;
      managerId?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    message?: string | null;
    parentId?: string | null;
    parent?: {
      __typename: 'EventMessage';
      id: string;
      eventId?: string | null;
      message?: string | null;
      parentId?: string | null;
      attachmentUrl?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    replies?: {
      __typename: 'ModelEventMessageConnection';
      nextToken?: string | null;
    } | null;
    attachmentUrl?: string | null;
    createdAt: string;
    updatedAt: string;
  } | null;
};

export type OnDeleteEventMessageSubscriptionVariables = {
  filter?: ModelSubscriptionEventMessageFilterInput | null;
};

export type OnDeleteEventMessageSubscription = {
  onDeleteEventMessage?: {
    __typename: 'EventMessage';
    id: string;
    eventId?: string | null;
    from?: {
      __typename: 'Employee';
      id: string;
      organizationId?: string | null;
      organizationUnitId?: string | null;
      userId: string;
      nik: string;
      status: EmploymentStatus;
      domicile?: string | null;
      managerId?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    toId?: {
      __typename: 'Employee';
      id: string;
      organizationId?: string | null;
      organizationUnitId?: string | null;
      userId: string;
      nik: string;
      status: EmploymentStatus;
      domicile?: string | null;
      managerId?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    message?: string | null;
    parentId?: string | null;
    parent?: {
      __typename: 'EventMessage';
      id: string;
      eventId?: string | null;
      message?: string | null;
      parentId?: string | null;
      attachmentUrl?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    replies?: {
      __typename: 'ModelEventMessageConnection';
      nextToken?: string | null;
    } | null;
    attachmentUrl?: string | null;
    createdAt: string;
    updatedAt: string;
  } | null;
};

export type OnCreateArticleSubscriptionVariables = {
  filter?: ModelSubscriptionArticleFilterInput | null;
};

export type OnCreateArticleSubscription = {
  onCreateArticle?: {
    __typename: 'Article';
    id: string;
    profileUrl?: string | null;
    status: ArticleStatus;
    owner?: {
      __typename: 'User';
      id: string;
      username: string;
      name: string;
      email: string;
      createdAt: string;
      updatedAt: string;
    } | null;
    title: string;
    content: string;
    createdAt?: string | null;
    createdBy?: {
      __typename: 'User';
      id: string;
      username: string;
      name: string;
      email: string;
      createdAt: string;
      updatedAt: string;
    } | null;
    updatedAt?: string | null;
    updatedBy?: {
      __typename: 'User';
      id: string;
      username: string;
      name: string;
      email: string;
      createdAt: string;
      updatedAt: string;
    } | null;
  } | null;
};

export type OnUpdateArticleSubscriptionVariables = {
  filter?: ModelSubscriptionArticleFilterInput | null;
};

export type OnUpdateArticleSubscription = {
  onUpdateArticle?: {
    __typename: 'Article';
    id: string;
    profileUrl?: string | null;
    status: ArticleStatus;
    owner?: {
      __typename: 'User';
      id: string;
      username: string;
      name: string;
      email: string;
      createdAt: string;
      updatedAt: string;
    } | null;
    title: string;
    content: string;
    createdAt?: string | null;
    createdBy?: {
      __typename: 'User';
      id: string;
      username: string;
      name: string;
      email: string;
      createdAt: string;
      updatedAt: string;
    } | null;
    updatedAt?: string | null;
    updatedBy?: {
      __typename: 'User';
      id: string;
      username: string;
      name: string;
      email: string;
      createdAt: string;
      updatedAt: string;
    } | null;
  } | null;
};

export type OnDeleteArticleSubscriptionVariables = {
  filter?: ModelSubscriptionArticleFilterInput | null;
};

export type OnDeleteArticleSubscription = {
  onDeleteArticle?: {
    __typename: 'Article';
    id: string;
    profileUrl?: string | null;
    status: ArticleStatus;
    owner?: {
      __typename: 'User';
      id: string;
      username: string;
      name: string;
      email: string;
      createdAt: string;
      updatedAt: string;
    } | null;
    title: string;
    content: string;
    createdAt?: string | null;
    createdBy?: {
      __typename: 'User';
      id: string;
      username: string;
      name: string;
      email: string;
      createdAt: string;
      updatedAt: string;
    } | null;
    updatedAt?: string | null;
    updatedBy?: {
      __typename: 'User';
      id: string;
      username: string;
      name: string;
      email: string;
      createdAt: string;
      updatedAt: string;
    } | null;
  } | null;
};

export type OnCreateSurveySubscriptionVariables = {
  filter?: ModelSubscriptionSurveyFilterInput | null;
};

export type OnCreateSurveySubscription = {
  onCreateSurvey?: {
    __typename: 'Survey';
    id: string;
    name: string;
    datetimeStart?: string | null;
    datetimeEnd?: string | null;
    options?: {
      __typename: 'ModelSurveyOptionConnection';
      nextToken?: string | null;
    } | null;
    createdAt: string;
    updatedAt: string;
  } | null;
};

export type OnUpdateSurveySubscriptionVariables = {
  filter?: ModelSubscriptionSurveyFilterInput | null;
};

export type OnUpdateSurveySubscription = {
  onUpdateSurvey?: {
    __typename: 'Survey';
    id: string;
    name: string;
    datetimeStart?: string | null;
    datetimeEnd?: string | null;
    options?: {
      __typename: 'ModelSurveyOptionConnection';
      nextToken?: string | null;
    } | null;
    createdAt: string;
    updatedAt: string;
  } | null;
};

export type OnDeleteSurveySubscriptionVariables = {
  filter?: ModelSubscriptionSurveyFilterInput | null;
};

export type OnDeleteSurveySubscription = {
  onDeleteSurvey?: {
    __typename: 'Survey';
    id: string;
    name: string;
    datetimeStart?: string | null;
    datetimeEnd?: string | null;
    options?: {
      __typename: 'ModelSurveyOptionConnection';
      nextToken?: string | null;
    } | null;
    createdAt: string;
    updatedAt: string;
  } | null;
};

export type OnCreateSurveyOptionSubscriptionVariables = {
  filter?: ModelSubscriptionSurveyOptionFilterInput | null;
};

export type OnCreateSurveyOptionSubscription = {
  onCreateSurveyOption?: {
    __typename: 'SurveyOption';
    id: string;
    surveyOptionId?: string | null;
    caption?: string | null;
    totalVote?: number | null;
    createdAt: string;
    updatedAt: string;
  } | null;
};

export type OnUpdateSurveyOptionSubscriptionVariables = {
  filter?: ModelSubscriptionSurveyOptionFilterInput | null;
};

export type OnUpdateSurveyOptionSubscription = {
  onUpdateSurveyOption?: {
    __typename: 'SurveyOption';
    id: string;
    surveyOptionId?: string | null;
    caption?: string | null;
    totalVote?: number | null;
    createdAt: string;
    updatedAt: string;
  } | null;
};

export type OnDeleteSurveyOptionSubscriptionVariables = {
  filter?: ModelSubscriptionSurveyOptionFilterInput | null;
};

export type OnDeleteSurveyOptionSubscription = {
  onDeleteSurveyOption?: {
    __typename: 'SurveyOption';
    id: string;
    surveyOptionId?: string | null;
    caption?: string | null;
    totalVote?: number | null;
    createdAt: string;
    updatedAt: string;
  } | null;
};
